
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("e6Iiv", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1PKpt = parcelRequire("1PKpt");


var $6cQbn = parcelRequire("6cQbn");


var $2NcJL = parcelRequire("2NcJL");

function $607d01f653400a02$export$2e2bcd8739ae039(appearance) {
    appearance = appearance || 'comment';
    switch(appearance){
        case 'full-page':
        case 'full-width':
        case 'max':
            return 0, $2NcJL.FullPageEditor;
        case 'chromeless':
            return 0, $1PKpt.default;
        case 'comment':
            return 0, $6cQbn.CommentEditorWithIntl;
        default:
            throw new Error(`Appearance '${appearance}' is not supported by the editor.`);
    }
}



var $b5IZN = parcelRequire("b5IZN");

const $a840efb09fa6938c$export$36a7c46ebbddbc5d = (0, $4pOgL.isReactCompilerActivePlatform)() ? function ComposableEditor(props) {
    const $ = (0, $frIzR.c)(5);
    let t0;
    if ($[0] !== props.appearance) {
        t0 = (0, $607d01f653400a02$export$2e2bcd8739ae039)(props.appearance);
        $[0] = props.appearance;
        $[1] = t0;
    } else t0 = $[1];
    const AppearanceComponent = t0;
    let t1;
    if ($[2] !== AppearanceComponent || $[3] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b5IZN.CoreEditor), {
            ...props,
            AppearanceComponent: AppearanceComponent
        });
        $[2] = AppearanceComponent;
        $[3] = props;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : function ComposableEditor(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const AppearanceComponent = (0, $42omo.useMemo)(()=>(0, $607d01f653400a02$export$2e2bcd8739ae039)(props.appearance), [
        props.appearance
    ]);
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b5IZN.CoreEditor), {
        ...props,
        AppearanceComponent: AppearanceComponent
    });
};
module.exports["ComposableEditor"] = $a840efb09fa6938c$export$36a7c46ebbddbc5d;

});

parcelRegister("2NcJL", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $d7ZU3 = parcelRequire("d7ZU3");


var $eiA8Z = parcelRequire("eiA8Z");


var $lnATY = parcelRequire("lnATY");


var $3bEAg = parcelRequire("3bEAg");


var $b3YrF = parcelRequire("b3YrF");


var $aFUXX = parcelRequire("aFUXX");


var $g9Jfe = parcelRequire("g9Jfe");


var $9JpPs = parcelRequire("9JpPs");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");


var $4cy2V = parcelRequire("4cy2V");











var $gMc0m = parcelRequire("gMc0m");

const $b17a27d9ac03e128$var$styles = {
    root: "_1ul95x59 _4t3i1osq _1e0c1txw _2lx21bp4 _vchhusvi"
};
const $b17a27d9ac03e128$export$2e95191265575e53 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $frIzR.c)(7);
    const { children: children, className: className, style: style } = t0;
    let t1;
    if ($[0] !== className) {
        t1 = (0, $gMc0m.default)([
            $b17a27d9ac03e128$var$styles.root,
            className
        ]);
        $[0] = className;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== ref || $[4] !== style || $[5] !== t1) {
        t2 = /*#__PURE__*/ $42omo.createElement("div", {
            ref: ref,
            className: t1,
            style: style
        }, children);
        $[2] = children;
        $[3] = ref;
        $[4] = style;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ({ children: children, className: className, style: style }, ref)=>/*#__PURE__*/ $42omo.createElement("div", {
        ref: ref,
        className: (0, $gMc0m.default)([
            $b17a27d9ac03e128$var$styles.root,
            className
        ]),
        style: style
    }, children));


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /**
 * Emotion fallback branch of the `platform_editor_core_non_ecc_static_css` experiment.
 * Used via `componentWithCondition` in `FullPage.tsx`.
 *
 * Cleanup: delete this file once the experiment has shipped.
 */ 



var $9K4OG = parcelRequire("9K4OG");

/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766 */ function $3dfe29ddb16847ad$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3dfe29ddb16847ad$export$ffbc962f588258d5 = {
    name: "cui2x",
    styles: "min-width:340px;height:100%;display:flex;flex-direction:column;box-sizing:border-box"
};
const $3dfe29ddb16847ad$export$484266f72d7ebbab = {
    name: "znpqtq",
    styles: "width:100%;container-type:inline-size;container-name:editor-area;contain:layout style inline-size"
};
const $3dfe29ddb16847ad$export$a838a71bfc839c1d = {
    name: "18di8tn",
    styles: "height:100%;box-sizing:border-box;align-self:flex-end;.extension-editable-area &{height:auto;position:sticky;top:0;align-self:flex-start;}"
};


const $c1ce045772fcbcf5$export$41c7ea372447284a = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, className: className, style: style }, ref)=>// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-classname-prop -- intentional: emotion fallback branch reuses StyledComponents style
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: (0, $3dfe29ddb16847ad$export$ffbc962f588258d5),
        ref: ref,
        className: className,
        style: style
    }, children));








/* FullPageContentArea-compiled.tsx generated by @compiled/babel-plugin v2.0.0 */ 






var $2daQU = parcelRequire("2daQU");


var $aXWIB = parcelRequire("aXWIB");





var $8aWkM = parcelRequire("8aWkM");








var $dZ8uq = parcelRequire("dZ8uq");





var $kXpLO = parcelRequire("kXpLO");


var $45E6y = parcelRequire("45E6y");


var $auRzv = parcelRequire("auRzv");


var $axOCf = parcelRequire("axOCf");


var $3ae8F = parcelRequire("3ae8F");

const $b165f8ba5e312426$var$akEditorFullWidthLayoutWidth = 1800;
const $b165f8ba5e312426$var$akEditorUltraWideLayoutWidth = 4000;
const $b165f8ba5e312426$var$akEditorSwoopCubicBezier = `cubic-bezier(0.15, 1, 0.3, 1)`;
const $b165f8ba5e312426$var$tableMarginFullWidthMode = 2;
const $b165f8ba5e312426$var$akLayoutGutterOffset = 12;
const $b165f8ba5e312426$var$SWOOP_ANIMATION = `0.5s ${$b165f8ba5e312426$var$akEditorSwoopCubicBezier}`;
const $b165f8ba5e312426$var$AK_NESTED_DND_GUTTER_OFFSET = 8;
const $b165f8ba5e312426$var$getTotalPadding = ()=>(0, $aFUXX.akEditorGutterPaddingDynamic)() * 2;
const $b165f8ba5e312426$var$compiledStyles = {
    contentAreaWrapper: "_1bsb1osq _7cca15wb _1f38dez1 _njlp131u",
    sidebarArea: "_4t3i1osq _vchhusvi _1wpzesu3 _1hgw1wug _1t1q1if8 _uj9widpf _13hh1y6m",
    editorContentAreaProsemirrorStyle: "_j9k7kb7n _18q6usvi _l4a11hrf _1nw4glyw _yq1qglyw _1qzyglyw _ongaglyw _1rnyglyw _vtulglyw _13svglyw _t2fzglyw _7uc0glyw _1gl01ejb",
    hideEditorContentAreaProsemirrorWithAttributeStyle: "_12glglyw",
    hideEditorContentAreaScrollGutterWithAttributeStyle: "_amwgglyw",
    hideEditorScrollGutterStyle: "_1e0cglyw",
    fullWidthNonChromelessBreakoutBlockTableStyle: "_xpemaq80 _pnffaq80 _zr7faq80 _qkfz261p _i92uagmp",
    editorContentAreaNew: "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _v5641fxv _vwz41tcg _ca0qoahv _n3tdoahv _4t3i1ap5 _1bsb1osq _2lx21bp4 _16jlkb7n _p12f5kin _1uizkqmb",
    tableFullPageEditorStylesNew: "_1tb2idpf _8vye1n1a _1k8i1osq",
    editorContentAreaContainerNestedDndStyle: "_tynl4diq",
    editorContentAreaContainerStyleExcludeCodeBlockNew: "_1wxymslj _9dtbmslj _17q71osq _1b7c1kw7 _tynlfknx",
    editorContentAreaContainerStyleNew: "_142emslj _1wxymslj _9dtbmslj _17q71osq _1b7c1kw7 _tynlfknx",
    editorContentGutterStyleFG: "_ca0qidpf _u5f3t9kd _n3tdidpf _19bvt9kd",
    editorContentGutterStyles: "_ca0qidpf _u5f31ex1 _n3tdidpf _19bv1ex1 _vchhusvi",
    editorContentReducedGutterStyles: "_1d7gidpf _n2nw1tcg _d329idpf _105p1tcg",
    contentAreaNew: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _v5642kub _1e0c1txw _2lx2vrvc _4t3ibhu0 _vchhusvi _8j6w1lxk",
    contentAreaHeightNoToolbar: "_4t3i1osq",
    markdownModeContainerBackgroundStyle: "_bfhkhfxm _101j15vq",
    markdownModeContentAreaStyle: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _vchhusvi _4t3i1osq _p12fglyw _1ul9idpf _n3tdidpf _ca0qidpf _1bsb1osq _fh67idpf _71ybidpf _evz0idpf _1n5qidpf _1wrrusvi _13jk1txw _q0l01bp4 _1a1d1osq _1vbxidpf _1xouidpf _4tbp1osq _1e8kkb7n _boivkb7n _13t61wug _11bl1txw _1593idpf _qgzyidpf _li931osq"
};
const $b165f8ba5e312426$export$81adcdb8b9fca1f7 = 'ak-editor-fp-content-area'; // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $b165f8ba5e312426$export$5c151fe82051a1a7 = 'ak-editor-container';
const $b165f8ba5e312426$var$Content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((props, ref)=>{
    const fullWidthMode = props.appearance === 'full-width';
    const maxWidthMode = props.appearance === 'max';
    const scrollContainerRef = (0, $42omo.useRef)(null);
    const contentAreaRef = (0, $42omo.useRef)(null);
    const containerRef = (0, $42omo.useRef)(null);
    const allowScrollGutter = props.editorAPI?.base?.sharedState.currentState()?.allowScrollGutter;
    const contentAreaMaxWidth = $b165f8ba5e312426$var$getTotalPadding() + (!fullWidthMode ? maxWidthMode ? $b165f8ba5e312426$var$akEditorUltraWideLayoutWidth : (0, $aFUXX.akEditorDefaultLayoutWidth) : $b165f8ba5e312426$var$akEditorFullWidthLayoutWidth); // Get useStandardNodeWidth from block menu plugin shared state
    // Only access editorAPI when the experiment is enabled to avoid performance impact
    const useStandardNodeWidth = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && (props.editorAPI?.blockMenu?.sharedState?.currentState()?.useStandardNodeWidth ?? false);
    (0, $42omo.useImperativeHandle)(ref, ()=>({
            get scrollContainer () {
                return scrollContainerRef.current;
            },
            get contentArea () {
                return contentAreaRef.current;
            },
            get containerArea () {
                return containerRef.current;
            }
        }), []);
    const markdownPluginCurrentView = (0, $eiA8Z.useSharedPluginStateWithSelector)(props.editorAPI, [
        'markdownMode'
    ], (states)=>states.markdownModeState?.view);
    const markdownPluginCurrentIsMarkdownMode = (0, $eiA8Z.useSharedPluginStateWithSelector)(props.editorAPI, [
        'markdownMode'
    ], (states_0)=>states_0.markdownModeState?.isMarkdownMode);
    const isMarkdownModeExperimentEnabled = (0, $dZ8uq.expValEqualsNoExposure)('cc-markdown-mode', 'isEnabled', true);
    const shouldHideProseMirrorForMarkdownMode = isMarkdownModeExperimentEnabled && markdownPluginCurrentView !== 'preview' && markdownPluginCurrentIsMarkdownMode;
    const shouldHideScrollGutterForMarkdownMode = isMarkdownModeExperimentEnabled && markdownPluginCurrentIsMarkdownMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": $b165f8ba5e312426$export$81adcdb8b9fca1f7,
        ref: containerRef,
        className: (0, $gMc0m.default)([
            $b165f8ba5e312426$var$compiledStyles.contentAreaNew,
            props.isEditorToolbarHidden && $b165f8ba5e312426$var$compiledStyles.contentAreaHeightNoToolbar
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": $b165f8ba5e312426$export$5c151fe82051a1a7,
        "data-editor-container": 'true',
        className: (0, $gMc0m.default)([
            $b165f8ba5e312426$var$compiledStyles.contentAreaWrapper,
            shouldHideProseMirrorForMarkdownMode && $b165f8ba5e312426$var$compiledStyles.markdownModeContainerBackgroundStyle
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $axOCf.default // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ), {
        className: "fabric-editor-popup-scroll-parent",
        featureFlags: props.featureFlags,
        ref: scrollContainerRef,
        viewMode: props?.viewMode,
        isScrollable: true,
        appearance: props.appearance,
        contentMode: props.contentMode,
        useStandardNodeWidth: useStandardNodeWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXpLO.ClickAreaBlock), {
        editorView: props.editorView,
        editorDisabled: props.disabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-markdown-mode-hide-prosemirror": shouldHideProseMirrorForMarkdownMode ? 'true' : undefined,
        "data-markdown-mode-hide-scroll-gutter": shouldHideScrollGutterForMarkdownMode ? 'true' : undefined,
        style: {
            '--ak-editor-content-area-max-width': `${contentAreaMaxWidth}px`
        },
        className: (0, $gMc0m.default)([
            $b165f8ba5e312426$var$compiledStyles.editorContentAreaNew,
            $b165f8ba5e312426$var$compiledStyles.editorContentAreaProsemirrorStyle,
            shouldHideProseMirrorForMarkdownMode && $b165f8ba5e312426$var$compiledStyles.hideEditorContentAreaProsemirrorWithAttributeStyle,
            shouldHideScrollGutterForMarkdownMode && $b165f8ba5e312426$var$compiledStyles.hideEditorContentAreaScrollGutterWithAttributeStyle,
            shouldHideProseMirrorForMarkdownMode && $b165f8ba5e312426$var$compiledStyles.markdownModeContentAreaStyle,
            $b165f8ba5e312426$var$compiledStyles.tableFullPageEditorStylesNew,
            $b165f8ba5e312426$var$compiledStyles.fullWidthNonChromelessBreakoutBlockTableStyle,
            (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_breakout_resizing', 'isEnabled', true) ? $b165f8ba5e312426$var$compiledStyles.editorContentAreaContainerStyleExcludeCodeBlockNew : $b165f8ba5e312426$var$compiledStyles.editorContentAreaContainerStyleNew,
            (0, $g9Jfe.fg)('platform_editor_nested_dnd_styles_changes') && $b165f8ba5e312426$var$compiledStyles.editorContentAreaContainerNestedDndStyle,
            "ak-editor-content-area-region"
        ]),
        "data-editor-editable-content": true,
        role: "region",
        "aria-label": props.intl.formatMessage((0, $8aWkM.messages).editableContentLabel),
        ref: contentAreaRef,
        "data-vc": "editor-content-area-region"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            $b165f8ba5e312426$var$compiledStyles.editorContentGutterStyles,
            (0, $g9Jfe.fg)('platform_editor_controls_increase_full_page_gutter') && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && $b165f8ba5e312426$var$compiledStyles.editorContentGutterStyleFG,
            (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
                exposure: true
            }) && $b165f8ba5e312426$var$compiledStyles.editorContentReducedGutterStyles,
            (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('ak-editor-content-area', 'appearance-full-page', {
                'fabric-editor--full-width-mode': fullWidthMode,
                'fabric-editor--max-width-mode': Boolean(maxWidthMode)
            })
        ]),
        ref: contentAreaRef
    }, !!props.customContentComponents && 'before' in props.customContentComponents ? (0, $45E6y.contentComponentClickWrapper)(props.customContentComponents.before) : (0, $45E6y.contentComponentClickWrapper)(props.customContentComponents), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3ae8F.default), {
        editorView: props.editorView,
        editorActions: props.editorActions,
        eventDispatcher: props.eventDispatcher,
        providerFactory: props.providerFactory,
        appearance: props.appearance,
        items: props.contentComponents,
        pluginHooks: props.pluginHooks,
        contentArea: contentAreaRef.current ?? undefined,
        popupsMountPoint: props.popupsMountPoint,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsScrollableElement: props.popupsScrollableElement,
        disabled: !!props.disabled,
        containerElement: scrollContainerRef.current,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        wrapperElement: props.wrapperElement
    }), props.editorDOMElement, !!props.customContentComponents && 'after' in props.customContentComponents ? (0, $45E6y.contentComponentClickWrapper)(props.customContentComponents.after) : null, allowScrollGutter && ((0, $iu6m9.editorExperiment)('platform_editor_blocks', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        id: "editor-scroll-gutter",
        style: {
            paddingBottom: `${allowScrollGutter.gutterSize ?? '120'}px`
        },
        "data-vc": "scroll-gutter",
        "data-editor-scroll-gutter": "true",
        className: (0, $gMc0m.default)([
            shouldHideScrollGutterForMarkdownMode && $b165f8ba5e312426$var$compiledStyles.hideEditorScrollGutterStyle
        ])
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        id: "editor-scroll-gutter",
        style: {
            paddingBottom: `${allowScrollGutter.gutterSize ?? '120'}px`
        },
        "data-vc": "scroll-gutter",
        className: (0, $gMc0m.default)([
            shouldHideScrollGutterForMarkdownMode && $b165f8ba5e312426$var$compiledStyles.hideEditorScrollGutterStyle
        ])
    }))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $b165f8ba5e312426$var$compiledStyles.sidebarArea
        ])
    }, props.contextPanel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auRzv.ContextPanel), {
        editorAPI: props.editorAPI,
        visible: false
    })));
});
const $b165f8ba5e312426$export$776d816c3b1a9691 = (0, $aXWIB.injectIntl)($b165f8ba5e312426$var$Content, {
    forwardRef: true
});


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 





var $6dGgK = parcelRequire("6dGgK");








var $gClzS = parcelRequire("gClzS");

var $cXZ4C = parcelRequire("cXZ4C");






































function $8c8b3abb735ead62$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8c8b3abb735ead62$var$akEditorFullWidthLayoutWidth = 1800;
const $8c8b3abb735ead62$var$akEditorUltraWideLayoutWidth = 4000;
const $8c8b3abb735ead62$var$akEditorSwoopCubicBezier = `cubic-bezier(0.15, 1, 0.3, 1)`;
const $8c8b3abb735ead62$var$tableMarginFullWidthMode = 2;
const $8c8b3abb735ead62$var$akLayoutGutterOffset = 12;
const $8c8b3abb735ead62$var$SWOOP_ANIMATION = `0.5s ${$8c8b3abb735ead62$var$akEditorSwoopCubicBezier}`;
const $8c8b3abb735ead62$var$AK_NESTED_DND_GUTTER_OFFSET = 8;
const $8c8b3abb735ead62$var$getTotalPadding = ()=>(0, $aFUXX.akEditorGutterPaddingDynamic)() * 2;
const $8c8b3abb735ead62$var$editorContentAreaProsemirrorStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& .ProseMirror': {
        flexGrow: 1,
        boxSizing: 'border-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > *': {
            clear: 'both'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`> p, > ul, > ol:not(${0, $cXZ4C.taskListSelector}):not(${0, $gClzS.decisionListSelector}), > h1, > h2, > h3, > h4, > h5, > h6`]: {
            clear: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '> p:last-child': {
            marginBottom: "var(--ds-space-300, 24px)"
        }
    }
}); /*
     EDITOR-7249: Scope to the main editor's ProseMirror (direct child) so nested
     editors like the footer page-comment composer aren't hidden in Syntax view.
    */ 
const $8c8b3abb735ead62$var$hideEditorContentAreaProsemirrorWithAttributeStyle = {
    name: "1q5kzop",
    styles: "&[data-markdown-mode-hide-prosemirror=\"true\"] > .ak-editor-content-area > .ProseMirror{display:none;}"
};
const $8c8b3abb735ead62$var$hideEditorContentAreaScrollGutterWithAttributeStyle = {
    name: "1aax7yz",
    styles: "&[data-markdown-mode-hide-scroll-gutter=\"true\"] > .ak-editor-content-area > [data-vc=\"scroll-gutter\"]{display:none;}"
};
const $8c8b3abb735ead62$var$hideEditorScrollGutterStyle = {
    name: "eivff4",
    styles: "display:none"
};
const $8c8b3abb735ead62$var$fullWidthNonChromelessBreakoutBlockTableStyle = {
    name: "bywn89",
    styles: ".fabric-editor--full-width-mode:not(:has(#chromeless-editor)){.fabric-editor-breakout-mark, .extension-container.block, .pm-table-container{width:100% !important;}.fabric-editor-breakout-mark{margin-left:unset !important;transform:none !important;}}"
}; // new styles
const $8c8b3abb735ead62$var$editorContentAreaNew = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '24px',
    paddingTop: "var(--ds-space-600, 48px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.ak-editor-content-area-no-toolbar &': {
        // When the toolbar is hidden, we don't want content to jump up
        // the extra 1px is to account for the border on the toolbar
        paddingTop: `calc(${"var(--ds-space-600, 48px)"} + var(--ak-editor-fullpage-toolbar-height) + 1px)`
    },
    paddingBottom: "var(--ds-space-600, 48px)",
    height: 'calc( 100% - 105px )',
    width: '100%',
    margin: 'auto',
    flexDirection: 'column',
    flexGrow: 1,
    maxWidth: 'var(--ak-editor-content-area-max-width)',
    transition: `max-width ${$8c8b3abb735ead62$var$SWOOP_ANIMATION}`
});
const $8c8b3abb735ead62$var$tableFullPageEditorStylesNew = {
    name: "1h9cr7f",
    styles: ".ProseMirror .pm-table-wrapper > table{margin-left:0;margin-right:-1px;width:100%;}"
};
const $8c8b3abb735ead62$var$editorContentAreaContainerNestedDndStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.fabric-editor--full-width-mode': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            maxWidth: `calc(100% + ${($8c8b3abb735ead62$var$akLayoutGutterOffset + $8c8b3abb735ead62$var$AK_NESTED_DND_GUTTER_OFFSET) * 2}px)`
        }
    }
}); /* Prevent horizontal scroll on page in full width mode */ 
const $8c8b3abb735ead62$var$editorContentAreaContainerStyleExcludeCodeBlockNew = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.fabric-editor--full-width-mode': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.extension-container, .multiBodiedExtension--container': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            maxWidth: `calc(100% - ${$8c8b3abb735ead62$var$tableMarginFullWidthMode * 2}px)`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.extension-container.inline': {
            maxWidth: '100%'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        'td .extension-container.inline': {
            maxWidth: 'inherit'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '[data-layout-section]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            maxWidth: `calc(100% + ${$8c8b3abb735ead62$var$akLayoutGutterOffset * 2}px)`
        }
    }
}); /* Prevent horizontal scroll on page in full width mode */ 
const $8c8b3abb735ead62$var$editorContentAreaContainerStyleNew = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.fabric-editor--full-width-mode': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.code-block, .extension-container, .multiBodiedExtension--container': {
            maxWidth: `calc(100% - ${$8c8b3abb735ead62$var$tableMarginFullWidthMode * 2}px)`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.extension-container.inline': {
            maxWidth: '100%'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        'td .extension-container.inline': {
            maxWidth: 'inherit'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '[data-layout-section]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            maxWidth: `calc(100% + ${$8c8b3abb735ead62$var$akLayoutGutterOffset * 2}px)`
        }
    }
});
const $8c8b3abb735ead62$var$editorContentGutterStyleFG = {
    name: "56lgh2",
    styles: "padding:0 72px"
};
const $8c8b3abb735ead62$var$editorContentGutterStyles = {
    name: "1h0el6e",
    styles: "box-sizing:border-box;padding:0 52px"
};
const $8c8b3abb735ead62$var$editorContentReducedGutterStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    [`@container editor-area (max-width: ${0, $aFUXX.akEditorFullPageNarrowBreakout}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: `0 ${(0, $aFUXX.akEditorGutterPaddingReduced)}px`
    }
});
const $8c8b3abb735ead62$var$contentAreaNew = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'flex',
    flexDirection: 'row',
    height: `calc(100% - var(--ak-editor-fullpage-toolbar-height))`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    '&.ak-editor-content-area-no-toolbar': {
        // The editor toolbar height is 1px off (from the border) -- so we need to add 1px to the height
        // to match the toolbar height
        height: `calc(100% + 1px)`
    },
    boxSizing: 'border-box',
    margin: 0,
    padding: 0,
    transition: `padding 0ms ${$8c8b3abb735ead62$var$akEditorSwoopCubicBezier}`
});
const $8c8b3abb735ead62$var$contentAreaHeightNoToolbar = {
    name: "13udsys",
    styles: "height:100%"
}; // When the markdown source view is shown (markdown mode toggled on and not in
// the WYSIWYG "preview" view) we tint the whole editor container with the
// sunken surface so the source editor reads as a distinct, inset surface.
const $8c8b3abb735ead62$var$markdownModeContainerBackgroundStyle = {
    name: "1r5xjsv",
    styles: "background-color:var(--ds-surface-sunken, #F8F8F8);& [data-editor-scroll-container=\"true\"]{overflow-y:hidden;}"
};
const $8c8b3abb735ead62$var$markdownModeContentAreaStyle = {
    name: "eecls",
    styles: "box-sizing:border-box;height:100%;margin:0;max-width:none;min-width:0;padding-bottom:0;padding-top:0;width:100%;> .ak-editor-content-area{box-sizing:border-box;display:flex;flex-direction:column;height:100%;min-height:0;min-width:0;padding:0;width:100%;}> .ak-editor-content-area > [data-testid=\"plugins-components-wrapper\"]{display:flex;flex:1 1 auto;min-height:0;min-width:0;width:100%;}"
};
const $8c8b3abb735ead62$export$81adcdb8b9fca1f7 = 'ak-editor-fp-content-area'; // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $8c8b3abb735ead62$export$5c151fe82051a1a7 = 'ak-editor-container';
const $8c8b3abb735ead62$var$Content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((props, ref)=>{
    const theme = (0, $6dGgK.u)();
    const fullWidthMode = props.appearance === 'full-width';
    const maxWidthMode = props.appearance === 'max';
    const scrollContainerRef = (0, $42omo.useRef)(null);
    const contentAreaRef = (0, $42omo.useRef)(null);
    const containerRef = (0, $42omo.useRef)(null);
    const allowScrollGutter = props.editorAPI?.base?.sharedState.currentState()?.allowScrollGutter;
    const contentAreaMaxWidth = $8c8b3abb735ead62$var$getTotalPadding() + (!fullWidthMode ? maxWidthMode ? $8c8b3abb735ead62$var$akEditorUltraWideLayoutWidth : (0, $1oCLl.expValEquals)('platform_editor_core_non_ecc_static_css', 'isEnabled', true) || (0, $1oCLl.expValEquals)('platform_editor_core_static_css', 'isEnabled', true) ? (0, $aFUXX.akEditorDefaultLayoutWidth) : theme.layoutMaxWidth : $8c8b3abb735ead62$var$akEditorFullWidthLayoutWidth); // Get useStandardNodeWidth from block menu plugin shared state
    // Only access editorAPI when the experiment is enabled to avoid performance impact
    const useStandardNodeWidth = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && (props.editorAPI?.blockMenu?.sharedState?.currentState()?.useStandardNodeWidth ?? false);
    (0, $42omo.useImperativeHandle)(ref, ()=>({
            get scrollContainer () {
                return scrollContainerRef.current;
            },
            get contentArea () {
                return contentAreaRef.current;
            },
            get containerArea () {
                return containerRef.current;
            }
        }), []);
    const markdownPluginCurrentView = (0, $eiA8Z.useSharedPluginStateWithSelector)(props.editorAPI, [
        'markdownMode'
    ], (states)=>states.markdownModeState?.view);
    const markdownPluginCurrentIsMarkdownMode = (0, $eiA8Z.useSharedPluginStateWithSelector)(props.editorAPI, [
        'markdownMode'
    ], (states)=>states.markdownModeState?.isMarkdownMode);
    const isMarkdownModeExperimentEnabled = (0, $dZ8uq.expValEqualsNoExposure)('cc-markdown-mode', 'isEnabled', true);
    const shouldHideProseMirrorForMarkdownMode = isMarkdownModeExperimentEnabled && markdownPluginCurrentView !== 'preview' && markdownPluginCurrentIsMarkdownMode;
    const shouldHideScrollGutterForMarkdownMode = isMarkdownModeExperimentEnabled && markdownPluginCurrentIsMarkdownMode;
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            $8c8b3abb735ead62$var$contentAreaNew,
            props.isEditorToolbarHidden && $8c8b3abb735ead62$var$contentAreaHeightNoToolbar
        ],
        "data-testid": $8c8b3abb735ead62$export$81adcdb8b9fca1f7,
        ref: containerRef
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $3dfe29ddb16847ad$export$484266f72d7ebbab),
            shouldHideProseMirrorForMarkdownMode && $8c8b3abb735ead62$var$markdownModeContainerBackgroundStyle
        ],
        "data-testid": $8c8b3abb735ead62$export$5c151fe82051a1a7,
        "data-editor-container": 'true'
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $axOCf.default // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ), {
        className: "fabric-editor-popup-scroll-parent",
        featureFlags: props.featureFlags,
        ref: scrollContainerRef,
        viewMode: props?.viewMode,
        isScrollable: true,
        appearance: props.appearance,
        contentMode: props.contentMode,
        useStandardNodeWidth: useStandardNodeWidth
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $kXpLO.default), {
        editorView: props.editorView,
        editorDisabled: props.disabled
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "data-markdown-mode-hide-prosemirror": shouldHideProseMirrorForMarkdownMode ? 'true' : undefined,
        "data-markdown-mode-hide-scroll-gutter": shouldHideScrollGutterForMarkdownMode ? 'true' : undefined,
        css: [
            $8c8b3abb735ead62$var$editorContentAreaNew,
            $8c8b3abb735ead62$var$editorContentAreaProsemirrorStyle,
            // EDITOR-6558: hide ProseMirror when the markdown-mode plugin
            // reports a non-WYSIWYG view.
            shouldHideProseMirrorForMarkdownMode && $8c8b3abb735ead62$var$hideEditorContentAreaProsemirrorWithAttributeStyle,
            shouldHideScrollGutterForMarkdownMode && $8c8b3abb735ead62$var$hideEditorContentAreaScrollGutterWithAttributeStyle,
            shouldHideProseMirrorForMarkdownMode && $8c8b3abb735ead62$var$markdownModeContentAreaStyle,
            $8c8b3abb735ead62$var$tableFullPageEditorStylesNew,
            $8c8b3abb735ead62$var$fullWidthNonChromelessBreakoutBlockTableStyle,
            // for breakout resizing, there's no need to restrict the width of codeblocks as they're always wrapped in a breakout mark
            (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_breakout_resizing', 'isEnabled', true) ? $8c8b3abb735ead62$var$editorContentAreaContainerStyleExcludeCodeBlockNew : $8c8b3abb735ead62$var$editorContentAreaContainerStyleNew,
            (0, $g9Jfe.fg)('platform_editor_nested_dnd_styles_changes') && $8c8b3abb735ead62$var$editorContentAreaContainerNestedDndStyle
        ],
        style: {
            '--ak-editor-content-area-max-width': `${contentAreaMaxWidth}px`
        },
        className: "ak-editor-content-area-region",
        "data-editor-editable-content": true,
        role: "region",
        "aria-label": props.intl.formatMessage((0, $8aWkM.messages).editableContentLabel),
        ref: contentAreaRef,
        "data-vc": "editor-content-area-region"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            $8c8b3abb735ead62$var$editorContentGutterStyles,
            // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $g9Jfe.fg)('platform_editor_controls_increase_full_page_gutter') && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && $8c8b3abb735ead62$var$editorContentGutterStyleFG,
            (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
                exposure: true
            }) && $8c8b3abb735ead62$var$editorContentReducedGutterStyles
        ],
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('ak-editor-content-area', 'appearance-full-page', {
            'fabric-editor--full-width-mode': fullWidthMode,
            'fabric-editor--max-width-mode': Boolean(maxWidthMode)
        }),
        ref: contentAreaRef
    }, !!props.customContentComponents && 'before' in props.customContentComponents ? (0, $45E6y.contentComponentClickWrapper)(props.customContentComponents.before) : (0, $45E6y.contentComponentClickWrapper)(props.customContentComponents), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3ae8F.default), {
        editorView: props.editorView,
        editorActions: props.editorActions,
        eventDispatcher: props.eventDispatcher,
        providerFactory: props.providerFactory,
        appearance: props.appearance,
        items: props.contentComponents,
        pluginHooks: props.pluginHooks,
        contentArea: contentAreaRef.current ?? undefined,
        popupsMountPoint: props.popupsMountPoint,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsScrollableElement: props.popupsScrollableElement,
        disabled: !!props.disabled,
        containerElement: scrollContainerRef.current,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        wrapperElement: props.wrapperElement
    }), props.editorDOMElement, !!props.customContentComponents && 'after' in props.customContentComponents ? (0, $45E6y.contentComponentClickWrapper)(props.customContentComponents.after) : null, allowScrollGutter && ((0, $iu6m9.editorExperiment)('platform_editor_blocks', true) ? /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        id: "editor-scroll-gutter",
        css: shouldHideScrollGutterForMarkdownMode && $8c8b3abb735ead62$var$hideEditorScrollGutterStyle,
        style: {
            paddingBottom: `${allowScrollGutter.gutterSize ?? '120'}px`
        },
        "data-vc": "scroll-gutter",
        "data-editor-scroll-gutter": "true"
    }) : /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        id: "editor-scroll-gutter",
        css: shouldHideScrollGutterForMarkdownMode && $8c8b3abb735ead62$var$hideEditorScrollGutterStyle,
        style: {
            paddingBottom: `${allowScrollGutter.gutterSize ?? '120'}px`
        },
        "data-vc": "scroll-gutter"
    }))))))), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: (0, $3dfe29ddb16847ad$export$a838a71bfc839c1d)
    }, props.contextPanel || /*#__PURE__*/ (0, $9K4OG.jsx)((0, $auRzv.ContextPanel), {
        editorAPI: props.editorAPI,
        visible: false
    })));
});
const $8c8b3abb735ead62$export$272e13b0c66d0169 = (0, $aXWIB.injectIntl)($8c8b3abb735ead62$var$Content, {
    forwardRef: true
});


const $f148f84351b38b5e$export$81adcdb8b9fca1f7 = 'ak-editor-fp-content-area';
const $f148f84351b38b5e$export$5c151fe82051a1a7 = 'ak-editor-container';
const $f148f84351b38b5e$export$7db1e8e055ebd208 = (0, $9JpPs.componentWithCondition)(()=>(0, $1oCLl.expValEquals)('platform_editor_core_non_ecc_static_css', 'isEnabled', true), (0, $b165f8ba5e312426$export$776d816c3b1a9691), (0, $8c8b3abb735ead62$export$272e13b0c66d0169));





















var $5Gwdo = parcelRequire("5Gwdo");





var $9kMHa = parcelRequire("9kMHa");


var $1xxAs = parcelRequire("1xxAs");



















const $c56492ca893f1c41$var$styles = {
    beforePrimaryToolbarPluginWrapper: "_1e0c1txw _16jlkb7n _1bahesu3 _4cvr1h6o"
};
const $c56492ca893f1c41$export$25fbb719f83ec07a = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $gMc0m.default)([
            $c56492ca893f1c41$var$styles.beforePrimaryToolbarPluginWrapper
        ]);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props.beforePrimaryToolbarComponents) {
        t1 = /*#__PURE__*/ $42omo.createElement("div", {
            "data-testid": "before-primary-toolbar-components-plugin",
            className: t0
        }, props.beforePrimaryToolbarComponents);
        $[1] = props.beforePrimaryToolbarComponents;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ $42omo.createElement("div", {
        "data-testid": 'before-primary-toolbar-components-plugin',
        className: (0, $gMc0m.default)([
            $c56492ca893f1c41$var$styles.beforePrimaryToolbarPluginWrapper
        ])
    }, props.beforePrimaryToolbarComponents);


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /**
 * Emotion fallback branch of the `platform_editor_core_non_ecc_static_css` experiment.
 * Used via `componentWithCondition` in `BeforeWrapper.tsx`.
 *
 * Cleanup: delete this file once the experiment has shipped.
 */ 


function $1b09b826fd7d564f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1b09b826fd7d564f$var$beforePrimaryToolbarPluginWrapperStyles = {
    name: "ep0vx",
    styles: "display:flex;flex-grow:1;justify-content:flex-end;align-items:center"
};
const $1b09b826fd7d564f$export$5b210105ec3161aa = (props)=>/*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $1b09b826fd7d564f$var$beforePrimaryToolbarPluginWrapperStyles,
        "data-testid": 'before-primary-toolbar-components-plugin'
    }, props.beforePrimaryToolbarComponents);


const $6accd3fc044a700a$export$b41281e8d2acb8ab = (0, $9JpPs.componentWithCondition)(()=>(0, $1oCLl.expValEquals)('platform_editor_core_non_ecc_static_css', 'isEnabled', true), (0, $c56492ca893f1c41$export$25fbb719f83ec07a), (0, $1b09b826fd7d564f$export$5b210105ec3161aa));




















const $02b02a8454ef2cf5$var$firstChildStyles = {
    base: "_1e0c1txw _16jlkb7n",
    twoLine: "_u89dkb7n _9gudkb7n _1hoh1osq _8o3817qo _lhl4esu3 _1s2p1ns9"
};
const $02b02a8454ef2cf5$var$secondChildStyles = {
    base: "_1ul91ns9",
    twoLine: "_u89dkb7n _9gudkb7n _1hoh1osq _1tjb1wug _1rg31wug _1jzq1wug _cn5x1wug _87t41txw _8o3817qo _1s2pidpf"
}; // ---------------- First child wrapper ----------------
const $02b02a8454ef2cf5$export$2c0ded503b620548 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { twoLineEditorToolbar: twoLineEditorToolbar, children: children, role: role, "aria-label": ariaLabel, "data-testid": testId } = t0;
    const t1 = twoLineEditorToolbar && $02b02a8454ef2cf5$var$firstChildStyles.twoLine;
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $gMc0m.default)([
            $02b02a8454ef2cf5$var$firstChildStyles.base,
            t1
        ]);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== ariaLabel || $[3] !== children || $[4] !== role || $[5] !== t2 || $[6] !== testId) {
        t3 = /*#__PURE__*/ $42omo.createElement("div", {
            role: role,
            "aria-label": ariaLabel,
            "data-testid": testId,
            className: t2
        }, children);
        $[2] = ariaLabel;
        $[3] = children;
        $[4] = role;
        $[5] = t2;
        $[6] = testId;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ twoLineEditorToolbar: twoLineEditorToolbar, children: children, role: role, 'aria-label': ariaLabel, 'data-testid': testId })=>/*#__PURE__*/ $42omo.createElement("div", {
        role: role,
        "aria-label": ariaLabel,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            $02b02a8454ef2cf5$var$firstChildStyles.base,
            twoLineEditorToolbar && $02b02a8454ef2cf5$var$firstChildStyles.twoLine
        ])
    }, children); // ---------------- Second child wrapper ----------------
const $02b02a8454ef2cf5$export$e0d25e266e1f98e9 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { twoLineEditorToolbar: twoLineEditorToolbar, children: children, role: role, "aria-label": ariaLabel, "data-testid": testId } = t0;
    const t1 = twoLineEditorToolbar && $02b02a8454ef2cf5$var$secondChildStyles.twoLine;
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $gMc0m.default)([
            $02b02a8454ef2cf5$var$secondChildStyles.base,
            t1
        ]);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== ariaLabel || $[3] !== children || $[4] !== role || $[5] !== t2 || $[6] !== testId) {
        t3 = /*#__PURE__*/ $42omo.createElement("div", {
            role: role,
            "aria-label": ariaLabel,
            "data-testid": testId,
            className: t2
        }, children);
        $[2] = ariaLabel;
        $[3] = children;
        $[4] = role;
        $[5] = t2;
        $[6] = testId;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ twoLineEditorToolbar: twoLineEditorToolbar, children: children, role: role, 'aria-label': ariaLabel, 'data-testid': testId })=>/*#__PURE__*/ $42omo.createElement("div", {
        role: role,
        "aria-label": ariaLabel,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            $02b02a8454ef2cf5$var$secondChildStyles.base,
            twoLineEditorToolbar && $02b02a8454ef2cf5$var$secondChildStyles.twoLine
        ])
    }, children);


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /**
 * Emotion fallback branch of the `platform_editor_core_non_ecc_static_css` experiment.
 * Used via `componentWithCondition` in `CustomToolbarWrapper.tsx`.
 *
 * Cleanup: delete this file once the experiment has shipped.
 */ parcelRequire("42omo");




function $88b7ecfb7ff42c66$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Pre-computed static styles for first- and second-child wrappers.
// These contain no runtime logic and are safe for static-emotion mode.
const $88b7ecfb7ff42c66$var$firstChildStaticBase = {
    name: "5thnkd",
    styles: "display:flex;flex-grow:1"
};
// we can't avoid some kind of function call here, so we need to disable the rule
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $88b7ecfb7ff42c66$var$firstChildStaticTwoLine = {
    name: "125cgyn",
    styles: "@media (max-width: 868px){flex:1 1 100%;height:var(--ak-editor-fullpage-toolbar-height);justify-content:flex-end;min-width:fit-content;}"
};
const $88b7ecfb7ff42c66$var$secondChildStaticBase = {
    name: "g8017n",
    styles: "min-width:fit-content"
};
// we can't avoid some kind of function call here, so we need to disable the rule
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $88b7ecfb7ff42c66$var$secondChildStaticTwoLine = {
    name: "3psy",
    styles: "@media (max-width: 868px){display:flex;flex-grow:1;flex:1 1 100%;margin:auto;height:var(--ak-editor-fullpage-toolbar-height);min-width:0;}"
};
const $88b7ecfb7ff42c66$export$d2325359d397e0b2 = ({ twoLineEditorToolbar: twoLineEditorToolbar, children: children, role: role, 'aria-label': ariaLabel, 'data-testid': testId })=>/*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            $88b7ecfb7ff42c66$var$firstChildStaticBase,
            twoLineEditorToolbar && $88b7ecfb7ff42c66$var$firstChildStaticTwoLine
        ],
        role: role,
        "aria-label": ariaLabel,
        "data-testid": testId
    }, children);
const $88b7ecfb7ff42c66$export$d02bc47084c37572 = ({ twoLineEditorToolbar: twoLineEditorToolbar, children: children, role: role, 'aria-label': ariaLabel, 'data-testid': testId })=>/*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            $88b7ecfb7ff42c66$var$secondChildStaticBase,
            twoLineEditorToolbar && $88b7ecfb7ff42c66$var$secondChildStaticTwoLine
        ],
        role: role,
        "aria-label": ariaLabel,
        "data-testid": testId
    }, children);


const $e5e54ebad419265b$export$e9a48721664257fd = (0, $9JpPs.componentWithCondition)(()=>(0, $1oCLl.expValEquals)('platform_editor_core_non_ecc_static_css', 'isEnabled', true), (0, $02b02a8454ef2cf5$export$2c0ded503b620548), (0, $88b7ecfb7ff42c66$export$d2325359d397e0b2));
const $e5e54ebad419265b$export$c8150e2de9fece09 = (0, $9JpPs.componentWithCondition)(()=>(0, $1oCLl.expValEquals)('platform_editor_core_non_ecc_static_css', 'isEnabled', true), (0, $02b02a8454ef2cf5$export$e0d25e266e1f98e9), (0, $88b7ecfb7ff42c66$export$d02bc47084c37572));




















const $742fc465331bfa18$var$nonCustomToolbarWrapperCompiledStyles = {
    root: "_4cvr1h6o _1e0c1txw _16jlkb7n"
};
const $742fc465331bfa18$export$237e1ac09b615dbd = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $gMc0m.default)([
            $742fc465331bfa18$var$nonCustomToolbarWrapperCompiledStyles.root
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $742fc465331bfa18$var$nonCustomToolbarWrapperCompiledStyles.root
        ])
    }, children);
const $742fc465331bfa18$var$customToolbarWrapperCompiledStyles = {
    root: "_4cvr1h6o _1e0c1txw"
}; // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $742fc465331bfa18$export$cbddf074130aa75 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $gMc0m.default)([
            $742fc465331bfa18$var$customToolbarWrapperCompiledStyles.root
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $742fc465331bfa18$var$customToolbarWrapperCompiledStyles.root
        ])
    }, children);
const $742fc465331bfa18$var$mainToolbarIconBeforeCompiledStyles = {
    root: "_19pkpxbi _2hwxpxbi _otyrpxbi _18u0pxbi _4t3ixy5q _1bsbxy5q _mlgzkb7n _tuuhkb7n"
}; // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $742fc465331bfa18$export$fb3cf9f8d75e0584 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $gMc0m.default)([
            $742fc465331bfa18$var$mainToolbarIconBeforeCompiledStyles.root
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $742fc465331bfa18$var$mainToolbarIconBeforeCompiledStyles.root
        ])
    }, children);


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /**
* Emotion fallback branch of the `platform_editor_core_non_ecc_static_css` experiment.
* Used via `componentWithCondition` in `MainToolbar.tsx`.
*
* Cleanup: delete this file once the experiment has shipped.
*/ parcelRequire("42omo");







function $95fa7e0632393328$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $95fa7e0632393328$var$nonCustomToolbarWrapperEmotionStyles = {
    name: "t6ix9q",
    styles: "align-items:center;display:flex;flex-grow:1"
};
const $95fa7e0632393328$export$b15d6273b403900f = ({ children: children })=>/*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $95fa7e0632393328$var$nonCustomToolbarWrapperEmotionStyles
    }, children);
const $95fa7e0632393328$var$customToolbarWrapperEmotionStyles = {
    name: "1vr7vmn",
    styles: "align-items:center;display:flex"
}; // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $95fa7e0632393328$export$cae7d61e24bc118f = ({ children: children })=>/*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $95fa7e0632393328$var$customToolbarWrapperEmotionStyles
    }, children);
const $95fa7e0632393328$var$mainToolbarIconBeforeEmotionStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    margin: "var(--ds-space-200, 16px)",
    height: "var(--ds-space-400, 32px)",
    width: "var(--ds-space-400, 32px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${0, $aFUXX.akEditorMobileMaxWidth}px)`]: {
        gridColumn: 1,
        gridRow: 1
    }
}); // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $95fa7e0632393328$export$c648b69d467ee76 = ({ children: children })=>/*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $95fa7e0632393328$var$mainToolbarIconBeforeEmotionStyles
    }, children);


const $5f29b3bae3a18a45$export$d44d6319207b3004 = (0, $9JpPs.componentWithCondition)(()=>(0, $1oCLl.expValEquals)('platform_editor_core_non_ecc_static_css', 'isEnabled', true), (0, $742fc465331bfa18$export$cbddf074130aa75), (0, $95fa7e0632393328$export$cae7d61e24bc118f));


const $dec1329f8579fa72$export$f71dca5c73c8a7 = 868;










const $09ac5bf3ecb721e2$export$8889272e3d68acbb = (0, $9JpPs.componentWithCondition)(()=>(0, $1oCLl.expValEquals)('platform_editor_core_non_ecc_static_css', 'isEnabled', true), (0, $742fc465331bfa18$export$fb3cf9f8d75e0584), (0, $95fa7e0632393328$export$c648b69d467ee76));




















const $4b220ca2e5101bee$var$styles = {
    base: "_v56419ab _n7zlia51 _kqswh2mm _4cvr1h6o _16qsglyw _1pby16oo _1e0c1txw _4t3i17qo _1o9zidpf _bfhkvuon _1krdgrf3",
    flexibleIconSize: "_3pwj1osq",
    keyline: "_16qs1nax",
    twoLine: "_1s5v1g80 _8o38zpre"
};
const $4b220ca2e5101bee$export$112f93be337305c1 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { showKeyline: showKeyline, twoLineEditorToolbar: twoLineEditorToolbar, children: children, "data-testid": testId } = t0;
    const t1 = showKeyline && $4b220ca2e5101bee$var$styles.keyline;
    const t2 = twoLineEditorToolbar && $4b220ca2e5101bee$var$styles.twoLine;
    let t3;
    if ($[0] !== t1 || $[1] !== t2) {
        t3 = (0, $gMc0m.default)([
            $4b220ca2e5101bee$var$styles.base,
            $4b220ca2e5101bee$var$styles.flexibleIconSize,
            t1,
            t2
        ]);
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== children || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": testId,
            className: t3
        }, children);
        $[3] = children;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : ({ showKeyline: showKeyline, twoLineEditorToolbar: twoLineEditorToolbar, children: children, 'data-testid': testId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            $4b220ca2e5101bee$var$styles.base,
            $4b220ca2e5101bee$var$styles.flexibleIconSize,
            showKeyline && $4b220ca2e5101bee$var$styles.keyline,
            twoLineEditorToolbar && $4b220ca2e5101bee$var$styles.twoLine
        ])
    }, children);
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /**
* Emotion fallback branch of the `platform_editor_core_non_ecc_static_css` experiment.
* Used via `componentWithCondition` in `MainToolbarWrapper.tsx`.
*
* Cleanup: delete this file once the experiment has shipped.
*/ parcelRequire("42omo");








function $a2c09700cee72939$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a2c09700cee72939$var$baseToolbarStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    position: 'relative',
    alignItems: 'center',
    boxShadow: 'none',
    borderBottom: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `box-shadow 200ms ${(0, $aFUXX.akEditorSwoopCubicBezier)}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    zIndex: (0, $aFUXX.akEditorFloatingDialogZIndex),
    display: 'flex',
    height: 'var(--ak-editor-fullpage-toolbar-height)',
    flexShrink: 0,
    backgroundColor: "var(--ds-surface, #FFFFFF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& object': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        height: '0 !important'
    }
});
const $a2c09700cee72939$var$flexibleIconSize = {
    name: "1ymvw5b",
    styles: "& span svg{max-width:100%;}"
};
const $a2c09700cee72939$var$mainToolbarWithKeyline = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    boxShadow: `${"var(--ds-shadow-overflow, 0px 0px 8px #1E1F2128, 0px 0px 1px #1E1F211e)"}`
});
const $a2c09700cee72939$var$mainToolbarTwoLineStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${0, $dec1329f8579fa72$export$f71dca5c73c8a7}px)`]: {
        flexWrap: 'wrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `calc(var(--ak-editor-fullpage-toolbar-height) * 2)`
    }
});
const $a2c09700cee72939$export$2a90a9bbb1b4d6a3 = ({ showKeyline: showKeyline, twoLineEditorToolbar: twoLineEditorToolbar, children: children, 'data-testid': testId })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div" // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    , {
        css: [
            $a2c09700cee72939$var$baseToolbarStyles,
            $a2c09700cee72939$var$flexibleIconSize,
            showKeyline && $a2c09700cee72939$var$mainToolbarWithKeyline,
            twoLineEditorToolbar && $a2c09700cee72939$var$mainToolbarTwoLineStyle
        ],
        "data-testid": testId
    }, children);
};


const $ced7311cd1392a2e$export$9e3c8dcb351b94fd = (0, $9JpPs.componentWithCondition)(()=>(0, $1oCLl.expValEquals)('platform_editor_core_non_ecc_static_css', 'isEnabled', true), (0, $4b220ca2e5101bee$export$112f93be337305c1), (0, $a2c09700cee72939$export$2a90a9bbb1b4d6a3));










const $1926aaf693cd8354$export$c576cd6cf1d399bf = (0, $9JpPs.componentWithCondition)(()=>(0, $1oCLl.expValEquals)('platform_editor_core_non_ecc_static_css', 'isEnabled', true), (0, $742fc465331bfa18$export$237e1ac09b615dbd), (0, $95fa7e0632393328$export$b15d6273b403900f));


const $351b868f15072c21$export$477aaffea178bc4e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(49);
    const [shouldSplitToolbar, setShouldSplitToolbar] = (0, $42omo.useState)(false);
    const { editorAPI: editorAPI } = props;
    const twoLineEditorToolbar = (0, $iu6m9.editorExperiment)("platform_editor_controls", "variant1") ? !!props.customPrimaryToolbarComponents && props.primaryToolbarComponents?.length !== 0 : !!props.customPrimaryToolbarComponents;
    const { Portal: ToolbarPortal } = (0, $9kMHa.useToolbarPortal)() ?? {
        Portal: (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment
    };
    const hasToolbarPortal = ToolbarPortal !== (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment;
    const popupsMountPoint = hasToolbarPortal ? undefined : props.popupsMountPoint;
    let t0;
    if ($[0] !== props.beforeIcon) {
        t0 = props.beforeIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $09ac5bf3ecb721e2$export$8889272e3d68acbb), null, props.beforeIcon);
        $[0] = props.beforeIcon;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== popupsMountPoint || $[3] !== props.appearance || $[4] !== props.containerElement || $[5] !== props.disabled || $[6] !== props.dispatchAnalyticsEvent || $[7] !== props.editorActions || $[8] !== props.editorView || $[9] !== props.eventDispatcher || $[10] !== props.hasMinWidth || $[11] !== props.popupsBoundariesElement || $[12] !== props.popupsScrollableElement || $[13] !== props.primaryToolbarComponents || $[14] !== props.providerFactory || $[15] !== twoLineEditorToolbar) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1xxAs.ToolbarWithSizeDetector), {
            editorView: props.editorView,
            editorActions: props.editorActions,
            eventDispatcher: props.eventDispatcher,
            providerFactory: props.providerFactory,
            appearance: props.appearance,
            items: props.primaryToolbarComponents,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: props.popupsBoundariesElement,
            popupsScrollableElement: props.popupsScrollableElement,
            disabled: props.disabled,
            dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
            containerElement: props.containerElement,
            hasMinWidth: props.hasMinWidth,
            twoLineEditorToolbar: twoLineEditorToolbar
        });
        $[2] = popupsMountPoint;
        $[3] = props.appearance;
        $[4] = props.containerElement;
        $[5] = props.disabled;
        $[6] = props.dispatchAnalyticsEvent;
        $[7] = props.editorActions;
        $[8] = props.editorView;
        $[9] = props.eventDispatcher;
        $[10] = props.hasMinWidth;
        $[11] = props.popupsBoundariesElement;
        $[12] = props.popupsScrollableElement;
        $[13] = props.primaryToolbarComponents;
        $[14] = props.providerFactory;
        $[15] = twoLineEditorToolbar;
        $[16] = t1;
    } else t1 = $[16];
    let t2;
    if ($[17] !== t0 || $[18] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1926aaf693cd8354$export$c576cd6cf1d399bf), null, t0, t1);
        $[17] = t0;
        $[18] = t1;
        $[19] = t2;
    } else t2 = $[19];
    const nonCustomToolbar = t2;
    let t3;
    if ($[20] !== props.customPrimaryToolbarComponents) {
        t3 = !!props.customPrimaryToolbarComponents && "before" in props.customPrimaryToolbarComponents ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6accd3fc044a700a$export$b41281e8d2acb8ab), {
            beforePrimaryToolbarComponents: props.customPrimaryToolbarComponents?.before
        }) : null;
        $[20] = props.customPrimaryToolbarComponents;
        $[21] = t3;
    } else t3 = $[21];
    let t4;
    if ($[22] !== editorAPI?.findReplace || $[23] !== popupsMountPoint || $[24] !== props.containerElement || $[25] !== props.dispatchAnalyticsEvent || $[26] !== props.editorView || $[27] !== props.popupsBoundariesElement || $[28] !== props.popupsScrollableElement || $[29] !== twoLineEditorToolbar) {
        t4 = !(0, $iu6m9.editorExperiment)("platform_editor_controls", "variant1") && editorAPI?.findReplace && twoLineEditorToolbar ? editorAPI?.findReplace.actions.registerToolbarButton({
            popupsBoundariesElement: props.popupsBoundariesElement,
            popupsMountPoint: popupsMountPoint,
            popupsScrollableElement: props.popupsScrollableElement,
            editorView: props.editorView,
            containerElement: props.containerElement,
            dispatchAnalyticsEvent: props.dispatchAnalyticsEvent
        }) : null;
        $[22] = editorAPI?.findReplace;
        $[23] = popupsMountPoint;
        $[24] = props.containerElement;
        $[25] = props.dispatchAnalyticsEvent;
        $[26] = props.editorView;
        $[27] = props.popupsBoundariesElement;
        $[28] = props.popupsScrollableElement;
        $[29] = twoLineEditorToolbar;
        $[30] = t4;
    } else t4 = $[30];
    const t5 = !!props.customPrimaryToolbarComponents && "after" in props.customPrimaryToolbarComponents ? props.customPrimaryToolbarComponents.after : props.customPrimaryToolbarComponents;
    let t6;
    if ($[31] !== t3 || $[32] !== t4 || $[33] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5f29b3bae3a18a45$export$d44d6319207b3004), null, t3, t4, t5);
        $[31] = t3;
        $[32] = t4;
        $[33] = t5;
        $[34] = t6;
    } else t6 = $[34];
    const customToolbar = t6;
    let t7;
    if ($[35] !== twoLineEditorToolbar) {
        t7 = ()=>{
            if (twoLineEditorToolbar) {
                const updateOnResize = ()=>{
                    setShouldSplitToolbar(window.innerWidth <= (0, $dec1329f8579fa72$export$f71dca5c73c8a7));
                };
                window.addEventListener("resize", updateOnResize);
                updateOnResize();
                return ()=>window.removeEventListener("resize", updateOnResize);
            }
        };
        $[35] = twoLineEditorToolbar;
        $[36] = t7;
    } else t7 = $[36];
    (0, $42omo.useEffect)(t7);
    const isShortcutToFocusToolbar = $351b868f15072c21$var$_temp;
    let t8;
    if ($[37] !== props.editorView) {
        t8 = (event_0)=>{
            if (!props.editorView?.hasFocus()) props.editorView?.focus();
            event_0.preventDefault();
            event_0.stopPropagation();
        };
        $[37] = props.editorView;
        $[38] = t8;
    } else t8 = $[38];
    const handleEscape = t8;
    let t9;
    if ($[39] !== ToolbarPortal || $[40] !== customToolbar || $[41] !== handleEscape || $[42] !== nonCustomToolbar || $[43] !== props.editorView || $[44] !== props.intl || $[45] !== props.showKeyline || $[46] !== shouldSplitToolbar || $[47] !== twoLineEditorToolbar) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3bEAg.ContextPanelConsumer), null, (t10)=>{
            const { width: contextPanelWidth } = t10;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Gwdo.ToolbarArrowKeyNavigationProvider), {
                editorView: props.editorView,
                childComponentSelector: "[data-testid='ak-editor-main-toolbar']",
                isShortcutToFocusToolbar: isShortcutToFocusToolbar,
                handleEscape: handleEscape,
                intl: props.intl
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ToolbarPortal, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ced7311cd1392a2e$export$9e3c8dcb351b94fd), {
                showKeyline: props.showKeyline || contextPanelWidth > 0,
                twoLineEditorToolbar: twoLineEditorToolbar,
                "data-testid": "ak-editor-main-toolbar"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e5e54ebad419265b$export$e9a48721664257fd), {
                twoLineEditorToolbar: twoLineEditorToolbar,
                role: "toolbar",
                "aria-label": props.intl.formatMessage((0, $8aWkM.messages).toolbarLabel)
            }, shouldSplitToolbar ? customToolbar : nonCustomToolbar), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e5e54ebad419265b$export$c8150e2de9fece09), {
                twoLineEditorToolbar: twoLineEditorToolbar,
                "data-testid": "avatar-group-outside-plugin",
                role: "region",
                "aria-label": props.intl.formatMessage((0, $8aWkM.messages).pageActionsLabel)
            }, shouldSplitToolbar ? nonCustomToolbar : customToolbar), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9kMHa.ToolbarPortalMountPoint), null))));
        });
        $[39] = ToolbarPortal;
        $[40] = customToolbar;
        $[41] = handleEscape;
        $[42] = nonCustomToolbar;
        $[43] = props.editorView;
        $[44] = props.intl;
        $[45] = props.showKeyline;
        $[46] = shouldSplitToolbar;
        $[47] = twoLineEditorToolbar;
        $[48] = t9;
    } else t9 = $[48];
    return t9;
} : (props)=>{
    const [shouldSplitToolbar, setShouldSplitToolbar] = (0, $42omo.useState)(false);
    const { editorAPI: editorAPI } = props;
    // When primary toolbar components is undefined, do not show two line editor toolbar
    const twoLineEditorToolbar = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? !!props.customPrimaryToolbarComponents && props.primaryToolbarComponents?.length !== 0 : !!props.customPrimaryToolbarComponents;
    // When a toolbar portal context is provided, render the  toolbar inside a portal.
    // Otherwise fall back to a fragment just to avoid forking rendering logic.
    const { Portal: ToolbarPortal } = (0, $9kMHa.useToolbarPortal)() ?? {
        Portal: (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment
    };
    const hasToolbarPortal = ToolbarPortal !== (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment;
    const popupsMountPoint = hasToolbarPortal ? undefined : props.popupsMountPoint;
    const nonCustomToolbar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1926aaf693cd8354$export$c576cd6cf1d399bf), null, props.beforeIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $09ac5bf3ecb721e2$export$8889272e3d68acbb), null, props.beforeIcon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1xxAs.ToolbarWithSizeDetector), {
        editorView: props.editorView,
        editorActions: props.editorActions,
        eventDispatcher: props.eventDispatcher,
        providerFactory: props.providerFactory,
        appearance: props.appearance,
        items: props.primaryToolbarComponents,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsScrollableElement: props.popupsScrollableElement,
        disabled: props.disabled,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        containerElement: props.containerElement,
        hasMinWidth: props.hasMinWidth,
        twoLineEditorToolbar: twoLineEditorToolbar
    }));
    const customToolbar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5f29b3bae3a18a45$export$d44d6319207b3004), null, !!props.customPrimaryToolbarComponents && 'before' in props.customPrimaryToolbarComponents ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6accd3fc044a700a$export$b41281e8d2acb8ab), {
        beforePrimaryToolbarComponents: props.customPrimaryToolbarComponents?.before
    }) : null, !(0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && editorAPI?.findReplace && twoLineEditorToolbar ? editorAPI?.findReplace.actions.registerToolbarButton({
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsMountPoint: popupsMountPoint,
        popupsScrollableElement: props.popupsScrollableElement,
        editorView: props.editorView,
        containerElement: props.containerElement,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent
    }) : null, !!props.customPrimaryToolbarComponents && 'after' in props.customPrimaryToolbarComponents ? props.customPrimaryToolbarComponents.after : props.customPrimaryToolbarComponents);
    (0, $42omo.useEffect)(()=>{
        if (twoLineEditorToolbar) {
            const updateOnResize = ()=>{
                setShouldSplitToolbar(window.innerWidth <= (0, $dec1329f8579fa72$export$f71dca5c73c8a7));
            };
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.addEventListener('resize', updateOnResize);
            updateOnResize();
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            return ()=>window.removeEventListener('resize', updateOnResize);
        }
    });
    const isShortcutToFocusToolbar = (0, $42omo.useCallback)((event)=>{
        //Alt + F9 to reach first element in this main toolbar
        return event.altKey && (event.key === 'F9' || event.keyCode === 120);
    }, []);
    const handleEscape = (0, $42omo.useCallback)((event_0)=>{
        if (!props.editorView?.hasFocus()) props.editorView?.focus();
        event_0.preventDefault();
        event_0.stopPropagation();
    }, [
        props.editorView
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3bEAg.ContextPanelConsumer), null, ({ width: contextPanelWidth })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Gwdo.ToolbarArrowKeyNavigationProvider), {
            editorView: props.editorView,
            childComponentSelector: "[data-testid='ak-editor-main-toolbar']",
            isShortcutToFocusToolbar: isShortcutToFocusToolbar,
            handleEscape: handleEscape,
            intl: props.intl
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ToolbarPortal, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ced7311cd1392a2e$export$9e3c8dcb351b94fd), {
            showKeyline: props.showKeyline || contextPanelWidth > 0,
            twoLineEditorToolbar: twoLineEditorToolbar,
            "data-testid": "ak-editor-main-toolbar"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e5e54ebad419265b$export$e9a48721664257fd), {
            twoLineEditorToolbar: twoLineEditorToolbar,
            role: "toolbar",
            "aria-label": props.intl.formatMessage((0, $8aWkM.messages).toolbarLabel)
        }, shouldSplitToolbar ? customToolbar : nonCustomToolbar), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e5e54ebad419265b$export$c8150e2de9fece09), {
            twoLineEditorToolbar: twoLineEditorToolbar,
            "data-testid": "avatar-group-outside-plugin",
            role: "region",
            "aria-label": props.intl.formatMessage((0, $8aWkM.messages).pageActionsLabel)
        }, shouldSplitToolbar ? nonCustomToolbar : customToolbar), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9kMHa.ToolbarPortalMountPoint), null)))));
});
const $351b868f15072c21$export$26f3f0e30f9545b4 = (0, $aXWIB.injectIntl)($351b868f15072c21$export$477aaffea178bc4e);
function $351b868f15072c21$var$_temp(event) {
    return event.altKey && (event.key === "F9" || event.keyCode === 120);
}





















var $eTj7Y = parcelRequire("eTj7Y");




const $4d5734bc1dd005e3$export$2b04a2c5fbfbfe6c = (contextualFormattingEnabled, toolbarDockingPosition)=>{
    if (contextualFormattingEnabled === 'controlled') return toolbarDockingPosition !== 'none';
    if (contextualFormattingEnabled === 'always-pinned') return true;
    return false;
};


var $cPCP8 = parcelRequire("cPCP8");











var $5ZzFz = parcelRequire("5ZzFz");













/**
 * ExcludeFromHydration component delays rendering of its children until after the initial
 * hydration phase. It renders the fallback during SSR/hydration and children after.
 * @param children - The content to render after hydration
 * @param fallback - Optional fallback content to render during hydration (e.g., a placeholder to prevent layout shift)
 * @returns
 */ const $8be08ecc0f0fb8a8$var$ExcludeFromHydration = (0, $4pOgL.isReactCompilerActivePlatform)() ? function ExcludeFromHydration(t0) {
    const $ = (0, $frIzR.c)(2);
    const { children: children, fallback: t1 } = t0;
    const fallback = t1 === undefined ? null : t1;
    const [shouldRender, setShouldRender] = (0, $42omo.useState)(false);
    let t2;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            if ((0, $eTj7Y.isSSR)()) return;
            setShouldRender(true);
        };
        t3 = [];
        $[0] = t2;
        $[1] = t3;
    } else {
        t2 = $[0];
        t3 = $[1];
    }
    (0, $42omo.useEffect)(t2, t3);
    if (!shouldRender) return fallback ?? null;
    return children;
} : function ExcludeFromHydration({ children: children, fallback: fallback = null }) {
    const [shouldRender, setShouldRender] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if ((0, $eTj7Y.isSSR)()) return;
        setShouldRender(true);
    }, []);
    if (!shouldRender) return fallback ?? null;
    return children;
};
var $8be08ecc0f0fb8a8$export$2e2bcd8739ae039 = $8be08ecc0f0fb8a8$var$ExcludeFromHydration;



var $eUp7e = parcelRequire("eUp7e");




const $2c1c1320beb5acd3$var$styles = {
    mainToolbarIconBefore: "_19pkpxbi _2hwxpxbi _otyrpxbi",
    mainToolbarIconBeforeNew: "_4cvr1h6o _1e0c1txw",
    mainToolbarWrapper: "_1rjc12x7 _18zrutpp _n7zlia51",
    mainToolbarNew: "_1e0c1txw _4t3izwfg",
    mainToolbarZIndex: "_1pby16oo _kqswh2mm",
    mainToolbarWithKeyline: "_16qs1nax",
    customToolbarWrapperStyle: "_4cvr1h6o _1e0c1txw",
    firstChildWrapperOneLine: "_1e0c1txw _16jlkb7n",
    firstChildWrapperContainerContext: "_7cca15wb _1f38ptqj",
    secondChildWrapperOneLine: "_1e0c1txw _1ul91ns9 _4cvr1h6o",
    beforePrimaryToolbarComponents: "_1e0c1txw _16jlkb7n _1bahesu3 _4cvr1h6o",
    backgroundColor: "_bfhkvuon"
};
const $2c1c1320beb5acd3$var$MainToolbarWrapper = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { children: children, testId: testId, showKeyline: showKeyline } = t0;
    const t1 = showKeyline && $2c1c1320beb5acd3$var$styles.mainToolbarWithKeyline;
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $gMc0m.default)([
            $2c1c1320beb5acd3$var$styles.mainToolbarWrapper,
            t1,
            $2c1c1320beb5acd3$var$styles.mainToolbarZIndex,
            $2c1c1320beb5acd3$var$styles.mainToolbarNew,
            (0, $1oCLl.expValEquals)("platform_editor_table_sticky_header_improvements", "cohort", "test_with_overflow") && $2c1c1320beb5acd3$var$styles.backgroundColor
        ]);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== children || $[3] !== t2 || $[4] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": testId,
            className: t2
        }, children);
        $[2] = children;
        $[3] = t2;
        $[4] = testId;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ({ children: children, testId: testId, showKeyline: showKeyline })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            $2c1c1320beb5acd3$var$styles.mainToolbarWrapper,
            showKeyline && $2c1c1320beb5acd3$var$styles.mainToolbarWithKeyline,
            $2c1c1320beb5acd3$var$styles.mainToolbarZIndex,
            $2c1c1320beb5acd3$var$styles.mainToolbarNew,
            (0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && $2c1c1320beb5acd3$var$styles.backgroundColor
        ])
    }, children);
};
const $2c1c1320beb5acd3$var$FirstChildWrapper = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $gMc0m.default)([
            $2c1c1320beb5acd3$var$styles.firstChildWrapperOneLine,
            $2c1c1320beb5acd3$var$styles.firstChildWrapperContainerContext
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "main-toolbar-first-child-wrapper",
            className: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "main-toolbar-first-child-wrapper",
        className: (0, $gMc0m.default)([
            $2c1c1320beb5acd3$var$styles.firstChildWrapperOneLine,
            $2c1c1320beb5acd3$var$styles.firstChildWrapperContainerContext
        ])
    }, children);
};
const $2c1c1320beb5acd3$var$SecondChildWrapper = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $gMc0m.default)([
            $2c1c1320beb5acd3$var$styles.secondChildWrapperOneLine
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "main-toolbar-second-child-wrapper",
            className: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "main-toolbar-second-child-wrapper",
        className: (0, $gMc0m.default)([
            $2c1c1320beb5acd3$var$styles.secondChildWrapperOneLine
        ])
    }, children);
};
const $2c1c1320beb5acd3$var$shouldShowToolbarContainer = (toolbar, customPrimaryToolbarComponents)=>{
    return !!toolbar || !!customPrimaryToolbarComponents;
};
const $2c1c1320beb5acd3$var$getToolbarComponentsForMarkdownView = (components, markdownModeView, isConvertedMarkdownPreview)=>{
    if (markdownModeView === 'syntax' || markdownModeView === 'preview') {
        // Converted markdown live pages in preview should show full toolbar content
        // so preference-based docking can work consistently.
        if (isConvertedMarkdownPreview) return components;
        return components.filter((component)=>component.key === (0, $cPCP8.TOOLBARS).PRIMARY_TOOLBAR || component.key === (0, $cPCP8.VIEW_MODE_TOGGLE_SECTION).key);
    }
    return components;
};
const $2c1c1320beb5acd3$export$9f4aa6ea8358228b = ({ editorAPI: editorAPI, beforeIcon: beforeIcon, toolbarDockingPosition: toolbarDockingPosition, editorView: editorView, popupsMountPoint: popupsMountPoint, showKeyline: showKeyline, customPrimaryToolbarComponents: customPrimaryToolbarComponents, disabled: disabled, disabledWithoutInteractionLogic: disabledWithoutInteractionLogic })=>{
    const components = editorAPI?.toolbar?.actions.getComponents();
    const runtimeOverride = (0, $eiA8Z.useSharedPluginStateWithSelector)(editorAPI, [
        'toolbar'
    ], (states)=>states.toolbarState?.contextualFormattingModeOverride);
    const contextualFormattingEnabled = runtimeOverride ?? editorAPI?.toolbar?.actions.contextualFormattingMode();
    const markdownModeState = (0, $eiA8Z.useSharedPluginStateWithSelector)(editorAPI, [
        'markdownMode'
    ], (states_0)=>states_0.markdownModeState);
    const isLivePage = markdownModeState?.isLivePage;
    const isMarkdownMode = markdownModeState?.isMarkdownMode;
    const markdownModeView = markdownModeState?.view;
    const isConvertedMarkdownPreview = isMarkdownMode === true && isLivePage === true && markdownModeView === 'preview' && (0, $g9Jfe.fg)('platform_editor_markdown_patch_m3');
    const intl = (0, $aXWIB.useIntl)();
    const toolbar = components?.find((component)=>component.key === (0, $cPCP8.TOOLBARS).PRIMARY_TOOLBAR);
    const visibleToolbarComponents = (0, $42omo.useMemo)(()=>components ? $2c1c1320beb5acd3$var$getToolbarComponentsForMarkdownView(components, markdownModeView, isConvertedMarkdownPreview) : undefined, [
        components,
        markdownModeView,
        isConvertedMarkdownPreview
    ]);
    const effectiveContextualFormattingEnabled = isConvertedMarkdownPreview && contextualFormattingEnabled === 'always-pinned' ? 'controlled' : contextualFormattingEnabled;
    const primaryToolbarDockingConfigEnabled = (0, $4d5734bc1dd005e3$export$2b04a2c5fbfbfe6c)(effectiveContextualFormattingEnabled, toolbarDockingPosition); // When a toolbar portal context is provided, render the  toolbar inside a portal.
    // Otherwise fall back to a fragment just to avoid forking rendering logic.
    const { Portal: ToolbarPortal } = (0, $9kMHa.useToolbarPortal)() ?? {
        Portal: (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment
    };
    const hasToolbarPortal = ToolbarPortal !== (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment;
    const mountPoint = hasToolbarPortal ? undefined : popupsMountPoint;
    const isShortcutToFocusToolbar = (0, $42omo.useCallback)((event)=>{
        //Alt + F9 to reach first element in this main toolbar
        return event.altKey && event.key === 'F9';
    }, []);
    const handleEscape = (0, $42omo.useCallback)((event_0)=>{
        if (!editorView?.hasFocus()) editorView?.focus();
        event_0.preventDefault();
        event_0.stopPropagation();
    }, [
        editorView
    ]); // Remove entire primary toolbar region if:
    // - primary toolbar isn't registered
    // - no custom primary toolbar components to render
    // note: primary toolbar must render if toolbar docking preference is set to "controlled" to avoid SSR conflicts
    // note(platform_editor_ssr_toolbar_optimistic): On the SSR and CSR, the toolbar plugin may be registered in the
    // injection API but its components not yet populated. Bypass the early-return
    // so the toolbar chrome stays mounted for layout stability; ToolbarNext renders
    // null inside it until components arrive.
    const isAwaitingToolbarComponents = (0, $1oCLl.expValEquals)('platform_editor_ssr_toolbar_optimistic', 'isEnabled', true) && !Boolean(editorAPI?.toolbar);
    if (!isAwaitingToolbarComponents && !$2c1c1320beb5acd3$var$shouldShowToolbarContainer(toolbar, customPrimaryToolbarComponents)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ToolbarPortal, null, null);
    if (isConvertedMarkdownPreview && !primaryToolbarDockingConfigEnabled && !customPrimaryToolbarComponents) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ToolbarPortal, null, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3bEAg.ContextPanelConsumer), null, ({ width: ContextPanelWidth })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Gwdo.ToolbarArrowKeyNavigationProvider), {
            editorView: editorView,
            childComponentSelector: "[data-testid='ak-editor-main-toolbar']",
            isShortcutToFocusToolbar: isShortcutToFocusToolbar,
            handleEscape: handleEscape,
            intl: intl
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ToolbarPortal, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2c1c1320beb5acd3$var$MainToolbarWrapper, {
            testId: "ak-editor-main-toolbar",
            showKeyline: showKeyline || ContextPanelWidth > 0
        }, beforeIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                $2c1c1320beb5acd3$var$styles.mainToolbarIconBefore,
                $2c1c1320beb5acd3$var$styles.mainToolbarIconBeforeNew
            ])
        }, beforeIcon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2c1c1320beb5acd3$var$FirstChildWrapper, null, (0, $1oCLl.expValEquals)('platform_editor_ssr_toolbar_optimistic', 'isEnabled', true) ? // optimistic toolbar — render immediately on both SSR and CSR with items enabled.
        // Clicks are noops until editorView mounts.
        primaryToolbarDockingConfigEnabled && (components && visibleToolbarComponents && (0, $5ZzFz.isToolbar)(toolbar) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eUp7e.ToolbarNext), {
            toolbar: toolbar,
            components: visibleToolbarComponents,
            editorView: editorView,
            editorAPI: editorAPI,
            popupsMountPoint: mountPoint,
            editorAppearance: "full-page",
            isDisabled: disabled,
            disabledWithoutInteractionLogic: false
        }) : null) : (0, $1oCLl.expValEquals)('platform_editor_default_toolbar_state', 'isEnabled', true) ? primaryToolbarDockingConfigEnabled && components && visibleToolbarComponents && (0, $5ZzFz.isToolbar)(toolbar) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eUp7e.ToolbarNext), {
            toolbar: toolbar,
            components: visibleToolbarComponents,
            editorView: editorView,
            editorAPI: editorAPI,
            popupsMountPoint: mountPoint,
            editorAppearance: "full-page",
            isDisabled: disabled,
            disabledWithoutInteractionLogic: disabledWithoutInteractionLogic
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8be08ecc0f0fb8a8$export$2e2bcd8739ae039), null, primaryToolbarDockingConfigEnabled && components && visibleToolbarComponents && (0, $5ZzFz.isToolbar)(toolbar) && editorView && !(0, $eTj7Y.isSSR)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eUp7e.ToolbarNext), {
            toolbar: toolbar,
            components: visibleToolbarComponents,
            editorView: editorView,
            editorAPI: editorAPI,
            popupsMountPoint: mountPoint,
            editorAppearance: "full-page",
            isDisabled: disabled,
            disabledWithoutInteractionLogic: disabledWithoutInteractionLogic
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2c1c1320beb5acd3$var$SecondChildWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                $2c1c1320beb5acd3$var$styles.customToolbarWrapperStyle
            ])
        }, !!customPrimaryToolbarComponents && 'before' in customPrimaryToolbarComponents && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": 'before-primary-toolbar-components-plugin',
            className: (0, $gMc0m.default)([
                $2c1c1320beb5acd3$var$styles.beforePrimaryToolbarComponents
            ])
        }, customPrimaryToolbarComponents.before), !!customPrimaryToolbarComponents && 'after' in customPrimaryToolbarComponents ? customPrimaryToolbarComponents.after : customPrimaryToolbarComponents)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9kMHa.ToolbarPortalMountPoint), null))))));
};


const $add8e6b8e65420e3$var$SSR_TRACE_SEGMENT_NAME = 'reactEditorView/fullPageAppearance';
const $add8e6b8e65420e3$var$FullPageEditorWrapperMigration = (0, $9JpPs.componentWithCondition)(()=>(0, $1oCLl.expValEquals)('platform_editor_core_non_ecc_static_css', 'isEnabled', true), (0, $b17a27d9ac03e128$export$2e95191265575e53), (0, $c1ce045772fcbcf5$export$41c7ea372447284a));
const $add8e6b8e65420e3$var$useShowKeyline = (0, $4pOgL.isReactCompilerActivePlatform)() ? (contentAreaRef)=>{
    const $ = (0, $frIzR.c)(3);
    const [showKeyline, setShowKeyline] = (0, $42omo.useState)(false);
    let t0;
    let t1;
    if ($[0] !== contentAreaRef) {
        t0 = ()=>{
            if (!contentAreaRef.current?.contentArea) return;
            const browser = (0, $d7ZU3.getBrowserInfo)();
            const intersection = new IntersectionObserver((t2)=>{
                const [entry] = t2;
                setShowKeyline(!entry.isIntersecting && entry.boundingClientRect.top < entry.intersectionRect.top);
            }, {
                root: undefined,
                threshold: browser.safari ? 0.98 : 1
            });
            intersection.observe(contentAreaRef.current.contentArea);
            return ()=>{
                intersection.disconnect();
            };
        };
        t1 = [
            contentAreaRef
        ];
        $[0] = contentAreaRef;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $42omo.useEffect)(t0, t1);
    return showKeyline;
} : (contentAreaRef)=>{
    const [showKeyline, setShowKeyline] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (!contentAreaRef.current?.contentArea) return;
        const browser = (0, $d7ZU3.getBrowserInfo)();
        const intersection = new IntersectionObserver(([entry])=>{
            setShowKeyline(!entry.isIntersecting && entry.boundingClientRect.top < entry.intersectionRect.top);
        }, {
            root: undefined,
            // Safari seems to miss events (on fast scroll) sometimes due
            // to differences in IntersectionObserver behaviour between browsers.
            // By lowering the threshold a little it gives Safari more
            // time to catch these events.
            threshold: browser.safari ? 0.98 : 1
        });
        intersection.observe(contentAreaRef.current.contentArea);
        return ()=>{
            intersection.disconnect();
        };
    }, [
        contentAreaRef
    ]);
    return showKeyline;
};
const $add8e6b8e65420e3$var$hasCustomComponents = (components)=>{
    if (!components) return false;
    if ('before' in components) return Array.isArray(components.before) && components.before.length > 0 || !!components.before || Array.isArray(components.after) && components.after.length > 0 || !!components.after;
    return true;
};
const $add8e6b8e65420e3$export$a15423dd96de66f2 = (props)=>{
    // Should be always the first statement in the component
    const firstRenderStartTimestampRef = (0, $42omo.useRef)(performance.now());
    const wrapperElementRef = (0, $42omo.useMemo)(()=>props.innerRef, [
        props.innerRef
    ]);
    const scrollContentContainerRef = (0, $42omo.useRef)(null);
    const showKeyline = $add8e6b8e65420e3$var$useShowKeyline(scrollContentContainerRef);
    const editorAPI = props.editorAPI;
    const state = (0, $eiA8Z.useSharedPluginStateWithSelector)(editorAPI, [
        'primaryToolbar',
        'interaction',
        'editorViewMode',
        'toolbar'
    ], (states)=>({
            primaryToolbarComponents: states.primaryToolbarState?.components,
            interactionState: states.interactionState?.interactionState,
            editorViewMode: states.editorViewModeState?.mode,
            contextualFormattingModeOverride: states.toolbarState?.contextualFormattingModeOverride
        }));
    // Markdown Mode forces `'always-pinned'` while in source / preview view
    // (no PM selection to anchor a floating toolbar to). The user's docking
    // pref alone is not enough to decide whether to mount the primary toolbar
    // in that case — the override has to short-circuit the hide gate below.
    const forcePrimaryToolbarPinned = state.contextualFormattingModeOverride === 'always-pinned';
    const interactionState = state.interactionState;
    const primaryToolbarState = (0, $4cy2V.getPrimaryToolbarComponents)(editorAPI, state.primaryToolbarComponents);
    const hasHadInteraction = interactionState !== 'hasNotHadInteraction';
    let toolbarDocking = (0, $b3YrF.useSharedPluginStateSelector)(editorAPI, 'selectionToolbar.toolbarDocking', {
        disabled: (0, $g9Jfe.fg)('platform_editor_use_preferences_plugin')
    });
    if (!(0, $g9Jfe.fg)('platform_editor_use_preferences_plugin')) {
        if (!toolbarDocking) {
            // This is a workaround for the rendering issue with the selection toolbar
            // where using useSharedPluginStateSelector or useSharedPluginState the state are not
            // available when the editor is first loaded. and cause the toolbar to blink.
            const defaultDocking = props.__livePage ? 'none' : 'top';
            toolbarDocking = editorAPI?.selectionToolbar?.sharedState.currentState()?.toolbarDocking ?? defaultDocking;
        }
    }
    let { toolbarDockingPosition: toolbarDockingPosition } = (0, $b3YrF.useSharedPluginStateSelector)(editorAPI, 'userPreferences.preferences', {
        disabled: !(0, $g9Jfe.fg)('platform_editor_use_preferences_plugin')
    }) || {};
    if ((0, $g9Jfe.fg)('platform_editor_use_preferences_plugin')) {
        if (!toolbarDockingPosition) {
            // This is a workaround for the rendering issue with the selection toolbar
            // when using useSharedPluginStateWithSelector the state is not yet
            // available when the editor is first loaded.
            // This causes the toolbar to blink creating a layout shift.
            const defaultDockingPosition = props.__livePage ? 'none' : 'top';
            toolbarDockingPosition = editorAPI?.userPreferences?.actions.getUserPreferences()?.toolbarDockingPosition ?? defaultDockingPosition;
        }
    }
    let primaryToolbarComponents = props.primaryToolbarComponents;
    if (Array.isArray(primaryToolbarState?.components) && Array.isArray(primaryToolbarComponents)) primaryToolbarComponents = primaryToolbarState.components.concat(primaryToolbarComponents);
    let isEditorToolbarHidden = state.editorViewMode === 'view';
    const { customPrimaryToolbarComponents: customPrimaryToolbarComponents } = props;
    if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1', {
        exposure: true
    })) {
        if ((0, $g9Jfe.fg)('platform_editor_use_preferences_plugin')) // need to check if the toolbarDockingPosition is set to 'none' or 'top'
        {
            if (toolbarDockingPosition === 'none' && !forcePrimaryToolbarPinned) {
                primaryToolbarComponents = [];
                if (!$add8e6b8e65420e3$var$hasCustomComponents(customPrimaryToolbarComponents)) isEditorToolbarHidden = true;
            }
        } else if (toolbarDocking === 'none' && !forcePrimaryToolbarPinned) {
            primaryToolbarComponents = [];
            if (!$add8e6b8e65420e3$var$hasCustomComponents(customPrimaryToolbarComponents)) isEditorToolbarHidden = true;
        }
    }
    const isToolbarAIFCEnabled = Boolean(editorAPI?.toolbar);
    const popupsBoundariesElement = props.popupsBoundariesElement || scrollContentContainerRef?.current?.containerArea || undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lnATY.SSRRenderMeasure), {
        segmentName: $add8e6b8e65420e3$var$SSR_TRACE_SEGMENT_NAME,
        startTimestampRef: firstRenderStartTimestampRef,
        onSSRMeasure: props.onSSRMeasure
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3bEAg.ContextPanelWidthProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($add8e6b8e65420e3$var$FullPageEditorWrapperMigration, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "akEditor",
        ref: wrapperElementRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props
        {
            '--ak-editor-fullpage-toolbar-height': // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $aFUXX.FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)(isToolbarAIFCEnabled)
        }
    }, !isEditorToolbarHidden && (isToolbarAIFCEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2c1c1320beb5acd3$export$9f4aa6ea8358228b), {
        disabled: (0, $1oCLl.expValEquals)('platform_editor_ssr_toolbar_optimistic', 'isEnabled', true) ? !hasHadInteraction ? false : !!props.disabled : !!props.disabled || !hasHadInteraction && (0, $1oCLl.expValEquals)('platform_editor_default_toolbar_state', 'isEnabled', true),
        disabledWithoutInteractionLogic: !!props.disabled,
        toolbarDockingPosition: toolbarDockingPosition ?? toolbarDocking,
        beforeIcon: props.primaryToolbarIconBefore,
        editorAPI: editorAPI,
        editorView: props.editorView,
        popupsMountPoint: props.popupsMountPoint,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsScrollableElement: props.popupsScrollableElement,
        showKeyline: showKeyline,
        customPrimaryToolbarComponents: props.customPrimaryToolbarComponents
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $351b868f15072c21$export$26f3f0e30f9545b4), {
        appearance: props.appearance,
        editorAPI: editorAPI,
        beforeIcon: props.primaryToolbarIconBefore,
        collabEdit: props.collabEdit,
        containerElement: scrollContentContainerRef.current?.scrollContainer ?? null,
        customPrimaryToolbarComponents: props.customPrimaryToolbarComponents,
        disabled: !!props.disabled,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        editorActions: props.editorActions,
        editorDOMElement: props.editorDOMElement,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        editorView: props.editorView,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        eventDispatcher: props.eventDispatcher,
        hasMinWidth: props.enableToolbarMinWidth,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsMountPoint: props.popupsMountPoint,
        popupsScrollableElement: props.popupsScrollableElement,
        primaryToolbarComponents: primaryToolbarComponents,
        providerFactory: props.providerFactory,
        showKeyline: showKeyline,
        featureFlags: props.featureFlags
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f148f84351b38b5e$export$7db1e8e055ebd208), {
        editorAPI: editorAPI,
        ref: scrollContentContainerRef,
        appearance: props.appearance,
        contentComponents: props.contentComponents,
        contextPanel: props.contextPanel,
        customContentComponents: props.customContentComponents,
        disabled: props.disabled,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        editorActions: props.editorActions,
        editorDOMElement: props.editorDOMElement,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        editorView: props.editorView,
        eventDispatcher: props.eventDispatcher,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsMountPoint: props.popupsMountPoint,
        popupsScrollableElement: props.popupsScrollableElement,
        providerFactory: props.providerFactory,
        wrapperElement: wrapperElementRef?.current ?? null,
        pluginHooks: props.pluginHooks,
        featureFlags: props.featureFlags,
        isEditorToolbarHidden: isEditorToolbarHidden,
        viewMode: state.editorViewMode,
        hasHadInteraction: hasHadInteraction,
        contentMode: props.contentMode
    }))));
};
module.exports["FullPageEditor"] = $add8e6b8e65420e3$export$a15423dd96de66f2;

});

parcelRegister("auRzv", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $7uLCZ = parcelRequire("7uLCZ");


var $3bEAg = parcelRequire("3bEAg");


var $eiA8Z = parcelRequire("eiA8Z");


var $kofef = parcelRequire("kofef");


var $aFUXX = parcelRequire("aFUXX");


var $g9Jfe = parcelRequire("g9Jfe");


var $9JpPs = parcelRequire("9JpPs");


var $1oCLl = parcelRequire("1oCLl");











var $gMc0m = parcelRequire("gMc0m");

const $cf4e37e7892e72de$var$ANIM_SPEED_MS = 500;
const $cf4e37e7892e72de$var$getContextPanelWidthStyle = ({ customWidth: customWidth, visible: visible })=>{
    if (!visible) return {
        width: 0
    };
    if (customWidth) return {
        width: `${customWidth}px`
    };
    return undefined;
};
const $cf4e37e7892e72de$var$panelStyles = {
    panel: "_v5648l2w _1reo15vq _18m915vq _1bsbnklw _4t3i1osq _16qshh4h",
    disablePanelAnimation: "_v564glyw",
    content: "_v564e1q5 _vchhusvi _1bsbnklw _4t3i1osq _18m91wug",
    padding: "_ca0qpxbi _u5f3pxbi _n3tdze3t _19bvpxbi",
    customWidthOverflow: "_1reo15vq"
};
const $cf4e37e7892e72de$export$1427500076f636b6 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(17);
    let children;
    let customWidth;
    let disableAnimation;
    let rest;
    let visible;
    if ($[0] !== t0) {
        ({ children: children, customWidth: customWidth, visible: visible, disableAnimation: disableAnimation, ...rest } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = customWidth;
        $[3] = disableAnimation;
        $[4] = rest;
        $[5] = visible;
    } else {
        children = $[1];
        customWidth = $[2];
        disableAnimation = $[3];
        rest = $[4];
        visible = $[5];
    }
    let t1;
    if ($[6] !== customWidth || $[7] !== visible) {
        t1 = $cf4e37e7892e72de$var$getContextPanelWidthStyle({
            customWidth: customWidth,
            visible: visible
        });
        $[6] = customWidth;
        $[7] = visible;
        $[8] = t1;
    } else t1 = $[8];
    const widthStyle = t1;
    const t2 = customWidth && "";
    const t3 = disableAnimation && $cf4e37e7892e72de$var$panelStyles.disablePanelAnimation;
    let t4;
    if ($[9] !== t2 || $[10] !== t3) {
        t4 = (0, $gMc0m.default)([
            $cf4e37e7892e72de$var$panelStyles.panel,
            t2,
            t3
        ]);
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== children || $[13] !== rest || $[14] !== t4 || $[15] !== widthStyle) {
        t5 = /*#__PURE__*/ $42omo.createElement("div", {
            style: widthStyle,
            ...rest,
            className: t4
        }, children);
        $[12] = children;
        $[13] = rest;
        $[14] = t4;
        $[15] = widthStyle;
        $[16] = t5;
    } else t5 = $[16];
    return t5;
} : ({ children: children, customWidth: customWidth, visible: visible, disableAnimation: disableAnimation, ...rest })=>{
    const widthStyle = (0, $42omo.useMemo)(()=>$cf4e37e7892e72de$var$getContextPanelWidthStyle({
            customWidth: customWidth,
            visible: visible
        }), [
        customWidth,
        visible
    ]);
    return /*#__PURE__*/ $42omo.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- dynamic width cannot be expressed as static compiled CSS
    , {
        style: widthStyle,
        ...rest,
        className: (0, $gMc0m.default)([
            $cf4e37e7892e72de$var$panelStyles.panel,
            customWidth && "",
            disableAnimation && $cf4e37e7892e72de$var$panelStyles.disablePanelAnimation
        ])
    }, children);
};
const $cf4e37e7892e72de$export$90b9783dea435d4f = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(19);
    let children;
    let customWidth;
    let disableAnimation;
    let hasPadding;
    let rest;
    let visible;
    if ($[0] !== t0) {
        ({ children: children, customWidth: customWidth, visible: visible, disableAnimation: disableAnimation, hasPadding: hasPadding, ...rest } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = customWidth;
        $[3] = disableAnimation;
        $[4] = hasPadding;
        $[5] = rest;
        $[6] = visible;
    } else {
        children = $[1];
        customWidth = $[2];
        disableAnimation = $[3];
        hasPadding = $[4];
        rest = $[5];
        visible = $[6];
    }
    let t1;
    if ($[7] !== customWidth || $[8] !== visible) {
        t1 = $cf4e37e7892e72de$var$getContextPanelWidthStyle({
            customWidth: customWidth,
            visible: visible
        });
        $[7] = customWidth;
        $[8] = visible;
        $[9] = t1;
    } else t1 = $[9];
    const widthStyle = t1;
    const t2 = hasPadding && $cf4e37e7892e72de$var$panelStyles.padding;
    const t3 = customWidth && "";
    const t4 = disableAnimation && $cf4e37e7892e72de$var$panelStyles.disablePanelAnimation;
    let t5;
    if ($[10] !== t2 || $[11] !== t3 || $[12] !== t4) {
        t5 = (0, $gMc0m.default)([
            $cf4e37e7892e72de$var$panelStyles.content,
            t2,
            t3,
            t4
        ]);
        $[10] = t2;
        $[11] = t3;
        $[12] = t4;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== children || $[15] !== rest || $[16] !== t5 || $[17] !== widthStyle) {
        t6 = /*#__PURE__*/ $42omo.createElement("div", {
            style: widthStyle,
            ...rest,
            className: t5
        }, children);
        $[14] = children;
        $[15] = rest;
        $[16] = t5;
        $[17] = widthStyle;
        $[18] = t6;
    } else t6 = $[18];
    return t6;
} : ({ children: children, customWidth: customWidth, visible: visible, disableAnimation: disableAnimation, hasPadding: hasPadding, ...rest })=>{
    const widthStyle = (0, $42omo.useMemo)(()=>$cf4e37e7892e72de$var$getContextPanelWidthStyle({
            customWidth: customWidth,
            visible: visible
        }), [
        customWidth,
        visible
    ]);
    return /*#__PURE__*/ $42omo.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- dynamic width cannot be expressed as static compiled CSS
    , {
        style: widthStyle,
        ...rest,
        className: (0, $gMc0m.default)([
            $cf4e37e7892e72de$var$panelStyles.content,
            hasPadding && $cf4e37e7892e72de$var$panelStyles.padding,
            customWidth && "",
            disableAnimation && $cf4e37e7892e72de$var$panelStyles.disablePanelAnimation
        ])
    }, children);
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /**
* Emotion fallback branch of the `platform_editor_core_non_ecc_static_css` experiment.
* Used via `componentWithCondition` in `index.tsx`.
*
* Cleanup: delete this file once the `platform_editor_core_non_ecc_static_css` experiment has shipped.
*/ 



var $9K4OG = parcelRequire("9K4OG");




function $87bced88799afcc6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $87bced88799afcc6$var$ANIM_SPEED_MS = 500;
const $87bced88799afcc6$var$panelHidden = {
    name: "k2uqvh",
    styles: "width:0"
};
const $87bced88799afcc6$var$panel = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $aFUXX.akEditorContextPanelWidth)}px`,
    height: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width ${$87bced88799afcc6$var$ANIM_SPEED_MS}ms ${(0, $aFUXX.akEditorSwoopCubicBezier)}`,
    overflow: 'hidden',
    boxShadow: `inset 2px 0 0 0 ${"var(--ds-border, #0B120E24)"}`
});
const $87bced88799afcc6$var$disablePanelAnimation = {
    name: "1wx2bp",
    styles: "transition:none"
};
const $87bced88799afcc6$var$content = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width 600ms ${(0, $aFUXX.akEditorSwoopCubicBezier)}`,
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $aFUXX.akEditorContextPanelWidth)}px`,
    height: '100%',
    overflowY: 'auto'
});
const $87bced88799afcc6$var$paddingStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-200, 16px)"} 0px`
});
const $87bced88799afcc6$export$cf4d28bc76693823 = ({ children: children, customWidth: customWidth, visible: visible, disableAnimation: disableAnimation, ...rest })=>{
    const customPanelWidthStyles = (0, $42omo.useMemo)(()=>customWidth ? /*#__PURE__*/ (0, $9K4OG.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @repo/internal/react/no-class-components
            width: `${customWidth}px`,
            overflowX: 'hidden'
        }) : undefined, [
        customWidth
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            $87bced88799afcc6$var$panel,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/consistent-css-prop-usage
            customPanelWidthStyles,
            !visible && $87bced88799afcc6$var$panelHidden,
            disableAnimation && $87bced88799afcc6$var$disablePanelAnimation
        ],
        ...rest
    }, children);
};
const $87bced88799afcc6$export$8d909fc7bf63a35 = ({ children: children, customWidth: customWidth, visible: visible, disableAnimation: disableAnimation, hasPadding: hasPadding, ...rest })=>{
    const customPanelWidthStyles = (0, $42omo.useMemo)(()=>customWidth ? /*#__PURE__*/ (0, $9K4OG.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @repo/internal/react/no-class-components
            width: `${customWidth}px`,
            overflowX: 'hidden'
        }) : undefined, [
        customWidth
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            $87bced88799afcc6$var$content,
            hasPadding && $87bced88799afcc6$var$paddingStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/consistent-css-prop-usage
            customPanelWidthStyles,
            !visible && $87bced88799afcc6$var$panelHidden,
            disableAnimation && $87bced88799afcc6$var$disablePanelAnimation
        ],
        ...rest
    }, children);
};


const $3e0be7976f7dcf3f$var$ANIM_SPEED_MS = 500;
const $3e0be7976f7dcf3f$var$ContextPanelWrapperMigration = (0, $9JpPs.componentWithCondition)(()=>(0, $1oCLl.expValEquals)('platform_editor_core_non_ecc_static_css', 'isEnabled', true), (0, $cf4e37e7892e72de$export$1427500076f636b6), (0, $87bced88799afcc6$export$cf4d28bc76693823));
const $3e0be7976f7dcf3f$var$ContextPanelContentMigration = (0, $9JpPs.componentWithCondition)(()=>(0, $1oCLl.expValEquals)('platform_editor_core_non_ecc_static_css', 'isEnabled', true), (0, $cf4e37e7892e72de$export$90b9783dea435d4f), (0, $87bced88799afcc6$export$8d909fc7bf63a35));
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $3e0be7976f7dcf3f$var$SwappableContentAreaInner extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    static getDerivedStateFromProps(props, state) {
        if (props.pluginContent !== state.currentPluginContent) return {
            ...state,
            currentPluginContent: props.pluginContent
        };
        return null;
    }
    unsetPluginContent() {
        this.setState({
            currentPluginContent: undefined
        });
    }
    componentDidMount() {
        // use this to trigger an animation
        this.setState({
            mounted: true
        });
    }
    render() {
        const width = this.props.customWidth ?? (0, $aFUXX.akEditorContextPanelWidth);
        const userVisible = !!this.props.visible;
        const visible = userVisible || !!this.state.currentPluginContent;
        const hasPadding = this.props.hasPadding === undefined ? true : this.props.hasPadding;
        const disableAnimation = (0, $g9Jfe.fg)('platform_editor_disable_context_panel_animation');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3bEAg.ContextPanelConsumer), null, ({ broadcastWidth: broadcastWidth })=>{
            const contextPanelWidth = visible ? width : 0;
            broadcastWidth(contextPanelWidth);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3e0be7976f7dcf3f$var$ContextPanelWrapperMigration, {
                customWidth: this.props.customWidth,
                visible: visible,
                disableAnimation: disableAnimation,
                "data-testid": "context-panel-panel",
                // eslint-disable-next-line @atlassian/a11y/no-empty-aria-label -- Pre-existing; intl should always resolve a label here
                "aria-label": this.props.intl?.formatMessage((0, $kofef.contextPanelMessages).panelLabel) || '',
                "aria-modal": "false",
                role: "dialog"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3e0be7976f7dcf3f$var$ContextPanelContentMigration, {
                customWidth: this.props.customWidth,
                visible: visible,
                disableAnimation: disableAnimation,
                hasPadding: hasPadding,
                "data-testid": "context-panel-content",
                // Adding tabIndex=0 here to make content focusable as it is a scrollable region
                tabIndex: 0,
                role: "region",
                "aria-label": this.props.intl?.formatMessage((0, $kofef.contextPanelMessages).panelContentLabel)
            }, this.showPluginContent() || this.showProvidedContent(userVisible)));
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            mounted: false,
            currentPluginContent: undefined
        };
        this.handleTransitionExited = ()=>{
            this.unsetPluginContent();
        };
        this.focusEditor = ()=>{
            const { editorAPI: editorAPI } = this.props;
            editorAPI?.core?.actions.focus({
                scrollIntoView: false
            });
        };
        this.showPluginContent = ()=>{
            const { pluginContent: pluginContent } = this.props;
            const { currentPluginContent: currentPluginContent } = this.state;
            if (!currentPluginContent) return;
            const animSpeedMs = (0, $g9Jfe.fg)('platform_editor_disable_context_panel_animation') ? 0 : $3e0be7976f7dcf3f$var$ANIM_SPEED_MS;
            const onExited = (0, $1oCLl.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? this.handleTransitionExited : ()=>this.unsetPluginContent();
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7uLCZ.default), {
                timeout: this.state.mounted ? animSpeedMs : 0,
                in: !!pluginContent,
                mountOnEnter: true,
                unmountOnExit: true,
                onExited: onExited
            }, currentPluginContent);
        };
        this.showProvidedContent = (isVisible)=>{
            const { children: children } = this.props;
            if (!children) return;
            const animSpeedMs = (0, $g9Jfe.fg)('platform_editor_disable_context_panel_animation') ? 0 : $3e0be7976f7dcf3f$var$ANIM_SPEED_MS;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7uLCZ.default), {
                timeout: this.state.mounted ? animSpeedMs : 0,
                in: isVisible,
                mountOnEnter: true,
                unmountOnExit: true,
                onExiting: this.focusEditor
            }, children);
        };
    }
}
const $3e0be7976f7dcf3f$export$2aac880ec6fe2608 = (0, $aXWIB.injectIntl)($3e0be7976f7dcf3f$var$SwappableContentAreaInner);
const $3e0be7976f7dcf3f$export$c174a7dc96b2afb8 = (0, $4pOgL.isReactCompilerActivePlatform)() ? function ContextPanel(props) {
    const $ = (0, $frIzR.c)(6);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [
            "contextPanel"
        ];
        $[0] = t0;
    } else t0 = $[0];
    const contextPanelContents = (0, $eiA8Z.useSharedPluginStateWithSelector)(props.editorAPI, t0, $3e0be7976f7dcf3f$var$_temp);
    let t1;
    if ($[1] !== contextPanelContents) {
        t1 = contextPanelContents && contextPanelContents.find(Boolean);
        $[1] = contextPanelContents;
        $[2] = t1;
    } else t1 = $[2];
    const firstContent = t1;
    let t2;
    if ($[3] !== firstContent || $[4] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3e0be7976f7dcf3f$export$2aac880ec6fe2608, {
            ...props,
            editorAPI: props.editorAPI,
            pluginContent: firstContent
        });
        $[3] = firstContent;
        $[4] = props;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : function ContextPanel(props) {
    const contextPanelContents = (0, $eiA8Z.useSharedPluginStateWithSelector)(props.editorAPI, [
        'contextPanel'
    ], (states)=>states?.contextPanelState?.contents);
    const firstContent = contextPanelContents && contextPanelContents.find(Boolean);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3e0be7976f7dcf3f$export$2aac880ec6fe2608, {
        ...props,
        editorAPI: props.editorAPI,
        pluginContent: firstContent
    });
};
function $3e0be7976f7dcf3f$var$_temp(states) {
    return states?.contextPanelState?.contents;
}
module.exports["ContextPanel"] = $3e0be7976f7dcf3f$export$c174a7dc96b2afb8;

});

parcelRegister("9kMHa", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");

const $b0152837669a5888$var$ToolbarPortalContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(undefined);
const $b0152837669a5888$export$89a0c16b81a39772 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { children: children, portal: portal, isActive: isActive } = t0;
    let t1;
    if ($[0] !== isActive || $[1] !== portal) {
        t1 = {
            Portal: portal,
            isActive: isActive
        };
        $[0] = isActive;
        $[1] = portal;
        $[2] = t1;
    } else t1 = $[2];
    const value = t1;
    let t2;
    if ($[3] !== children || $[4] !== value) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b0152837669a5888$var$ToolbarPortalContext.Provider, {
            value: value
        }, children);
        $[3] = children;
        $[4] = value;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ children: children, portal: portal, isActive: isActive })=>{
    const value = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>({
            Portal: portal,
            isActive: isActive
        }), [
        portal,
        isActive
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b0152837669a5888$var$ToolbarPortalContext.Provider, {
        value: value
    }, children);
}; // NOTE: This doesn't throw on undefined context on purpose, as it is likely that
const $b0152837669a5888$export$9fa9b541c351558 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($b0152837669a5888$var$ToolbarPortalContext);
} : ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($b0152837669a5888$var$ToolbarPortalContext);
};
const $b0152837669a5888$var$toolbarPortalStyles = {
    portal: "_1r04ze3t _kqswstnw _fiawglyw"
};
const $b0152837669a5888$export$ed65ed0e830b18c8 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    const portal = $b0152837669a5888$export$9fa9b541c351558();
    if (portal) return null;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                $b0152837669a5888$var$toolbarPortalStyles.portal,
                "ak-editor-toolbar-portal"
            ])
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    const portal = $b0152837669a5888$export$9fa9b541c351558(); // Don't render a mountpoint when we're already inside a portal
    if (portal) return null;
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $b0152837669a5888$var$toolbarPortalStyles.portal,
            "ak-editor-toolbar-portal"
        ])
    });
};
module.exports["ToolbarPortalContextProvider"] = $b0152837669a5888$export$89a0c16b81a39772;
module.exports["useToolbarPortal"] = $b0152837669a5888$export$9fa9b541c351558;
module.exports["ToolbarPortalMountPoint"] = $b0152837669a5888$export$ed65ed0e830b18c8;

});

parcelRegister("hEicH", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $b9bd51baba75fd69$export$b5633b5b7afd4542 = (0, $4pOgL.isReactCompilerActivePlatform)() ? function useResolvedUserPreferences(userPreferencesProvider) {
    const $ = (0, $frIzR.c)(7);
    let t0;
    if ($[0] !== userPreferencesProvider) {
        t0 = userPreferencesProvider?.getPreferences() || null;
        $[0] = userPreferencesProvider;
        $[1] = t0;
    } else t0 = $[1];
    const [resolvedUserPreferences, setResolvedUserPreferences] = (0, $42omo.useState)(t0);
    let t1;
    let t2;
    if ($[2] !== userPreferencesProvider) {
        t1 = ()=>userPreferencesProvider?.onUpdate(()=>{
                setResolvedUserPreferences(userPreferencesProvider.getPreferences());
            });
        t2 = [
            userPreferencesProvider
        ];
        $[2] = userPreferencesProvider;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[5] !== resolvedUserPreferences) {
        t3 = {
            resolvedUserPreferences: resolvedUserPreferences
        };
        $[5] = resolvedUserPreferences;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : function useResolvedUserPreferences(userPreferencesProvider) {
    const [resolvedUserPreferences, setResolvedUserPreferences] = (0, $42omo.useState)(userPreferencesProvider?.getPreferences() || null);
    (0, $42omo.useEffect)(()=>{
        return userPreferencesProvider?.onUpdate(()=>{
            setResolvedUserPreferences(userPreferencesProvider.getPreferences());
        });
    }, [
        userPreferencesProvider
    ]);
    return {
        resolvedUserPreferences: resolvedUserPreferences
    };
};



var $d925B = parcelRequire("d925B");


var $hWRJP = parcelRequire("hWRJP");


var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");


var $iu6m9 = parcelRequire("iu6m9");

const $853af264aab12b2b$export$17267f5809d60e00 = (currentOverrides, override)=>{
    const { key: key, value: value } = override;
    if (value === null || value === undefined) {
        const { [key]: _, ...rest } = currentOverrides;
        return rest;
    }
    return {
        ...currentOverrides,
        [key]: value
    };
};
const $853af264aab12b2b$export$26bf7aeec579553f = new (0, $ks2lK.PluginKey)('userPreferencesPlugin');
const $853af264aab12b2b$export$ae829ec7b2625219 = (pluginOptions, _api)=>{
    const { userPreferencesProvider: userPreferencesProvider, initialUserPreferences: initialUserPreferences } = pluginOptions;
    const getInitialUserPreferences = ()=>{
        if (initialUserPreferences && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) return initialUserPreferences;
        return {
            toolbarDockingPosition: 'top'
        };
    };
    return new (0, $1S4f7.SafePlugin)({
        key: $853af264aab12b2b$export$26bf7aeec579553f,
        state: {
            init () {
                return {
                    preferences: userPreferencesProvider?.getPreferences() || getInitialUserPreferences(),
                    overrides: {}
                };
            },
            apply: (tr, currentPluginState)=>{
                const meta = tr.getMeta($853af264aab12b2b$export$26bf7aeec579553f);
                if (!meta || !meta.preferences && !meta.override) return currentPluginState;
                const nextState = {
                    ...currentPluginState
                };
                if (meta.preferences) nextState.preferences = {
                    ...currentPluginState.preferences,
                    ...meta.preferences
                };
                if (meta.override) nextState.overrides = $853af264aab12b2b$export$17267f5809d60e00(currentPluginState.overrides, meta.override);
                return nextState;
            }
        }
    });
};


const $dabc3407d69b6572$export$f9431c71d648ada2 = ({ key: key, value: value })=>({ tr: tr })=>{
        tr.setMeta((0, $853af264aab12b2b$export$26bf7aeec579553f), {
            override: {
                key: key,
                value: value
            }
        });
        return tr;
    };
const $dabc3407d69b6572$export$8243f41c2dd518ad = ({ key: key })=>({ tr: tr })=>{
        tr.setMeta((0, $853af264aab12b2b$export$26bf7aeec579553f), {
            override: {
                key: key,
                value: null
            }
        });
        return tr;
    };
const $dabc3407d69b6572$export$32e4436123e4fc74 = ({ key: key, value: value, userPreferencesProvider: userPreferencesProvider, editorAnalyticsApi: editorAnalyticsApi })=>({ tr: tr })=>{
        try {
            userPreferencesProvider?.updatePreference(key, value);
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-plugin-user-preferences/userPreferencesPlugin'
            });
        }
        // If the userPreferencesProvider is not available,
        // the plugin's state will be updated to operate in 'in memory' mode.
        tr.setMeta((0, $853af264aab12b2b$export$26bf7aeec579553f), {
            preferences: {
                [key]: value
            }
        });
        if (key === 'toolbarDockingPosition') editorAnalyticsApi?.attachAnalyticsEvent({
            action: (0, $d925B.ACTION).UPDATED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).USER_PREFERENCES,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).SELECTION_TOOLBAR_PREFERENCES,
            attributes: {
                toolbarDocking: value
            },
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    };







var $fFa3V = parcelRequire("fFa3V");




const $dd77f5c6ef9e2e7f$export$c3ff777471586be2 = (userPreferencesProvider)=>{
    (0, $42omo.useEffect)(()=>{
        if (userPreferencesProvider) {
            const refreshPreferences = async ()=>{
                if (document.visibilityState === 'visible') try {
                    await userPreferencesProvider.loadPreferences();
                } catch (error) {
                    (0, $hWRJP.logException)(error, {
                        location: 'editor-plugin-user-preferences/userPreferencesPlugin'
                    });
                }
            };
            return (0, $fFa3V.bind)(document, {
                type: 'visibilitychange',
                listener: refreshPreferences
            });
        }
    }, [
        userPreferencesProvider
    ]);
};









var $1oCLl = parcelRequire("1oCLl");

const $2fa57ad8231f2b94$export$2bd306fd54c8196e = (isInitialized, resolvedUserPreferences, api)=>{
    const isInitializedRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (isInitialized && resolvedUserPreferences && !isInitializedRef.current) {
            isInitializedRef.current = true;
            api?.analytics?.actions.fireAnalyticsEvent({
                action: (0, $d925B.ACTION).INITIALISED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).USER_PREFERENCES,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).SELECTION_TOOLBAR_PREFERENCES,
                attributes: {
                    toolbarDocking: resolvedUserPreferences.toolbarDockingPosition
                },
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
            });
            // Only users with the toolbar docked at the top will see the button, so we
            // constrain the experiment population here rather than on every editor load.
            // This call is purely to log the exposure.
            if (resolvedUserPreferences.toolbarDockingPosition === 'top') // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $1oCLl.expValEquals)('platform_editor_ai_improve_formatting_toolbar', 'isEnabled', true);
        }
    }, [
        api,
        isInitialized,
        resolvedUserPreferences
    ]);
};






const $739ed6292b62a46a$export$c4b185fa097d4dc = (editorView, resolvedUserPreferences)=>{
    (0, $42omo.useEffect)(()=>{
        if (resolvedUserPreferences) editorView.dispatch(editorView.state.tr.setMeta((0, $853af264aab12b2b$export$26bf7aeec579553f), {
            preferences: resolvedUserPreferences
        }));
    }, [
        resolvedUserPreferences,
        editorView
    ]);
};


const $7a657067d403e4ad$export$b2ef360f69e1145b = ({ config: config, api: api })=>{
    const userPreferencesProvider = config.userPreferencesProvider;
    return {
        name: 'userPreferences',
        pmPlugins () {
            return [
                {
                    name: 'userPreferencesPlugin',
                    plugin: ()=>{
                        return (0, $853af264aab12b2b$export$ae829ec7b2625219)(config, api);
                    }
                }
            ];
        },
        actions: {
            updateUserPreference: (key, value)=>{
                return (0, $dabc3407d69b6572$export$32e4436123e4fc74)({
                    key: key,
                    value: value,
                    userPreferencesProvider: userPreferencesProvider,
                    editorAnalyticsApi: api?.analytics?.actions
                });
            },
            getUserPreferences: ()=>{
                if (!userPreferencesProvider) return config.initialUserPreferences;
                return userPreferencesProvider.getPreferences();
            }
        },
        commands: {
            overrideUserPreference: (key, value)=>{
                return (0, $dabc3407d69b6572$export$f9431c71d648ada2)({
                    key: key,
                    value: value
                });
            },
            clearOverrideUserPreference: (key)=>{
                return (0, $dabc3407d69b6572$export$8243f41c2dd518ad)({
                    key: key
                });
            }
        },
        getSharedState (editorState) {
            if (!editorState) return null;
            const state = (0, $853af264aab12b2b$export$26bf7aeec579553f).getState(editorState);
            // state can return undefined if the plugin hasn't been registered
            if (!state) return null;
            else if (!state.overrides || Object.keys(state.overrides).length === 0) return state;
            return {
                ...state,
                preferences: {
                    ...state.preferences,
                    ...state.overrides
                }
            };
        },
        usePluginHook ({ editorView: editorView }) {
            const { resolvedUserPreferences: resolvedUserPreferences } = (0, $b9bd51baba75fd69$export$b5633b5b7afd4542)(userPreferencesProvider);
            (0, $739ed6292b62a46a$export$c4b185fa097d4dc)(editorView, resolvedUserPreferences);
            (0, $dd77f5c6ef9e2e7f$export$c3ff777471586be2)(userPreferencesProvider);
            (0, $2fa57ad8231f2b94$export$2bd306fd54c8196e)(Boolean(userPreferencesProvider?.isInitialized), resolvedUserPreferences, api);
        }
    };
};
module.exports["userPreferencesPlugin"] = $7a657067d403e4ad$export$b2ef360f69e1145b;

});

parcelRegister("jmHSv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jy7VG = parcelRequire("jy7VG");


var $inPa6 = parcelRequire("inPa6");


var $d925B = parcelRequire("d925B");

var $ajtqX = parcelRequire("ajtqX");

var $4VpM8 = parcelRequire("4VpM8");


var $aAn37 = parcelRequire("aAn37");


var $jz9wK = parcelRequire("jz9wK");


var $1S4f7 = parcelRequire("1S4f7");









var $36502d5e54a5ed4c$export$96527b3d022fe7df = /*#__PURE__*/ function(SELECTION_TYPE) {
    SELECTION_TYPE["CURSOR"] = "cursor";
    SELECTION_TYPE["RANGED"] = "ranged";
    SELECTION_TYPE["TEXT"] = "text";
    SELECTION_TYPE["NODE"] = "node";
    SELECTION_TYPE["CELL"] = "cell";
    SELECTION_TYPE["GAP_CURSOR"] = "gapCursor";
    return SELECTION_TYPE;
}({});
var $36502d5e54a5ed4c$export$f64a96dc7664cbe5 = /*#__PURE__*/ function(SELECTION_POSITION) {
    SELECTION_POSITION["START"] = "start";
    SELECTION_POSITION["MIDDLE"] = "middle";
    SELECTION_POSITION["END"] = "end";
    SELECTION_POSITION["LEFT"] = "left";
    SELECTION_POSITION["RIGHT"] = "right";
    return SELECTION_POSITION;
}({});



var $2XzVT = parcelRequire("2XzVT");


var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");


var $7XFGZ = parcelRequire("7XFGZ");


var $iu6m9 = parcelRequire("iu6m9");

function $66e1d4391a39b785$export$ab5b04535d7a5950(selection) {
    let type;
    let position;
    if (selection?.constructor?.name === 'GapCursorSelection') {
        type = (0, $36502d5e54a5ed4c$export$96527b3d022fe7df).GAP_CURSOR;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        position = selection.side;
    } else if (selection instanceof (0, $7XFGZ.CellSelection)) type = (0, $36502d5e54a5ed4c$export$96527b3d022fe7df).CELL;
    else if (selection instanceof (0, $ks2lK.NodeSelection)) type = (0, $36502d5e54a5ed4c$export$96527b3d022fe7df).NODE;
    else if (selection.from !== selection.to) type = (0, $36502d5e54a5ed4c$export$96527b3d022fe7df).RANGED;
    else {
        type = (0, $36502d5e54a5ed4c$export$96527b3d022fe7df).CURSOR;
        const { from: from, $from: $from } = selection;
        if (from === $from.start()) position = (0, $36502d5e54a5ed4c$export$f64a96dc7664cbe5).START;
        else if (from === $from.end()) position = (0, $36502d5e54a5ed4c$export$f64a96dc7664cbe5).END;
        else position = (0, $36502d5e54a5ed4c$export$f64a96dc7664cbe5).MIDDLE;
    }
    return {
        type: type,
        position: position
    };
}
function $66e1d4391a39b785$var$findInsertedLocation(oldSelection, newSelection, tr) {
    const { schema: schema } = newSelection.$from.doc.type;
    const { nodes: { paragraph: paragraph, table: table } } = schema;
    if (oldSelection instanceof (0, $7XFGZ.CellSelection)) return table.name;
    const newDoc = newSelection.$from.doc;
    const insertLocationInfo = (0, $8m4tT.findParentNode)((node)=>node.type !== paragraph)(oldSelection);
    let pos = insertLocationInfo?.start || 0;
    // Map the old document position through the transaction's steps
    pos = tr.mapping.map(pos);
    let parentNodePos = newDoc.resolve(pos);
    // Keep going one level above the attempted insert position till we find a node that contains the current cursor position in it's range
    while(parentNodePos.end() < newSelection.$from.pos)parentNodePos = newDoc.resolve(parentNodePos.start(Math.max(parentNodePos.depth - 1, 0)));
    return parentNodePos.node().type.name;
}
function $66e1d4391a39b785$export$b8d8bec4e31cbd66(selection, payload, tr) {
    if (!payload.attributes) return payload;
    const { type: type, position: position } = $66e1d4391a39b785$export$ab5b04535d7a5950(selection);
    payload.attributes.selectionType = type;
    if (position) payload.attributes.selectionPosition = position;
    const insertLocation = (0, $2XzVT.findInsertLocation)(selection);
    if (tr && payload.action === (0, $d925B.ACTION).INSERTED && payload.actionSubject !== (0, $d925B.ACTION_SUBJECT).ANNOTATION && payload.actionSubject !== (0, $d925B.ACTION_SUBJECT).EDITOR_PLUGIN_AI) payload.attributes.insertedLocation = $66e1d4391a39b785$var$findInsertedLocation(selection, tr.selection, tr);
    if (payload.action === (0, $d925B.ACTION).INSERTED && payload.actionSubject === (0, $d925B.ACTION_SUBJECT).DOCUMENT && payload.attributes) {
        payload.attributes.insertLocation = insertLocation;
        if ((0, $iu6m9.editorExperiment)('platform_synced_block', true)) {
            const { bodiedSyncBlock: bodiedSyncBlock } = selection.$from.doc.type.schema.nodes;
            payload.attributes.isInsideSyncedBlock = Boolean((0, $8m4tT.findParentNodeOfType)(bodiedSyncBlock)(selection));
        }
    } else payload.attributes.nodeLocation = insertLocation;
    return payload;
}





function $43e57b44b2cccdc3$export$dd48e359ffe98e59(payload) {
    const documentInserted = payload.action === (0, $d925B.ACTION).INSERTED && payload.actionSubject === (0, $d925B.ACTION_SUBJECT).DOCUMENT;
    const textFormatted = payload.action === (0, $d925B.ACTION).FORMATTED && payload.actionSubject === (0, $d925B.ACTION_SUBJECT).TEXT;
    const hasActionSubjectId = !!payload.actionSubjectId;
    if (hasActionSubjectId && (documentInserted || textFormatted)) payload.attributes = {
        ...payload.attributes,
        // @ts-expect-error
        actionSubjectId: payload.actionSubjectId
    };
    return payload;
}


const $12fcbd906e4a44c8$var$actionsToIgnore = [
    (0, $d925B.ACTION).INVOKED,
    (0, $d925B.ACTION).OPENED
];
const $12fcbd906e4a44c8$export$539ce7f09649e93 = (selection)=>({ payload: payload, tr: tr, channel: channel })=>$12fcbd906e4a44c8$var$attachPayloadIntoTransaction({
            payload: payload,
            selection: selection,
            tr: tr,
            channel: channel
        });
// This utils was taken as reference in packages/editor/editor-plugin-ai/src/analytics/utils.ts
//  to create new util attachPayloadIntoTransaction in above file.
// If you make a change here, please review attachPayloadIntoTransaction in above
//  file and update it as well if needed.
const $12fcbd906e4a44c8$var$attachPayloadIntoTransaction = ({ payload: payload, selection: selection, tr: tr, channel: channel })=>{
    payload = (0, $66e1d4391a39b785$export$b8d8bec4e31cbd66)(selection, payload, tr);
    payload = (0, $43e57b44b2cccdc3$export$dd48e359ffe98e59)(payload);
    const { storedMarks: storedMarks } = tr;
    const pos = tr.mapping.map(selection.$from.pos, -1);
    tr.step(new (0, $jy7VG.AnalyticsStep)([
        {
            payload: payload,
            channel: channel
        }
    ], $12fcbd906e4a44c8$var$actionsToIgnore, pos));
    // When you add a new step all the storedMarks are removed it
    if (storedMarks) tr.setStoredMarks(storedMarks);
};




var $k7eoe = parcelRequire("k7eoe");

const $f252b62bd7a1cfc2$export$1467dbbb3bb418c6 = (0, $k7eoe.FabricChannel).editor;





const $697ad0b0cd92ae81$export$c4a4504e8a9a0b2e = new (0, $ks2lK.PluginKey)('analyticsPlugin');


const $94f8c745f0d72a08$var$getUndoRedoInputSource = (tr)=>{
    // Please, do not copy or use this kind of code below
    return tr.getMeta('undoRedoPlugin$') ?? null;
};
const $94f8c745f0d72a08$export$67d130a769494b9b = (tr)=>{
    const undoRedoPluginInputSource = $94f8c745f0d72a08$var$getUndoRedoInputSource(tr);
    return (payload)=>{
        const shouldAddHistoryTriggerMethodAttribute = undoRedoPluginInputSource && [
            'undid',
            'redid'
        ].includes(payload.action);
        return !shouldAddHistoryTriggerMethodAttribute ? payload : {
            ...payload,
            attributes: {
                ...payload.attributes,
                historyTriggerMethod: undoRedoPluginInputSource
            }
        };
    };
};


function $3b43fa9f9a00094f$var$createPlugin(options, featureFlags) {
    if (!options) return;
    const hasRequiredPerformanceAPIs = (0, $aAn37.isPerformanceAPIAvailable)();
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $697ad0b0cd92ae81$export$c4a4504e8a9a0b2e),
        state: {
            init: ()=>{
                return {
                    ...options,
                    fireAnalytics: (0, $ajtqX.fireAnalyticsEvent)(options.createAnalyticsEvent)
                };
            },
            apply: (tr, pluginState, _, state)=>{
                const { createAnalyticsEvent: createAnalyticsEvent } = tr.getMeta((0, $697ad0b0cd92ae81$export$c4a4504e8a9a0b2e)) ?? {};
                // When the createAnalyticsEvent is reconfigured
                if (options.createAnalyticsEvent && options.createAnalyticsEvent !== pluginState.createAnalyticsEvent || pluginState.createAnalyticsEvent !== createAnalyticsEvent && createAnalyticsEvent) return {
                    ...pluginState,
                    createAnalyticsEvent: options.createAnalyticsEvent ?? createAnalyticsEvent
                };
                if (featureFlags.catchAllTracking) {
                    const analyticsEventWithChannel = (0, $4VpM8.getAnalyticsEventsFromTransaction)(tr);
                    if (analyticsEventWithChannel.length > 0) {
                        for (const { payload: payload, channel: channel } of analyticsEventWithChannel)// Measures how much time it takes to update the DOM after each ProseMirror document update
                        // that has an analytics event.
                        if (hasRequiredPerformanceAPIs && tr.docChanged && payload.action !== (0, $d925B.ACTION).INSERTED && payload.action !== (0, $d925B.ACTION).DELETED) {
                            const measureName = `${payload.actionSubject}:${payload.action}:${payload.actionSubjectId}`;
                            (0, $jz9wK.measureRender)(// NOTE this name could be resulting in misleading data -- where if multiple payloads are
                            // received before a render completes -- the measurement value will be inaccurate (this is
                            // due to measureRender requiring unique measureNames)
                            measureName, ({ duration: duration, distortedDuration: distortedDuration })=>{
                                (0, $ajtqX.fireAnalyticsEvent)(pluginState.createAnalyticsEvent)({
                                    payload: $3b43fa9f9a00094f$var$extendPayload({
                                        payload: payload,
                                        duration: duration,
                                        distortedDuration: distortedDuration
                                    }),
                                    channel: channel
                                });
                            });
                        }
                    }
                }
                return pluginState;
            }
        }
    });
}
/**
 * Analytics plugin to be added to an `EditorPresetBuilder` and used with `ComposableEditor`
 * from `@atlaskit/editor-core`.
 */ const $3b43fa9f9a00094f$export$f26023c5d4a5ab44 = ({ config: options = {}, api: api })=>{
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    const analyticsEventPropQueue = new Set();
    return {
        name: 'analytics',
        getSharedState: (editorState)=>{
            if (!editorState) return {
                createAnalyticsEvent: null,
                attachAnalyticsEvent: null,
                performanceTracking: undefined
            };
            const { createAnalyticsEvent: createAnalyticsEvent, performanceTracking: performanceTracking } = (0, $697ad0b0cd92ae81$export$c4a4504e8a9a0b2e).getState(editorState) ?? {};
            return {
                createAnalyticsEvent: createAnalyticsEvent,
                attachAnalyticsEvent: (0, $12fcbd906e4a44c8$export$539ce7f09649e93)(editorState.selection),
                performanceTracking: performanceTracking
            };
        },
        actions: {
            attachAnalyticsEvent: (payload, channel = (0, $f252b62bd7a1cfc2$export$1467dbbb3bb418c6))=>(tr)=>{
                    const { createAnalyticsEvent: createAnalyticsEvent, attachAnalyticsEvent: attachAnalyticsEvent } = api?.analytics?.sharedState.currentState() ?? {};
                    if (!tr || !createAnalyticsEvent || !attachAnalyticsEvent) {
                        analyticsEventPropQueue.add({
                            payload: payload,
                            channel: channel
                        });
                        return false;
                    }
                    attachAnalyticsEvent({
                        tr: tr,
                        payload: payload,
                        channel: channel
                    });
                    return true;
                },
            fireAnalyticsEvent (payload, channel = (0, $f252b62bd7a1cfc2$export$1467dbbb3bb418c6), options) {
                const { createAnalyticsEvent: createAnalyticsEvent } = api?.analytics?.sharedState.currentState() ?? {};
                if (options?.context) payload = (0, $66e1d4391a39b785$export$b8d8bec4e31cbd66)(options.context.selection, payload);
                if (!createAnalyticsEvent) {
                    analyticsEventPropQueue.add({
                        payload: payload,
                        channel: channel
                    });
                    return;
                }
                // This cast is needed to satisfy TS when using custom payloads which is only allowed by
                // the fireAnalyticsEvent function in EditorAnalyticsAPI for now.
                // createAnalyticsEvent actually fires our standard AnalyticsEventPayload type which is less strict
                // so this is safe.
                const firedPayload = payload;
                (0, $ajtqX.fireAnalyticsEvent)(createAnalyticsEvent, options)({
                    payload: firedPayload,
                    channel: channel
                });
            }
        },
        usePluginHook ({ editorView: editorView }) {
            const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
            (0, $42omo.useLayoutEffect)(()=>{
                const { dispatch: dispatch, state: { tr: tr } } = editorView;
                tr.setMeta((0, $697ad0b0cd92ae81$export$c4a4504e8a9a0b2e), {
                    createAnalyticsEvent: createAnalyticsEvent
                });
                dispatch(tr);
                // Attach all analytics events to the transaction
                analyticsEventPropQueue.forEach(({ payload: payload, channel: channel })=>{
                    createAnalyticsEvent(payload)?.fire(channel ?? (0, $f252b62bd7a1cfc2$export$1467dbbb3bb418c6));
                });
                // Clear the queue
                analyticsEventPropQueue.clear();
            }, [
                createAnalyticsEvent,
                editorView
            ]);
        },
        pmPlugins () {
            return [
                {
                    name: 'analyticsPlugin',
                    plugin: ()=>$3b43fa9f9a00094f$var$createPlugin(options, featureFlags)
                }
            ];
        },
        onEditorViewStateUpdated ({ originalTransaction: originalTransaction, transactions: transactions, newEditorState: newEditorState }) {
            const pluginState = (0, $697ad0b0cd92ae81$export$c4a4504e8a9a0b2e).getState(newEditorState);
            if (!pluginState || !pluginState.createAnalyticsEvent) return;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const steps = transactions.reduce((acc, tr)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const payloads = tr.steps// Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                .filter((step)=>step instanceof (0, $jy7VG.AnalyticsStep)).map((x)=>x.analyticsEvents).reduce((acc, val)=>acc.concat(val), []);
                acc.push(...payloads);
                return acc;
            }, []);
            if (steps.length === 0) return;
            const { createAnalyticsEvent: createAnalyticsEvent } = pluginState;
            const undoAnaltyicsEventTransformer = (0, $94f8c745f0d72a08$export$67d130a769494b9b)(originalTransaction);
            steps.forEach(({ payload: payload, channel: channel })=>{
                const nextPayload = undoAnaltyicsEventTransformer(payload);
                (0, $ajtqX.fireAnalyticsEvent)(createAnalyticsEvent)({
                    payload: nextPayload,
                    channel: channel
                });
            });
        }
    };
};
function $3b43fa9f9a00094f$var$extendPayload({ payload: payload, duration: duration, distortedDuration: distortedDuration }) {
    return {
        ...payload,
        attributes: {
            ...payload.attributes,
            duration: duration,
            distortedDuration: distortedDuration
        },
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
    };
}
module.exports["analyticsPlugin"] = $3b43fa9f9a00094f$export$f26023c5d4a5ab44;

});

parcelRegister("adayn", function(module, exports) {

var $8m4tT = parcelRequire("8m4tT");

const $72dd76db1875ebb5$export$de2a5eca4f1cacc0 = new WeakMap();
const $72dd76db1875ebb5$export$785b8bfd794fa7b6 = (node)=>{
    // @ts-ignore - TS2869 TypeScript 5.9.2 upgrade
    return !$72dd76db1875ebb5$export$de2a5eca4f1cacc0.get(node) ?? false;
};
const $72dd76db1875ebb5$export$90f32e719ed9ccda = (editorView, selection)=>{
    let parentNode = (0, $8m4tT.findParentNodeOfType)([
        editorView.state.schema.nodes.listItem,
        editorView.state.schema.nodes.heading,
        editorView.state.schema.nodes.blockquote,
        editorView.state.schema.nodes.taskItem,
        editorView.state.schema.nodes.mediaSingle
    ])(selection);
    const tableRowNode = (0, $8m4tT.findParentNodeOfType)([
        editorView.state.schema.nodes.tableRow
    ])(selection);
    if (tableRowNode) parentNode = tableRowNode;
    if (!parentNode) {
        const paragraphNode = (0, $8m4tT.findParentNodeOfType)([
            editorView.state.schema.nodes.paragraph
        ])(selection);
        if (!paragraphNode) return;
        parentNode = paragraphNode;
    }
    if (!parentNode) return undefined;
    const endPosOffset = parentNode && [
        'taskItem',
        'listItem',
        'tableRow'
    ].includes(parentNode.node.type.name) ? 1 : 0;
    const endOfTextblockPos = parentNode.start + parentNode.node.content.size + endPosOffset + 1;
    if (endOfTextblockPos > editorView.state.doc.content.size) return undefined;
    const $endOfTextblockPos = editorView.state.doc.resolve(endOfTextblockPos);
    if ($endOfTextblockPos?.nodeAfter && [
        'expand',
        'nestedExpand'
    ].includes($endOfTextblockPos.nodeAfter.type.name)) return endOfTextblockPos + 1;
    return undefined;
};
module.exports["expandedState"] = $72dd76db1875ebb5$export$de2a5eca4f1cacc0;
module.exports["isExpandCollapsed"] = $72dd76db1875ebb5$export$785b8bfd794fa7b6;
module.exports["getNextNodeExpandPos"] = $72dd76db1875ebb5$export$90f32e719ed9ccda;

});

parcelRegister("Yqd3z", function(module, exports) {
const $e7fc4d15e5a27605$export$21d634b1d5d9bee3 = '[data-editor-block-ctrl-drag-handle]';
const $e7fc4d15e5a27605$export$8e6a2e69f746ce30 = 12;
const $e7fc4d15e5a27605$export$4ca64d379b54b5d9 = '[data-toolbar-nested-dropdown-menu]';
module.exports["DRAG_HANDLE_SELECTOR"] = $e7fc4d15e5a27605$export$21d634b1d5d9bee3;
module.exports["DRAG_HANDLE_WIDTH"] = $e7fc4d15e5a27605$export$8e6a2e69f746ce30;
module.exports["NESTED_DROPDOWN_MENU"] = $e7fc4d15e5a27605$export$4ca64d379b54b5d9;

});

parcelRegister("2vD5B", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");


var $1oCLl = parcelRequire("1oCLl");

const $6fbfb3a48de5e245$var$styles = {
    container: "_2rko12b0 _bfhk1bhr _16qs130s",
    radiusUpdate: "_2rko1mok",
    emptyMenuSectionStyles: "_1cc0glyw _1k2yglyw"
};
const $6fbfb3a48de5e245$export$7ddb7d7248bd500a = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $frIzR.c)(9);
    const { children: children, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, testId: testId, xcss: xcss } = t0;
    let t1;
    if ($[0] !== xcss) {
        t1 = (0, $1Whri.cx)($6fbfb3a48de5e245$var$styles.container, (0, $1oCLl.expValEquals)("platform_editor_menu_radius_update", "isEnabled", true) && $6fbfb3a48de5e245$var$styles.radiusUpdate, (0, $1oCLl.expValEquals)("platform_editor_menu_radius_update", "isEnabled", true) && $6fbfb3a48de5e245$var$styles.emptyMenuSectionStyles, (0, $1oCLl.expValEquals)("platform_editor_menu_radius_update", "isEnabled", true) && xcss);
        $[0] = xcss;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== onMouseDown || $[4] !== onMouseEnter || $[5] !== ref || $[6] !== t1 || $[7] !== testId) {
        t2 = /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.Box), {
            xcss: t1,
            testId: testId,
            onMouseDown: onMouseDown,
            onMouseEnter: onMouseEnter,
            "data-toolbar-component": "menu",
            role: "menu",
            ref: ref,
            children: children
        });
        $[2] = children;
        $[3] = onMouseDown;
        $[4] = onMouseEnter;
        $[5] = ref;
        $[6] = t1;
        $[7] = testId;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ children: children, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, testId: testId, xcss: xcss }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.Box), {
        xcss: (0, $1Whri.cx)($6fbfb3a48de5e245$var$styles.container, (0, $1oCLl.expValEquals)('platform_editor_menu_radius_update', 'isEnabled', true) && $6fbfb3a48de5e245$var$styles.radiusUpdate, (0, $1oCLl.expValEquals)('platform_editor_menu_radius_update', 'isEnabled', true) && $6fbfb3a48de5e245$var$styles.emptyMenuSectionStyles, (0, $1oCLl.expValEquals)('platform_editor_menu_radius_update', 'isEnabled', true) && xcss),
        testId: testId,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        "data-toolbar-component": "menu",
        role: "menu",
        ref: ref,
        children: children
    });
});
module.exports["ToolbarMenuContainer"] = $6fbfb3a48de5e245$export$7ddb7d7248bd500a;

});

parcelRegister("87Gms", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");

parcelRequire("42omo");


var $1bHXt = parcelRequire("1bHXt");


var $52EPl = parcelRequire("52EPl");


var $g9Jfe = parcelRequire("g9Jfe");


var $gdv5Z = parcelRequire("gdv5Z");


var $2GVu1 = parcelRequire("2GVu1");


var $iIVVb = parcelRequire("iIVVb");

const $a02d656535d0452b$var$styles = {
    scrollContainer: "_c71lnklw _18m91wug"
};
const $a02d656535d0452b$export$21541b912954ea8c = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(22);
    const { elemBefore: elemBefore, text: text, elemAfterText: elemAfterText, elemAfter: elemAfter, children: children, isDisabled: isDisabled, testId: testId, dropdownTestId: dropdownTestId, enableMaxHeight: t1, onClick: onClick, shouldFitContainer: t2, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent, shouldTitleWrap: shouldTitleWrap, tooltipContent: tooltipContent, "data-extension-item-key": dataExtensionItemKey } = t0;
    const enableMaxHeight = t1 === undefined ? false : t1;
    const shouldFitContainer = t2 === undefined ? false : t2;
    const t3 = (0, $g9Jfe.fg)("cc_blocks_changeboarding") ? shouldIgnoreCloseEvent : undefined;
    let t4;
    if ($[0] !== dataExtensionItemKey || $[1] !== elemAfter || $[2] !== elemAfterText || $[3] !== elemBefore || $[4] !== isDisabled || $[5] !== onClick || $[6] !== shouldTitleWrap || $[7] !== testId || $[8] !== text || $[9] !== tooltipContent) {
        t4 = (triggerProps)=>{
            const item = /*#__PURE__*/ (0, $l998X.jsxs)((0, $2GVu1.ToolbarDropdownItem), {
                elemBefore: elemBefore,
                elemAfter: elemAfter,
                isSelected: triggerProps.isSelected,
                onClick: (e)=>{
                    onClick && onClick(e);
                    triggerProps.onClick && triggerProps.onClick(e);
                },
                testId: testId,
                triggerRef: triggerProps.triggerRef,
                hasNestedDropdownMenu: true,
                isDisabled: isDisabled,
                shouldTitleWrap: shouldTitleWrap,
                "data-extension-item-key": (0, $g9Jfe.fg)("cc_blocks_changeboarding") ? dataExtensionItemKey : undefined,
                children: [
                    text,
                    elemAfterText
                ]
            });
            if (tooltipContent) return /*#__PURE__*/ (0, $l998X.jsx)((0, $iIVVb.ToolbarTooltip), {
                content: tooltipContent,
                position: "top",
                children: item
            });
            return item;
        };
        $[0] = dataExtensionItemKey;
        $[1] = elemAfter;
        $[2] = elemAfterText;
        $[3] = elemBefore;
        $[4] = isDisabled;
        $[5] = onClick;
        $[6] = shouldTitleWrap;
        $[7] = testId;
        $[8] = text;
        $[9] = tooltipContent;
        $[10] = t4;
    } else t4 = $[10];
    const t5 = enableMaxHeight && $a02d656535d0452b$var$styles.scrollContainer;
    let t6;
    if ($[11] !== t5) {
        t6 = (0, $1bHXt.cx)(t5);
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== children || $[14] !== t6) {
        t7 = /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.Box), {
            xcss: t6,
            "data-toolbar-nested-dropdown-menu": true,
            children: children
        });
        $[13] = children;
        $[14] = t6;
        $[15] = t7;
    } else t7 = $[15];
    let t8;
    if ($[16] !== dropdownTestId || $[17] !== shouldFitContainer || $[18] !== t3 || $[19] !== t4 || $[20] !== t7) {
        t8 = /*#__PURE__*/ (0, $l998X.jsx)((0, $52EPl.default), {
            shouldFitContainer: shouldFitContainer,
            shouldIgnoreCloseEvent: t3,
            placement: "right-start",
            testId: dropdownTestId,
            trigger: t4,
            children: t7
        });
        $[16] = dropdownTestId;
        $[17] = shouldFitContainer;
        $[18] = t3;
        $[19] = t4;
        $[20] = t7;
        $[21] = t8;
    } else t8 = $[21];
    return t8;
} : ({ elemBefore: elemBefore, text: text, elemAfterText: elemAfterText, elemAfter: elemAfter, children: children, isDisabled: isDisabled, testId: testId, dropdownTestId: dropdownTestId, enableMaxHeight: enableMaxHeight = false, onClick: onClick, shouldFitContainer: shouldFitContainer = false, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent, shouldTitleWrap: shouldTitleWrap, tooltipContent: tooltipContent, 'data-extension-item-key': dataExtensionItemKey })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $52EPl.default), {
        shouldFitContainer: shouldFitContainer,
        shouldIgnoreCloseEvent: (0, $g9Jfe.fg)('cc_blocks_changeboarding') ? shouldIgnoreCloseEvent : undefined,
        placement: "right-start",
        testId: dropdownTestId,
        trigger: (triggerProps)=>{
            const item = /*#__PURE__*/ (0, $l998X.jsxs)((0, $2GVu1.ToolbarDropdownItem), {
                elemBefore: elemBefore,
                elemAfter: elemAfter,
                isSelected: triggerProps.isSelected,
                onClick: (e)=>{
                    onClick && onClick(e);
                    triggerProps.onClick && triggerProps.onClick(e);
                },
                testId: testId,
                triggerRef: triggerProps.triggerRef,
                hasNestedDropdownMenu: true,
                isDisabled: isDisabled,
                shouldTitleWrap: shouldTitleWrap,
                "data-extension-item-key": (0, $g9Jfe.fg)('cc_blocks_changeboarding') ? dataExtensionItemKey : undefined,
                children: [
                    text,
                    elemAfterText
                ]
            });
            if (tooltipContent) return /*#__PURE__*/ (0, $l998X.jsx)((0, $iIVVb.ToolbarTooltip), {
                content: tooltipContent,
                position: "top",
                children: item
            });
            return item;
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.Box), {
            xcss: (0, $1bHXt.cx)(enableMaxHeight && $a02d656535d0452b$var$styles.scrollContainer),
            "data-toolbar-nested-dropdown-menu": true,
            children: children
        })
    });
};
module.exports["ToolbarNestedDropdownMenu"] = $a02d656535d0452b$export$21541b912954ea8c;

});

parcelRegister("kXH7i", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $bI3mS = parcelRequire("bI3mS");


var $ks2lK = parcelRequire("ks2lK");

const $4f752808e6b613f5$var$pluginKey = new (0, $ks2lK.PluginKey)('clearMarksOnChangeToEmptyDocumentPlugin');
function $4f752808e6b613f5$var$createPlugin() {
    return new (0, $1S4f7.SafePlugin)({
        key: $4f752808e6b613f5$var$pluginKey,
        appendTransaction: (_transactions, oldState, newState)=>{
            // ED-2973: When a user clears the editor's content, remove the current active marks
            if (!(0, $bI3mS.isEmptyDocument)(oldState.doc) && (0, $bI3mS.isEmptyDocument)(newState.doc)) return newState.tr.setStoredMarks([]);
            return;
        }
    });
}
const $4f752808e6b613f5$export$30b76f1055cbb7e9 = ()=>({
        name: 'clearMarksOnEmptyDoc',
        pmPlugins () {
            return [
                {
                    name: 'clearMarksOnChange',
                    plugin: $4f752808e6b613f5$var$createPlugin
                }
            ];
        }
    });
module.exports["clearMarksOnEmptyDocPlugin"] = $4f752808e6b613f5$export$30b76f1055cbb7e9;

});

parcelRegister("acwPl", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $cMZNY = parcelRequire("cMZNY");


var $1S4f7 = parcelRequire("1S4f7");


var $5SAOw = parcelRequire("5SAOw");


var $8m4tT = parcelRequire("8m4tT");


var $ks2lK = parcelRequire("ks2lK");

const $a58403f7035f2379$export$7ff3d0e65871bad3 = new (0, $ks2lK.PluginKey)('clipboardPlugin');


var $e90e4c856ab8111f$export$304e24f67740de29 = /*#__PURE__*/ function(ClipboardEventType) {
    ClipboardEventType["CUT"] = "CUT";
    ClipboardEventType["COPY"] = "COPY";
    return ClipboardEventType;
}({});
let $e90e4c856ab8111f$var$lastEventType = null;
const $e90e4c856ab8111f$export$ae829ec7b2625219 = ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, schema: schema })=>{
    let editorView;
    const getEditorView = ()=>editorView;
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $a58403f7035f2379$export$7ff3d0e65871bad3),
        view: (view)=>{
            editorView = view;
            return {
                update: (view)=>{
                    editorView = view;
                }
            };
        },
        props: {
            handleDOMEvents: {
                cut: (view)=>{
                    $e90e4c856ab8111f$export$47cf4f31f028e0c9("CUT");
                    return $e90e4c856ab8111f$export$e8eabed2709e2a33(view, dispatchAnalyticsEvent, (0, $d925B.ACTION).CUT);
                },
                copy: (view)=>{
                    $e90e4c856ab8111f$export$47cf4f31f028e0c9("COPY");
                    return $e90e4c856ab8111f$export$e8eabed2709e2a33(view, dispatchAnalyticsEvent, (0, $d925B.ACTION).COPIED);
                }
            },
            clipboardSerializer: $e90e4c856ab8111f$export$33f65796de3575a9(schema, getEditorView)
        }
    });
};
const $e90e4c856ab8111f$export$33f65796de3575a9 = (schema, getEditorView)=>{
    const oldSerializer = (0, $5SAOw.DOMSerializer).fromSchema(schema);
    const newSerializer = new (0, $5SAOw.DOMSerializer)(oldSerializer.nodes, oldSerializer.marks);
    const originalSerializeFragment = newSerializer.serializeFragment.bind(newSerializer);
    newSerializer.serializeFragment = (content, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    options = {}, target)=>{
        const editorView = getEditorView();
        const selection = editorView.state.selection;
        // We do not need to handle when a user copies a tableRow + other content.
        // In that scenario it already wraps the Row with correct Table and attributes.
        if (!options.tableWrapperExists) {
            let i = 0;
            while(i < content.childCount){
                if (content.maybeChild(i)?.type.name === 'table') {
                    options.tableWrapperExists = true;
                    break;
                }
                i++;
            }
        }
        // When the content being copied includes a tableRow that is not already wrapped with a table,
        // We will wrap it with one ourselves, while preserving the parent table's attributes.
        if (content.firstChild?.type.name === 'tableRow' && !options.tableWrapperExists) {
            // We only want 1 table wrapping the rows.
            // tableWrapperExist is a custom prop added solely for the purposes of this recursive algorithm.
            // The function is recursively called for each node in the tree captured in the fragment.
            // For recursive logic see the bind call above and the prosemirror-model (https://github.com/ProseMirror/prosemirror-model/blob/master/src/to_dom.js#L44
            // and https://github.com/ProseMirror/prosemirror-model/blob/master/src/to_dom.js#L87)
            options.tableWrapperExists = true;
            const parentTable = (0, $8m4tT.findParentNodeOfType)(schema.nodes.table)(selection);
            const attributes = parentTable?.node.attrs;
            const newTable = schema.nodes.table;
            // Explicitly remove local id since we are creating a new table and it should have a unique local id which will be generated.
            const newTableNode = newTable.createChecked({
                ...attributes,
                localId: undefined
            }, content);
            const newContent = (0, $5SAOw.Fragment).from(newTableNode);
            // Pass updated content into original ProseMirror serializeFragment function.
            // Currently incorrectly typed in @Types. See this GitHub thread: https://github.com/DefinitelyTyped/DefinitelyTyped/pull/57668
            //@ts-ignore
            return originalSerializeFragment(newContent, options, target);
        }
        // Remove annotations from media nodes when copying to clipboard, only do this for copy operations
        // and keep existing content nodes from the parent.
        if ($e90e4c856ab8111f$var$lastEventType === "COPY" && content.firstChild?.type.name === 'media') {
            const mediaNode = content.firstChild;
            const strippedMediaNode = schema.nodes.media.createChecked(mediaNode.attrs, mediaNode.content, mediaNode.marks?.filter((mark)=>mark.type.name !== 'annotation'));
            // Content for media parents can include multiple content nodes (media and captions). We now take that
            // into consideration when we are stripping annotations.
            let contentArray = [
                strippedMediaNode
            ];
            content.forEach((node)=>{
                if (node.type.name !== 'media') contentArray = [
                    ...contentArray,
                    node
                ];
            });
            const newContent = (0, $5SAOw.Fragment).fromArray(contentArray);
            // Currently incorrectly typed, see comment above
            // @ts-ignore
            return originalSerializeFragment(newContent, options, target);
        }
        // If we're not copying any rows or media nodes, just run default serializeFragment function.
        // Currently incorrectly typed in @Types. See this GitHub thread: https://github.com/DefinitelyTyped/DefinitelyTyped/pull/57668
        //@ts-ignore
        return originalSerializeFragment(content, options, target);
    };
    return newSerializer;
};
const $e90e4c856ab8111f$export$e8eabed2709e2a33 = (view, dispatchAnalyticsEvent, action)=>{
    const clipboardAnalyticsPayload = (0, $cMZNY.getAnalyticsPayload)(view.state, action);
    if (clipboardAnalyticsPayload) dispatchAnalyticsEvent(clipboardAnalyticsPayload);
    // return false so we don't block any other plugins' cut or copy handlers
    // from running just because we are sending an analytics event
    return false;
};
const $e90e4c856ab8111f$export$47cf4f31f028e0c9 = (eventType)=>$e90e4c856ab8111f$var$lastEventType = eventType;


const $bef15437a6801032$var$clipboard = ()=>({
        name: 'clipboard',
        pmPlugins () {
            return [
                {
                    name: 'clipboard',
                    plugin: (options)=>(0, $e90e4c856ab8111f$export$ae829ec7b2625219)(options)
                }
            ];
        }
    });
var $bef15437a6801032$export$2e2bcd8739ae039 = $bef15437a6801032$var$clipboard;
module.exports["default"] = $bef15437a6801032$export$2e2bcd8739ae039;

});

parcelRegister("kbe7k", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");

const $1bf41817841eac5e$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('contextIdentiferPlugin');
async function $1bf41817841eac5e$var$updateContextIdentifier(config, api) {
    const provider = await config.contextIdentifierProvider;
    api?.core?.actions.execute(api?.contextIdentifier?.commands.setProvider({
        contextIdentifierProvider: provider
    }));
}
const $1bf41817841eac5e$export$ae829ec7b2625219 = (initialConfig, api)=>()=>{
        if (initialConfig) $1bf41817841eac5e$var$updateContextIdentifier(initialConfig, api);
        return new (0, $1S4f7.SafePlugin)({
            key: $1bf41817841eac5e$export$18d4026d1ea86bb1,
            state: {
                init: ()=>initialConfig,
                apply: (tr, pluginState)=>{
                    const meta = tr.getMeta($1bf41817841eac5e$export$18d4026d1ea86bb1);
                    return meta ? meta : pluginState;
                }
            }
        });
    };


const $62c1068719723e82$export$43b392516e89a467 = ({ config: config, api: api })=>{
    return {
        name: 'contextIdentifier',
        commands: {
            setProvider: (config)=>({ tr: tr })=>{
                    // If no change, don't dispatch
                    if (config?.contextIdentifierProvider === api?.contextIdentifier?.sharedState.currentState()?.contextIdentifierProvider) return null;
                    return tr.setMeta((0, $1bf41817841eac5e$export$18d4026d1ea86bb1), {
                        contextIdentifierProvider: config?.contextIdentifierProvider
                    });
                }
        },
        getSharedState (state) {
            if (!state) return undefined;
            return {
                contextIdentifierProvider: (0, $1bf41817841eac5e$export$18d4026d1ea86bb1).getState(state)?.contextIdentifierProvider
            };
        },
        pmPlugins: ()=>{
            return [
                {
                    name: 'contextIdentifier',
                    plugin: (0, $1bf41817841eac5e$export$ae829ec7b2625219)(config, api)
                }
            ];
        }
    };
};
module.exports["contextIdentifierPlugin"] = $62c1068719723e82$export$43b392516e89a467;

});

parcelRegister("l7rln", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");

const $8eb28bf449dbd43f$var$pluginKey = new (0, $ks2lK.PluginKey)('featureFlags');
const $8eb28bf449dbd43f$export$79626a094e303f80 = ({ config: featureFlags = {} })=>({
        name: 'featureFlags',
        getSharedState (editorState) {
            if (!editorState) return featureFlags || {};
            return $8eb28bf449dbd43f$var$pluginKey.getState(editorState) || featureFlags || {};
        },
        pmPlugins () {
            return [
                {
                    name: 'featureFlags',
                    plugin: ()=>new (0, $1S4f7.SafePlugin)({
                            key: $8eb28bf449dbd43f$var$pluginKey,
                            state: {
                                init: ()=>({
                                        ...featureFlags
                                    }),
                                apply: (_, pluginState)=>pluginState
                            }
                        })
                }
            ];
        }
    });
module.exports["featureFlagsPlugin"] = $8eb28bf449dbd43f$export$79626a094e303f80;

});

parcelRegister("jS0a0", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");

const $f9b63c7aa6ca33fa$export$df61b30b684217c0 = new (0, $ks2lK.PluginKey)('focusPluginHandler');
const $f9b63c7aa6ca33fa$export$ae829ec7b2625219 = ()=>new (0, $1S4f7.SafePlugin)({
        key: $f9b63c7aa6ca33fa$export$df61b30b684217c0,
        state: {
            init () {
                return {
                    hasFocus: false
                };
            },
            apply (tr, oldPluginState) {
                const meta = tr.getMeta($f9b63c7aa6ca33fa$export$df61b30b684217c0);
                if (typeof meta === 'boolean') {
                    if (meta !== oldPluginState.hasFocus) return {
                        hasFocus: meta
                    };
                }
                return oldPluginState;
            }
        },
        props: {
            handleDOMEvents: {
                focus: (view)=>{
                    const focusState = $f9b63c7aa6ca33fa$export$df61b30b684217c0.getState(view.state);
                    if (!focusState?.hasFocus) view.dispatch(view.state.tr.setMeta($f9b63c7aa6ca33fa$export$df61b30b684217c0, true));
                    return false;
                },
                blur: (view)=>{
                    const focusState = $f9b63c7aa6ca33fa$export$df61b30b684217c0.getState(view.state);
                    if (focusState?.hasFocus) view.dispatch(view.state.tr.setMeta($f9b63c7aa6ca33fa$export$df61b30b684217c0, false));
                    return false;
                }
            }
        }
    });


const $5de22ed74749f08f$export$78540d08bd386fba = ({ api: _api })=>{
    return {
        name: 'focus',
        getSharedState (editorState) {
            if (!editorState) return {
                hasFocus: false
            };
            return {
                hasFocus: Boolean((0, $f9b63c7aa6ca33fa$export$df61b30b684217c0).getState(editorState)?.hasFocus)
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'focusHandlerPlugin',
                    plugin: (0, $f9b63c7aa6ca33fa$export$ae829ec7b2625219)
                }
            ];
        }
    };
};
module.exports["focusPlugin"] = $5de22ed74749f08f$export$78540d08bd386fba;

});

parcelRegister("HYzBP", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $lkJUe = parcelRequire("lkJUe");

var $6a5eda8a3c839f56$export$324bf1d9598f1f30 = /*#__PURE__*/ function(HistoryActionTypes) {
    HistoryActionTypes["UPDATE"] = "UPDATE";
    return HistoryActionTypes;
}({});



const $b86e11f1ad027829$var$reducer = (state, action)=>{
    switch(action.type){
        case (0, $6a5eda8a3c839f56$export$324bf1d9598f1f30).UPDATE:
            return {
                canUndo: action.canUndo,
                canRedo: action.canRedo
            };
    }
    return state;
};
var $b86e11f1ad027829$export$2e2bcd8739ae039 = $b86e11f1ad027829$var$reducer;



var $l9G9n = parcelRequire("l9G9n");

// Internal prosemirror history plugin does not export its plugin key.
// Previously we searched through all the plugins to find the history plugin
// but it's faster to look up the plugin directly via `getState`.
const $6cc951fdff6f8091$var$fakePluginKey = {
    key: (0, $l9G9n.pmHistoryPluginKey),
    getState: (state)=>{
        // The plugin key is used to index state
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return state[0, $l9G9n.pmHistoryPluginKey];
    },
    get (state) {
        return state.plugins.find(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (plugin)=>plugin.key === (0, $l9G9n.pmHistoryPluginKey));
    }
};
const $6cc951fdff6f8091$export$6bcebd7b5d7b9325 = (state)=>{
    return $6cc951fdff6f8091$var$fakePluginKey.getState(state);
};



var $ks2lK = parcelRequire("ks2lK");

const $510a64dd8161a6ce$export$8869884044241c3c = new (0, $ks2lK.PluginKey)('historyPlugin');


const $2bd8775bc1fc5e24$var$getInitialState = ()=>({
        canUndo: false,
        canRedo: false
    });
const { createPluginState: $2bd8775bc1fc5e24$var$createPluginState, getPluginState: $2bd8775bc1fc5e24$var$getPluginState } = (0, $lkJUe.pluginFactory)((0, $510a64dd8161a6ce$export$8869884044241c3c), (0, $b86e11f1ad027829$export$2e2bcd8739ae039));
const $2bd8775bc1fc5e24$var$createPlugin = (dispatch)=>new (0, $1S4f7.SafePlugin)({
        state: $2bd8775bc1fc5e24$var$createPluginState(dispatch, $2bd8775bc1fc5e24$var$getInitialState),
        key: (0, $510a64dd8161a6ce$export$8869884044241c3c),
        appendTransaction: (transactions, oldState, newState)=>{
            if (transactions.find((tr)=>tr.docChanged && tr.getMeta('addToHistory') !== false || tr.getMeta('endHistorySlice'))) {
                const pmHistoryPluginState = (0, $6cc951fdff6f8091$export$6bcebd7b5d7b9325)(newState);
                if (!pmHistoryPluginState) return;
                const canUndo = pmHistoryPluginState.done.eventCount > 0;
                const canRedo = pmHistoryPluginState.undone.eventCount > 0;
                const { canUndo: prevCanUndo, canRedo: prevCanRedo } = $2bd8775bc1fc5e24$var$getPluginState(newState);
                if (canUndo !== prevCanUndo || canRedo !== prevCanRedo) {
                    const action = {
                        type: (0, $6a5eda8a3c839f56$export$324bf1d9598f1f30).UPDATE,
                        canUndo: canUndo,
                        canRedo: canRedo
                    };
                    return newState.tr.setMeta((0, $510a64dd8161a6ce$export$8869884044241c3c), action);
                }
            }
        }
    });
const $2bd8775bc1fc5e24$var$historyPlugin = ({ api: api })=>{
    let currentId = null;
    return {
        name: 'history',
        pmPlugins () {
            return [
                {
                    name: 'history',
                    plugin: ({ dispatch: dispatch })=>$2bd8775bc1fc5e24$var$createPlugin(dispatch)
                }
            ];
        },
        getSharedState: (editorState)=>{
            if (!editorState) return undefined;
            const historyPluginState = (0, $510a64dd8161a6ce$export$8869884044241c3c).getState(editorState);
            if (!historyPluginState) return undefined;
            const { done: done, undone: undone } = (0, $6cc951fdff6f8091$export$6bcebd7b5d7b9325)(editorState) ?? {};
            return {
                canUndo: historyPluginState.canUndo,
                canRedo: historyPluginState.canRedo,
                done: {
                    eventCount: done?.eventCount ?? 0
                },
                undone: {
                    eventCount: undone?.eventCount ?? 0
                }
            };
        },
        commands: {
            updatePluginState: ({ tr: tr })=>{
                const { done: done, undone: undone } = api?.history.sharedState.currentState() ?? {};
                if (done === undefined || undone === undefined) return tr;
                const canUndo = done.eventCount > 0;
                const canRedo = undone.eventCount > 0;
                const action = {
                    type: (0, $6a5eda8a3c839f56$export$324bf1d9598f1f30).UPDATE,
                    canUndo: canUndo,
                    canRedo: canRedo
                };
                return tr.setMeta((0, $510a64dd8161a6ce$export$8869884044241c3c), action);
            },
            startHistorySlice: (id)=>({ tr: tr })=>{
                    if (currentId) return null;
                    currentId = id;
                    return tr.setMeta('startHistorySlice', true);
                },
            endHistorySlice: (id)=>({ tr: tr })=>{
                    if (currentId !== id) return null;
                    currentId = null;
                    return tr.setMeta('endHistorySlice', true);
                }
        }
    };
};
var $2bd8775bc1fc5e24$export$2e2bcd8739ae039 = $2bd8775bc1fc5e24$var$historyPlugin;
module.exports["default"] = $2bd8775bc1fc5e24$export$2e2bcd8739ae039;

});

parcelRegister("6AqNX", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");

const $b913d4d013f6b599$export$df61b30b684217c0 = new (0, $ks2lK.PluginKey)('interactionPluginHandler');
const $b913d4d013f6b599$var$handleInteraction = (view)=>{
    const interactionState = $b913d4d013f6b599$export$df61b30b684217c0.getState(view.state);
    if (!interactionState?.hasHadInteraction) view.dispatch(view.state.tr.setMeta($b913d4d013f6b599$export$df61b30b684217c0, {
        hasHadInteraction: true
    }));
    return false;
};
const $b913d4d013f6b599$export$ae829ec7b2625219 = ()=>new (0, $1S4f7.SafePlugin)({
        key: $b913d4d013f6b599$export$df61b30b684217c0,
        state: {
            init () {
                return {
                    hasHadInteraction: false
                };
            },
            apply (tr, oldPluginState) {
                const meta = tr.getMeta($b913d4d013f6b599$export$df61b30b684217c0);
                if (typeof meta === 'object') {
                    if (meta.hasHadInteraction !== oldPluginState.hasHadInteraction) return {
                        hasHadInteraction: meta.hasHadInteraction
                    };
                }
                return oldPluginState;
            }
        },
        props: {
            handleDOMEvents: {
                // Handle all pointer click events (includes drag inside editor)
                mousedown: $b913d4d013f6b599$var$handleInteraction,
                // Handle keyboard events. Must be keyup to handle tabbing into editor (keyup occurs
                // on the "next focused" element)
                keyup: $b913d4d013f6b599$var$handleInteraction,
                // Handle drag and drop _into_ the editor from outside. Eg image DnD
                drop: $b913d4d013f6b599$var$handleInteraction,
                focus: $b913d4d013f6b599$var$handleInteraction
            }
        }
    });


const $d25dda4ec15a5e92$export$f92f816359ce0a38 = ()=>{
    return {
        name: 'interaction',
        getSharedState (editorState) {
            if (!editorState) return {
                interactionState: 'hasNotHadInteraction'
            };
            return {
                /**
         * Interaction state can either be null or 'hasNotHadInteraction'. We
         * are specifically only returning an explicit value for 'hasNotHadInteraction'
         * because behaviour should only change when the user has _not_ ineteracted
         * with the editor. The behaviour of when `hasHadInteraction` is true and
         * when the plugin is undefined should be the same.
         */ interactionState: (0, $b913d4d013f6b599$export$df61b30b684217c0).getState(editorState)?.hasHadInteraction ? null : 'hasNotHadInteraction'
            };
        },
        commands: {
            handleInteraction: ({ tr: tr })=>{
                return tr.setMeta((0, $b913d4d013f6b599$export$df61b30b684217c0), {
                    hasHadInteraction: true
                });
            }
        },
        pmPlugins () {
            return [
                {
                    name: 'interactionHandlerPlugin',
                    plugin: (0, $b913d4d013f6b599$export$ae829ec7b2625219)
                }
            ];
        }
    };
};
module.exports["interactionPlugin"] = $d25dda4ec15a5e92$export$f92f816359ce0a38;

});

parcelRegister("kYgUn", function(module, exports) {
/* placeholderPlugin.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $eTj7Y = parcelRequire("eTj7Y");


var $bI3mS = parcelRequire("bI3mS");


var $ks2lK = parcelRequire("ks2lK");


var $gdv5Z = parcelRequire("gdv5Z");


var $9hlns = parcelRequire("9hlns");


var $1S4f7 = parcelRequire("1S4f7");


var $aeAfU = parcelRequire("aeAfU");


var $kYgUn = parcelRequire("kYgUn");

const $2298aaad5b52bb00$export$53e9a5af7ff64f3e = 'placeholder-test-id';
const $2298aaad5b52bb00$export$2d1270bfa8929bb4 = 50; // Delay between typing each character
const $2298aaad5b52bb00$export$ae685e1a0fa5d78 = 2000; // Pause before starting to erase text
const $2298aaad5b52bb00$export$ff06808c8f6da73a = 40; // Delay between erasing each character
const $2298aaad5b52bb00$export$d41926d20419077b = 500; // Delay before starting next cycle
const $2298aaad5b52bb00$export$4b72a719051acd03 = 1500; // Delay before starting animation after user typed and deleted
const $2298aaad5b52bb00$export$a754230d588f273f = [
    'expand',
    'panel'
];
const $2298aaad5b52bb00$export$70f0891e62fedaad = [
    'tableCell',
    'tableHeader'
];
const $2298aaad5b52bb00$export$b5dfee3212a7a6ea = [
    'bodiedSyncBlock'
];



var $d7ZU3 = parcelRequire("d7ZU3");


var $6tl2G = parcelRequire("6tl2G");


var $TfRUG = parcelRequire("TfRUG");


var $5SAOw = parcelRequire("5SAOw");


var $ftzrq = parcelRequire("ftzrq");


var $iu6m9 = parcelRequire("iu6m9");


const $ca7e9dbc2b9889fb$export$e2d45b5ccf27f1ce = (placeholderPrompts, activeTypewriterTimeouts, placeholderNodeWithText, initialDelayWhenUserTypedAndDeleted = 0)=>{
    let currentPromptIndex = 0;
    let displayedText = '';
    let animationTimeouts = [];
    const clearAllTimeouts = ()=>{
        animationTimeouts.forEach((timeoutId)=>clearTimeout(timeoutId));
        animationTimeouts = [];
    };
    const scheduleTimeout = (callback, delay)=>{
        const timeoutId = setTimeout(callback, delay);
        animationTimeouts.push(timeoutId);
        return timeoutId;
    };
    const startAnimationCycle = ()=>{
        const currentPrompt = placeholderPrompts[currentPromptIndex];
        let characterIndex = 0;
        const typeNextCharacter = ()=>{
            if (characterIndex < currentPrompt.length) {
                displayedText = currentPrompt.substring(0, characterIndex + 1);
                placeholderNodeWithText.textContent = displayedText;
                characterIndex++;
                scheduleTimeout(typeNextCharacter, (0, $2298aaad5b52bb00$export$2d1270bfa8929bb4));
            } else scheduleTimeout(eraseLastCharacter, (0, $2298aaad5b52bb00$export$ae685e1a0fa5d78));
        };
        const eraseLastCharacter = ()=>{
            if (displayedText.length > 1) {
                displayedText = displayedText.substring(0, displayedText.length - 1);
                placeholderNodeWithText.textContent = displayedText;
                scheduleTimeout(eraseLastCharacter, (0, $2298aaad5b52bb00$export$ff06808c8f6da73a));
            } else {
                displayedText = ' ';
                placeholderNodeWithText.textContent = displayedText;
                currentPromptIndex = (currentPromptIndex + 1) % placeholderPrompts.length;
                scheduleTimeout(startAnimationCycle, (0, $2298aaad5b52bb00$export$d41926d20419077b));
            }
        };
        typeNextCharacter();
    };
    activeTypewriterTimeouts?.push(clearAllTimeouts);
    if (initialDelayWhenUserTypedAndDeleted > 0) {
        placeholderNodeWithText.textContent = ' ';
        scheduleTimeout(startAnimationCycle, initialDelayWhenUserTypedAndDeleted);
    } else startAnimationCycle();
};



function $9124964b11572045$export$980ea07f18fbfea9(editorState, placeholderText, placeholderPrompts, activeTypewriterTimeouts, pos = 1, initialDelayWhenUserTypedAndDeleted = 0, placeholderADF, showOnEmptyParagraph) {
    const browser = (0, $d7ZU3.getBrowserInfo)();
    const placeholderDecoration = document.createElement('span');
    let placeholderNodeWithText = placeholderDecoration;
    placeholderDecoration.setAttribute('data-testid', (0, $2298aaad5b52bb00$export$53e9a5af7ff64f3e));
    const shouldFadeIn = showOnEmptyParagraph;
    placeholderDecoration.className = shouldFadeIn ? 'placeholder-decoration placeholder-decoration-fade-in' : 'placeholder-decoration';
    placeholderDecoration.setAttribute('aria-hidden', 'true'); // PM sets contenteditable to false on Decorations so Firefox doesn't display the flashing cursor
    // So adding an extra span which will contain the placeholder text
    if (browser.gecko) {
        const placeholderNode = document.createElement('span');
        placeholderNode.setAttribute('contenteditable', 'true'); // explicitly overriding the default Decoration behaviour
        placeholderDecoration.appendChild(placeholderNode);
        placeholderNodeWithText = placeholderNode;
    }
    if (placeholderText) placeholderNodeWithText.textContent = placeholderText || ' ';
    else if (placeholderADF) {
        const serializer = (0, $5SAOw.DOMSerializer).fromSchema(editorState.schema); // Get a PMNode from docnode
        const docNode = (0, $6tl2G.processRawValue)(editorState.schema, placeholderADF);
        if (docNode) {
            // Extract only the inline content from paragraphs, avoiding block-level elements
            // that can interfere with cursor rendering
            docNode.children.forEach((node)=>{
                // For paragraph nodes, serialize their content (inline elements) directly
                // without the wrapping <p> tag
                if (node.type.name === 'paragraph') node.content.forEach((inlineNode)=>{
                    const inlineDOM = serializer.serializeNode(inlineNode);
                    placeholderNodeWithText.append(inlineDOM);
                });
                else {
                    // For non-paragraph nodes, serialize normally
                    const nodeDOM = serializer.serializeNode(node);
                    placeholderNodeWithText.append(nodeDOM);
                }
            });
            const markElements = placeholderNodeWithText.querySelectorAll('[data-prosemirror-content-type="mark"]');
            markElements.forEach((markEl)=>{
                if (markEl instanceof HTMLElement) markEl.style.setProperty('color', "var(--ds-text-subtlest, #6B6E76)");
            }); // Ensure all child elements don't block pointer events or cursor
            const allElements = placeholderNodeWithText.querySelectorAll('*');
            allElements.forEach((el)=>{
                if (el instanceof HTMLElement) {
                    el.style.pointerEvents = 'none';
                    el.style.userSelect = 'none';
                }
            });
        }
    } else if (placeholderPrompts) (0, $ca7e9dbc2b9889fb$export$e2d45b5ccf27f1ce)(placeholderPrompts, activeTypewriterTimeouts, placeholderNodeWithText, initialDelayWhenUserTypedAndDeleted);
    // ME-2289 Tapping on backspace in empty editor hides and displays the keyboard
    // Add a editable buff node as the cursor moving forward is inevitable
    // when backspace in GBoard composition
    if (browser.android && browser.chrome) {
        const buffNode = document.createElement('span');
        buffNode.setAttribute('class', 'placeholder-android');
        buffNode.setAttribute('contenteditable', 'true');
        buffNode.textContent = ' ';
        placeholderDecoration.appendChild(buffNode);
    }
    const isTargetNested = editorState.doc.resolve(pos).depth > 1; // only truncate text for nested nodes, otherwise applying 'overflow: hidden;' to top level nodes
    // creates issues with quick insert button
    if (isTargetNested && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) placeholderDecoration.classList.add('placeholder-decoration-hide-overflow');
    if (placeholderADF && browser.chrome) {
        const fragment = document.createDocumentFragment(); // An issue occurs with the caret where it gets bigger when it's next to a non-editable element like a decoration.
        // See: https://discuss.prosemirror.net/t/chrome-caret-cursor-larger-than-the-text-with-inlined-items/5946/2
        // Adding a zero-width space seems to fix this issue.
        fragment.appendChild(document.createTextNode((0, $TfRUG.ZERO_WIDTH_SPACE)));
        fragment.appendChild(placeholderDecoration);
        return (0, $ftzrq.DecorationSet).create(editorState.doc, [
            (0, $ftzrq.Decoration).widget(pos, fragment, {
                side: 0,
                key: `placeholder ${placeholderText}`
            })
        ]);
    }
    return (0, $ftzrq.DecorationSet).create(editorState.doc, [
        (0, $ftzrq.Decoration).widget(pos, placeholderDecoration, {
            side: 0,
            key: `placeholder ${placeholderText}`
        })
    ]);
}



var $hdkJi = parcelRequire("hdkJi");


var $2pjJ5 = parcelRequire("2pjJ5");

var $l9G9n = parcelRequire("l9G9n");




var $cX9xt = parcelRequire("cX9xt");


var $8m4tT = parcelRequire("8m4tT");


var $1oCLl = parcelRequire("1oCLl");








var $iJQnc = parcelRequire("iJQnc");

var $aoDcQ = parcelRequire("aoDcQ");




const $715a4eb6f35c742c$export$1107bf49e86ec6cc = ({ formatMessage: formatMessage })=>({
        version: 1,
        type: 'doc',
        content: [
            {
                type: 'paragraph',
                content: [
                    (0, $iJQnc.code)(formatMessage((0, $hdkJi.placeholderTextMessages).shortEmptyNodePlaceholderADFSlashShortcut)),
                    (0, $aoDcQ.text)(' '),
                    (0, $aoDcQ.text)(formatMessage((0, $hdkJi.placeholderTextMessages).shortEmptyNodePlaceholderADFSuffix))
                ]
            }
        ]
    });
const $715a4eb6f35c742c$export$45e9ce38f04dd0ca = ({ formatMessage: formatMessage })=>({
        version: 1,
        type: 'doc',
        content: [
            {
                type: 'paragraph',
                content: [
                    (0, $aoDcQ.text)(formatMessage((0, $hdkJi.placeholderTextMessages).longEmptyNodePlaceholderADFPrefix)),
                    (0, $aoDcQ.text)(' '),
                    (0, $iJQnc.code)(formatMessage((0, $hdkJi.placeholderTextMessages).longEmptyNodePlaceholderADFSlashShortcut)),
                    (0, $aoDcQ.text)(' '),
                    (0, $aoDcQ.text)(formatMessage((0, $hdkJi.placeholderTextMessages).longEmptyNodePlaceholderADFSuffix))
                ]
            }
        ]
    });



function $5be848d566fb6ba7$export$3defeb66989079cc(editorState) {
    return (0, $kYgUn.pluginKey).getState(editorState);
}
function $5be848d566fb6ba7$export$5e4e0b200a219da7({ placeholderText: placeholderText, pos: pos, placeholderPrompts: placeholderPrompts, typedAndDeleted: typedAndDeleted, userHadTyped: userHadTyped, canShowOnEmptyParagraph: canShowOnEmptyParagraph, showOnEmptyParagraph: showOnEmptyParagraph, contextPlaceholderADF: contextPlaceholderADF }) {
    return {
        hasPlaceholder: true,
        placeholderText: placeholderText,
        placeholderPrompts: placeholderPrompts,
        contextPlaceholderADF: contextPlaceholderADF,
        pos: pos ? pos : 1,
        typedAndDeleted: typedAndDeleted,
        userHadTyped: userHadTyped,
        canShowOnEmptyParagraph: canShowOnEmptyParagraph,
        showOnEmptyParagraph: showOnEmptyParagraph
    };
}
const $5be848d566fb6ba7$export$a76584009ca8faeb = ({ placeholderText: placeholderText, placeholderPrompts: placeholderPrompts, userHadTyped: userHadTyped, pos: pos, canShowOnEmptyParagraph: canShowOnEmptyParagraph, showOnEmptyParagraph: showOnEmptyParagraph })=>({
        hasPlaceholder: false,
        placeholderText: placeholderText,
        placeholderPrompts: placeholderPrompts,
        userHadTyped: userHadTyped,
        typedAndDeleted: false,
        canShowOnEmptyParagraph: canShowOnEmptyParagraph,
        showOnEmptyParagraph: showOnEmptyParagraph,
        pos: pos
    });
function $5be848d566fb6ba7$export$e919c54ee5ce8f92({ isInitial: isInitial, isEditorFocused: isEditorFocused, editorState: editorState, isTypeAheadOpen: isTypeAheadOpen, defaultPlaceholderText: defaultPlaceholderText, intl: intl, bracketPlaceholderText: bracketPlaceholderText, emptyLinePlaceholder: emptyLinePlaceholder, placeholderADF: placeholderADF, placeholderPrompts: placeholderPrompts, typedAndDeleted: typedAndDeleted, userHadTyped: userHadTyped, isPlaceholderHidden: isPlaceholderHidden, withEmptyParagraph: withEmptyParagraph, showOnEmptyParagraph: showOnEmptyParagraph }) {
    const shouldHidePlaceholder = isPlaceholderHidden;
    if (shouldHidePlaceholder) return {
        ...$5be848d566fb6ba7$export$a76584009ca8faeb({
            placeholderText: defaultPlaceholderText,
            placeholderPrompts: placeholderPrompts,
            userHadTyped: userHadTyped
        }),
        isPlaceholderHidden: isPlaceholderHidden
    };
    if (isTypeAheadOpen?.(editorState)) return $5be848d566fb6ba7$export$a76584009ca8faeb({
        placeholderText: defaultPlaceholderText,
        placeholderPrompts: placeholderPrompts,
        userHadTyped: userHadTyped
    });
    if ((defaultPlaceholderText || placeholderPrompts || placeholderADF) && (0, $bI3mS.isEmptyDocument)(editorState.doc)) return $5be848d566fb6ba7$export$5e4e0b200a219da7({
        placeholderText: defaultPlaceholderText,
        pos: 1,
        placeholderPrompts: placeholderPrompts,
        typedAndDeleted: typedAndDeleted,
        userHadTyped: userHadTyped
    });
    if (withEmptyParagraph) {
        const { from: from, to: to, $to: $to } = editorState.selection;
        const isOnEmptyParagraphInNonEmptyDoc = (defaultPlaceholderText || placeholderADF) && withEmptyParagraph && !isInitial && !(0, $bI3mS.isEmptyDocument)(editorState.doc) && from === to && (0, $l9G9n.isEmptyParagraph)($to.parent) && (0, $l9G9n.hasDocAsParent)($to);
        if (isOnEmptyParagraphInNonEmptyDoc) {
            // If placeholder was already shown, keep it visible even without focus
            // This prevents the placeholder from disappearing when switching browser tabs
            if (showOnEmptyParagraph) return $5be848d566fb6ba7$export$5e4e0b200a219da7({
                placeholderText: defaultPlaceholderText,
                pos: to,
                placeholderPrompts: placeholderPrompts,
                typedAndDeleted: typedAndDeleted,
                userHadTyped: userHadTyped,
                canShowOnEmptyParagraph: true,
                showOnEmptyParagraph: true
            });
            // Focus is required to start the timeout for showing placeholder
            if (isEditorFocused) return $5be848d566fb6ba7$export$a76584009ca8faeb({
                placeholderText: defaultPlaceholderText,
                placeholderPrompts: placeholderPrompts,
                userHadTyped: userHadTyped,
                canShowOnEmptyParagraph: true,
                showOnEmptyParagraph: false,
                pos: to
            });
        }
    }
    if (isEditorFocused && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) {
        const { $from: $from, $to: $to } = editorState.selection;
        if ($from.pos !== $to.pos) return $5be848d566fb6ba7$export$a76584009ca8faeb({
            placeholderText: defaultPlaceholderText,
            placeholderPrompts: placeholderPrompts,
            userHadTyped: userHadTyped
        });
        const parentNode = $from.node($from.depth - 1);
        const parentType = parentNode?.type && (0, $1oCLl.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $cX9xt.getBaseNodeTypeName)(parentNode.type) : parentNode?.type?.name;
        if (emptyLinePlaceholder && parentType === 'doc') {
            const isEmptyLine = (0, $l9G9n.isEmptyParagraph)($from.parent);
            if (isEmptyLine) return $5be848d566fb6ba7$export$5e4e0b200a219da7({
                placeholderText: emptyLinePlaceholder,
                pos: $from.pos,
                placeholderPrompts: placeholderPrompts,
                typedAndDeleted: typedAndDeleted,
                userHadTyped: userHadTyped
            });
        }
        const isEmptyNode = parentNode?.childCount === 1 && parentNode.firstChild?.content.size === 0 && parentNode.firstChild?.type.name === 'paragraph';
        if ((0, $2298aaad5b52bb00$export$70f0891e62fedaad).includes(parentType) && isEmptyNode) {
            const table = (0, $8m4tT.findParentNode)((node)=>node.type === editorState.schema.nodes.table)(editorState.selection);
            if (!table) return $5be848d566fb6ba7$export$a76584009ca8faeb({
                placeholderText: defaultPlaceholderText,
                placeholderPrompts: placeholderPrompts,
                userHadTyped: userHadTyped
            });
            const isFirstCell = table?.node.firstChild?.content.firstChild === parentNode;
            if (isFirstCell) return $5be848d566fb6ba7$export$5e4e0b200a219da7({
                placeholderText: undefined,
                contextPlaceholderADF: (0, $715a4eb6f35c742c$export$1107bf49e86ec6cc)(intl),
                pos: $from.pos,
                placeholderPrompts: placeholderPrompts,
                typedAndDeleted: typedAndDeleted,
                userHadTyped: userHadTyped
            });
        }
        if ((0, $2298aaad5b52bb00$export$a754230d588f273f).includes(parentType) && isEmptyNode) return $5be848d566fb6ba7$export$5e4e0b200a219da7({
            placeholderText: undefined,
            contextPlaceholderADF: (0, $715a4eb6f35c742c$export$45e9ce38f04dd0ca)(intl),
            pos: $from.pos,
            placeholderPrompts: placeholderPrompts,
            typedAndDeleted: typedAndDeleted,
            userHadTyped: userHadTyped
        });
        if ((0, $2298aaad5b52bb00$export$b5dfee3212a7a6ea).includes(parentType) && isEmptyNode && (0, $iu6m9.editorExperiment)('platform_synced_block', true) && !(0, $1oCLl.expValEquals)('platform_editor_sync_block_activation', 'isEnabled', true)) return $5be848d566fb6ba7$export$5e4e0b200a219da7({
            placeholderText: intl.formatMessage((0, $hdkJi.placeholderTextMessages).sourceSyncBlockPlaceholderText),
            pos: $from.pos,
            placeholderPrompts: placeholderPrompts,
            typedAndDeleted: typedAndDeleted,
            userHadTyped: userHadTyped
        });
        return $5be848d566fb6ba7$export$a76584009ca8faeb({
            placeholderText: defaultPlaceholderText,
            placeholderPrompts: placeholderPrompts,
            userHadTyped: userHadTyped
        });
    }
    if (bracketPlaceholderText && (0, $2pjJ5.bracketTyped)(editorState) && isEditorFocused) {
        const { $from: $from } = editorState.selection;
        // Space is to account for positioning of the bracket
        const bracketHint = '  ' + bracketPlaceholderText;
        return $5be848d566fb6ba7$export$5e4e0b200a219da7({
            placeholderText: bracketHint,
            pos: $from.pos - 1,
            placeholderPrompts: placeholderPrompts,
            typedAndDeleted: typedAndDeleted,
            userHadTyped: userHadTyped
        });
    }
    return $5be848d566fb6ba7$export$a76584009ca8faeb({
        placeholderText: defaultPlaceholderText,
        placeholderPrompts: placeholderPrompts,
        userHadTyped: userHadTyped
    });
}
function $5be848d566fb6ba7$export$31fe4973d007ea9c({ placeholderState: placeholderState, oldEditorState: oldEditorState, newEditorState: newEditorState }) {
    const wasEmpty = oldEditorState ? (0, $bI3mS.isEmptyDocument)(oldEditorState.doc) : true;
    const isEmpty = (0, $bI3mS.isEmptyDocument)(newEditorState.doc);
    const hasEverTyped = Boolean(placeholderState?.userHadTyped) || // Previously typed
    !wasEmpty || // Had content before
    wasEmpty && !isEmpty; // Just added content
    const justDeletedAll = hasEverTyped && isEmpty && !wasEmpty;
    const isInTypedAndDeletedState = justDeletedAll || Boolean(placeholderState?.typedAndDeleted) && isEmpty;
    // Only reset user interaction tracking when editor is cleanly empty
    const shouldResetInteraction = isEmpty && !isInTypedAndDeletedState;
    return {
        userHadTyped: shouldResetInteraction ? false : hasEverTyped,
        typedAndDeleted: isInTypedAndDeletedState
    };
}


function $77f7095c9e90a15b$export$2e2bcd8739ae039(intl, defaultPlaceholderText, bracketPlaceholderText, emptyLinePlaceholder, placeholderPrompts, withEmptyParagraph, initialIsPlaceholderHidden, placeholderADF, isRovoLLMEnabled, api) {
    if (!defaultPlaceholderText && !placeholderPrompts && !bracketPlaceholderText && !placeholderADF) return;
    let isDestroyed = false;
    let activeTypewriterTimeouts = [];
    const clearAllTypewriterTimeouts = ()=>{
        activeTypewriterTimeouts.forEach((clearFn)=>clearFn());
        activeTypewriterTimeouts = [];
    };
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $kYgUn.pluginKey),
        state: {
            init: (_, state)=>(0, $5be848d566fb6ba7$export$e919c54ee5ce8f92)({
                    isInitial: true,
                    isEditorFocused: Boolean(api?.focus?.sharedState.currentState()?.hasFocus),
                    editorState: state,
                    isTypeAheadOpen: api?.typeAhead?.actions.isOpen,
                    defaultPlaceholderText: defaultPlaceholderText,
                    bracketPlaceholderText: bracketPlaceholderText,
                    emptyLinePlaceholder: emptyLinePlaceholder,
                    placeholderADF: placeholderADF,
                    placeholderPrompts: placeholderPrompts,
                    typedAndDeleted: false,
                    userHadTyped: false,
                    intl: intl,
                    withEmptyParagraph: withEmptyParagraph,
                    isPlaceholderHidden: initialIsPlaceholderHidden
                }),
            apply: (tr, placeholderState, _oldEditorState, newEditorState)=>{
                const meta = tr.getMeta((0, $kYgUn.pluginKey));
                const isEditorFocused = Boolean(api?.focus?.sharedState.currentState()?.hasFocus);
                const { userHadTyped: userHadTyped, typedAndDeleted: typedAndDeleted } = (0, $5be848d566fb6ba7$export$31fe4973d007ea9c)({
                    placeholderState: placeholderState,
                    oldEditorState: _oldEditorState,
                    newEditorState: newEditorState
                });
                let isPlaceholderHidden = placeholderState?.isPlaceholderHidden ?? false;
                const shouldUpdatePlaceholderHidden = meta?.isPlaceholderHidden !== undefined;
                if (shouldUpdatePlaceholderHidden) isPlaceholderHidden = meta.isPlaceholderHidden;
                if (meta?.placeholderText !== undefined && withEmptyParagraph) {
                    const isCreateWithRovoOverride = !!meta.placeholderText && isRovoLLMEnabled && (0, $aeAfU.expVal)('cwr_blank_object_experiment', 'isEnabled', false);
                    // Only update defaultPlaceholderText from meta if we're not using ADF placeholder
                    // OR when the create-with-rovo experiment is active to allow intentional non-empty placeholder overrides
                    if (!placeholderADF || isCreateWithRovoOverride) defaultPlaceholderText = meta.placeholderText;
                }
                const newPlaceholderState = (0, $5be848d566fb6ba7$export$e919c54ee5ce8f92)({
                    isEditorFocused: isEditorFocused,
                    editorState: newEditorState,
                    isTypeAheadOpen: api?.typeAhead?.actions.isOpen,
                    defaultPlaceholderText: withEmptyParagraph ? defaultPlaceholderText : meta?.placeholderText ?? placeholderState?.placeholderText ?? defaultPlaceholderText,
                    bracketPlaceholderText: bracketPlaceholderText,
                    emptyLinePlaceholder: emptyLinePlaceholder,
                    placeholderADF: placeholderADF,
                    placeholderPrompts: meta?.placeholderPrompts ?? placeholderState?.placeholderPrompts ?? placeholderPrompts,
                    typedAndDeleted: typedAndDeleted,
                    userHadTyped: userHadTyped,
                    intl: intl,
                    isPlaceholderHidden: isPlaceholderHidden,
                    withEmptyParagraph: withEmptyParagraph,
                    showOnEmptyParagraph: meta?.showOnEmptyParagraph ?? placeholderState?.showOnEmptyParagraph
                });
                // Clear timeouts when hasPlaceholder becomes false
                if (!newPlaceholderState.hasPlaceholder) clearAllTypewriterTimeouts();
                return newPlaceholderState;
            }
        },
        props: {
            decorations (editorState) {
                // @ts-ignore quick fix which needs follow up to use standard apis
                if (editorState.collabEditPlugin$ && editorState.collabEditPlugin$.isReady !== true) return;
                const { hasPlaceholder: hasPlaceholder, placeholderText: placeholderText, pos: pos, typedAndDeleted: typedAndDeleted, contextPlaceholderADF: contextPlaceholderADF, showOnEmptyParagraph: showOnEmptyParagraph } = (0, $5be848d566fb6ba7$export$3defeb66989079cc)(editorState);
                // Decorations is still called after plugin is destroyed
                // So we need to make sure decorations is not called if plugin has been destroyed to prevent the placeholder animations' setTimeouts called infinitely
                if (isDestroyed) return;
                const compositionPluginState = api?.composition?.sharedState.currentState();
                const isShowingDiff = Boolean(api?.showDiff?.sharedState.currentState()?.isDisplayingChanges);
                if (hasPlaceholder && ((placeholderText ?? '') || placeholderPrompts || placeholderADF || contextPlaceholderADF) && pos !== undefined && !compositionPluginState?.isComposing && !isShowingDiff) {
                    const initialDelayWhenUserTypedAndDeleted = typedAndDeleted ? (0, $2298aaad5b52bb00$export$4b72a719051acd03) : 0;
                    // contextPlaceholderADF takes precedence over the global placeholderADF
                    const placeholderAdfToUse = contextPlaceholderADF || placeholderADF;
                    return (0, $9124964b11572045$export$980ea07f18fbfea9)(editorState, placeholderText ?? '', placeholderPrompts, activeTypewriterTimeouts, pos, initialDelayWhenUserTypedAndDeleted, placeholderAdfToUse, showOnEmptyParagraph);
                }
                return;
            }
        },
        view () {
            let timeoutId;
            function startEmptyParagraphTimeout(editorView) {
                if (timeoutId) return;
                timeoutId = setTimeout(()=>{
                    timeoutId = undefined;
                    editorView.dispatch(editorView.state.tr.setMeta((0, $kYgUn.pluginKey), {
                        showOnEmptyParagraph: true
                    }));
                }, (0, $kYgUn.EMPTY_PARAGRAPH_TIMEOUT_DELAY));
            }
            function destroyEmptyParagraphTimeout() {
                if (timeoutId) {
                    clearTimeout(timeoutId);
                    timeoutId = undefined;
                }
            }
            return {
                update (editorView, prevState) {
                    if (withEmptyParagraph) {
                        const prevPluginState = (0, $5be848d566fb6ba7$export$3defeb66989079cc)(prevState);
                        const newPluginState = (0, $5be848d566fb6ba7$export$3defeb66989079cc)(editorView.state);
                        // user start typing after move to an empty paragraph, clear timeout
                        if (!newPluginState.canShowOnEmptyParagraph && timeoutId) destroyEmptyParagraphTimeout();
                        else if (prevPluginState.canShowOnEmptyParagraph && newPluginState.canShowOnEmptyParagraph && newPluginState.pos !== prevPluginState.pos) {
                            editorView.dispatch(editorView.state.tr.setMeta((0, $kYgUn.pluginKey), {
                                showOnEmptyParagraph: false
                            }));
                            destroyEmptyParagraphTimeout();
                            startEmptyParagraphTimeout(editorView);
                        } else if (!prevPluginState.canShowOnEmptyParagraph && newPluginState.canShowOnEmptyParagraph && !newPluginState.showOnEmptyParagraph && !timeoutId) startEmptyParagraphTimeout(editorView);
                    }
                },
                destroy () {
                    clearAllTypewriterTimeouts();
                    destroyEmptyParagraphTimeout();
                    isDestroyed = true;
                }
            };
        }
    });
}


const $9eadb119ddd5afc3$export$d5dda3c025c51c47 = 2000; // Delay before showing placeholder on empty paragraph
const $9eadb119ddd5afc3$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('placeholderPlugin');
const $9eadb119ddd5afc3$export$ecbe4cfe6671ba88 = ({ config: options, api: api })=>{
    let currentPlaceholder = options?.placeholder;
    return {
        name: 'placeholder',
        commands: {
            setPlaceholder: (placeholderText)=>({ tr: tr })=>{
                    if (currentPlaceholder !== placeholderText) {
                        currentPlaceholder = placeholderText;
                        return tr.setMeta($9eadb119ddd5afc3$export$18d4026d1ea86bb1, {
                            placeholderText: placeholderText
                        });
                    }
                    return null;
                },
            setAnimatingPlaceholderPrompts: (placeholderPrompts)=>({ tr: tr })=>{
                    return tr.setMeta($9eadb119ddd5afc3$export$18d4026d1ea86bb1, {
                        placeholderPrompts: placeholderPrompts
                    });
                },
            setPlaceholderHidden: (isPlaceholderHidden)=>({ tr: tr })=>{
                    return tr.setMeta($9eadb119ddd5afc3$export$18d4026d1ea86bb1, {
                        isPlaceholderHidden: isPlaceholderHidden
                    });
                }
        },
        pmPlugins () {
            return [
                {
                    name: 'placeholder',
                    plugin: ({ getIntl: getIntl })=>(0, $77f7095c9e90a15b$export$2e2bcd8739ae039)(getIntl(), options && options.placeholder, options && options.placeholderBracketHint, options && options.emptyLinePlaceholder, options && options.placeholderPrompts, options?.withEmptyParagraph, options?.isPlaceholderHidden, options && options.placeholderADF, options?.isRovoLLMEnabled, api)
                }
            ];
        },
        contentComponent: (params)=>{
            if ((0, $eTj7Y.isSSR)()) return null;
             // If loading spinner is explicitly disabled (e.g., for DiffEditor/version history), skip
            if (options?.enableLoadingSpinner === false) return null;
            const doc = params.editorView?.state.doc; // @ts-ignore fix which needs follow up to use standard apis
            const collabEditPluginState = params.editorView?.state?.collabEditPlugin$;
            if (collabEditPluginState && collabEditPluginState.isReady !== true) {
                if (doc && !(0, $bI3mS.isEmptyDocument)(doc)) // If we have a document, and it's not empty - we should not show a loading component
                return null;
                 // In this scenario
                // - the collab plugin exists - but we don't have a "initial/placeholder" document
                // - and the collab plugin is not yet ready
                // So we show a placeholder spinner to indicate the content is still loading
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.Box), {
                    xcss: $9eadb119ddd5afc3$var$spinnerContainerStyles.spinnerContainer,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
                        interactionName: "live-pages-loading-spinner",
                        size: "medium"
                    })
                });
            }
            return null;
        }
    };
};
const $9eadb119ddd5afc3$var$spinnerContainerStyles = {
    spinnerContainer: "_1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _1bsb1osq"
};
module.exports["EMPTY_PARAGRAPH_TIMEOUT_DELAY"] = $9eadb119ddd5afc3$export$d5dda3c025c51c47;
module.exports["pluginKey"] = $9eadb119ddd5afc3$export$18d4026d1ea86bb1;
module.exports["placeholderPlugin"] = $9eadb119ddd5afc3$export$ecbe4cfe6671ba88;

});

parcelRegister("itirX", function(module, exports) {
const $ce844b7854732342$export$d74092cddf07c0aa = (componentRegistry)=>({ name: name, component: component })=>{
        componentRegistry.set(name, component);
    };



var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");


var $g9Jfe = parcelRequire("g9Jfe");


var $iu6m9 = parcelRequire("iu6m9");

const $7aa852d107b41e9c$export$a758406ca53b86a5 = ({ componentRegistry: componentRegistry, editorState: editorState, contextualFormattingEnabled: contextualFormattingEnabled })=>{
    let configuration;
    if (contextualFormattingEnabled && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1', {
        exposure: true
    })) {
        const shouldShowUndoRedoGroup = (0, $g9Jfe.fg)('platform_editor_undo_redo_find_on_primary_toolbar');
        configuration = $7aa852d107b41e9c$var$toolbarConfigurationV2(true, shouldShowUndoRedoGroup);
    } else {
        const shouldShowFindGroup = !!contextualFormattingEnabled;
        if (componentRegistry.has('trackChanges')) configuration = $7aa852d107b41e9c$var$toolbarConfigurationV3(shouldShowFindGroup);
        else configuration = $7aa852d107b41e9c$var$toolbarConfiguration(shouldShowFindGroup);
    }
    return configuration.filter((toolbarElement)=>typeof toolbarElement.enabled === 'undefined' || toolbarElement.enabled(componentRegistry, editorState)).reduce((acc, toolbarElement)=>{
        if (componentRegistry.has(toolbarElement.name)) {
            const component = componentRegistry.get(toolbarElement.name);
            if (!!component) acc.push(component);
        }
        return acc;
    }, []);
};
const $7aa852d107b41e9c$var$trackChangesGroup = [
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('undoRedo') || componentRegistry.has('trackChanges')
    },
    {
        name: 'undoRedoPlugin',
        enabled: (componentRegistry)=>componentRegistry.has('undoRedoPlugin')
    },
    {
        name: 'trackChanges',
        enabled: (componentRegistry)=>componentRegistry.has('trackChanges')
    }
];
const $7aa852d107b41e9c$var$undoRedoGroup = [
    {
        name: 'undoRedoPlugin'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('undoRedoPlugin')
    }
];
const $7aa852d107b41e9c$var$spellCheckGroup = [
    {
        name: 'spellCheck'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('spellCheck')
    }
];
const $7aa852d107b41e9c$var$blockTypeGroup = [
    {
        name: 'blockType'
    },
    {
        name: 'separator',
        enabled: (componentRegistry, editorState)=>componentRegistry.has('blockType') && // Use case where you want to have the block plugin but not render any toolbar items (when you exclude headings), we should be able to get rid of this when we split block type plugin up and check for the presence of the heading plugin directly
            !!editorState.schema.nodes.heading
    }
];
const $7aa852d107b41e9c$var$textFormattingGroup = [
    {
        name: 'textFormatting'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('textFormatting')
    }
];
const $7aa852d107b41e9c$var$alignmentGroup = [
    {
        name: 'alignment'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('alignment')
    }
];
const $7aa852d107b41e9c$var$textColorGroup = [
    {
        name: 'textColor'
    },
    {
        name: 'highlight'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('textColor') || componentRegistry.has('highlight')
    }
];
const $7aa852d107b41e9c$var$listFormattingGroup = [
    {
        name: 'toolbarListsIndentation'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('toolbarListsIndentation')
    }
];
const $7aa852d107b41e9c$var$hyperlinkGroup = [
    {
        name: 'hyperlink'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('hyperlink')
    }
];
const $7aa852d107b41e9c$var$insertBlockGroup = [
    {
        name: 'insertBlock'
    }
];
const $7aa852d107b41e9c$var$others = [
    {
        name: 'beforePrimaryToolbar'
    },
    {
        name: 'avatarGroup'
    },
    {
        name: 'findReplace'
    },
    {
        // TODO: ED-26962 - Should likely be split into three: spelling & grammar, separator, and AI trigger
        name: 'aiExperience'
    },
    {
        name: 'loom'
    }
];
const $7aa852d107b41e9c$var$othersGroupNoFind = [
    {
        name: 'beforePrimaryToolbar'
    },
    {
        name: 'avatarGroup'
    },
    {
        // TODO: ED-26962 - Should likely be split into three: spelling & grammar, separator, and AI trigger
        name: 'aiExperience'
    },
    {
        name: 'loom'
    }
];
const $7aa852d107b41e9c$var$findGroup = [
    {
        name: 'findReplace'
    }
];
const $7aa852d107b41e9c$var$toolbarConfigurationV3 = (shouldShowFindGroup)=>[
        ...$7aa852d107b41e9c$var$spellCheckGroup,
        ...$7aa852d107b41e9c$var$blockTypeGroup,
        ...$7aa852d107b41e9c$var$textFormattingGroup,
        ...$7aa852d107b41e9c$var$alignmentGroup,
        ...$7aa852d107b41e9c$var$textColorGroup,
        ...$7aa852d107b41e9c$var$listFormattingGroup,
        ...$7aa852d107b41e9c$var$insertBlockGroup,
        ...shouldShowFindGroup ? $7aa852d107b41e9c$var$others : $7aa852d107b41e9c$var$othersGroupNoFind,
        ...$7aa852d107b41e9c$var$trackChangesGroup
    ];
const $7aa852d107b41e9c$var$toolbarConfiguration = (shouldShowFindGroup)=>[
        ...$7aa852d107b41e9c$var$undoRedoGroup,
        ...$7aa852d107b41e9c$var$spellCheckGroup,
        ...$7aa852d107b41e9c$var$blockTypeGroup,
        ...$7aa852d107b41e9c$var$textFormattingGroup,
        ...$7aa852d107b41e9c$var$alignmentGroup,
        ...$7aa852d107b41e9c$var$textColorGroup,
        ...$7aa852d107b41e9c$var$listFormattingGroup,
        ...$7aa852d107b41e9c$var$insertBlockGroup,
        ...shouldShowFindGroup ? $7aa852d107b41e9c$var$others : $7aa852d107b41e9c$var$othersGroupNoFind
    ];
const $7aa852d107b41e9c$var$pinToolbar = [
    {
        name: 'pinToolbar'
    }
];
const $7aa852d107b41e9c$var$toolbarConfigurationV2 = (shouldShowInsertBlock, shouldShowUndoRedoGroup, shouldShowFindGroup = false)=>[
        ...shouldShowUndoRedoGroup ? $7aa852d107b41e9c$var$undoRedoGroup : [],
        ...$7aa852d107b41e9c$var$blockTypeGroup,
        ...$7aa852d107b41e9c$var$textFormattingGroup,
        ...$7aa852d107b41e9c$var$textColorGroup,
        ...$7aa852d107b41e9c$var$alignmentGroup,
        ...$7aa852d107b41e9c$var$listFormattingGroup,
        ...$7aa852d107b41e9c$var$hyperlinkGroup,
        ...shouldShowInsertBlock ? $7aa852d107b41e9c$var$insertBlockGroup : [],
        {
            name: 'selectionExtension'
        },
        ...$7aa852d107b41e9c$var$pinToolbar,
        {
            name: 'beforePrimaryToolbar'
        },
        ...shouldShowFindGroup ? $7aa852d107b41e9c$var$findGroup : []
    ];


const $61a61062142b6645$export$36f60c8b3eb879ae = new (0, $ks2lK.PluginKey)('primaryToolbar');
const $61a61062142b6645$export$ae829ec7b2625219 = ({ componentRegistry: componentRegistry, contextualFormattingEnabled: contextualFormattingEnabled })=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $61a61062142b6645$export$36f60c8b3eb879ae,
        state: {
            init: (_config, editorState)=>({
                    components: (0, $7aa852d107b41e9c$export$a758406ca53b86a5)({
                        componentRegistry: componentRegistry,
                        editorState: editorState,
                        contextualFormattingEnabled: contextualFormattingEnabled
                    })
                }),
            apply: (_tr, pluginState)=>pluginState
        }
    });
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports

var $9K4OG = parcelRequire("9K4OG");


var $cORDs = parcelRequire("cORDs");

var $92f8db87568333ef$export$2e2bcd8739ae039 = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: (0, $cORDs.wrapperStyle)
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        "data-vc": "primary-toolbar-separator",
        css: (0, $cORDs.separatorStyles)
    }));


const $e505b2a6e9f3b5fd$export$ad7799fd22a76abd = ({ config: config })=>{
    // We use a plugin variable to store the component registry to avoid having to use
    // effects in each plugin, and to enable rendering the toolbar in SSR
    // TODO: ED-26962 - Replace this with something in plugin state once we have a way to initialise across plugins on plugin initialisation
    const componentRegistry = new Map();
    // Pre-fill registry with the separator component
    componentRegistry.set('separator', (0, $92f8db87568333ef$export$2e2bcd8739ae039));
    return {
        name: 'primaryToolbar',
        actions: {
            registerComponent: (0, $ce844b7854732342$export$d74092cddf07c0aa)(componentRegistry)
        },
        pmPlugins: ()=>[
                {
                    name: 'primaryToolbar',
                    plugin: ()=>(0, $61a61062142b6645$export$ae829ec7b2625219)({
                            componentRegistry: componentRegistry,
                            contextualFormattingEnabled: config?.contextualFormattingEnabled
                        })
                }
            ],
        getSharedState (editorState) {
            if (!editorState) return;
            return (0, $61a61062142b6645$export$36f60c8b3eb879ae).getState(editorState);
        }
    };
};
module.exports["primaryToolbarPlugin"] = $e505b2a6e9f3b5fd$export$ad7799fd22a76abd;

});

parcelRegister("bULcr", function(module, exports) {

var $B9v3F = parcelRequire("B9v3F");

var $g4GD8 = parcelRequire("g4GD8");

const $52df13116bff6b88$export$ebd99cdb6a61129e = (api)=>(props)=>{
        const selection = props?.selection ?? api?.selection.sharedState?.currentState()?.selection;
        return (0, $B9v3F.getFragmentsFromSelection)(selection);
    };
const $52df13116bff6b88$export$27a1b30a70c1f80d = (api)=>(props)=>{
        let selection = props?.selection ?? api?.selection.sharedState?.currentState()?.selection;
        if (selection?.empty) // If we have an empty selection the current state might not be correct
        // We have a hack here to retrieve the current selection - but not dispatch a transaction
        api?.core.actions.execute(({ tr: tr })=>{
            selection = tr.selection;
            return null;
        });
        return (0, $g4GD8.getLocalIdsFromSelection)(selection);
    };



var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");




const $d2dc9e22b1699cc0$export$e6805678cce429a4 = new (0, $ks2lK.PluginKey)('autoExpandSelectionRangeOnInlineNodePlugin');


const $fda49fc05149e70b$export$b5faf98028194323 = ()=>{
    let mouseDownElement = null;
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $d2dc9e22b1699cc0$export$e6805678cce429a4),
        props: {
            handleDOMEvents: {
                mousedown: (_view, event)=>{
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    mouseDownElement = event.target;
                },
                mouseup: (view, event)=>{
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    const mouseUpElement = event.target;
                    // terminate early if mouse down and mouse up elements are the same -> e.g a click event
                    // or mouse down doesn't trigger
                    if (!mouseDownElement || mouseDownElement === mouseUpElement) {
                        mouseDownElement = null;
                        return;
                    }
                    // reset mouse down element after mouse up event
                    // so that we can detect the next mouse down event is triggered right after mouse up event or not
                    mouseDownElement = null;
                    // terminate early if mouse up event is not fired on inline node
                    if (!$fda49fc05149e70b$var$isMouseUpOnSupportedNode(mouseUpElement)) return;
                    const { dispatch: dispatch, state: state } = view;
                    const { selection: selection } = state;
                    // terminate early if current selection is not a text selection -> e.g. table cell selection
                    if (!(selection instanceof (0, $ks2lK.TextSelection))) return;
                    // find the document position of the mouse up element
                    const elementStartPosition = view.posAtDOM(mouseUpElement, 0);
                    // find out the direction of selection
                    const isAnchorBeforeElement = selection.$anchor.pos <= elementStartPosition;
                    const expandedSelectionHeadPosition = isAnchorBeforeElement ? elementStartPosition + 1 : elementStartPosition;
                    // expand the selection to include the mouse up element
                    const tr = state.tr.setSelection((0, $ks2lK.TextSelection).create(state.doc, selection.$anchor.pos, expandedSelectionHeadPosition));
                    dispatch(tr);
                }
            }
        }
    });
};
const $fda49fc05149e70b$var$isMouseUpOnSupportedNode = (mouseUpElement)=>{
    const supportedNodes = [
        'emoji',
        'status',
        'date',
        'mention',
        'inlineCard'
    ];
    const supportedNodeViewContentClassNamesList = supportedNodes.map((nodeType)=>`.${nodeType}View-content-wrap`).join(', ');
    return !!mouseUpElement.closest(supportedNodeViewContentClassNamesList);
};


/* eslint-disable import/no-extraneous-dependencies */ 
var $adhil = parcelRequire("adhil");

var $4Wd8f = parcelRequire("4Wd8f");

var $cQ4aK = parcelRequire("cQ4aK");

var $9GYNY = parcelRequire("9GYNY");


var $l9G9n = parcelRequire("l9G9n");




/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json




const $0d8c983a0ad0561c$export$e530ba00b008a680 = new (0, $ks2lK.PluginKey)('selection');
var $0d8c983a0ad0561c$export$5c80dd1df5708938 = /*#__PURE__*/ function(SelectionDirection) {
    SelectionDirection[SelectionDirection["Before"] = -1] = "Before";
    SelectionDirection[SelectionDirection["After"] = 1] = "After";
    return SelectionDirection;
}({});


var $5a86cab226cb9084$export$ab4e2275d2998c63 = /*#__PURE__*/ function(SelectionActionTypes) {
    SelectionActionTypes["SET_DECORATIONS"] = "SET_DECORATIONS";
    SelectionActionTypes["SET_RELATIVE_SELECTION"] = "SET_RELATIVE_SELECTION";
    return SelectionActionTypes;
}({});



var $lkJUe = parcelRequire("lkJUe");





var $ftzrq = parcelRequire("ftzrq");


var $7XFGZ = parcelRequire("7XFGZ");



function $e723e8984c914fbd$export$1650419e431d3ba3(pluginState, action) {
    switch(action.type){
        case (0, $5a86cab226cb9084$export$ab4e2275d2998c63).SET_DECORATIONS:
            return {
                ...pluginState,
                decorationSet: action.decorationSet,
                selection: action.selection
            };
        case (0, $5a86cab226cb9084$export$ab4e2275d2998c63).SET_RELATIVE_SELECTION:
            return {
                ...pluginState,
                selectionRelativeToNode: action.selectionRelativeToNode
            };
        default:
            return pluginState;
    }
}





var $1ts3S = parcelRequire("1ts3S");




var $4DdJm = parcelRequire("4DdJm");


var $cX9xt = parcelRequire("cX9xt");





var $8m4tT = parcelRequire("8m4tT");





var $aFUXX = parcelRequire("aFUXX");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");





const $127ef7226913ca31$var$hideCursorWidgetStyles = `
	position: absolute;
	pointer-events: none;
	width: 0;
	height: 0;
`;
const $127ef7226913ca31$var$createHideCursorWidget = ()=>{
    const span = document.createElement('span');
    span.className = 'ProseMirror-hide-cursor';
    span.setAttribute('style', $127ef7226913ca31$var$hideCursorWidgetStyles);
    return span;
};
const $127ef7226913ca31$export$22f5d232402cb4b = ()=>{
    return (0, $ftzrq.Decoration).widget(0, $127ef7226913ca31$var$createHideCursorWidget, {
        key: 'hide-cursor-decoration',
        side: -1
    });
};


const $a6582a741c8d0762$export$968abecb43309c32 = (tr, manualSelection, hideCursor, blockSelection)=>{
    let selection = tr.selection;
    const decorations = [];
    if (hideCursor) decorations.push((0, $127ef7226913ca31$export$22f5d232402cb4b)());
    if (selection instanceof (0, $ks2lK.NodeSelection)) {
        decorations.push((0, $ftzrq.Decoration).node(selection.from, selection.to, {
            class: (0, $aFUXX.akEditorSelectedNodeClassName)
        }));
        return (0, $ftzrq.DecorationSet).create(tr.doc, decorations);
    }
    if (selection instanceof (0, $ks2lK.TextSelection) || selection instanceof (0, $ks2lK.AllSelection)) {
        if (manualSelection && manualSelection.anchor >= 0 && manualSelection.head >= 0 && manualSelection.anchor <= tr.doc.nodeSize && manualSelection.head <= tr.doc.nodeSize) selection = (0, $ks2lK.TextSelection).create(tr.doc, manualSelection.anchor, manualSelection.head);
        // Only apply node decorations when there is an active block selection.
        // When there is no block selection, text selections should use native browser selection appearance.
        if (!(0, $iu6m9.editorExperiment)('platform_editor_block_menu', true, {
            exposure: true
        }) || blockSelection) {
            const selectionDecorations = $a6582a741c8d0762$export$299033b282ee8671(selection, tr.doc).map(({ node: node, pos: pos })=>{
                return (0, $ftzrq.Decoration).node(pos, pos + node.nodeSize, {
                    class: (0, $aFUXX.akEditorSelectedNodeClassName)
                });
            });
            decorations.push(...selectionDecorations);
        }
        return (0, $ftzrq.DecorationSet).create(tr.doc, decorations);
    }
    return decorations.length > 0 ? (0, $ftzrq.DecorationSet).create(tr.doc, decorations) : (0, $ftzrq.DecorationSet).empty;
};
const $a6582a741c8d0762$var$topLevelBlockNodesThatHaveSelectionStyles = [
    'table',
    'panel',
    'expand',
    'layoutSection',
    'decisionList',
    'decisionItem',
    'codeBlock'
];
const $a6582a741c8d0762$export$299033b282ee8671 = (selection, doc)=>{
    const nodes = [];
    if (selection.from !== selection.to) {
        const { from: from, to: to } = selection;
        doc.nodesBetween(from, to, (node, pos)=>{
            const withinSelection = from <= pos && pos + node.nodeSize <= to;
            // The reason we need to check for these nodes is to stop
            // traversing their children if they are within a selection -
            // this is to prevent selection styles from being added to
            // the children as well as the parent node.
            // Example scenario is if an entire table has been selected
            // we should not traverse its children so we can apply the
            // selection styles to the table. But if an entire tableRow
            // has been selected (but the parent table has not) we should
            // traverse it as it could contain other nodes that need
            // selection styles. I couldn’t see a clear way to differentiate
            // without explicitly stating which nodes should be traversed
            // and which shouldn’t.
            const nodeTypeName = (0, $1oCLl.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $cX9xt.getBaseNodeTypeName)(node.type) : node.type.name;
            const isTopLevelNodeThatHasSelectionStyles = $a6582a741c8d0762$var$topLevelBlockNodesThatHaveSelectionStyles.includes(nodeTypeName);
            // If the node is a top-level block node and completely sits within
            // the selection, we do not recurse it's children to prevent selection
            // styles being added to its child nodes. The expected behaviour
            // is that selection styles are only added to the parent.
            if (node && withinSelection && isTopLevelNodeThatHasSelectionStyles) {
                nodes.push({
                    node: node,
                    pos: pos
                });
                return false;
            // Otherwise we recurse the children and return them so we can apply
            // selection styles. Text is handled by the browser.
            } else if (node && withinSelection && !node.isText) nodes.push({
                node: node,
                pos: pos
            });
            return true;
        });
    }
    return nodes;
};
function $a6582a741c8d0762$export$8f1ae47b39045ce2({ oldEditorState: oldEditorState, newEditorState: newEditorState }) {
    const oldSelection = oldEditorState.selection;
    const newSelection = newEditorState.selection;
    const oldPluginState = (0, $0d8c983a0ad0561c$export$e530ba00b008a680).getState(oldEditorState);
    const newPluginState = (0, $0d8c983a0ad0561c$export$e530ba00b008a680).getState(newEditorState);
    if (!oldPluginState || !newPluginState) return false;
    // If selection is unchanged, no need to recalculate
    if (oldSelection.eq(newSelection)) {
        // We need this special case for NodeSelection, as Prosemirror still thinks the
        // selections are equal when the node has changed
        if (oldSelection instanceof (0, $ks2lK.NodeSelection) && newSelection instanceof (0, $ks2lK.NodeSelection)) {
            const oldDecorations = oldPluginState.decorationSet.find();
            const newDecorations = newPluginState.decorationSet.find();
            // There might not be old or new decorations if the node selection is for a text node
            // This wouldn't have happened intentionally, but we need to handle this case regardless
            if (oldDecorations.length > 0 && newDecorations.length > 0) return !oldDecorations[0].eq(newDecorations[0]);
            return !(oldDecorations.length === 0 && newDecorations.length === 0);
        }
        return false;
    }
    // There's no point updating decorations if going from one standard TextSelection to another
    if (oldSelection instanceof (0, $ks2lK.TextSelection) && newSelection instanceof (0, $ks2lK.TextSelection) && oldSelection.from === oldSelection.to && newSelection.from === newSelection.to) return false;
    return true;
}
const $a6582a741c8d0762$export$be9646888fa9d884 = (node)=>!!(node && !node.isAtom && (0, $ks2lK.NodeSelection).isSelectable(node));
const $a6582a741c8d0762$export$e6eb31f83412b327 = (node)=>!!(node && (node.isText || (0, $l9G9n.isEmptyParagraph)(node) || (0, $ks2lK.NodeSelection).isSelectable(node)));
const $a6582a741c8d0762$export$15e7624ccd1acbba = (selection)=>{
    let foundNodeThatSupportsGapCursor = false;
    const selectableNode = (0, $8m4tT.findParentNode)((node)=>{
        const isSelectable = $a6582a741c8d0762$export$be9646888fa9d884(node);
        if (!isSelectable && !(0, $4Wd8f.isIgnored)(node)) foundNodeThatSupportsGapCursor = true;
        return isSelectable;
    })(selection);
    if (!foundNodeThatSupportsGapCursor) return selectableNode;
};
const $a6582a741c8d0762$export$5a13616ef7dc6dd = ($pos, doc)=>{
    // prosemirror just returns the same pos from Selection.findFrom when
    // parent.inlineContent is true, so we move position back one here
    // to counteract that
    if ($pos.parent.inlineContent && $a6582a741c8d0762$export$be9646888fa9d884($pos.parent)) $pos = doc.resolve($pos.start() - 1);
    const selectionBefore = (0, $ks2lK.Selection).findFrom($pos, -1);
    if (selectionBefore) {
        const $selectionBefore = doc.resolve(selectionBefore.from);
        for(let i = $pos.depth + 1; i <= $selectionBefore.depth; i++){
            const node = $selectionBefore.node(i);
            if ($a6582a741c8d0762$export$be9646888fa9d884(node)) return {
                node: node,
                pos: $selectionBefore.start(i) - 1
            };
            if (i > $pos.depth + 1 && !(0, $4Wd8f.isIgnored)(node)) return;
        }
        /**
     * Stick to the default left selection behaviour,
     * useful for mediaSingleWithCaption
     */ if (selectionBefore instanceof (0, $ks2lK.NodeSelection) && (0, $ks2lK.NodeSelection).isSelectable(selectionBefore.node)) return {
            node: selectionBefore.node,
            pos: selectionBefore.from
        };
    }
};
const $a6582a741c8d0762$export$f64170c1c72ca928 = ($pos, doc)=>{
    const selectionAfter = (0, $ks2lK.Selection).findFrom($pos, 1);
    if (selectionAfter) {
        const $selectionAfter = doc.resolve(selectionAfter.from);
        for(let i = $pos.depth + 1; i <= $selectionAfter.depth; i++){
            const node = $selectionAfter.node(i);
            if ($a6582a741c8d0762$export$be9646888fa9d884(node)) return {
                node: node,
                pos: $selectionAfter.start(i) - 1
            };
            if (i > $pos.depth + 1 && !(0, $4Wd8f.isIgnored)(node)) return;
        }
    }
};
const $a6582a741c8d0762$export$12f3aca2cb5b5ae9 = (parent)=>(0, $8m4tT.flatten)(parent).find((child)=>$a6582a741c8d0762$export$e6eb31f83412b327(child.node) || !(0, $4Wd8f.isIgnored)(child.node));
const $a6582a741c8d0762$export$b5a7c30cdb2d437f = (parent)=>{
    let child;
    parent.descendants((node, pos)=>{
        if ($a6582a741c8d0762$export$e6eb31f83412b327(node) || !(0, $4Wd8f.isIgnored)(node)) {
            child = {
                node: node,
                pos: pos
            };
            return false;
        }
    });
    if (child) return child;
};
const $a6582a741c8d0762$export$f80a5aec143de6c6 = ($pos, selection)=>(0, $1ts3S.isSelectionAtStartOfNode)($pos, $a6582a741c8d0762$export$15e7624ccd1acbba(selection)?.node);
const $a6582a741c8d0762$export$1ab0c837d3abb951 = ($pos, selection)=>{
    // If the current position is at the end of its parent node's content.
    const isAtTheEndOfCurrentLevel = $pos.parent.content.size === $pos.parentOffset;
    if (!isAtTheEndOfCurrentLevel) return false;
    // If at the root or parent is selectable, we're at the end
    if ($pos.depth === 0 || (0, $ks2lK.NodeSelection).isSelectable($pos.parent)) return isAtTheEndOfCurrentLevel;
    // Handle lists: if in a list inside container and not at the end, return false
    if ((0, $8m4tT.hasParentNode)((0, $4DdJm.isListItemNode))(selection) && $a6582a741c8d0762$export$7eb6f464328bf47e($pos, selection)) return false;
    // Handle layout columns: if another node follows, not at end
    if ($a6582a741c8d0762$export$d2d208886cf1a82d($pos)) return false;
    // Default: if at end of parent's parent
    const $after = $pos.doc.resolve($pos.after());
    return $after.parent.content.size === $after.parentOffset;
};
const $a6582a741c8d0762$export$7eb6f464328bf47e = ($pos, selection)=>{
    const isInContainerNode = (0, $8m4tT.hasParentNode)($a6582a741c8d0762$export$5f94d2e4ba42a5c7)(selection);
    if (!isInContainerNode) return false;
    const parentList = (0, $8m4tT.findParentNodeClosestToPos)($pos, (0, $4DdJm.isListItemNode));
    if (!parentList) return false;
    const $parentListPos = $pos.doc.resolve(parentList.pos);
    const topLevelList = $a6582a741c8d0762$export$b0ac99e4524eec5a($pos);
    if (!topLevelList) return false;
    const $afterTopLevelList = $pos.doc.resolve(topLevelList.pos + topLevelList.node.nodeSize);
    const nodeAfterTopLevelList = $afterTopLevelList.nodeAfter;
    const grandParentList = (0, $8m4tT.findParentNodeClosestToPos)($pos.doc.resolve($parentListPos.before()), (0, $4DdJm.isListItemNode));
    const grandParentListPos = grandParentList ? $pos.doc.resolve(grandParentList.pos) : undefined;
    const isLastListItemInParent = // Check if the current list item is the last child in its parent list
    $parentListPos.index() === $parentListPos.parent.childCount - 1 && // Check if there is no grandparent list, or if the grandparent list item is also the last child in its parent
    (!grandParentList || grandParentListPos && grandParentListPos.index() === grandParentListPos.parent.childCount - 1);
    if (!isLastListItemInParent || nodeAfterTopLevelList) return true;
    return false;
};
const $a6582a741c8d0762$export$5f94d2e4ba42a5c7 = (node)=>{
    const { layoutColumn: layoutColumn, panel: panel, panel_c1: panel_c1, expand: expand } = node?.type?.schema?.nodes || {};
    const containerNodes = (0, $1oCLl.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? [
        panel,
        panel_c1,
        expand,
        layoutColumn
    ] : [
        panel,
        expand,
        layoutColumn
    ];
    return Boolean(node && node.type && containerNodes.includes(node.type));
};
const $a6582a741c8d0762$export$b0ac99e4524eec5a = (pos)=>{
    const { bulletList: bulletList, orderedList: orderedList } = pos.doc.type.schema.nodes;
    let currentDepth = pos.depth;
    let topLevelList;
    while(currentDepth > 0){
        const node = pos.node(currentDepth);
        if ([
            bulletList,
            orderedList
        ].includes(node.type)) topLevelList = {
            node: node,
            pos: pos.before(currentDepth)
        };
        currentDepth--;
    }
    return topLevelList;
};
const $a6582a741c8d0762$export$d2d208886cf1a82d = ($pos)=>{
    const layoutColumnParent = (0, $8m4tT.findParentNodeClosestToPos)($pos, $a6582a741c8d0762$export$c09dbe4edab814a2);
    if (!layoutColumnParent) return false;
    const panelOrExpandParent = (0, $8m4tT.findParentNodeClosestToPos)($pos, $a6582a741c8d0762$export$3180f8c1df4f8d41);
    if (panelOrExpandParent && panelOrExpandParent.pos > layoutColumnParent.pos) return false;
    const afterPos = layoutColumnParent.pos + layoutColumnParent.node.nodeSize;
    const $after = $pos.doc.resolve(afterPos);
    return Boolean($after.nodeAfter);
};
const $a6582a741c8d0762$export$c09dbe4edab814a2 = (node)=>{
    const { layoutColumn: layoutColumn } = node?.type?.schema?.nodes || {};
    return Boolean(node && node.type && node.type === layoutColumn);
};
const $a6582a741c8d0762$export$3180f8c1df4f8d41 = (node)=>{
    const { panel: panel, panel_c1: panel_c1, expand: expand } = node?.type?.schema?.nodes || {};
    return Boolean(node && node.type && (node.type === panel || (0, $1oCLl.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) && node.type === panel_c1 || node.type === expand));
};


const $a5f9baf1f4a52bd0$var$handleDocChanged = (tr, pluginState)=>{
    // in some collab edge cases mapping decorations could throw an error
    try {
        if (pluginState.decorationSet.find().length === 0 && (!tr.selectionSet || (0, $a6582a741c8d0762$export$968abecb43309c32)(tr).find().length === 0)) return pluginState;
        const decorationSet = pluginState.decorationSet.map(tr.mapping, tr.doc);
        return {
            ...pluginState,
            decorationSet: decorationSet
        };
    } catch (error) {
        return {
            ...pluginState,
            decorationSet: (0, $ftzrq.DecorationSet).empty
        };
    }
};
const $a5f9baf1f4a52bd0$var$handleSelectionChanged = (tr, pluginState)=>{
    // Reset relative selection pos when user clicks to select a node
    if ((tr.selection instanceof (0, $ks2lK.NodeSelection) && (0, $a6582a741c8d0762$export$be9646888fa9d884)(tr.selection.node) || tr.selection instanceof (0, $7XFGZ.CellSelection)) && !tr.getMeta((0, $0d8c983a0ad0561c$export$e530ba00b008a680))) return {
        ...pluginState,
        selectionRelativeToNode: undefined
    };
    return pluginState;
};
const $a5f9baf1f4a52bd0$var$dest = (0, $lkJUe.pluginFactory)((0, $0d8c983a0ad0561c$export$e530ba00b008a680), (0, $e723e8984c914fbd$export$1650419e431d3ba3), {
    onDocChanged: $a5f9baf1f4a52bd0$var$handleDocChanged,
    onSelectionChanged: $a5f9baf1f4a52bd0$var$handleSelectionChanged
});
const $a5f9baf1f4a52bd0$export$8d4021544bdece00 = $a5f9baf1f4a52bd0$var$dest.createCommand;
const $a5f9baf1f4a52bd0$export$f05434c51e3762e = $a5f9baf1f4a52bd0$var$dest.getPluginState;
const $a5f9baf1f4a52bd0$export$656c7661095efe2e = $a5f9baf1f4a52bd0$var$dest.createPluginState;



const $74dd4a6c0f671ce7$export$c7d22caae2fd3756 = (selectionRelativeToNode, selection)=>({ tr: tr })=>{
        tr.setMeta((0, $0d8c983a0ad0561c$export$e530ba00b008a680), {
            type: (0, $5a86cab226cb9084$export$ab4e2275d2998c63).SET_RELATIVE_SELECTION,
            selectionRelativeToNode: selectionRelativeToNode
        });
        if (selection) return tr.setSelection(selection);
        return tr;
    };
const $74dd4a6c0f671ce7$export$56a7f03ce3f93e52 = (selectionRelativeToNode, selection)=>(0, $a5f9baf1f4a52bd0$export$8d4021544bdece00)({
        type: (0, $5a86cab226cb9084$export$ab4e2275d2998c63).SET_RELATIVE_SELECTION,
        selectionRelativeToNode: selectionRelativeToNode
    }, (tr)=>{
        return $74dd4a6c0f671ce7$export$c7d22caae2fd3756(selectionRelativeToNode, selection)({
            tr: tr
        }) || tr;
    });
const $74dd4a6c0f671ce7$export$680a8d7c28b0860 = (state, dispatch)=>{
    const { selection: selection } = state;
    if (selection instanceof (0, $adhil.GapCursorSelection)) return $74dd4a6c0f671ce7$var$arrowRightFromGapCursor(selection)(state, dispatch);
    else if (selection instanceof (0, $ks2lK.NodeSelection)) return $74dd4a6c0f671ce7$var$arrowRightFromNode(selection)(state, dispatch);
    else if (selection instanceof (0, $ks2lK.TextSelection)) return $74dd4a6c0f671ce7$var$arrowRightFromText(selection)(state, dispatch);
    return false;
};
const $74dd4a6c0f671ce7$export$3ff8c533d254ed7c = (state, dispatch)=>{
    const { selection: selection } = state;
    if (selection instanceof (0, $adhil.GapCursorSelection)) return $74dd4a6c0f671ce7$var$arrowLeftFromGapCursor(selection)(state, dispatch);
    else if (selection instanceof (0, $ks2lK.NodeSelection)) return $74dd4a6c0f671ce7$var$arrowLeftFromNode(selection)(state, dispatch);
    else if (selection instanceof (0, $ks2lK.TextSelection)) return $74dd4a6c0f671ce7$var$arrowLeftFromText(selection)(state, dispatch);
    return false;
};
const $74dd4a6c0f671ce7$var$arrowRightFromGapCursor = (selection)=>(state, dispatch)=>{
        const { $from: $from, $to: $to, side: side } = selection;
        if (side === (0, $9GYNY.Side).LEFT) {
            const selectableNode = (0, $a6582a741c8d0762$export$f64170c1c72ca928)($to, state.doc);
            if (selectableNode) return $74dd4a6c0f671ce7$export$56a7f03ce3f93e52((0, $cQ4aK.RelativeSelectionPos).Start, (0, $ks2lK.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        } else if (side === (0, $9GYNY.Side).RIGHT && (0, $a6582a741c8d0762$export$1ab0c837d3abb951)($from, selection)) {
            const selectableNode = (0, $a6582a741c8d0762$export$15e7624ccd1acbba)(selection);
            if (selectableNode) return $74dd4a6c0f671ce7$export$56a7f03ce3f93e52((0, $cQ4aK.RelativeSelectionPos).End, (0, $ks2lK.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        }
        return false;
    };
const $74dd4a6c0f671ce7$var$arrowLeftFromGapCursor = (selection)=>(state, dispatch)=>{
        const { $from: $from, side: side } = selection;
        const { selectionRelativeToNode: selectionRelativeToNode } = (0, $a5f9baf1f4a52bd0$export$f05434c51e3762e)(state);
        if (side === (0, $9GYNY.Side).RIGHT) {
            const selectableNode = (0, $a6582a741c8d0762$export$5a13616ef7dc6dd)($from, state.doc);
            if (selectableNode) return $74dd4a6c0f671ce7$export$56a7f03ce3f93e52((0, $cQ4aK.RelativeSelectionPos).End, (0, $ks2lK.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        } else if (side === (0, $9GYNY.Side).LEFT && (0, $a6582a741c8d0762$export$f80a5aec143de6c6)($from, selection)) {
            if (selectionRelativeToNode === (0, $cQ4aK.RelativeSelectionPos).Before) {
                const $parent = state.doc.resolve(selection.$from.before(selection.$from.depth));
                if ($parent) {
                    const selectableNode = (0, $a6582a741c8d0762$export$5a13616ef7dc6dd)($parent, state.doc);
                    if (selectableNode && (0, $4Wd8f.isIgnored)(selectableNode.node)) // selection is inside node without gap cursor preceeded by another node without gap cursor - set node selection for previous node
                    return $74dd4a6c0f671ce7$export$56a7f03ce3f93e52((0, $cQ4aK.RelativeSelectionPos).End, (0, $ks2lK.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
                }
                // we don't return this as we want to reset the relative pos, but not block other plugins
                // from responding to arrow left key
                $74dd4a6c0f671ce7$export$56a7f03ce3f93e52()(state, dispatch);
            } else {
                const selectableNode = (0, $a6582a741c8d0762$export$15e7624ccd1acbba)(selection);
                if (selectableNode) return $74dd4a6c0f671ce7$export$56a7f03ce3f93e52((0, $cQ4aK.RelativeSelectionPos).Start, (0, $ks2lK.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
            }
        }
        return false;
    };
const $74dd4a6c0f671ce7$var$arrowRightFromNode = (selection)=>(state, dispatch)=>{
        const { node: node, from: from, $to: $to } = selection;
        const { selectionRelativeToNode: selectionRelativeToNode } = (0, $a5f9baf1f4a52bd0$export$f05434c51e3762e)(state);
        if (node.isAtom) {
            if ((0, $a6582a741c8d0762$export$1ab0c837d3abb951)($to, selection) && (node.isInline || (0, $4Wd8f.isIgnored)(node))) // selection is for inline node or atom node which is ignored by gap-cursor and that is the last child of its parent node - set text selection after it
            return $74dd4a6c0f671ce7$var$findAndSetTextSelection((0, $cQ4aK.RelativeSelectionPos).End, state.doc.resolve(from + 1), (0, $0d8c983a0ad0561c$export$5c80dd1df5708938).After)(state, dispatch);
            return false;
        } else if (selectionRelativeToNode === (0, $cQ4aK.RelativeSelectionPos).Start) // selection is for container node - set selection inside it at the start
        return $74dd4a6c0f671ce7$var$setSelectionInsideAtNodeStart((0, $cQ4aK.RelativeSelectionPos).Inside, node, from)(state, dispatch);
        else if ((0, $4Wd8f.isIgnored)(node) && (!selectionRelativeToNode || selectionRelativeToNode === (0, $cQ4aK.RelativeSelectionPos).End)) {
            const selectableNode = (0, $a6582a741c8d0762$export$f64170c1c72ca928)($to, state.doc);
            if (selectableNode && (0, $4Wd8f.isIgnored)(selectableNode.node)) // selection is for node without gap cursor followed by another node without gap cursor - set node selection for next node
            return $74dd4a6c0f671ce7$export$56a7f03ce3f93e52((0, $cQ4aK.RelativeSelectionPos).Start, (0, $ks2lK.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        }
        return false;
    };
const $74dd4a6c0f671ce7$var$arrowLeftFromNode = (selection)=>(state, dispatch)=>{
        const { node: node, from: from, to: to, $from: $from } = selection;
        const { selectionRelativeToNode: selectionRelativeToNode } = (0, $a5f9baf1f4a52bd0$export$f05434c51e3762e)(state);
        if (node.isAtom) {
            if ((0, $a6582a741c8d0762$export$f80a5aec143de6c6)($from, selection) && (node.isInline || (0, $4Wd8f.isIgnored)(node))) // selection is for inline node or atom node which is ignored by gap-cursor and that is the first child of its parent node - set text selection before it
            return $74dd4a6c0f671ce7$var$findAndSetTextSelection((0, $cQ4aK.RelativeSelectionPos).Start, state.doc.resolve(from), (0, $0d8c983a0ad0561c$export$5c80dd1df5708938).Before)(state, dispatch);
            return false;
        } else if (selectionRelativeToNode === (0, $cQ4aK.RelativeSelectionPos).End) // selection is for container node - set selection inside it at the end
        return $74dd4a6c0f671ce7$export$7c9ae5d21795cde4((0, $cQ4aK.RelativeSelectionPos).Inside, node, from, to)(state, dispatch);
        else if (!selectionRelativeToNode || selectionRelativeToNode === (0, $cQ4aK.RelativeSelectionPos).Inside) // selection is for container node - set selection inside it at the start
        // (this is a special case when the user selects by clicking node)
        return $74dd4a6c0f671ce7$var$setSelectionInsideAtNodeStart((0, $cQ4aK.RelativeSelectionPos).Before, node, from)(state, dispatch);
        else if ((0, $4Wd8f.isIgnored)(node) && selectionRelativeToNode === (0, $cQ4aK.RelativeSelectionPos).Start) {
            // selection is for node without gap cursor preceeded by another node without gap cursor - set node selection for previous node
            const selectableNode = (0, $a6582a741c8d0762$export$5a13616ef7dc6dd)($from, state.doc);
            if (selectableNode && (0, $4Wd8f.isIgnored)(selectableNode.node)) return $74dd4a6c0f671ce7$export$56a7f03ce3f93e52((0, $cQ4aK.RelativeSelectionPos).End, (0, $ks2lK.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        }
        return false;
    };
const $74dd4a6c0f671ce7$var$arrowRightFromText = (selection)=>(state, dispatch)=>{
        if ((0, $a6582a741c8d0762$export$1ab0c837d3abb951)(selection.$to, selection)) {
            const selectableNode = (0, $a6582a741c8d0762$export$15e7624ccd1acbba)(selection);
            if (selectableNode) return $74dd4a6c0f671ce7$export$56a7f03ce3f93e52((0, $cQ4aK.RelativeSelectionPos).End, (0, $ks2lK.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        }
        return false;
    };
const $74dd4a6c0f671ce7$var$arrowLeftFromText = (selection)=>(state, dispatch)=>{
        const { selectionRelativeToNode: selectionRelativeToNode } = (0, $a5f9baf1f4a52bd0$export$f05434c51e3762e)(state);
        if (selectionRelativeToNode === (0, $cQ4aK.RelativeSelectionPos).Before) {
            const selectableNode = (0, $a6582a741c8d0762$export$5a13616ef7dc6dd)(selection.$from, state.doc);
            if (selectableNode && (0, $4Wd8f.isIgnored)(selectableNode.node)) // selection is inside node without gap cursor preceeded by another node without gap cursor - set node selection for previous node
            return $74dd4a6c0f671ce7$export$56a7f03ce3f93e52((0, $cQ4aK.RelativeSelectionPos).End, (0, $ks2lK.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
            // we don't return this as we want to reset the relative pos, but not block other plugins
            // from responding to arrow left key
            $74dd4a6c0f671ce7$export$56a7f03ce3f93e52(undefined)(state, dispatch);
        } else if ((0, $a6582a741c8d0762$export$f80a5aec143de6c6)(selection.$from, selection)) {
            const selectableNode = (0, $a6582a741c8d0762$export$15e7624ccd1acbba)(selection);
            if (selectableNode) return $74dd4a6c0f671ce7$export$56a7f03ce3f93e52((0, $cQ4aK.RelativeSelectionPos).Start, (0, $ks2lK.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        }
        return false;
    };
const $74dd4a6c0f671ce7$var$findAndSetTextSelection = (selectionRelativeToNode, $pos, dir)=>(state, dispatch)=>{
        const sel = (0, $ks2lK.Selection).findFrom($pos, dir, true);
        if (sel) return $74dd4a6c0f671ce7$export$56a7f03ce3f93e52(selectionRelativeToNode, sel)(state, dispatch);
        return false;
    };
const $74dd4a6c0f671ce7$var$setSelectionInsideAtNodeStart = (selectionRelativeToNode, node, pos)=>(state, dispatch)=>{
        if ((0, $l9G9n.isNodeEmpty)(node)) return $74dd4a6c0f671ce7$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(pos), (0, $0d8c983a0ad0561c$export$5c80dd1df5708938).After)(state, dispatch);
        const selectableNode = (0, $a6582a741c8d0762$export$12f3aca2cb5b5ae9)(node);
        if (selectableNode) {
            const { node: childNode, pos: childPos } = selectableNode;
            const selectionPos = pos + childPos + 1;
            if (childNode.isText || childNode.isAtom && (0, $4Wd8f.isIgnored)(childNode) || childNode.isInline) //selection is for text node, inline node or atom node which is ignored by gap-cursor. set selection before it.
            return $74dd4a6c0f671ce7$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(selectionPos), (0, $0d8c983a0ad0561c$export$5c80dd1df5708938).Before)(state, dispatch);
            else if ((0, $l9G9n.isEmptyParagraph)(childNode)) return $74dd4a6c0f671ce7$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(selectionPos + 1), (0, $0d8c983a0ad0561c$export$5c80dd1df5708938).Before)(state, dispatch);
            else if (!(0, $4Wd8f.isIgnored)(node)) return $74dd4a6c0f671ce7$export$56a7f03ce3f93e52(selectionRelativeToNode, new (0, $adhil.GapCursorSelection)(state.doc.resolve(selectionPos), (0, $9GYNY.Side).LEFT))(state, dispatch);
            else if ((0, $a6582a741c8d0762$export$be9646888fa9d884)(node)) return $74dd4a6c0f671ce7$export$56a7f03ce3f93e52(selectionRelativeToNode, (0, $ks2lK.NodeSelection).create(state.doc, selectionPos))(state, dispatch);
        }
        return false;
    };
const $74dd4a6c0f671ce7$export$7c9ae5d21795cde4 = (selectionRelativeToNode, node, from, to)=>(state, dispatch)=>{
        if ((0, $l9G9n.isNodeEmpty)(node)) return $74dd4a6c0f671ce7$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(to), (0, $0d8c983a0ad0561c$export$5c80dd1df5708938).Before)(state, dispatch);
        const selectableNode = (0, $a6582a741c8d0762$export$b5a7c30cdb2d437f)(node);
        if (selectableNode) {
            const { node: childNode, pos: childPos } = selectableNode;
            const selectionPos = from + childPos + childNode.nodeSize;
            if (childNode.isText || childNode.isAtom && (0, $4Wd8f.isIgnored)(childNode) || childNode.isInline) //selection is for text node, inline node or atom node which is ignored by gap-cursor. set selection after it.
            return $74dd4a6c0f671ce7$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(selectionPos + 1), (0, $0d8c983a0ad0561c$export$5c80dd1df5708938).After)(state, dispatch);
            else if ((0, $l9G9n.isEmptyParagraph)(childNode)) return $74dd4a6c0f671ce7$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(selectionPos), (0, $0d8c983a0ad0561c$export$5c80dd1df5708938).After)(state, dispatch);
            else if (!(0, $4Wd8f.isIgnored)(node)) return $74dd4a6c0f671ce7$export$56a7f03ce3f93e52(selectionRelativeToNode, new (0, $adhil.GapCursorSelection)(state.doc.resolve(selectionPos + 1), (0, $9GYNY.Side).RIGHT))(state, dispatch);
            else if ((0, $a6582a741c8d0762$export$be9646888fa9d884)(node)) return $74dd4a6c0f671ce7$export$56a7f03ce3f93e52(selectionRelativeToNode, (0, $ks2lK.NodeSelection).create(state.doc, selectionPos))(state, dispatch);
        }
        return false;
    };



var $hgeg8 = parcelRequire("hgeg8");





var $astHL = parcelRequire("astHL");


var $dus6D = parcelRequire("dus6D");


var $e2a9y = parcelRequire("e2a9y");

var $laABt = parcelRequire("laABt");



var $1gpr6 = parcelRequire("1gpr6");




var $eYkDj = parcelRequire("eYkDj");

var $cMz8d = parcelRequire("cMz8d");

var $1d0KH = parcelRequire("1d0KH");


var $TfRUG = parcelRequire("TfRUG");










const $fc8a611e6beee526$export$21af267ac39e2110 = new (0, $ks2lK.PluginKey)('gapCursorPlugin');


var $3e272686381fb0d0$export$cacd6541cfeeb6c1 = /*#__PURE__*/ function(Direction) {
    Direction["UP"] = "up";
    Direction["RIGHT"] = "right";
    Direction["DOWN"] = "down";
    Direction["LEFT"] = "left";
    Direction["BACKWARD"] = "backward";
    Direction["FORWARD"] = "forward";
    return Direction;
}({});
function $3e272686381fb0d0$export$4d894a9a195acd59(dir) {
    return [
        "up",
        "left",
        "backward"
    ].indexOf(dir) !== -1;
}
function $3e272686381fb0d0$export$9439bc4ba99faca1(dir) {
    return [
        "right",
        "down",
        "forward"
    ].indexOf(dir) !== -1;
}



var $gAARK = parcelRequire("gAARK");





var $9Fl9f = parcelRequire("9Fl9f");
const $aaa72554d92ed7ed$export$629043421dcc56e5 = {
    BLOCK_CONTAINER: 'unsupportedBlockView-content-wrap',
    INLINE_CONTAINER: 'unsupportedInlineView-content-wrap'
};





const $d3def550605fb38a$export$2b745dec73894c8a = (side)=>side === (0, $9GYNY.Side).LEFT;
function $d3def550605fb38a$export$ed28bfac31d0c2ef(doc, $pos, schema, dir = -1) {
    let $currentPos = $pos;
    let currentNode = null;
    const { mediaSingle: mediaSingle, media: media, mediaGroup: mediaGroup } = schema.nodes;
    do {
        $currentPos = doc.resolve(dir === -1 ? $currentPos.before() : $currentPos.after());
        if (!$currentPos) return null;
        currentNode = (dir === -1 ? $currentPos.nodeBefore : $currentPos.nodeAfter) || $currentPos.parent;
        if (!currentNode || currentNode.type === schema.nodes.doc) return null;
        if (currentNode.type === mediaSingle || currentNode.type === media || currentNode.type === mediaGroup) return currentNode;
    }while ($currentPos.depth > 0);
    return null;
}
const $d3def550605fb38a$export$84353379d6171bb9 = (doc, schema, $pos, dir)=>{
    let $currentPos = $pos;
    let currentNode = dir === -1 ? $currentPos.nodeBefore : $currentPos.nodeAfter;
    // If next node is a text or a text block bail out early.
    if (currentNode && (currentNode.isTextblock || currentNode.isText)) return true;
    while($currentPos.depth > 0){
        $currentPos = doc.resolve(dir === -1 ? $currentPos.before() : $currentPos.after());
        if (!$currentPos) return false;
        currentNode = (dir === -1 ? $currentPos.nodeBefore : $currentPos.nodeAfter) || $currentPos.parent;
        if (!currentNode || currentNode.type === schema.nodes.doc) return false;
        if (currentNode.isTextblock) return true;
    }
    let childNode = currentNode;
    while(childNode && childNode.firstChild){
        childNode = childNode.firstChild;
        if (childNode && (childNode.isTextblock || childNode.isText)) return true;
    }
    return false;
};
function $d3def550605fb38a$export$698eab35981fecbc(node) {
    let layout;
    if (node.attrs.layout) layout = node.attrs.layout;
    if (node.marks && node.marks.length) layout = (node.marks.find((mark)=>mark.type.name === 'breakout') || {
        attrs: {
            mode: ''
        }
    }).attrs.mode;
    if (node.type.name === 'table' && node.attrs.width) layout = 'fixed-width';
    if ([
        'wide',
        'full-width',
        'fixed-width'
    ].indexOf(layout) === -1) return '';
    return layout;
}
const $d3def550605fb38a$export$e5da7366668fb130 = (elem)=>{
    if (elem?.nodeName === 'BUTTON' || elem?.closest('button')) return true;
    // check if we're clicking an image caption placeholder
    if (elem?.closest(`[data-id="${(0, $gAARK.CAPTION_PLACEHOLDER_ID)}"]`)) return true;
    // check if target node has a parent table node
    let tableWrap;
    let node = elem;
    while(node){
        if (node.className && (node.getAttribute('class') || '').indexOf((0, $9Fl9f.TableSharedCssClassName).TABLE_CONTAINER) > -1) {
            tableWrap = node;
            break;
        }
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        node = node.parentNode;
    }
    if (tableWrap) {
        const rowControls = tableWrap.querySelector(`.${(0, $9Fl9f.TableSharedCssClassName).TABLE_ROW_CONTROLS_WRAPPER}`);
        const isColumnControlsDecoration = elem && elem.classList && elem.classList.contains((0, $9Fl9f.TableSharedCssClassName).TABLE_COLUMN_CONTROLS_DECORATIONS);
        return rowControls && rowControls.contains(elem) || isColumnControlsDecoration;
    }
    // Check if unsupported node selection
    // (without this, selection requires double clicking in FF due to posAtCoords differences)
    if (elem?.closest(`.${(0, $aaa72554d92ed7ed$export$629043421dcc56e5).BLOCK_CONTAINER}`)) return true;
    return false;
};
const $d3def550605fb38a$export$b5b7287d8577df27 = (dom, node, style)=>{
    if (node && node.type.name === 'table') {
        const tableContainer = dom.querySelector('.pm-table-container');
        if (tableContainer) return window.getComputedStyle(tableContainer);
    }
    if ((0, $iu6m9.editorExperiment)('advanced_layouts', true) && node && node.type.name === 'layoutSection') {
        const layoutSectionContainer = dom.querySelector('.layout-section-container');
        if (layoutSectionContainer) return window.getComputedStyle(layoutSectionContainer);
    }
    return style;
};


const $09a1774d4707e2e2$export$1c8a4d720fa6d473 = (direction, state, $pos)=>{
    const { doc: doc, schema: schema } = state;
    switch(direction){
        case (0, $3e272686381fb0d0$export$cacd6541cfeeb6c1).UP:
            if ((0, $e2a9y.atTheBeginningOfDoc)(state)) return false;
            return (0, $1d0KH.isPositionNearTableRow)($pos, schema, 'before') || (0, $d3def550605fb38a$export$84353379d6171bb9)(doc, schema, $pos, -1) || (0, $cMz8d.isNodeBeforeMediaNode)($pos, state);
        case (0, $3e272686381fb0d0$export$cacd6541cfeeb6c1).DOWN:
            return(// end of a paragraph
            (0, $laABt.atTheEndOfDoc)(state) || (0, $d3def550605fb38a$export$84353379d6171bb9)(doc, schema, $pos, 1) || (0, $1d0KH.isPositionNearTableRow)($pos, schema, 'after') || $pos.nodeBefore?.type.name === 'text' && !$pos.nodeAfter);
        default:
            return false;
    }
};
// These cases should be handled using the handleMediaGapCursor function
function $09a1774d4707e2e2$var$shouldHandleMediaGapCursor(dir, state) {
    const { selection: selection } = state;
    const upArrowFromGapCursorIntoMedia = selection instanceof (0, $adhil.GapCursorSelection) && dir === (0, $3e272686381fb0d0$export$cacd6541cfeeb6c1).UP && selection.$from.nodeBefore && (0, $eYkDj.isMediaNode)(selection.$from.nodeBefore);
    const downArrowFromGapCursorIntoMediaGroup = selection instanceof (0, $adhil.GapCursorSelection) && dir === (0, $3e272686381fb0d0$export$cacd6541cfeeb6c1).DOWN && selection.$from.nodeAfter?.type.name === 'mediaGroup';
    return upArrowFromGapCursorIntoMedia || downArrowFromGapCursorIntoMediaGroup;
}
// Handle media gap cursor for up/down arrow into media nodes
// Should check this case by using shouldHandleMediaGapCursor first
function $09a1774d4707e2e2$var$handleMediaGapCursor(dir, state) {
    const { selection: selection, tr: tr } = state;
    const $pos = (0, $3e272686381fb0d0$export$4d894a9a195acd59)(dir) ? selection.$from : selection.$to;
    if (dir === (0, $3e272686381fb0d0$export$cacd6541cfeeb6c1).UP && selection.$from.nodeBefore && (0, $eYkDj.isMediaNode)(selection.$from.nodeBefore)) {
        const nodeBeforePos = (0, $8m4tT.findPositionOfNodeBefore)(tr.selection);
        if (nodeBeforePos && selection.side === 'right' && tr.doc.nodeAt(nodeBeforePos)?.type.name === 'mediaSingle') tr.setSelection(new (0, $ks2lK.NodeSelection)(tr.doc.resolve(nodeBeforePos))).scrollIntoView();
        else if (nodeBeforePos || nodeBeforePos === 0) tr.setSelection(new (0, $adhil.GapCursorSelection)(tr.doc.resolve(nodeBeforePos), (0, $9GYNY.Side).LEFT)).scrollIntoView();
    }
    if (dir === (0, $3e272686381fb0d0$export$cacd6541cfeeb6c1).DOWN && selection.$from.nodeAfter) {
        const nodeAfterPos = selection.side === 'right' ? $pos.pos : $pos.pos + selection.$from.nodeAfter.nodeSize;
        if (nodeAfterPos) tr.setSelection(new (0, $adhil.GapCursorSelection)(tr.doc.resolve(nodeAfterPos), (0, $9GYNY.Side).LEFT)).scrollIntoView();
    }
    return tr;
}
const $09a1774d4707e2e2$export$f2120bbfa5450bd2 = (dir, endOfTextblock)=>(state, dispatch, view)=>{
        const { doc: doc, selection: selection, tr: tr } = state;
        let $pos = (0, $3e272686381fb0d0$export$4d894a9a195acd59)(dir) ? selection.$from : selection.$to;
        let mustMove = selection.empty;
        // start from text selection
        if (selection instanceof (0, $ks2lK.TextSelection)) {
            // if cursor is in the middle of a text node, do nothing
            if (!endOfTextblock || !endOfTextblock(dir.toString())) return false;
            // UP/DOWN jumps to the nearest texblock skipping gapcursor whenever possible
            if ($09a1774d4707e2e2$export$1c8a4d720fa6d473(dir, state, $pos)) return false;
            // otherwise resolve previous/next position
            $pos = doc.resolve((0, $3e272686381fb0d0$export$4d894a9a195acd59)(dir) ? $pos.before() : $pos.after());
            mustMove = false;
        }
        if (selection instanceof (0, $ks2lK.NodeSelection)) {
            if (selection.node.isInline) return false;
            if (dir === (0, $3e272686381fb0d0$export$cacd6541cfeeb6c1).UP && !(0, $e2a9y.atTheBeginningOfDoc)(state) && !(0, $cMz8d.isNodeBeforeMediaNode)($pos, state) || dir === (0, $3e272686381fb0d0$export$cacd6541cfeeb6c1).DOWN) // We dont add gap cursor on node selections going up and down
            // Except we do if we're going up for a block node which is the
            // first node in the document OR the node before is a media node
            return false;
        }
        // Handle media gap cursor for up/down arrow into media nodes
        if ($09a1774d4707e2e2$var$shouldHandleMediaGapCursor(dir, state)) {
            const updatedTr = $09a1774d4707e2e2$var$handleMediaGapCursor(dir, state);
            if (dispatch) dispatch(updatedTr);
            return true;
        }
        // when jumping between block nodes at the same depth, we need to reverse cursor without changing ProseMirror position
        if (selection instanceof (0, $adhil.GapCursorSelection) && // next node allow gap cursor position
        (0, $1gpr6.isValidTargetNode)((0, $3e272686381fb0d0$export$4d894a9a195acd59)(dir) ? $pos.nodeBefore : $pos.nodeAfter) && // gap cursor changes block node
        ((0, $3e272686381fb0d0$export$4d894a9a195acd59)(dir) && selection.side === (0, $9GYNY.Side).LEFT || (0, $3e272686381fb0d0$export$9439bc4ba99faca1)(dir) && selection.side === (0, $9GYNY.Side).RIGHT)) {
            // reverse cursor position
            if (dispatch) dispatch(tr.setSelection(new (0, $adhil.GapCursorSelection)($pos, selection.side === (0, $9GYNY.Side).RIGHT ? (0, $9GYNY.Side).LEFT : (0, $9GYNY.Side).RIGHT)).scrollIntoView());
            return true;
        }
        if (view) {
            const domAtPos = view.domAtPos.bind(view);
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const target = (0, $8m4tT.findDomRefAtPos)($pos.pos, domAtPos);
            if (target && target.textContent === (0, $TfRUG.ZERO_WIDTH_SPACE)) return false;
        }
        const nextSelection = (0, $adhil.GapCursorSelection).findFrom($pos, (0, $3e272686381fb0d0$export$4d894a9a195acd59)(dir) ? -1 : 1, mustMove);
        if (!nextSelection) return false;
        if (!(0, $1gpr6.isValidTargetNode)((0, $3e272686381fb0d0$export$9439bc4ba99faca1)(dir) ? nextSelection.$from.nodeBefore : nextSelection.$from.nodeAfter)) {
            // reverse cursor position
            if (dispatch) dispatch(tr.setSelection(new (0, $adhil.GapCursorSelection)(nextSelection.$from, (0, $3e272686381fb0d0$export$9439bc4ba99faca1)(dir) ? (0, $9GYNY.Side).LEFT : (0, $9GYNY.Side).RIGHT)).scrollIntoView());
            return true;
        }
        if (dispatch) dispatch(tr.setSelection(nextSelection).scrollIntoView());
        return true;
    };
const $09a1774d4707e2e2$export$b05da9e94a08038f = (dir)=>(state, dispatch)=>{
        if (state.selection instanceof (0, $adhil.GapCursorSelection)) {
            const { $from: $from, $anchor: $anchor } = state.selection;
            let { tr: tr } = state;
            if ((0, $3e272686381fb0d0$export$4d894a9a195acd59)(dir)) {
                if (state.selection.side === 'left') {
                    tr.setSelection(new (0, $adhil.GapCursorSelection)($anchor, (0, $9GYNY.Side).RIGHT));
                    if (dispatch) dispatch(tr);
                    return true;
                }
                tr = (0, $8m4tT.removeNodeBefore)(state.tr);
            } else if ($from.nodeAfter) tr = tr.delete($from.pos, $from.pos + $from.nodeAfter.nodeSize);
            if (dispatch) dispatch(tr.setSelection((0, $ks2lK.Selection).near(tr.doc.resolve(tr.mapping.map(state.selection.$from.pos)))).scrollIntoView());
            return true;
        }
        return false;
    };
// This function captures clicks outside of the ProseMirror contentEditable area
// see also description of "handleClick" in gap-cursor pm-plugin
const $09a1774d4707e2e2$var$captureCursorCoords = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
event, editorRef, posAtCoords, tr)=>{
    const rect = editorRef.getBoundingClientRect();
    // capture clicks before the first block element
    if (event.clientY < rect.top) return {
        position: 0,
        side: (0, $9GYNY.Side).LEFT
    };
    if (rect.left > 0) {
        // calculate start position of a node that is vertically at the same level
        const coords = posAtCoords({
            left: rect.left,
            top: event.clientY
        });
        if (coords && coords.inside > -1) {
            const $from = tr.doc.resolve(coords.inside);
            const start = $from.before(1);
            const side = event.clientX < rect.left ? (0, $9GYNY.Side).LEFT : (0, $9GYNY.Side).RIGHT;
            let position;
            if (side === (0, $9GYNY.Side).LEFT) position = start;
            else {
                const node = tr.doc.nodeAt(start);
                if (node) position = start + node.nodeSize;
            }
            return {
                position: position,
                side: side
            };
        }
    }
    return null;
};
const $09a1774d4707e2e2$export$1b305efb24649ca5 = (tr, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
event, editorRef, posAtCoords, editorFocused)=>{
    const cursorCoords = $09a1774d4707e2e2$var$captureCursorCoords(event, editorRef, posAtCoords, tr);
    if (!cursorCoords) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const $pos = cursorCoords.position !== undefined ? tr.doc.resolve(cursorCoords.position) : null;
    if ($pos === null) return;
    const isGapCursorAllowed = cursorCoords.side === (0, $9GYNY.Side).LEFT ? (0, $1gpr6.isValidTargetNode)($pos.nodeAfter) : (0, $1gpr6.isValidTargetNode)($pos.nodeBefore);
    if (isGapCursorAllowed && (0, $adhil.GapCursorSelection).valid($pos)) {
        // this forces PM to re-render the decoration node if we change the side of the gap cursor, it doesn't do it by default
        if (tr.selection instanceof (0, $adhil.GapCursorSelection)) tr.setSelection((0, $ks2lK.Selection).near($pos));
        else tr.setSelection(new (0, $adhil.GapCursorSelection)($pos, cursorCoords.side));
    } else if (editorFocused === false) {
        const selectionTemp = (0, $ks2lK.Selection).findFrom($pos, cursorCoords.side === (0, $9GYNY.Side).LEFT ? 1 : -1, true);
        if (selectionTemp) tr.setSelection(selectionTemp);
    }
};
const $09a1774d4707e2e2$export$ddeed8e54d88a7b0 = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
event, editorRef, posAtCoords, editorFocused)=>(state, dispatch)=>{
        const { tr: tr } = state;
        $09a1774d4707e2e2$export$1b305efb24649ca5(tr, event, editorRef, posAtCoords, editorFocused);
        if (tr.selectionSet && dispatch) {
            dispatch(tr);
            return true;
        }
        return false;
    };
const $09a1774d4707e2e2$export$a3664bef63da9388 = (state)=>{
    return Boolean((0, $fc8a611e6beee526$export$21af267ac39e2110).get(state));
};



function $602d85d93e41ad51$export$2e2bcd8739ae039() {
    const map = {};
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.insertNewLine).common, (state, dispatch, view)=>{
        const isInGapCursor = state.selection instanceof (0, $adhil.GapCursorSelection);
        // Only operate in gap cursor
        if (!isInGapCursor) return false;
        return (0, $astHL.createParagraphNear)(state, dispatch);
    }, map);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.moveLeft).common, (state, dispatch, view)=>{
        const endOfTextblock = view ? view.endOfTextblock.bind(view) : undefined;
        return (0, $09a1774d4707e2e2$export$f2120bbfa5450bd2)((0, $3e272686381fb0d0$export$cacd6541cfeeb6c1).LEFT, endOfTextblock)(state, dispatch, view);
    }, map);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.moveRight).common, (state, dispatch, view)=>{
        const endOfTextblock = view ? view.endOfTextblock.bind(view) : undefined;
        return (0, $09a1774d4707e2e2$export$f2120bbfa5450bd2)((0, $3e272686381fb0d0$export$cacd6541cfeeb6c1).RIGHT, endOfTextblock)(state, dispatch);
    }, map);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.moveUp).common, (state, dispatch, view)=>{
        const endOfTextblock = view ? view.endOfTextblock.bind(view) : undefined;
        return (0, $09a1774d4707e2e2$export$f2120bbfa5450bd2)((0, $3e272686381fb0d0$export$cacd6541cfeeb6c1).UP, endOfTextblock)(state, dispatch);
    }, map);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.moveDown).common, (state, dispatch, view)=>{
        const endOfTextblock = view ? view.endOfTextblock.bind(view) : undefined;
        return (0, $09a1774d4707e2e2$export$f2120bbfa5450bd2)((0, $3e272686381fb0d0$export$cacd6541cfeeb6c1).DOWN, endOfTextblock)(state, dispatch);
    }, map);
    // default PM's Backspace doesn't handle removing block nodes when cursor is after it
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.backspace).common, (0, $09a1774d4707e2e2$export$b05da9e94a08038f)((0, $3e272686381fb0d0$export$cacd6541cfeeb6c1).BACKWARD), map);
    // handle Delete key (remove node after the cursor)
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.deleteKey).common, (0, $09a1774d4707e2e2$export$b05da9e94a08038f)((0, $3e272686381fb0d0$export$cacd6541cfeeb6c1).FORWARD), map);
    return (0, $dus6D.keymap)(map);
}








var $4AaC5 = parcelRequire("4AaC5");

var $1zPzM = parcelRequire("1zPzM");






























/**
 * We have a couple of nodes that require us to compute style
 * on different elements, ideally all nodes should be able to
 * compute the appropriate styles based on their wrapper.
 */ const $1f50cb9f720b3079$var$nestedCases = {
    'tableView-content-wrap': 'table',
    'mediaSingleView-content-wrap': '.rich-media-item',
    'bodiedExtensionView-content-wrap': '.extension-container',
    'multiBodiedExtensionView-content-wrap': '.multiBodiedExtension--container',
    'embedCardView-content-wrap': '.rich-media-item',
    'datasourceView-content-wrap': '.datasourceView-content-inner-wrap'
};
const $1f50cb9f720b3079$var$getNestedSelector = (key)=>{
    if (key === 'multiBodiedExtensionView-content-wrap' && (0, $1oCLl.expValEquals)('confluence_native_tabs_experiment', 'isEnabled', true)) return '.multiBodiedExtension--wrapper';
    return $1f50cb9f720b3079$var$nestedCases[key];
};
const $1f50cb9f720b3079$var$computeNestedStyle = (dom)=>{
    const foundKey = Object.keys($1f50cb9f720b3079$var$nestedCases).find((className)=>dom.classList.contains(className));
    const nestedSelector = foundKey && $1f50cb9f720b3079$var$getNestedSelector(foundKey);
    if (nestedSelector) {
        const nestedElement = dom.querySelector(nestedSelector);
        if (nestedElement) return window.getComputedStyle(nestedElement);
    }
};
const $1f50cb9f720b3079$var$measureHeight = (style)=>{
    return $1f50cb9f720b3079$var$measureValue(style, [
        'height',
        'padding-top',
        'padding-bottom',
        'border-top-width',
        'border-bottom-width'
    ]);
};
const $1f50cb9f720b3079$var$measureWidth = (style)=>{
    return $1f50cb9f720b3079$var$measureValue(style, [
        'width',
        'padding-left',
        'padding-right',
        'border-left-width',
        'border-right-width'
    ]);
};
const $1f50cb9f720b3079$var$measureValue = (style, measureValues)=>{
    const [base, ...contentBoxValues] = measureValues;
    const measures = [
        style.getPropertyValue(base)
    ];
    const boxSizing = style.getPropertyValue('box-sizing');
    if (boxSizing === 'content-box') contentBoxValues.forEach((value)=>{
        measures.push(style.getPropertyValue(value));
    });
    let result = 0;
    for(let i = 0; i < measures.length; i++)result += parseFloat(measures[i]);
    return result;
};
const $1f50cb9f720b3079$var$mutateElementStyle = (element, style, side)=>{
    element.style.transform = style.getPropertyValue('transform');
    if ((0, $d3def550605fb38a$export$2b745dec73894c8a)(side)) {
        element.style.width = style.getPropertyValue('width');
        element.style.marginLeft = style.getPropertyValue('margin-left');
    } else {
        const marginRight = parseFloat(style.getPropertyValue('margin-right'));
        if (marginRight > 0) element.style.marginLeft = `-${Math.abs(marginRight)}px`;
        else element.style.paddingRight = `${Math.abs(marginRight)}px`;
    }
};
/**
 * For nested elements (e.g. .extension-container inside
 * .extensionView-content-wrap), use getBoundingClientRect to compute
 * the exact pixel offset between the gap cursor's position in the
 * flow and the inner element's visual position.
 */ const $1f50cb9f720b3079$var$positionFromRect = (gapCursor, cursorParent, nestedElement)=>{
    const cursorRect = cursorParent.getBoundingClientRect();
    const innerRect = nestedElement.getBoundingClientRect();
    gapCursor.style.marginTop = `${innerRect.top - cursorRect.top}px`;
    gapCursor.style.left = `${innerRect.left - cursorRect.left}px`;
    gapCursor.style.width = `${innerRect.width}px`;
};
const $1f50cb9f720b3079$export$289411c5a7970646 = (view, getPos)=>{
    const selection = view.state.selection;
    const { $from: $from, side: side } = selection;
    const isRightCursor = side === (0, $9GYNY.Side).RIGHT;
    const node = isRightCursor ? $from.nodeBefore : $from.nodeAfter;
    const element = document.createElement('span');
    element.className = `ProseMirror-gapcursor ${isRightCursor ? '-right' : '-left'}`;
    element.appendChild(document.createElement('span'));
    if (element.firstChild) {
        const gapCursor = element.firstChild;
        // The DOM from view.nodeDOM() might be stale after paste
        // Use requestAnimationFrame to wait for DOM to update, then fetch and measure
        requestAnimationFrame(()=>{
            const nodeStart = getPos();
            if (nodeStart === undefined) return;
            // if selection has changed, we no longer need to compute the styles for the gapcursor
            if (!view.state.selection.eq(selection)) return;
            const dom = view.nodeDOM(nodeStart);
            if (dom instanceof HTMLElement) {
                // For native embed extensions only, use getBoundingClientRect
                // to position the gap cursor precisely relative to the inner
                // .extension-container
                if (dom.classList.contains('extensionView-content-wrap')) {
                    const nativeEmbed = dom.querySelector('.extension-container:has([data-native-embed-alignment])');
                    if (nativeEmbed) {
                        const nativeEmbedStyle = window.getComputedStyle(nativeEmbed);
                        gapCursor.style.height = `${$1f50cb9f720b3079$var$measureHeight(nativeEmbedStyle)}px`;
                        $1f50cb9f720b3079$var$positionFromRect(gapCursor, element, nativeEmbed);
                        return;
                    }
                }
                const style = $1f50cb9f720b3079$var$computeNestedStyle(dom) || window.getComputedStyle(dom);
                gapCursor.style.height = `${$1f50cb9f720b3079$var$measureHeight(style)}px`;
                const layoutMode = node && (0, $d3def550605fb38a$export$698eab35981fecbc)(node);
                if (nodeStart !== 0 || layoutMode || node?.type.name === 'table') gapCursor.style.marginTop = style.getPropertyValue('margin-top');
                const isNestedTable = node?.type.name === 'table' && selection.$to.depth > 0;
                if (layoutMode && !isNestedTable) {
                    gapCursor.setAttribute('layout', layoutMode);
                    const breakoutModeStyle = (0, $d3def550605fb38a$export$b5b7287d8577df27)(dom, node, style);
                    gapCursor.style.width = `${$1f50cb9f720b3079$var$measureWidth(breakoutModeStyle)}px`;
                } else $1f50cb9f720b3079$var$mutateElementStyle(gapCursor, style, selection.side);
            }
        });
    }
    return element;
};


const $6fb0e0ba57f67fb1$var$plugin = new (0, $1S4f7.SafePlugin)({
    key: (0, $fc8a611e6beee526$export$21af267ac39e2110),
    state: {
        init: ()=>({
                selectionIsGapCursor: false,
                displayGapCursor: true,
                hideCursor: false
            }),
        apply: (tr, pluginState, _oldState, newState)=>{
            const meta = tr.getMeta((0, $fc8a611e6beee526$export$21af267ac39e2110));
            const selectionMeta = tr.getMeta((0, $0d8c983a0ad0561c$export$e530ba00b008a680));
            const selectionIsGapCursor = newState.selection instanceof (0, $adhil.GapCursorSelection);
            return {
                selectionIsGapCursor: selectionIsGapCursor,
                // only attempt to hide gap cursor if selection is gap cursor
                displayGapCursor: selectionIsGapCursor ? meta?.displayGapCursor ?? pluginState.displayGapCursor : true,
                // track hideCursor state from selection plugin
                hideCursor: selectionMeta?.hideCursor ?? pluginState.hideCursor
            };
        }
    },
    view: (view)=>{
        /**
     * If the selection is at the beginning of a document and is a NodeSelection,
     * convert to a GapCursor selection. This is to stop users accidentally replacing
     * the first node of a document by accident.
     */ if (view.state.selection.anchor === 0 && view.state.selection instanceof (0, $ks2lK.NodeSelection)) // This is required otherwise the dispatch doesn't trigger in the correct place
        window.requestAnimationFrame(()=>{
            view.dispatch(view.state.tr.setSelection(new (0, $adhil.GapCursorSelection)(view.state.doc.resolve(0), (0, $9GYNY.Side).LEFT)));
        });
        return {
            update (view) {
                if ((0, $iu6m9.editorExperiment)('platform_synced_block', true)) // Caret visibility now handled directly via CSS selector in gapCursorStyles.ts
                return;
                const { selectionIsGapCursor: selectionIsGapCursor } = (0, $fc8a611e6beee526$export$21af267ac39e2110).getState(view.state);
                /**
         * Starting with prosemirror-view 1.19.4, cursor wrapper that previously was hiding cursor doesn't exist:
         * https://github.com/ProseMirror/prosemirror-view/commit/4a56bc7b7e61e96ef879d1dae1014ede0fc09e43
         *
         * Because it was causing issues with RTL: https://github.com/ProseMirror/prosemirror/issues/948
         *
         * This is the work around which uses `caret-color: transparent` in order to hide regular caret,
         * when gap cursor is visible.
         *
         * Browser support is pretty good: https://caniuse.com/#feat=css-caret-color
         */ view.dom.classList.toggle((0, $4AaC5.hideCaretModifier), selectionIsGapCursor);
            }
        };
    },
    props: {
        decorations: (editorState)=>{
            const { doc: doc, selection: selection } = editorState;
            const { displayGapCursor: displayGapCursor, hideCursor: hideCursor } = (0, $fc8a611e6beee526$export$21af267ac39e2110).getState(editorState);
            if (selection instanceof (0, $adhil.GapCursorSelection) && displayGapCursor && !hideCursor) {
                const { $from: $from, side: side } = selection;
                // render decoration DOM node always to the left of the target node even if selection points to the right
                // otherwise positioning of the right gap cursor is a nightmare when the target node has a nodeView with vertical margins
                let position = selection.head;
                const isRightCursor = side === (0, $9GYNY.Side).RIGHT;
                if (isRightCursor && $from.nodeBefore) {
                    const nodeBeforeStart = (0, $8m4tT.findPositionOfNodeBefore)(selection);
                    if (typeof nodeBeforeStart === 'number') position = nodeBeforeStart;
                }
                const node = isRightCursor ? $from.nodeBefore : $from.nodeAfter;
                const layoutMode = node && (0, $d3def550605fb38a$export$698eab35981fecbc)(node);
                return (0, $ftzrq.DecorationSet).create(doc, [
                    (0, $ftzrq.Decoration).widget(position, (0, $1f50cb9f720b3079$export$289411c5a7970646), {
                        key: `${(0, $adhil.JSON_ID)}-${side}-${layoutMode}`,
                        // position === 0: if gap cursor at start of document, render it on the left side of the selection to enable pasting (otherwise Chrome doesn't pick up the paste event)
                        side: layoutMode || position === 0 ? -1 : 0
                    })
                ]);
            }
            return null;
        },
        // render gap cursor only when its valid
        createSelectionBetween (view, $anchor, $head) {
            if (view && view.state && view.state.selection instanceof (0, $7XFGZ.CellSelection)) // Do not show GapCursor when there is a CellSection happening
            return null;
            if ($anchor.pos === $head.pos && (0, $adhil.GapCursorSelection).valid($head)) return new (0, $adhil.GapCursorSelection)($head);
            return null;
        },
        handleClick (view, nodePos, event) {
            const posAtCoords = view.posAtCoords({
                left: event.clientX,
                top: event.clientY
            });
            if (!posAtCoords || (0, $d3def550605fb38a$export$e5da7366668fb130)(event.target instanceof HTMLElement ? event.target : null)) return false;
            const isInsideTheTarget = posAtCoords.pos === posAtCoords.inside;
            if (isInsideTheTarget) return false;
            const leftSideOffsetX = 20;
            const side = event.offsetX > leftSideOffsetX ? (0, $9GYNY.Side).RIGHT : (0, $9GYNY.Side).LEFT;
            const $pos = view.state.doc.resolve(nodePos);
            // In the new prosemirror-view posAtCoords  is not returning a precise value for our media nodes
            if ($pos.parent?.type.name === 'mediaSingle') {
                const $insidePos = view.state.doc.resolve(Math.max(posAtCoords.inside, 0));
                // We don't have GapCursors problems when the node target is inside the root level
                if ($insidePos.depth <= 1) return false;
                const mediaGapCursor = !$pos.nodeBefore ? $pos.before() : $pos.after();
                return (0, $1zPzM.setGapCursorAtPos)(mediaGapCursor, side)(view.state, view.dispatch);
            }
            const docSize = view.state.doc.content.size;
            const nodeInside = posAtCoords.inside < 0 || posAtCoords.inside > docSize ? null : view.state.doc.nodeAt(posAtCoords.inside);
            if (nodeInside?.isAtom) return false;
            return (0, $1zPzM.setGapCursorAtPos)(nodePos, side)(view.state, view.dispatch);
        },
        handleDOMEvents: {
            /**
       * Android composition events aren't handled well by Prosemirror
       * We've added a couple of beforeinput hooks to help PM out when trying to delete
       * certain nodes. We can remove these when PM has better composition support.
       * @see https://github.com/ProseMirror/prosemirror/issues/543
       */ // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            beforeinput: (view, event)=>{
                if (event.inputType === 'deleteContentBackward' && view.state.selection instanceof (0, $adhil.GapCursorSelection)) {
                    event.preventDefault();
                    return (0, $09a1774d4707e2e2$export$b05da9e94a08038f)((0, $3e272686381fb0d0$export$cacd6541cfeeb6c1).BACKWARD)(view.state, view.dispatch);
                }
                return false;
            }
        }
    }
});
var $6fb0e0ba57f67fb1$export$2e2bcd8739ae039 = $6fb0e0ba57f67fb1$var$plugin;










function $9c32f9a018c13f89$var$keymapPlugin() {
    const list = {};
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.moveRight).common, (0, $74dd4a6c0f671ce7$export$680a8d7c28b0860), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.moveLeft).common, (0, $74dd4a6c0f671ce7$export$3ff8c533d254ed7c), list);
    return (0, $dus6D.keymap)(list);
}
var $9c32f9a018c13f89$export$2e2bcd8739ae039 = $9c32f9a018c13f89$var$keymapPlugin;











const $262303cab724525d$export$220fecd6a5c51ffb = new (0, $ks2lK.PluginKey)('markBoundaryCursorPlugin');





const $e3c059b401f80939$var$containerStyle = `
	position: relative;
`;
const $e3c059b401f80939$var$caretStyle = `
	position: absolute;
	height: 100%;
	width: 1px;
	left: -0.5px;
	bottom: 0;
	background-color: ${"var(--ds-text, #292A2E)"};
`;
const $e3c059b401f80939$var$toDOM = ()=>{
    const container = document.createElement('span');
    container.className = 'ProseMirror-mark-boundary-cursor';
    container.setAttribute('style', $e3c059b401f80939$var$containerStyle);
    const caret = document.createElement('div');
    caret.setAttribute('style', $e3c059b401f80939$var$caretStyle);
    caret.animate?.([
        {
            opacity: 1
        },
        {
            opacity: 1,
            offset: 0.5
        },
        {
            opacity: 0,
            offset: 0.5
        },
        {
            opacity: 0
        }
    ], {
        duration: 1000,
        iterations: Infinity
    });
    container.appendChild(caret);
    return container;
};
const $e3c059b401f80939$export$499e8e2917534a4d = (pos, side)=>{
    return (0, $ftzrq.Decoration).widget(pos, $e3c059b401f80939$var$toDOM, {
        key: 'mark-boundary-cursor',
        side: side
    });
};



var $1XMEN = parcelRequire("1XMEN");


var $5SAOw = parcelRequire("5SAOw");

var $7d3fde91160039cc$export$6705e1762430d43f = /*#__PURE__*/ function(MarksSide) {
    MarksSide[MarksSide["None"] = 0] = "None";
    MarksSide[MarksSide["Left"] = -1] = "Left";
    MarksSide[MarksSide["Right"] = 1] = "Right";
    return MarksSide;
}({});



function $00d80c3bd3c01123$export$325621c34246ee7d({ leftMarks: leftMarks, rightMarks: rightMarks, storedMarks: storedMarks }) {
    const isInlineCodeToLeft = leftMarks.some((mark)=>mark.type.name === 'code');
    const isInlineCodeToRight = rightMarks.some((mark)=>mark.type.name === 'code');
    const isInlineCodeBeingStored = !!storedMarks && storedMarks?.some((mark)=>mark.type.name === 'code');
    const isStoredMarksBeingCleared = !!storedMarks && storedMarks.length === 0;
    // This condition covers two scenarios:
    // a) When the cursor is on the left side of the inline code, and is expected to be
    // positioned within the inline code after pressing arrow right
    // b) When the cursor is on the right side of the inline code, and is expected to be
    // positioned outside of the inline code after pressing arrow right
    // in both of these cases the cursor needs to be corrected to be positioned inline
    // with the node to the right
    // NOTE: In editor-plugin-text-formatting there is logic on left/right key press
    // which dispatches a transaction to update the stored marks
    if (isInlineCodeToRight && isInlineCodeBeingStored || isInlineCodeToLeft && isStoredMarksBeingCleared) return (0, $7d3fde91160039cc$export$6705e1762430d43f).Right;
    return (0, $7d3fde91160039cc$export$6705e1762430d43f).None;
}


function $6e66307a90713cc5$export$8f6a177d567e1134({ selection: selection, storedMarks: storedMarks }) {
    if (!(0, $1XMEN.isTextSelection)(selection) || !selection.empty) return (0, $7d3fde91160039cc$export$6705e1762430d43f).None;
    const { nodeBefore: nodeBefore, nodeAfter: nodeAfter } = selection.$head;
    const leftMarks = nodeBefore?.marks ?? [];
    const rightMarks = nodeAfter?.marks ?? [];
    if ((0, $5SAOw.Mark).sameSet(leftMarks, rightMarks)) return (0, $7d3fde91160039cc$export$6705e1762430d43f).None;
    return (0, $00d80c3bd3c01123$export$325621c34246ee7d)({
        leftMarks: leftMarks,
        rightMarks: rightMarks,
        storedMarks: storedMarks
    });
}


const $688ff34616ec256c$export$d3a8cfe12ba42d22 = ()=>{
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $262303cab724525d$export$220fecd6a5c51ffb),
        state: {
            init: ()=>({
                    decorations: (0, $ftzrq.DecorationSet).empty
                }),
            apply (tr, currentState) {
                const { selection: selection, storedMarks: storedMarks, doc: doc, selectionSet: selectionSet, storedMarksSet: storedMarksSet, docChanged: docChanged } = tr;
                if (!selectionSet && !storedMarksSet && !docChanged) return currentState;
                const side = (0, $6e66307a90713cc5$export$8f6a177d567e1134)({
                    selection: selection,
                    storedMarks: storedMarks
                });
                if (!side) return {
                    decorations: (0, $ftzrq.DecorationSet).empty
                };
                return {
                    decorations: (0, $ftzrq.DecorationSet).create(doc, [
                        (0, $e3c059b401f80939$export$499e8e2917534a4d)(selection.head, side)
                    ])
                };
            }
        },
        props: {
            decorations: (state)=>{
                return (0, $262303cab724525d$export$220fecd6a5c51ffb).getState(state)?.decorations;
            }
        }
    });
};






















const $1f4b90791a37d5fa$var$DOC_START_POS = 0;
function $1f4b90791a37d5fa$var$isNodeContentEmpty(maybeNode) {
    return maybeNode?.content.size === 0 || maybeNode?.textContent === '';
}
function $1f4b90791a37d5fa$var$findEmptySelectableParentNodePosition($pos) {
    const { doc: doc } = $pos;
    if ($pos.pos > doc.content.size) return null;
    if ($1f4b90791a37d5fa$var$isCurrentNodeAtomOrEmptySelectable($pos)) return $pos;
    if ($pos.nodeBefore !== null) return null;
    if ($pos.depth === 0 && $pos.pos === 0) return $pos;
    const positionLevelUp = $pos.before();
    const resolvedPositionLevelUp = doc.resolve(positionLevelUp);
    return $1f4b90791a37d5fa$var$findEmptySelectableParentNodePosition(resolvedPositionLevelUp);
}
const $1f4b90791a37d5fa$var$isCurrentNodeAtomOrEmptySelectable = ($pos)=>{
    //ED-20209: Using $resolvedJustBeforeNodePos so that $resolvedJustBeforeNodePos.nodeAfter return the node at $pos.pos even if that is an atomic node
    if ($pos.pos === $1f4b90791a37d5fa$var$DOC_START_POS) return false;
    const justBeforeNodePos = $pos.pos - 1;
    const $resolvedjustBeforePos = $pos.doc.resolve(justBeforeNodePos);
    const maybeNode = $resolvedjustBeforePos.nodeAfter;
    if (!maybeNode || !maybeNode.isBlock) return false;
    if (maybeNode.isAtom) return true;
    return $1f4b90791a37d5fa$var$isNodeContentEmpty(maybeNode) && (0, $ks2lK.NodeSelection).isSelectable(maybeNode);
};
function $1f4b90791a37d5fa$var$findNextSelectionPosition({ $targetHead: $targetHead, $anchor: $anchor, doc: doc }) {
    const direction = $anchor.pos < $targetHead.pos ? 'down' : 'up';
    //ED-20209: If the targetHead position is just before some node, Then return $targetHead and not select any node.
    let maybeNode = null;
    // prosemirror calls 'createSelectionBetween' for native 'drop' events, it passes $anchor
    // and $head which are based on a transformed document, but only provides the original
    // doc. Need to remap the $head pos to last element in doc to avoid RangeErrors.
    if ($targetHead.pos >= doc.nodeSize) maybeNode = doc.resolve(doc.nodeSize - 2).nodeBefore;
    else if ($targetHead.pos !== $1f4b90791a37d5fa$var$DOC_START_POS) {
        const justBeforeHeadPos = $targetHead.pos - 1;
        const $resolvedJustBeforeHeadPos = doc.resolve(justBeforeHeadPos);
        maybeNode = $resolvedJustBeforeHeadPos.nodeAfter;
    }
    if (maybeNode === null) {
        maybeNode = $targetHead.nodeAfter;
        if (maybeNode !== null) $targetHead = doc.resolve($targetHead.pos + 1);
        else return null;
    }
    const maybeNextPosition = $1f4b90791a37d5fa$var$findEmptySelectableParentNodePosition($targetHead);
    if (maybeNextPosition) {
        const justBeforeMaybeNextPos = maybeNextPosition.pos - 1;
        if (direction === 'up') return doc.resolve(Math.max(justBeforeMaybeNextPos, 0));
        else {
            const maybeNextNode = doc.resolve(justBeforeMaybeNextPos).nodeAfter;
            if (maybeNextNode) return doc.resolve(Math.min(justBeforeMaybeNextPos + maybeNextNode.nodeSize, doc.content.size));
        }
    }
    return null;
}
const $1f4b90791a37d5fa$export$ba3a236bf89a370d = (view, $anchor, $head)=>{
    if ($anchor.pos === $head.pos) return null;
    if ($anchor.depth === $head.depth && $anchor.sameParent($head)) return null;
    // If the head is targeting a paragraph on root, then let ProseMirror handle the text selection
    if ($head.depth === 1 && $head.parent?.type.name === 'paragraph') return null;
    // If head is at the beginning of a non-empty textblock, let ProseMirror handle the text selection
    if ($head.parent?.isTextblock && !$1f4b90791a37d5fa$var$isNodeContentEmpty($head.parent) && $head.parentOffset === 0) return null;
    const $nextHeadPosition = $1f4b90791a37d5fa$var$findNextSelectionPosition({
        $targetHead: $head,
        $anchor: $anchor,
        doc: view.state.doc
    });
    if (!$nextHeadPosition) return null;
    const forcedTextSelection = (0, $ks2lK.TextSelection).create(view.state.doc, $anchor.pos, $nextHeadPosition.pos);
    return forcedTextSelection;
};



var $adayn = parcelRequire("adayn");








var $dZ8uq = parcelRequire("dZ8uq");

/*
 * The way expand was built, no browser recognize selection on it.
 * For instance, when a selection going to a "collapsed" expand
 * the browser will try to send the cursor to inside the expand content (wrong),
 * this behavior is caused because the expand content is never true hidden
 * we just set the height to 1px.
 *
 * So, we need to capture a possible selection event
 * when a collapsed expand is the next node in the common depth.
 * If that is true, we create a new TextSelection and stop the event bubble
 */ const $42b8ff92e0383dba$var$isCollapsedExpand = (node, { __livePage: __livePage })=>{
    let currentExpandedState;
    if (__livePage && (0, $1oCLl.expValEquals)('platform_editor_single_player_expand', 'isEnabled', true)) currentExpandedState = node ? !(0, $adayn.expandedState).get(node) : undefined;
    else if (__livePage) currentExpandedState = node?.attrs.__expanded;
    else currentExpandedState = !node?.attrs.__expanded;
    return Boolean(node && [
        'expand',
        'nestedExpand'
    ].includes(node.type.name) && currentExpandedState);
};
/**
 * ED-18072 - Cannot shift + arrow past bodied extension if it is not empty
 */ const $42b8ff92e0383dba$var$isBodiedExtension = (node)=>{
    return Boolean(node && [
        'bodiedExtension'
    ].includes(node.type.name));
};
/**
 * ED-19861 - [Regression] keyboard selections within action items are unpredicatable
 * Table was added to the list of problematic nodes because the desired behaviour when Shift+Up from outside the
 * table is to select the table node itself, rather than the table cell content. Previously this behaviour was handled
 * in `packages/editor/editor-core/src/plugins/selection/pm-plugins/events/create-selection-between.ts` but there was
 * a bug in `create-selection-between` which after fixing the bug that code was no longer handling table selection
 * correctly, so to fix that table was added here.
 */ const $42b8ff92e0383dba$var$isTable = (node)=>{
    return Boolean(node && [
        'table'
    ].includes(node.type.name));
};
const $42b8ff92e0383dba$var$isProblematicNode = (node, { __livePage: __livePage })=>{
    return $42b8ff92e0383dba$var$isCollapsedExpand(node, {
        __livePage: __livePage
    }) || $42b8ff92e0383dba$var$isBodiedExtension(node) || $42b8ff92e0383dba$var$isTable(node);
};
const $42b8ff92e0383dba$var$findFixedProblematicNodePosition = (doc, $head, direction, { __livePage: __livePage })=>{
    if ($head.pos === 0 || $head.depth === 0) return null;
    if (direction === 'up') {
        const pos = $head.before();
        const $posResolved = $head.doc.resolve(pos);
        const maybeProblematicNode = $posResolved.nodeBefore;
        if (maybeProblematicNode && $42b8ff92e0383dba$var$isProblematicNode(maybeProblematicNode, {
            __livePage: __livePage
        })) {
            const nodeSize = maybeProblematicNode.nodeSize;
            const nodeStartPosition = pos - nodeSize;
            // ($head.pos - 1) will correspond to (nodeStartPosition + nodeSize) when we are at the start of the text node
            const isAtEndOfProblematicNode = $head.pos - 1 === nodeStartPosition + nodeSize;
            if (isAtEndOfProblematicNode) {
                const startPosNode = Math.max(nodeStartPosition, 0);
                const $startPosNode = $head.doc.resolve(Math.min(startPosNode, $head.doc.content.size));
                return $startPosNode;
            }
        }
    }
    if (direction === 'down') {
        const pos = $head.after();
        const maybeProblematicNode = doc.nodeAt(pos);
        if (maybeProblematicNode && $42b8ff92e0383dba$var$isProblematicNode(maybeProblematicNode, {
            __livePage: __livePage
        }) && $head.pos + 1 === pos) {
            const nodeSize = maybeProblematicNode.nodeSize;
            const nodePosition = pos + nodeSize;
            const startPosNode = Math.max(nodePosition, 0);
            const $startPosNode = $head.doc.resolve(Math.min(startPosNode, $head.doc.content.size));
            return $startPosNode;
        }
    }
    return null;
};
const $42b8ff92e0383dba$var$isSelectionLineShortcutWhenCursorIsInsideInlineNode = (view, event)=>{
    if (!event.shiftKey || !event.metaKey) return false;
    const selection = view.state.selection;
    if (!(selection instanceof (0, $ks2lK.TextSelection))) return false;
    if (!selection.$cursor) return false;
    const isSelectingInlineNodeForward = event.key === 'ArrowRight' && Boolean(selection.$cursor.nodeAfter?.isInline);
    const isSelectingInlineNodeBackward = event.key === 'ArrowLeft' && Boolean(selection.$cursor.nodeBefore?.isInline);
    return isSelectingInlineNodeForward || isSelectingInlineNodeBackward;
};
const $42b8ff92e0383dba$var$isNavigatingVerticallyWhenCursorIsInsideInlineNode = (view, event)=>{
    if (event.shiftKey || event.metaKey) return false;
    const selection = view.state?.selection;
    if (!(selection instanceof (0, $ks2lK.TextSelection))) return false;
    if (!selection.$cursor) return false;
    const isNavigatingInlineNodeDownward = event.key === 'ArrowDown' && Boolean(selection.$cursor.nodeBefore?.isInline) && Boolean(selection.$cursor.nodeAfter?.isInline);
    if (isNavigatingInlineNodeDownward && (0, $adayn.getNextNodeExpandPos)(view, selection) !== undefined && (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_lovability_navigation_fixes', 'isEnabled', true)) return false;
    return isNavigatingInlineNodeDownward;
};
function $42b8ff92e0383dba$export$1bff6ff05fed49a5({ __livePage: __livePage = false }) {
    function onKeydown(view, event) {
        /*
		 * This workaround is needed for some specific situations.
		 * - expand collapse
		 * - bodied extension
		 */ if (!(event instanceof KeyboardEvent)) return false;
        // Override the default behaviour to make sure that the selection always extends to
        // the start of the document and not just the first inline position.
        if (event.shiftKey && event.metaKey && event.key === 'ArrowUp') {
            const selection = (0, $ks2lK.TextSelection).create(view.state.doc, view.state.selection.$anchor.pos, 0);
            view.dispatch(view.state.tr.setSelection(selection));
            event.preventDefault();
            return true;
        }
        if ($42b8ff92e0383dba$var$isSelectionLineShortcutWhenCursorIsInsideInlineNode(view, event)) return true;
        if ($42b8ff92e0383dba$var$isNavigatingVerticallyWhenCursorIsInsideInlineNode(view, event)) return true;
        if (!event.shiftKey || event.ctrlKey || event.metaKey) return false;
        if (![
            'ArrowUp',
            'ArrowDown',
            'ArrowRight',
            'ArrowLeft',
            'Home',
            'End'
        ].includes(event.key)) return false;
        const { doc: doc, selection: { $head: $head, $anchor: $anchor } } = view.state;
        if (event.key === 'ArrowRight' && $head.nodeAfter || event.key === 'ArrowLeft' && $head.nodeBefore) return false;
        const direction = [
            'ArrowLeft',
            'ArrowUp',
            'Home'
        ].includes(event.key) ? 'up' : 'down';
        const $fixedProblematicNodePosition = $42b8ff92e0383dba$var$findFixedProblematicNodePosition(doc, $head, direction, {
            __livePage: __livePage
        });
        if ($fixedProblematicNodePosition) {
            // an offset is used here so that left arrow selects the first character before the node (consistent with arrow right)
            const headOffset = event.key === 'ArrowLeft' ? -1 : 0;
            const head = $fixedProblematicNodePosition.pos + headOffset;
            const forcedTextSelection = (0, $ks2lK.TextSelection).create(view.state.doc, $anchor.pos, head);
            const tr = view.state.tr;
            tr.setSelection(forcedTextSelection);
            view.dispatch(tr);
            event.preventDefault();
            return true;
        }
        return false;
    }
    return onKeydown;
}





function $f554f85f5a6c0a77$export$53f3d8e656ab0334(selection) {
    if (selection.empty) return false;
    const { $anchor: $anchor, $head: $head } = selection;
    // Head must be at the start of its parent node's content
    if ($head.parentOffset !== 0) return false;
    // Head must be nested (e.g., in a panel > paragraph, not directly in doc)
    if ($head.depth <= 1) return false;
    // Head must be in the first top-level block (before depth 1 is 0)
    if ($head.before(1) !== 0) return false;
    // Selection must not span within a shared deeper structure
    if ($head.sharedDepth($anchor.pos) !== 0) return false;
    // Head must be in the first block at every level
    let isFirstBlockInTree = true;
    for(let i = $head.depth - 1; i >= 0; i--)if ($head.index(i) !== 0) {
        isFirstBlockInTree = false;
        break;
    }
    if (!isFirstBlockInTree) return false;
    return true;
}
function $f554f85f5a6c0a77$export$65a11040da641544(view, event) {
    // Only trigger during a mouse drag
    if (event.buttons === 0) return false;
    if (view.state.selection instanceof (0, $ks2lK.TextSelection) && $f554f85f5a6c0a77$export$53f3d8e656ab0334(view.state.selection)) {
        // Set selection with head at document start (position 0)
        const selection = new (0, $ks2lK.TextSelection)(view.state.doc.resolve(view.state.selection.$anchor.pos), view.state.doc.resolve(0));
        view.dispatch(view.state.tr.setSelection(selection));
        return true;
    }
    return false;
}




const $f5f380ee3755bd85$export$53ac33307b5acee9 = (state)=>({
        decorationSet: (0, $a6582a741c8d0762$export$968abecb43309c32)(state.tr),
        selection: state.selection
    });
const $f5f380ee3755bd85$export$ae829ec7b2625219 = (api, dispatch, dispatchAnalyticsEvent, options = {})=>{
    let cursorHidden = false;
    let blockSelection;
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $0d8c983a0ad0561c$export$e530ba00b008a680),
        state: (0, $a5f9baf1f4a52bd0$export$656c7661095efe2e)(dispatch, $f5f380ee3755bd85$export$53ac33307b5acee9),
        appendTransaction (transactions, oldEditorState, newEditorState) {
            const { tr: tr } = newEditorState;
            let manualSelection;
            let hideCursorChanged = false;
            let blockSelectionChanged = false;
            const needsBlockSelection = (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true, {
                exposure: true
            });
            for(let i = transactions.length - 1; i >= 0; i--){
                const meta = transactions[i].getMeta((0, $0d8c983a0ad0561c$export$e530ba00b008a680));
                if (meta?.hideCursor !== undefined) {
                    const newHideCursorValue = meta.hideCursor;
                    if (cursorHidden !== newHideCursorValue) {
                        cursorHidden = newHideCursorValue;
                        hideCursorChanged = true;
                    }
                }
                if (meta?.manualSelection && !manualSelection) manualSelection = meta.manualSelection;
                if (needsBlockSelection) {
                    if (meta?.setBlockSelection) {
                        blockSelection = meta.setBlockSelection;
                        blockSelectionChanged = true;
                    }
                    if (meta?.clearBlockSelection) {
                        blockSelection = undefined;
                        blockSelectionChanged = true;
                    }
                }
            }
            if (!(0, $a6582a741c8d0762$export$8f1ae47b39045ce2)({
                oldEditorState: oldEditorState,
                newEditorState: newEditorState
            }) && !manualSelection && !hideCursorChanged && !blockSelectionChanged) return;
            tr.setMeta((0, $0d8c983a0ad0561c$export$e530ba00b008a680), {
                type: (0, $5a86cab226cb9084$export$ab4e2275d2998c63).SET_DECORATIONS,
                selection: tr.selection,
                decorationSet: (0, $a6582a741c8d0762$export$968abecb43309c32)(tr, manualSelection, cursorHidden, blockSelection)
            });
            return tr;
        },
        filterTransaction (tr, state) {
            // Prevent single click selecting atom nodes on mobile (we want to select with long press gesture instead)
            if (options.useLongPressSelection && tr.selectionSet && tr.selection instanceof (0, $ks2lK.NodeSelection) && !tr.getMeta((0, $0d8c983a0ad0561c$export$e530ba00b008a680))) return false;
            // Prevent prosemirror's mutation observer overriding a node selection with a text selection
            // for exact same range - this was cause of being unable to change dates in collab:
            // https://product-fabric.atlassian.net/browse/ED-10645
            if (state.selection instanceof (0, $ks2lK.NodeSelection) && tr.selection instanceof (0, $ks2lK.TextSelection) && state.selection.from === tr.selection.from && state.selection.to === tr.selection.to) return false;
            return true;
        },
        props: {
            createSelectionBetween: (0, $1f4b90791a37d5fa$export$ba3a236bf89a370d),
            decorations (state) {
                const interactionState = api?.interaction?.sharedState.currentState()?.interactionState;
                // Do not show selection decorations for live pages where the user has not
                // interacted with the page. We do not show cursor until interaction and we do not
                // want to show selections either.
                if ((options.__livePage || (0, $1oCLl.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true)) && interactionState === 'hasNotHadInteraction') return (0, $ftzrq.DecorationSet).empty;
                return (0, $a5f9baf1f4a52bd0$export$f05434c51e3762e)(state).decorationSet;
            },
            handleDOMEvents: {
                keydown: (0, $42b8ff92e0383dba$export$1bff6ff05fed49a5)({
                    __livePage: options.__livePage
                }),
                // Without this event, it is not possible to click and drag to select the first node in the
                // document if the node is a block with content (e.g. a panel with a paragraph inside).
                mouseout: (0, $f554f85f5a6c0a77$export$65a11040da641544)
            }
        }
    });
};



const $428707753ee5de8f$var$displayGapCursor = (toggle)=>({ tr: tr })=>{
        return tr.setMeta((0, $fc8a611e6beee526$export$21af267ac39e2110), {
            displayGapCursor: toggle
        });
    };
const $428707753ee5de8f$var$clearManualSelection = ()=>({ tr: tr })=>{
        const currMeta = tr.getMeta((0, $0d8c983a0ad0561c$export$e530ba00b008a680));
        return tr.setMeta((0, $0d8c983a0ad0561c$export$e530ba00b008a680), {
            ...currMeta,
            manualSelection: {}
        });
    };
const $428707753ee5de8f$var$setManualSelection = (anchor, head)=>({ tr: tr })=>{
        const currMeta = tr.getMeta((0, $0d8c983a0ad0561c$export$e530ba00b008a680));
        return tr.setMeta((0, $0d8c983a0ad0561c$export$e530ba00b008a680), {
            ...currMeta,
            manualSelection: {
                anchor: anchor,
                head: head
            }
        });
    };
const $428707753ee5de8f$var$hideCursor = (hide)=>({ tr: tr })=>{
        const currMeta = tr.getMeta((0, $0d8c983a0ad0561c$export$e530ba00b008a680));
        return tr.setMeta((0, $0d8c983a0ad0561c$export$e530ba00b008a680), {
            ...currMeta,
            hideCursor: hide
        });
    };
const $428707753ee5de8f$var$setBlockSelection = (selection)=>({ tr: tr })=>{
        const currMeta = tr.getMeta((0, $0d8c983a0ad0561c$export$e530ba00b008a680));
        return tr.setMeta((0, $0d8c983a0ad0561c$export$e530ba00b008a680), {
            ...currMeta,
            setBlockSelection: selection
        });
    };
const $428707753ee5de8f$var$clearBlockSelection = ()=>({ tr: tr })=>{
        const currMeta = tr.getMeta((0, $0d8c983a0ad0561c$export$e530ba00b008a680));
        return tr.setMeta((0, $0d8c983a0ad0561c$export$e530ba00b008a680), {
            ...currMeta,
            clearBlockSelection: true
        });
    };
const $428707753ee5de8f$export$35a6a08064a865b4 = ({ api: api, config: options })=>({
        name: 'selection',
        commands: {
            displayGapCursor: $428707753ee5de8f$var$displayGapCursor,
            clearManualSelection: $428707753ee5de8f$var$clearManualSelection,
            hideCursor: $428707753ee5de8f$var$hideCursor,
            setManualSelection: $428707753ee5de8f$var$setManualSelection,
            setBlockSelection: $428707753ee5de8f$var$setBlockSelection,
            clearBlockSelection: $428707753ee5de8f$var$clearBlockSelection
        },
        actions: {
            selectNearNode: ({ selectionRelativeToNode: selectionRelativeToNode, selection: selection })=>(state)=>{
                    return (0, $74dd4a6c0f671ce7$export$c7d22caae2fd3756)(selectionRelativeToNode, selection)({
                        tr: state.tr
                    }) || state.tr;
                },
            getSelectionFragment: (0, $52df13116bff6b88$export$ebd99cdb6a61129e)(api),
            getSelectionLocalIds: (0, $52df13116bff6b88$export$27a1b30a70c1f80d)(api)
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const pluginState = (0, $0d8c983a0ad0561c$export$e530ba00b008a680).getState(editorState);
            return {
                selectionRelativeToNode: pluginState?.selectionRelativeToNode,
                selection: pluginState?.selection
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'selection',
                    plugin: ({ dispatch: dispatch, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>(0, $f5f380ee3755bd85$export$ae829ec7b2625219)(api, dispatch, dispatchAnalyticsEvent, options)
                },
                {
                    name: 'selectionKeymap',
                    plugin: (0, $9c32f9a018c13f89$export$2e2bcd8739ae039)
                },
                {
                    name: 'gapCursorKeymap',
                    plugin: ()=>(0, $602d85d93e41ad51$export$2e2bcd8739ae039)()
                },
                {
                    name: 'gapCursor',
                    plugin: ()=>(0, $6fb0e0ba57f67fb1$export$2e2bcd8739ae039)
                },
                {
                    name: 'markBoundaryCursor',
                    plugin: ()=>(0, $688ff34616ec256c$export$d3a8cfe12ba42d22)()
                },
                {
                    name: 'autoExpandSelectionRangeOnInlineNode',
                    plugin: ()=>(0, $fda49fc05149e70b$export$b5faf98028194323)()
                }
            ];
        }
    });
var $428707753ee5de8f$export$2e2bcd8739ae039 = $428707753ee5de8f$export$35a6a08064a865b4;
module.exports["selectionPlugin"] = $428707753ee5de8f$export$35a6a08064a865b4;

});

parcelRegister("7nKrc", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $d925B = parcelRequire("d925B");


var $1S4f7 = parcelRequire("1S4f7");


var $lNDSG = parcelRequire("lNDSG");


var $ks2lK = parcelRequire("ks2lK");


var $g9Jfe = parcelRequire("g9Jfe");


var $iu6m9 = parcelRequire("iu6m9");










const $a54f7f7e66db851d$export$b382528b8197b4f1 = new (0, $ks2lK.PluginKey)('selectionToolbarPluginKey');


const $35ef7d1ba42c2fa2$export$9bf0179b815bb489 = ({ hide: hide })=>({ tr: tr })=>{
        tr.setMeta((0, $a54f7f7e66db851d$export$b382528b8197b4f1), {
            hide: hide
        });
        return tr;
    };
const $35ef7d1ba42c2fa2$export$78c8c4f9cf91105f = ({ toolbarDocking: toolbarDocking })=>({ tr: tr })=>{
        tr.setMeta((0, $a54f7f7e66db851d$export$b382528b8197b4f1), {
            toolbarDocking: toolbarDocking
        });
        return tr;
    };
const $35ef7d1ba42c2fa2$export$c90257e445702eb2 = ({ toolbarDocking: toolbarDocking, userPreferencesProvider: userPreferencesProvider, editorAnalyticsApi: editorAnalyticsApi })=>({ tr: tr })=>{
        // We currently ignore any update failures, need to confirm this is the desired behaviour
        userPreferencesProvider?.updatePreference('toolbarDockingInitialPosition', toolbarDocking);
        tr.setMeta((0, $a54f7f7e66db851d$export$b382528b8197b4f1), {
            toolbarDocking: toolbarDocking
        });
        if (toolbarDocking === 'top') // Remove the selection if the toolbar is docked to the top
        tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, tr.selection.head));
        editorAnalyticsApi?.attachAnalyticsEvent({
            action: (0, $d925B.ACTION).UPDATED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).USER_PREFERENCES,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).SELECTION_TOOLBAR_PREFERENCES,
            attributes: {
                toolbarDocking: toolbarDocking
            },
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    };
const $35ef7d1ba42c2fa2$export$93bfa5da95924fe8 = ({ toolbarDocking: toolbarDocking, userPreferencesProvider: userPreferencesProvider })=>({ tr: tr })=>{
        userPreferencesProvider?.updatePreference('toolbarDockingInitialPosition', toolbarDocking);
        tr.setMeta((0, $a54f7f7e66db851d$export$b382528b8197b4f1), {
            toolbarDocking: toolbarDocking
        });
        return tr;
    };




var $42omo = parcelRequire("42omo");





var $hWRJP = parcelRequire("hWRJP");

const $3f59dbd744c5a7fd$export$57bf1011afa72cdf = ({ api: api, userPreferencesProvider: userPreferencesProvider })=>{
    (0, $42omo.useEffect)(()=>{
        if (!userPreferencesProvider || !api) return;
        const refreshPrefrerence = async ()=>{
            if (document.visibilityState === 'visible') {
                try {
                    await userPreferencesProvider.loadPreferences();
                } catch (error) {
                    (0, $hWRJP.logException)(error, {
                        location: 'editor-plugin-selection-toolbar/PageVisibilityWatcher'
                    });
                }
                api?.selectionToolbar?.actions?.refreshToolbarDocking?.();
            }
        };
        return (0, $fFa3V.bind)(document, {
            type: 'visibilitychange',
            listener: refreshPrefrerence
        });
    }, [
        api,
        userPreferencesProvider
    ]);
    return null;
};





parcelRequire("42omo");


var $5dODy = parcelRequire("5dODy");


var $91bcx = parcelRequire("91bcx");


var $6V1ly = parcelRequire("6V1ly");


var $brxEJ = parcelRequire("brxEJ");

const $3c3fb9945e9e8cc1$export$c9b144c567898dd8 = ({ api: api, toolbarDocking: toolbarDocking, intl: intl })=>{
    const isOffline = (0, $91bcx.isOfflineMode)(api?.connectivity?.sharedState.currentState()?.mode);
    let pinButton = {
        disabled: isOffline,
        id: 'editor.toolbar.unpined',
        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6V1ly))), {
                label: ""
            }),
        onClick: ()=>{
            return api?.core.actions.execute(api?.userPreferences?.actions.updateUserPreference('toolbarDockingPosition', 'top')) ?? false;
        },
        title: intl.formatMessage((0, $5dODy.selectionToolbarMessages).toolbarPositionUnpined),
        type: 'button'
    };
    const isDockedToTop = toolbarDocking === 'top';
    if (isDockedToTop) pinButton = {
        disabled: isOffline,
        id: 'editor.toolbar.pinedToTop',
        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($brxEJ))), {
                label: ""
            }),
        onClick: ()=>{
            return api?.core.actions.execute(api?.userPreferences?.actions.updateUserPreference('toolbarDockingPosition', 'none')) ?? false;
        },
        type: 'button',
        title: intl.formatMessage((0, $5dODy.selectionToolbarMessages).toolbarPositionPinedAtTop)
    };
    return [
        {
            type: 'separator',
            fullHeight: true
        },
        pinButton
    ];
};


/* PrimaryToolbarComponent.tsx generated by @compiled/babel-plugin v2.0.0 */ 


parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");





var $a4eZN = parcelRequire("a4eZN");


var $b3YrF = parcelRequire("b3YrF");













const $321ab3976fd6480f$var$buttonStyles = null;
const $321ab3976fd6480f$export$94516d5cccf573e3 = ({ api: api, disabled: disabled })=>{
    const intl = (0, $aXWIB.useIntl)();
    const mode = (0, $b3YrF.useSharedPluginStateSelector)(api, 'connectivity.mode');
    const isOffline = (0, $91bcx.isOfflineMode)(mode);
    const isDockedToTop = (0, $g9Jfe.fg)('platform_editor_use_preferences_plugin') ? api?.userPreferences?.sharedState.currentState()?.preferences?.toolbarDockingPosition === 'top' : api?.selectionToolbar.sharedState.currentState()?.toolbarDocking === 'top';
    if (isDockedToTop) return /*#__PURE__*/ (0, $l998X.jsx)((0, $a4eZN.default), {
        "aria-label": intl.formatMessage((0, $5dODy.selectionToolbarMessages).toolbarPositionPinedAtTop),
        disabled: disabled || isOffline,
        iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($brxEJ))), {
            label: "",
            spacing: "spacious"
        }),
        onClick: ()=>{
            return api?.core.actions.execute(api?.userPreferences?.actions.updateUserPreference('toolbarDockingPosition', 'none')) ?? false;
        },
        title: intl.formatMessage((0, $5dODy.selectionToolbarMessages).toolbarPositionPinedAtTop),
        className: (0, $gMc0m.default)([
            "_ca0q12x7 _n3td12x7 _19bv12x7 _u5f312x7"
        ])
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $a4eZN.default), {
        "aria-label": intl.formatMessage((0, $5dODy.selectionToolbarMessages).toolbarPositionUnpined),
        disabled: disabled || isOffline,
        iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6V1ly))), {
            label: "",
            spacing: "spacious"
        }),
        onClick: ()=>{
            return api?.core.actions.execute(api?.userPreferences?.actions.updateUserPreference('toolbarDockingPosition', 'top')) ?? false;
        },
        title: intl.formatMessage((0, $5dODy.selectionToolbarMessages).toolbarPositionUnpined),
        className: (0, $gMc0m.default)([
            "_ca0q12x7 _n3td12x7 _19bv12x7 _u5f312x7"
        ])
    });
};





parcelRequire("42omo");


var $cPCP8 = parcelRequire("cPCP8");

var $4Chin = parcelRequire("4Chin");




parcelRequire("42omo");


var $gzUv9 = parcelRequire("gzUv9");


var $6UWPx = parcelRequire("6UWPx");

const $0fc53826b43355bb$var$usePluginState = (_api)=>{
    const { editorViewMode: editorViewMode } = (0, $gzUv9.useEditorToolbar)();
    return {
        editorViewMode: editorViewMode
    };
};
const $0fc53826b43355bb$export$4b1545b4f2016d26 = ({ children: children, api: api })=>{
    const { editorViewMode: editorViewMode } = $0fc53826b43355bb$var$usePluginState(api);
    const isEdit = editorViewMode === 'edit';
    if (!isEdit) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6UWPx.ToolbarDropdownItemSection), {
        hasSeparator: isEdit,
        children: children
    });
};





parcelRequire("42omo");





var $eiA8Z = parcelRequire("eiA8Z");










var $7ERUE = parcelRequire("7ERUE");

var $iIVVb = parcelRequire("iIVVb");

const $5744491e141fbab5$export$d2415675e97f35c2 = ({ api: api })=>{
    const intl = (0, $aXWIB.useIntl)();
    const message = intl.formatMessage((0, $5dODy.selectionToolbarMessages).toolbarPositionPinedAtTop);
    const { isOffline: isDisabled } = (0, $gzUv9.useEditorToolbar)();
    // Pin/unpin is meaningless when a runtime override forces `'always-pinned'`
    // (e.g. Markdown Mode source / preview view). Subscribe so we re-render and
    // hide ourselves on flip.
    const runtimeOverride = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'toolbar'
    ], (states)=>states.toolbarState?.contextualFormattingModeOverride);
    if (runtimeOverride === 'always-pinned') return null;
    const onClick = ()=>{
        if (!api || isDisabled) return;
        api?.core.actions.execute(api?.userPreferences?.actions.updateUserPreference('toolbarDockingPosition', 'none'));
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $iIVVb.ToolbarTooltip), {
        content: message,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7ERUE.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($brxEJ))), {
                size: "small",
                label: ""
            }),
            label: message,
            onClick: onClick,
            isDisabled: isDisabled
        })
    });
};





parcelRequire("42omo");


















var $2GVu1 = parcelRequire("2GVu1");




const $cd2a845aa809693c$var$shouldShowPinMenuItem = (editMode)=>{
    return editMode !== 'view';
};
const $cd2a845aa809693c$var$usePluginState = (_api)=>{
    const { editorViewMode: editorViewMode, editorToolbarDockingPreference: editorToolbarDockingPreference, isOffline: isOffline } = (0, $gzUv9.useEditorToolbar)();
    return {
        editorViewMode: editorViewMode,
        editorToolbarDockingPreference: editorToolbarDockingPreference,
        isOffline: isOffline
    };
};
const $cd2a845aa809693c$export$38c363c8d7e9c6f1 = ({ api: api, disablePin: disablePin })=>{
    const intl = (0, $aXWIB.useIntl)();
    const runtimeOverride = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'toolbar'
    ], (states)=>states.toolbarState?.contextualFormattingModeOverride);
    const { editorViewMode: editorViewMode, editorToolbarDockingPreference: editorToolbarDockingPreference, isOffline: isDisabled } = $cd2a845aa809693c$var$usePluginState(api);
    const isToolbarDocked = editorToolbarDockingPreference === 'top';
    if (disablePin || !$cd2a845aa809693c$var$shouldShowPinMenuItem(editorViewMode) || runtimeOverride === 'always-pinned' && (0, $g9Jfe.fg)('platform_editor_markdown_patch_m3')) return null;
    const onClick = ()=>{
        if (!api || isDisabled) return;
        api?.core.actions.execute(api?.userPreferences?.actions.updateUserPreference('toolbarDockingPosition', isToolbarDocked ? 'none' : 'top'));
    };
    const message = intl.formatMessage(isToolbarDocked ? (0, $5dODy.selectionToolbarMessages).toolbarPositionPinedAtTop : (0, $5dODy.selectionToolbarMessages).toolbarPositionUnpinnedConcise);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2GVu1.ToolbarDropdownItem), {
        onClick: onClick,
        isDisabled: isDisabled,
        elemBefore: isToolbarDocked ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($brxEJ))), {
            size: "small",
            label: ""
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6V1ly))), {
            size: "small",
            label: ""
        }),
        children: message
    });
};


const $b34092340a7d910e$export$a758406ca53b86a5 = (api, contextualFormattingEnabled, disablePin)=>{
    const components = [
        {
            type: (0, $cPCP8.PIN_MENU_SECTION).type,
            key: (0, $cPCP8.PIN_MENU_SECTION).key,
            parents: [
                {
                    type: (0, $cPCP8.OVERFLOW_MENU).type,
                    key: (0, $cPCP8.OVERFLOW_MENU).key,
                    rank: (0, $4Chin.OVERFLOW_MENU_RANK)[(0, $cPCP8.PIN_MENU_SECTION).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $0fc53826b43355bb$export$4b1545b4f2016d26), {
                    api: api,
                    children: children
                });
            }
        },
        {
            type: (0, $cPCP8.PIN_MENU_ITEM).type,
            key: (0, $cPCP8.PIN_MENU_ITEM).key,
            parents: [
                {
                    type: (0, $cPCP8.PIN_MENU_SECTION).type,
                    key: (0, $cPCP8.PIN_MENU_SECTION).key,
                    rank: (0, $4Chin.PIN_MENU_SECTION_RANK)[(0, $cPCP8.PIN_MENU_ITEM).key]
                }
            ],
            component: ()=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $cd2a845aa809693c$export$38c363c8d7e9c6f1), {
                    api: api,
                    disablePin: disablePin
                });
            }
        }
    ];
    // Add pin button to primary toolbar when contextual formatting is enabled
    if (contextualFormattingEnabled) {
        const pinButtonComponents = [
            {
                type: (0, $cPCP8.PIN_GROUP).type,
                key: (0, $cPCP8.PIN_GROUP).key,
                parents: [
                    {
                        type: (0, $cPCP8.PIN_SECTION).type,
                        key: (0, $cPCP8.PIN_SECTION).key,
                        rank: (0, $4Chin.PIN_SECTION_RANK)[(0, $cPCP8.PIN_GROUP).key]
                    }
                ]
            },
            {
                type: (0, $cPCP8.PIN_BUTTON).type,
                key: (0, $cPCP8.PIN_BUTTON).key,
                parents: [
                    {
                        type: (0, $cPCP8.PIN_GROUP).type,
                        key: (0, $cPCP8.PIN_GROUP).key,
                        rank: (0, $4Chin.PIN_GROUP_RANK)[(0, $cPCP8.PIN_BUTTON).key]
                    }
                ],
                component: ()=>{
                    return /*#__PURE__*/ (0, $l998X.jsx)((0, $5744491e141fbab5$export$d2415675e97f35c2), {
                        api: api
                    });
                }
            }
        ];
        components.push(...pinButtonComponents);
    }
    return components;
};


const $9f031664f93dee36$var$getToolbarDocking = (contextualFormattingEnabled, userPreferencesProvider)=>{
    if (contextualFormattingEnabled && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) return userPreferencesProvider?.getPreference('toolbarDockingInitialPosition') ?? 'none';
    return 'top';
};
const $9f031664f93dee36$var$getToolbarDockingV2 = (contextualFormattingEnabled, dockingPreference)=>{
    if (contextualFormattingEnabled && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) return dockingPreference ?? 'none';
    return 'top';
};
const $9f031664f93dee36$export$b621d761b94834de = ({ api: api, config: config })=>{
    const __selectionToolbarHandlers = [];
    let primaryToolbarComponent;
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    const { userPreferencesProvider: userPreferencesProvider, contextualFormattingEnabled: contextualFormattingEnabled, disablePin: disablePin } = config;
    if (isToolbarAIFCEnabled) /**
     * If toolbar is set to always-pinned or always-inline, there is no control over toolbar placement
     */ {
        if (api?.toolbar?.actions.contextualFormattingMode() === 'controlled') api?.toolbar?.actions.registerComponents((0, $b34092340a7d910e$export$a758406ca53b86a5)(api, true, disablePin));
    } else if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1', {
        exposure: true
    })) {
        primaryToolbarComponent = ({ disabled: disabled })=>{
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $321ab3976fd6480f$export$94516d5cccf573e3), {
                api: api,
                disabled: disabled
            });
        };
        api?.primaryToolbar?.actions.registerComponent({
            name: 'pinToolbar',
            component: primaryToolbarComponent
        });
    }
    let previousToolbarDocking = userPreferencesProvider?.getPreference('toolbarDockingInitialPosition') || null;
    let isPreferenceInitialized = false;
    return {
        name: 'selectionToolbar',
        actions: {
            /**
       * Overrides the user's toolbar docking position preference programmatically,
       * bypassing the normal user-driven preference update flow.
       */ overrideToolbarDocking: (toolbarDocking)=>{
                const command = api?.userPreferences?.commands.overrideUserPreference('toolbarDockingPosition', toolbarDocking);
                if (!command) return false;
                return api?.core.actions.execute(command) ?? false;
            },
            /**
       * Clears the toolbar docking override and reverts to the current preference/state value.
       */ clearToolbarDockingOverride: ()=>{
                const command = api?.userPreferences?.commands.clearOverrideUserPreference('toolbarDockingPosition');
                if (!command) return false;
                return api?.core.actions.execute(command) ?? false;
            },
            suppressToolbar: ()=>{
                return api?.core.actions.execute((0, $35ef7d1ba42c2fa2$export$9bf0179b815bb489)({
                    hide: true
                })) ?? false;
            },
            unsuppressToolbar: ()=>{
                return api?.core.actions.execute((0, $35ef7d1ba42c2fa2$export$9bf0179b815bb489)({
                    hide: false
                })) ?? false;
            },
            setToolbarDocking: (toolbarDocking)=>{
                if ((0, $g9Jfe.fg)('platform_editor_use_preferences_plugin')) return api?.core.actions.execute(api?.userPreferences?.actions.updateUserPreference('toolbarDockingPosition', toolbarDocking)) ?? false;
                return api?.core.actions.execute((0, $35ef7d1ba42c2fa2$export$c90257e445702eb2)({
                    toolbarDocking: toolbarDocking,
                    userPreferencesProvider: userPreferencesProvider,
                    editorAnalyticsApi: api?.analytics?.actions
                })) ?? false;
            },
            forceToolbarDockingWithoutAnalytics: (toolbarDocking)=>{
                if ((0, $g9Jfe.fg)('platform_editor_use_preferences_plugin')) return api?.core.actions.execute(api?.userPreferences?.actions.updateUserPreference('toolbarDockingPosition', toolbarDocking)) ?? false;
                return api?.core.actions.execute((0, $35ef7d1ba42c2fa2$export$93bfa5da95924fe8)({
                    toolbarDocking: toolbarDocking,
                    userPreferencesProvider: userPreferencesProvider
                })) ?? false;
            },
            refreshToolbarDocking: ()=>{
                if (userPreferencesProvider) {
                    const userToolbarDockingPref = $9f031664f93dee36$var$getToolbarDocking(contextualFormattingEnabled, userPreferencesProvider);
                    return api?.core.actions.execute((0, $35ef7d1ba42c2fa2$export$78c8c4f9cf91105f)({
                        toolbarDocking: userToolbarDockingPref
                    })) ?? false;
                }
                return false;
            }
        },
        getSharedState (editorState) {
            if (!editorState) return;
            return (0, $a54f7f7e66db851d$export$b382528b8197b4f1).getState(editorState);
        },
        pmPlugins (selectionToolbarHandlers) {
            if (selectionToolbarHandlers) __selectionToolbarHandlers.push(...selectionToolbarHandlers);
            const initialToolbarDocking = (0, $g9Jfe.fg)('platform_editor_use_preferences_plugin') ? $9f031664f93dee36$var$getToolbarDockingV2(contextualFormattingEnabled, api?.userPreferences?.sharedState.currentState()?.preferences?.toolbarDockingPosition) : $9f031664f93dee36$var$getToolbarDocking(contextualFormattingEnabled, userPreferencesProvider);
            return [
                {
                    name: 'selection-tracker',
                    plugin: ()=>{
                        return new (0, $1S4f7.SafePlugin)({
                            key: (0, $a54f7f7e66db851d$export$b382528b8197b4f1),
                            state: {
                                init () {
                                    return {
                                        selectionStable: false,
                                        hide: false,
                                        toolbarDocking: initialToolbarDocking
                                    };
                                },
                                apply (tr, pluginState) {
                                    const meta = tr.getMeta((0, $a54f7f7e66db851d$export$b382528b8197b4f1));
                                    let newPluginState = pluginState;
                                    if (meta) return {
                                        ...newPluginState,
                                        ...meta
                                    };
                                    if ((0, $iu6m9.editorExperiment)('platform_editor_block_menu', true)) {
                                        const isBlockMenuOpen = api?.userIntent?.sharedState.currentState()?.currentUserIntent === 'blockMenuOpen';
                                        newPluginState = {
                                            ...newPluginState,
                                            isBlockMenuOpen: isBlockMenuOpen
                                        };
                                    }
                                    // if the toolbarDockingInitialPosition preference has changed
                                    // update the toolbarDocking state
                                    if (!previousToolbarDocking) {
                                        // we currently only check for the initial value
                                        const toolbarDockingPreference = userPreferencesProvider?.getPreference('toolbarDockingInitialPosition');
                                        if (toolbarDockingPreference && toolbarDockingPreference !== previousToolbarDocking) {
                                            previousToolbarDocking = toolbarDockingPreference;
                                            const userToolbarDockingPref = $9f031664f93dee36$var$getToolbarDocking(contextualFormattingEnabled, userPreferencesProvider);
                                            if (pluginState.toolbarDocking !== userToolbarDockingPref) return {
                                                ...newPluginState,
                                                toolbarDocking: userToolbarDockingPref
                                            };
                                        }
                                    }
                                    return newPluginState;
                                }
                            },
                            view (view) {
                                const unbind = (0, $fFa3V.bind)(view.root, {
                                    type: 'mouseup',
                                    listener: (event)=>{
                                        // We only want to set selectionStable to true if the editor has focus
                                        // to prevent the toolbar from showing when the editor is blurred
                                        // due to a click outside the editor.
                                        const editorViewModePlugin = api?.editorViewMode?.sharedState.currentState();
                                        const isViewModeEnabled = editorViewModePlugin?.mode === 'view';
                                        const target = event.target;
                                        if (target && target instanceof Element) {
                                            const isRovoChangeToneButton = target.tagName === 'BUTTON' && $9f031664f93dee36$var$hasNestedSpanWithText(target, 'Change tone') || target.getAttribute('aria-label') === 'Change tone' || target.innerHTML === 'Change tone';
                                            const isRovoTranslateButton = target.tagName === 'BUTTON' && $9f031664f93dee36$var$hasNestedSpanWithText(target, 'Translate options') || target.getAttribute('aria-label') === 'Translate options' || target.innerHTML === 'Translate options';
                                            if (isRovoChangeToneButton || isRovoTranslateButton) return null;
                                        }
                                        view.dispatch(view.state.tr.setMeta((0, $a54f7f7e66db851d$export$b382528b8197b4f1), {
                                            selectionStable: !isViewModeEnabled ? view.hasFocus() : true
                                        }));
                                    }
                                });
                                const unbindEditorViewFocus = (0, $fFa3V.bind)(view.dom, {
                                    type: 'focus',
                                    listener: ()=>{
                                        view.dispatch(view.state.tr.setMeta((0, $a54f7f7e66db851d$export$b382528b8197b4f1), {
                                            selectionStable: true
                                        }));
                                    }
                                });
                                return {
                                    destroy () {
                                        unbind();
                                        unbindEditorViewFocus();
                                    }
                                };
                            },
                            appendTransaction (_transactions, _oldState, newState) {
                                if ((0, $g9Jfe.fg)('platform_editor_use_preferences_plugin')) return null;
                                if (!isPreferenceInitialized && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) {
                                    const toolbarDockingPreference = userPreferencesProvider?.getPreference('toolbarDockingInitialPosition');
                                    if (toolbarDockingPreference !== undefined) {
                                        isPreferenceInitialized = true;
                                        const userToolbarDockingPref = $9f031664f93dee36$var$getToolbarDocking(contextualFormattingEnabled, userPreferencesProvider);
                                        const tr = newState.tr;
                                        api?.analytics?.actions.attachAnalyticsEvent({
                                            action: (0, $d925B.ACTION).INITIALISED,
                                            actionSubject: (0, $d925B.ACTION_SUBJECT).USER_PREFERENCES,
                                            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).SELECTION_TOOLBAR_PREFERENCES,
                                            attributes: {
                                                toolbarDocking: userToolbarDockingPref
                                            },
                                            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
                                        })(tr);
                                        return tr;
                                    }
                                }
                                return null;
                            },
                            props: {
                                handleDOMEvents: {
                                    mousedown: (view)=>{
                                        view.dispatch(view.state.tr.setMeta((0, $a54f7f7e66db851d$export$b382528b8197b4f1), {
                                            selectionStable: false
                                        }));
                                        return false;
                                    }
                                }
                            }
                        });
                    }
                }
            ];
        },
        pluginsOptions: isToolbarAIFCEnabled ? {} : {
            floatingToolbar (state, intl, providerFactory) {
                const { selectionStable: selectionStable, hide: hide, toolbarDocking: toolbarDocking, isBlockMenuOpen: isBlockMenuOpen } = (0, $a54f7f7e66db851d$export$b382528b8197b4f1).getState(state);
                const isCellSelection = '$anchorCell' in state.selection;
                const isEditorControlsEnabled = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1');
                if (state.selection.empty || !selectionStable || hide || state.selection instanceof (0, $ks2lK.NodeSelection) || // $anchorCell is only available in CellSelection, this check is to
                // avoid importing CellSelection from @atlaskit/editor-tables
                isCellSelection && !isEditorControlsEnabled // for Editor Controls we want to show the toolbar on CellSelection
                ) // If there is no active selection, or the selection is not stable, or the selection is a node selection,
                // do not show the toolbar.
                return;
                if (isCellSelection && isEditorControlsEnabled) {
                    const isSelectedViaDragHandle = api?.blockControls?.sharedState.currentState()?.isSelectedViaDragHandle;
                    if (isSelectedViaDragHandle) return;
                }
                if (isBlockMenuOpen && isEditorControlsEnabled && (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true)) // If the block menu is open, do not show the selection toolbar.
                return;
                // Resolve the selectionToolbarHandlers to a list of SelectionToolbarGroups
                // and filter out any handlers which returned undefined
                const resolved = __selectionToolbarHandlers.map((selectionToolbarHandler)=>selectionToolbarHandler(state, intl, providerFactory)).filter((resolved)=>resolved !== undefined);
                // Sort the groups by rank
                // This is intended to allow different plugins to control the order of the groups
                // they add to the selection toolbar.
                // ie. if you want to have your plugin's group appear first, set rank to -10 if there is currently another
                // plugin you expect to be run at the same time as with an rank of -9
                resolved.sort(({ rank: rankA = 0 }, { rank: rankB = 0 })=>{
                    if (rankA < rankB) return 1;
                    return -1;
                });
                const items = [];
                // This flattens the groups passed into the floating toolbar into a single list of items
                for(let i = 0; i < resolved.length; i++){
                    // add a seperator icon after each group except the last
                    if (Array.isArray(resolved[i]?.items)) items.push(...resolved[i].items);
                    if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) {
                        if (resolved[i] && resolved[i + 1]) {
                            if (resolved[i + 1]?.pluginName === 'annotation') items.push({
                                type: 'separator',
                                fullHeight: true
                            });
                        }
                    } else if (i !== resolved.length - 1) items.push({
                        type: 'separator'
                    });
                }
                if (items.length > 0 && contextualFormattingEnabled && isEditorControlsEnabled) {
                    const toolbarDockingPref = api?.userPreferences && (0, $g9Jfe.fg)('platform_editor_use_preferences_plugin') ? api?.userPreferences?.sharedState.currentState()?.preferences?.toolbarDockingPosition : toolbarDocking;
                    items.push(...(0, $3c3fb9945e9e8cc1$export$c9b144c567898dd8)({
                        api: api,
                        toolbarDocking: toolbarDockingPref,
                        intl: intl
                    }));
                }
                let onPositionCalculated;
                const toolbarTitle = 'Selection toolbar';
                if (isCellSelection && isEditorControlsEnabled) onPositionCalculated = (0, $lNDSG.calculateToolbarPositionOnCellSelection)(toolbarTitle);
                else {
                    const calcToolbarPosition = config.preferenceToolbarAboveSelection ? (0, $lNDSG.calculateToolbarPositionAboveSelection) : (0, $lNDSG.calculateToolbarPositionTrackHead);
                    onPositionCalculated = calcToolbarPosition(toolbarTitle);
                }
                const nodeType = $9f031664f93dee36$var$getSelectionNodeTypes(state);
                return {
                    title: 'Selection toolbar',
                    nodeType: nodeType,
                    items: items,
                    ...isEditorControlsEnabled && {
                        scrollable: true
                    },
                    onPositionCalculated: onPositionCalculated
                };
            }
        },
        contentComponent: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && !(0, $g9Jfe.fg)('platform_editor_use_preferences_plugin') && (0, $g9Jfe.fg)('platform_editor_user_preferences_provider_update') ? ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3f59dbd744c5a7fd$export$57bf1011afa72cdf), {
                api: api,
                userPreferencesProvider: userPreferencesProvider
            }) : undefined,
        primaryToolbarComponent: !api?.primaryToolbar && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1', {
            exposure: true
        }) ? primaryToolbarComponent : undefined
    };
};
function $9f031664f93dee36$var$getSelectionNodeTypes(state) {
    const selectionNodeTypes = [];
    state.doc.nodesBetween(state.selection.from, state.selection.to, (node)=>{
        if (selectionNodeTypes.indexOf(node.type) !== 0) selectionNodeTypes.push(node.type);
    });
    return selectionNodeTypes;
}
const $9f031664f93dee36$var$hasNestedSpanWithText = (element, text)=>{
    if (element.tagName === 'SPAN' && element.innerHTML === text) return true;
    for (const child of Array.from(element.children)){
        if ($9f031664f93dee36$var$hasNestedSpanWithText(child, text)) return true;
    }
    return false;
};
module.exports["selectionToolbarPlugin"] = $9f031664f93dee36$export$b621d761b94834de;

});

parcelRegister("6borH", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $hgeg8 = parcelRequire("hgeg8");


var $lWghV = parcelRequire("lWghV");


var $dus6D = parcelRequire("dus6D");

function $a01d6a19cb9afa72$export$ae829ec7b2625219(eventDispatch, api, onSave) {
    if (!onSave) return;
    return (0, $dus6D.keymap)({
        [`${(0, $hgeg8.submit).common}`]: (state, _dispatch, editorView)=>{
            const mediaState = api?.media?.sharedState?.currentState();
            if (mediaState && mediaState.waitForMediaUpload && !mediaState.allUploadsFinished) return true;
            if (!editorView) return false;
            eventDispatch((0, $lWghV.analyticsEventKey), $a01d6a19cb9afa72$var$analyticsPayload(state));
            onSave(editorView);
            return true;
        }
    });
}
const $a01d6a19cb9afa72$var$analyticsPayload = (state)=>({
        payload: {
            action: (0, $d925B.ACTION).STOPPED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).SAVE,
            attributes: {
                inputMethod: (0, $d925B.INPUT_METHOD).SHORTCUT,
                documentSize: state.doc.nodeSize
            },
            eventType: (0, $d925B.EVENT_TYPE).UI
        }
    });


const $3e1d186d16c7f25c$export$e488d499f3ae3f86 = ({ config: onSave, api: api })=>({
        name: 'submitEditor',
        pmPlugins () {
            return [
                {
                    name: 'submitEditor',
                    plugin: ({ dispatch: dispatch })=>(0, $a01d6a19cb9afa72$export$ae829ec7b2625219)(dispatch, api, onSave)
                }
            ];
        }
    });
module.exports["submitEditorPlugin"] = $3e1d186d16c7f25c$export$e488d499f3ae3f86;

});

parcelRegister("3JBsx", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");

const $7f61bbc1e97d2781$export$34783ae4fef40269 = ()=>{
    const components = [];
    const register = (newComponents)=>{
        components.push(...newComponents);
    };
    /**
   * Similer to `register` but first checks the registry against `newComponents` using its
   * key and type, if it already exists it replaces the item instead of simply appending it.
   *
   * Most likely you should avoid using this and just use the `register` method as it's preferred
   * to register components statically.
   */ const safeRegister = (newComponents)=>{
        newComponents.forEach((newComponent)=>{
            const existingIndex = components.findIndex((existingComponent)=>existingComponent.type === newComponent.type && existingComponent.key === newComponent.key);
            if (existingIndex !== -1) // Replace existing component
            components[existingIndex] = newComponent;
            else // Add new component
            components.push(newComponent);
        });
    };
    return {
        register: register,
        safeRegister: safeRegister,
        components: components
    };
};



var $d925B = parcelRequire("d925B");


var $j85vL = parcelRequire("j85vL");

var $grmt9 = parcelRequire("grmt9");

var $8kPu1 = parcelRequire("8kPu1");

var $SI3ya = parcelRequire("SI3ya");

var $fo9p3 = parcelRequire("fo9p3");

var $6pIOC = parcelRequire("6pIOC");







const $43358589369c1658$var$pluginKey = new (0, $ks2lK.PluginKey)('selectionToolbarOpenExperience');
const $43358589369c1658$var$START_METHOD = {
    MOUSE_UP: 'mouseUp',
    KEY_DOWN: 'keyDown'
};
const $43358589369c1658$var$ABORT_REASON = {
    SELECTION_CLEARED: 'selectionCleared',
    BLOCK_MENU_OPENED: 'blockMenuOpened',
    EDITOR_DESTROYED: 'editorDestroyed'
};
const $43358589369c1658$export$cfe4aed4f8555228 = ({ refs: refs, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    let editorView;
    let targetEl;
    let shiftArrowKeyPressed = false;
    let mouseDownPos;
    const getTarget = ()=>{
        if (!targetEl) targetEl = refs.popupsMountPoint || (0, $6pIOC.getPopupContainerFromEditorView)(editorView?.dom);
        return targetEl;
    };
    const experience = new (0, $grmt9.Experience)((0, $8kPu1.EXPERIENCE_ID).TOOLBAR_OPEN, {
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).SELECTION_TOOLBAR,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        checks: [
            new (0, $fo9p3.ExperienceCheckTimeout)({
                durationMs: 1000,
                onTimeout: ()=>{
                    if ($43358589369c1658$var$isBlockMenuWithinNode(getTarget())) return {
                        status: 'abort',
                        reason: $43358589369c1658$var$ABORT_REASON.BLOCK_MENU_OPENED
                    };
                    else if ($43358589369c1658$var$isSelectionWithoutTextContent(editorView?.state.selection)) return {
                        status: 'abort',
                        reason: $43358589369c1658$var$ABORT_REASON.SELECTION_CLEARED
                    };
                }
            }),
            new (0, $SI3ya.ExperienceCheckDomMutation)({
                onDomMutation: ({ mutations: mutations })=>{
                    if (mutations.some($43358589369c1658$var$isSelectionToolbarAddedInMutation)) return {
                        status: 'success'
                    };
                },
                observeConfig: ()=>({
                        target: getTarget(),
                        options: {
                            childList: true
                        }
                    })
            })
        ]
    });
    const shouldSkipExperienceStart = (selection)=>{
        if ($43358589369c1658$var$isSelectionWithoutTextContent(selection) || $43358589369c1658$var$isSelectionWithinCodeBlock(selection)) return true;
        const target = getTarget();
        if (!target) // when target is not found, skip the experience start
        return true;
        return $43358589369c1658$var$isSelectionToolbarWithinNode(target) || $43358589369c1658$var$isBlockMenuWithinNode(target);
    };
    return new (0, $1S4f7.SafePlugin)({
        key: $43358589369c1658$var$pluginKey,
        state: {
            init: ()=>({}),
            apply: (_tr, pluginState, oldState, newState)=>{
                if (!oldState.selection.empty && $43358589369c1658$var$isSelectionWithoutTextContent(newState.selection)) experience.abort({
                    reason: $43358589369c1658$var$ABORT_REASON.SELECTION_CLEARED
                });
                const shouldStartExperience = shiftArrowKeyPressed && !newState.selection.eq(oldState.selection) && !shouldSkipExperienceStart(newState.selection);
                if (shouldStartExperience) {
                    experience.start({
                        method: $43358589369c1658$var$START_METHOD.KEY_DOWN
                    });
                    shiftArrowKeyPressed = false;
                }
                return pluginState;
            }
        },
        props: {
            handleDOMEvents: {
                mousedown: (_view, e)=>{
                    mouseDownPos = {
                        x: e.clientX,
                        y: e.clientY
                    };
                },
                mouseup: (view, e)=>{
                    if (!mouseDownPos || shouldSkipExperienceStart(view.state.selection)) return;
                    if (e.clientX !== mouseDownPos.x || e.clientY !== mouseDownPos.y) experience.start({
                        method: $43358589369c1658$var$START_METHOD.MOUSE_UP
                    });
                },
                dblclick: (view)=>{
                    if (shouldSkipExperienceStart(view.state.selection)) return;
                    experience.start({
                        method: $43358589369c1658$var$START_METHOD.MOUSE_UP
                    });
                },
                keydown: (_view, { shiftKey: shiftKey, key: key })=>{
                    shiftArrowKeyPressed = shiftKey && key.includes('Arrow') && !$43358589369c1658$var$isSelectionToolbarWithinNode(getTarget());
                },
                keyup: ()=>{
                    shiftArrowKeyPressed = false;
                }
            }
        },
        view: (view)=>{
            editorView = view;
            return {
                destroy: ()=>{
                    experience.abort({
                        reason: $43358589369c1658$var$ABORT_REASON.EDITOR_DESTROYED
                    });
                }
            };
        }
    });
};
const $43358589369c1658$var$isSelectionToolbarAddedInMutation = ({ type: type, addedNodes: addedNodes })=>{
    return type === 'childList' && [
        ...addedNodes
    ].some($43358589369c1658$var$isSelectionToolbarWithinNode);
};
const $43358589369c1658$var$isSelectionToolbarWithinNode = (node)=>{
    return (0, $j85vL.containsPopupWithNestedElement)(node, '[data-testid="editor-floating-toolbar"]');
};
const $43358589369c1658$var$isBlockMenuWithinNode = (node)=>{
    return (0, $j85vL.containsPopupWithNestedElement)(node, '[data-testid="editor-block-menu"]');
};
const $43358589369c1658$var$isSelectionWithoutTextContent = (selection)=>{
    if (!selection || selection.empty) return true;
    let hasText = false;
    selection.$from.doc.nodesBetween(selection.from, selection.to, (node)=>{
        if (hasText) return false;
        if (node.isText && node.text && node.text.length > 0) {
            hasText = true;
            return false;
        }
        return true;
    });
    return !hasText;
};
const $43358589369c1658$var$isSelectionWithinCodeBlock = (selection)=>{
    const { $from: $from, $to: $to } = selection;
    return $from.sameParent($to) && $from.parent.type.name === 'codeBlock';
};



var $fseNl = parcelRequire("fseNl");

const $b044906b4f51186e$export$e235a0bccaa8a700 = 'Selection toolbar';
const $b044906b4f51186e$export$c0535c9204f67376 = {
    toolbarContainer: '[role="toolbar"]',
    portal: '.atlaskit-portal'
};






var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");





var $eTj7Y = parcelRequire("eTj7Y");


var $7fmpI = parcelRequire("7fmpI");


var $eiA8Z = parcelRequire("eiA8Z");


var $hWRJP = parcelRequire("hWRJP");


var $gzUv9 = parcelRequire("gzUv9");

var $biAkr = parcelRequire("biAkr");
const $1da171b888e51db2$export$af4b2f219e301e70 = (contextualFormattingEnabled, toolbarDockingPosition)=>{
    if (contextualFormattingEnabled === 'controlled') return toolbarDockingPosition === 'top';
    if (contextualFormattingEnabled === 'always-inline') return true;
    return false;
};



var $jwWgu = parcelRequire("jwWgu");


var $lNDSG = parcelRequire("lNDSG");


var $91bcx = parcelRequire("91bcx");





var $aFUXX = parcelRequire("aFUXX");


var $kDB94 = parcelRequire("kDB94");

var $6UWPx = parcelRequire("6UWPx");

var $48SU7 = parcelRequire("48SU7");

var $8hoW2 = parcelRequire("8hoW2");


var $cf8NL = parcelRequire("cf8NL");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");



var $cKx73 = parcelRequire("cKx73");


var $8aWkM = parcelRequire("8aWkM");





var $f9zLy = parcelRequire("f9zLy");

const $56396ae0b6232fe6$export$3985dc3e1cbf9fe4 = (event, containerSelector)=>{
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return false;
    return !!target.closest(containerSelector);
};
const $56396ae0b6232fe6$export$d75f9c68101e0fa9 = (event)=>{
    return event.altKey && event.key === 'F10';
};
const $56396ae0b6232fe6$export$433aaa1f216cf32d = (rootNode)=>{
    if (!rootNode) return [];
    const focusableElements = rootNode.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, div[tabindex="-1"], div[tabindex="0"]') || [];
    const focusableElementsArray = Array.from(focusableElements);
    // filter out focusable elements from child components such as dropdown menus / popups
    return focusableElementsArray.filter((elm)=>{
        const style = window.getComputedStyle(elm);
        // filter out invisible elements
        return style.visibility !== 'hidden' && style.display !== 'none';
    });
};


const $2b454c365c97f6ab$export$48b8f4aa7f88bf3a = (editorView, intl, api)=>{
    if (!(editorView.dom instanceof HTMLElement)) return;
    const toolbarSelector = "[data-testid='editor-floating-toolbar']";
    return {
        childComponentSelector: toolbarSelector,
        dom: editorView.dom,
        isShortcutToFocusToolbar: (0, $56396ae0b6232fe6$export$d75f9c68101e0fa9),
        handleFocus: (event)=>{
            try {
                const toolbar = (0, $cKx73.getDocument)()?.querySelector(toolbarSelector);
                if (!(toolbar instanceof HTMLElement)) return;
                const filteredFocusableElements = (0, $56396ae0b6232fe6$export$433aaa1f216cf32d)(toolbar);
                filteredFocusableElements[0]?.focus();
                // the button element removes the focus ring so this class adds it back
                if (filteredFocusableElements[0]?.tagName === 'BUTTON') filteredFocusableElements[0].classList.add('first-floating-toolbar-button');
                filteredFocusableElements[0]?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'nearest'
                });
                event.preventDefault();
                event.stopPropagation();
            } catch (error) {
                if (error instanceof Error) (0, $hWRJP.logException)(error, {
                    location: 'editor-plugin-toolbar/selectionToolbar'
                });
            }
        },
        handleEscape: (event)=>{
            try {
                const isDropdownOpen = !!document.querySelector('[data-toolbar-component="menu-section"]');
                if (isDropdownOpen) return;
                api?.core.actions.focus();
                event.preventDefault();
                event.stopPropagation();
            } catch (error) {
                if (error instanceof Error) (0, $hWRJP.logException)(error, {
                    location: 'editor-plugin-toolbar/selectionToolbar'
                });
            }
        },
        ariaControls: (0, $f9zLy.EDIT_AREA_ID),
        ariaLabel: intl.formatMessage((0, $8aWkM.messages).toolbarLabel)
    };
};











const $3f28f07489e6242f$export$49d74ed2464a12b9 = (view, dispatchAnalyticsEvent)=>{
    try {
        const domRef = (0, $8m4tT.findDomRefAtPos)(view.state.selection.from, view.domAtPos.bind(view));
        if (domRef instanceof HTMLElement) return domRef;
        throw new Error('Invalid DOM reference');
    } catch (error) {
        if (dispatchAnalyticsEvent) {
            const payload = {
                action: (0, $d925B.ACTION).ERRORED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).CONTENT_COMPONENT,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    component: (0, $d925B.CONTENT_COMPONENT).SELECTION_TOOLBAR,
                    selection: view.state.selection.toJSON(),
                    position: view.state.selection.from,
                    docSize: view.state.doc.nodeSize,
                    error: error instanceof Error ? error.toString() : String(error),
                    // @ts-expect-error - Object literal may only specify known properties, 'errorStack' does not exist in type
                    // This error was introduced after upgrading to TypeScript 5
                    errorStack: error instanceof Error ? error.stack : undefined
                }
            };
            dispatchAnalyticsEvent(payload);
        }
        if (error instanceof Error) (0, $hWRJP.logException)(error, {
            location: 'editor-plugin-toolbar/selectionToolbar'
        });
    }
};


const $50bc1c4d30c9d49d$var$isToolbarComponent = (component)=>{
    return component.type === 'toolbar' && component.key === 'inline-text-toolbar';
};
const $50bc1c4d30c9d49d$var$usePluginState = (api)=>{
    return (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'connectivity',
        'userPreferences',
        'toolbar',
        'selection',
        'userIntent',
        'editorViewMode'
    ], (state)=>{
        return {
            connectivityStateMode: state.connectivityState?.mode,
            editorToolbarDockingPreference: state.userPreferencesState?.preferences?.toolbarDockingPosition,
            shouldShowToolbar: state.toolbarState?.shouldShowToolbar,
            selectedNode: state.toolbarState?.selectedNode,
            contextualFormattingModeOverride: state.toolbarState?.contextualFormattingModeOverride,
            selection: state.selectionState?.selection,
            currentUserIntent: state.userIntentState?.currentUserIntent,
            editorViewMode: state.editorViewModeState?.mode
        };
    });
};
const $50bc1c4d30c9d49d$var$useOnPositionCalculated = (editorView)=>{
    const onPositionCalculated = (0, $42omo.useCallback)((position)=>{
        try {
            // Show special position on cell selection only when editor controls experiment is enabled
            const isEditorControlsEnabled = (0, $1oCLl.expValEquals)('platform_editor_controls', 'cohort', 'variant1');
            const isCellSelection = '$anchorCell' in editorView.state.selection;
            if (isCellSelection && isEditorControlsEnabled) return (0, $lNDSG.calculateToolbarPositionOnCellSelection)((0, $b044906b4f51186e$export$e235a0bccaa8a700))(editorView, position);
            return (0, $lNDSG.calculateToolbarPositionTrackHead)((0, $b044906b4f51186e$export$e235a0bccaa8a700))(editorView, position);
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-plugin-toolbar/selectionToolbar'
            });
            return position;
        }
    }, [
        editorView
    ]);
    return onPositionCalculated;
};
const $50bc1c4d30c9d49d$export$5d706a9638468490 = ({ api: api, editorView: editorView, mountPoint: mountPoint, disableSelectionToolbarWhenPinned: disableSelectionToolbarWhenPinned })=>{
    const { connectivityStateMode: connectivityStateMode, editorToolbarDockingPreference: editorToolbarDockingPreference, currentUserIntent: currentUserIntent, shouldShowToolbar: shouldShowToolbar, editorViewMode: editorViewMode, contextualFormattingModeOverride: contextualFormattingModeOverride } = $50bc1c4d30c9d49d$var$usePluginState(api);
    const contextualFormattingEnabled = contextualFormattingModeOverride ?? api?.toolbar?.actions.contextualFormattingMode() ?? 'always-pinned';
    const selectionToolbarConfigEnabled = (0, $1da171b888e51db2$export$af4b2f219e301e70)(contextualFormattingEnabled, editorToolbarDockingPreference);
    const intl = (0, $aXWIB.useIntl)();
    const components = api?.toolbar?.actions.getComponents();
    const toolbar = components?.find((component)=>$50bc1c4d30c9d49d$var$isToolbarComponent(component));
    const keyboardNavigation = (0, $42omo.useMemo)(()=>{
        return (0, $2b454c365c97f6ab$export$48b8f4aa7f88bf3a)(editorView, intl, api);
    }, [
        editorView,
        intl,
        api
    ]);
    const { isDisabled: isDisabled } = (0, $8hoW2.useToolbarUI)();
    const isOffline = (0, $91bcx.isOfflineMode)(connectivityStateMode);
    const isTextSelection = !editorView.state.selection.empty && editorView.state.selection instanceof (0, $ks2lK.TextSelection);
    const isAllSelection = !editorView.state.selection.empty && editorView.state.selection instanceof (0, $ks2lK.AllSelection);
    const isCellSelection = !editorView.state.selection.empty && '$anchorCell' in editorView.state.selection;
    const onPositionCalculated = $50bc1c4d30c9d49d$var$useOnPositionCalculated(editorView);
    if (selectionToolbarConfigEnabled && disableSelectionToolbarWhenPinned || !components || !toolbar) return null;
    if (!(isTextSelection || isCellSelection || isAllSelection) || currentUserIntent === 'dragging' || !shouldShowToolbar || currentUserIntent === 'blockMenuOpen' && (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true) || // hide toolbar when user intent is not default, except when it's dragHandleSelected without cell selection
    currentUserIntent && currentUserIntent !== 'default' && !(currentUserIntent === 'dragHandleSelected' && !isCellSelection) || (0, $eTj7Y.isSSR)()) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $jwWgu.default), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        offset: [
            0,
            10
        ],
        target: (0, $3f28f07489e6242f$export$49d74ed2464a12b9)(editorView),
        onPositionCalculated: onPositionCalculated,
        mountTo: mountPoint,
        zIndex: (0, $aFUXX.akEditorFloatingDialogZIndex),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gzUv9.EditorToolbarProvider), {
            editorView: editorView,
            editorToolbarDockingPreference: editorToolbarDockingPreference,
            editorViewMode: editorViewMode ?? 'edit',
            isOffline: isOffline,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $biAkr.EditorToolbarUIProvider), {
                api: api,
                isDisabled: isDisabled,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                fireAnalyticsEvent: (payload)=>{
                    api?.analytics?.actions.fireAnalyticsEvent(payload);
                },
                keyboardNavigation: keyboardNavigation,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cf8NL.ToolbarModelRenderer), {
                    toolbar: toolbar,
                    components: components,
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    fallbacks: {
                        section: (0, $48SU7.ToolbarSection),
                        menuSection: (0, $6UWPx.ToolbarDropdownItemSection),
                        group: (0, $kDB94.ToolbarButtonGroup)
                    }
                })
            })
        })
    });
};
const $50bc1c4d30c9d49d$export$316d94f683c144f1 = ({ api: api, editorView: editorView, mountPoint: mountPoint, disableSelectionToolbarWhenPinned: disableSelectionToolbarWhenPinned })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7fmpI.ErrorBoundary), {
        component: (0, $d925B.ACTION_SUBJECT).TOOLBAR,
        componentId: (0, $d925B.ACTION_SUBJECT_ID).SELECTION_TOOLBAR,
        dispatchAnalyticsEvent: api?.analytics?.actions.fireAnalyticsEvent,
        fallbackComponent: null,
        children: /*#__PURE__*/ (0, $l998X.jsx)($50bc1c4d30c9d49d$export$5d706a9638468490, {
            api: api,
            editorView: editorView,
            mountPoint: mountPoint,
            disableSelectionToolbarWhenPinned: disableSelectionToolbarWhenPinned
        })
    });
};





parcelRequire("42omo");





var $cPCP8 = parcelRequire("cPCP8");

var $4Chin = parcelRequire("4Chin");


var $aro2m = parcelRequire("aro2m");

var $l7fKC = parcelRequire("l7fKC");





parcelRequire("42omo");





var $2zaaI = parcelRequire("2zaaI");





var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");

parcelRequire("42omo");


var $9VJDA = parcelRequire("9VJDA");

const $f9e2f00b7f1d8ea8$export$c07cde1baa478056 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { label: label, testId: testId, color: color, shouldRecommendSmallIcon: shouldRecommendSmallIcon, spacing: spacing } = t0;
    let t1;
    if ($[0] !== color || $[1] !== label || $[2] !== shouldRecommendSmallIcon || $[3] !== spacing || $[4] !== testId) {
        t1 = /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
            label: label,
            testId: testId,
            color: color,
            shouldRecommendSmallIcon: shouldRecommendSmallIcon,
            spacing: spacing,
            size: "small"
        });
        $[0] = color;
        $[1] = label;
        $[2] = shouldRecommendSmallIcon;
        $[3] = spacing;
        $[4] = testId;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
} : ({ label: label, testId: testId, color: color, shouldRecommendSmallIcon: shouldRecommendSmallIcon, spacing: spacing })=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
        label: label,
        testId: testId,
        color: color,
        shouldRecommendSmallIcon: shouldRecommendSmallIcon,
        spacing: spacing,
        size: "small"
    });


var $bTiiT = parcelRequire("bTiiT");

var $iIVVb = parcelRequire("iIVVb");

const $e53f3a9fdbeaf9e5$export$f62801e1786d0b09 = ({ children: children })=>{
    const intl = (0, $aXWIB.useIntl)();
    const tooltipContent = intl.formatMessage((0, $2zaaI.toolbarMessages).selectionToolbarOverflowMenuTooltip);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $bTiiT.ToolbarDropdownMenu), {
        label: tooltipContent,
        iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, $f9e2f00b7f1d8ea8$export$c07cde1baa478056), {
            label: ""
        }),
        tooltipComponent: /*#__PURE__*/ (0, $l998X.jsx)((0, $iIVVb.ToolbarTooltip), {
            content: tooltipContent,
            position: "top"
        }),
        children: children
    });
};





parcelRequire("42omo");







const $50dd0076ab6a6d47$export$e3cf1fcb813fa9a4 = ({ children: children })=>{
    const { editorViewMode: editorViewMode } = (0, $gzUv9.useEditorToolbar)();
    const isEdit = editorViewMode === 'edit';
    // only show separator in edit mode, when the pinned toolbar option is available
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6UWPx.ToolbarDropdownItemSection), {
        hasSeparator: isEdit,
        children: children
    });
};





parcelRequire("42omo");







const $57122a1757f10afa$export$3590112bc75b92dc = ({ children: children, hasSeparator: hasSeparator, testId: testId })=>{
    const { editorAppearance: editorAppearance } = (0, $gzUv9.useEditorToolbar)();
    if (editorAppearance === 'full-page') return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $48SU7.ToolbarSection), {
        hasSeparator: hasSeparator,
        testId: testId,
        children: children
    });
};





parcelRequire("42omo");










const $6bc09cb4361fa368$var$isFullPage = (editorAppearance)=>{
    return editorAppearance === 'full-page' || editorAppearance === 'full-width';
};
const $6bc09cb4361fa368$var$getBreakpointPreset = (breakpointPreset, editorAppearance)=>{
    if (breakpointPreset) return breakpointPreset;
    return editorAppearance && $6bc09cb4361fa368$var$isFullPage(editorAppearance) ? 'fullpage' : 'reduced';
};
const $6bc09cb4361fa368$export$7469f9986edfc2 = ({ children: children, breakpointPreset: breakpointPreset })=>{
    const { editorAppearance: editorAppearance } = (0, $gzUv9.useEditorToolbar)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l7fKC.PrimaryToolbar), {
        testId: (0, $1oCLl.expValEquals)('editor_a11y__primary-toolbar-aria-label_fy27', 'isEnabled', true) ? 'editor-primary-toolbar' : undefined,
        label: (0, $1oCLl.expValEquals)('editor_a11y__primary-toolbar-aria-label_fy27', 'isEnabled', true) ? undefined : 'Primary Toolbar',
        breakpointPreset: $6bc09cb4361fa368$var$getBreakpointPreset(breakpointPreset, editorAppearance),
        children: children
    });
};





parcelRequire("42omo");












const $72e3b75043e2a744$var$shouldShowSection = (editMode, toolbar, toolbarDocking, contextualFormattingEnabled)=>{
    if (editMode === 'view') return false;
    if (toolbar?.key === (0, $cPCP8.TOOLBARS).INLINE_TEXT_TOOLBAR) return toolbarDocking !== 'top' || contextualFormattingEnabled === 'always-inline';
    if (toolbar?.key === (0, $cPCP8.TOOLBARS).PRIMARY_TOOLBAR) return toolbarDocking !== 'none' || contextualFormattingEnabled === 'always-pinned';
    return false;
};
const $72e3b75043e2a744$var$usePluginState = (_api)=>{
    const { editorViewMode: editorViewMode, editorToolbarDockingPreference: editorToolbarDockingPreference, editorAppearance: editorAppearance } = (0, $gzUv9.useEditorToolbar)();
    return {
        editorViewMode: editorViewMode,
        editorToolbarDockingPreference: editorToolbarDockingPreference,
        editorAppearance: editorAppearance
    };
};
const $72e3b75043e2a744$export$6e2c8f0811a474ce = ({ children: children, parents: parents, api: api, testId: testId, showSeparatorInFullPagePrimaryToolbar: showSeparatorInFullPagePrimaryToolbar, isSharedSection: isSharedSection = true })=>{
    const { editorViewMode: editorViewMode, editorToolbarDockingPreference: editorToolbarDockingPreference, editorAppearance: editorAppearance } = $72e3b75043e2a744$var$usePluginState(api);
    const runtimeOverride = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'toolbar'
    ], (states)=>states.toolbarState?.contextualFormattingModeOverride);
    const toolbar = parents.find((parent)=>parent.type === 'toolbar');
    const contextualFormattingEnabled = runtimeOverride ?? api?.toolbar?.actions.contextualFormattingMode() ?? 'always-pinned';
    if (isSharedSection && !$72e3b75043e2a744$var$shouldShowSection(editorViewMode, toolbar, editorToolbarDockingPreference, contextualFormattingEnabled)) return null;
    const isFullPage = editorAppearance === 'full-page';
    const hasSeparator = showSeparatorInFullPagePrimaryToolbar && isFullPage;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $48SU7.ToolbarSection), {
        testId: testId,
        hasSeparator: hasSeparator ? (0, $48SU7.SeparatorPosition).START : hasSeparator,
        children: children
    });
};





parcelRequire("42omo");








var $f8c3d = parcelRequire("f8c3d");





const $9e6a17ef6bf75883$export$55607282fee51b86 = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $bTiiT.ToolbarDropdownMenu), {
        iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f8c3d))), {
            label: formatMessage((0, $2zaaI.toolbarMessages).textStylesTooltip),
            size: "small"
        }),
        enableMaxHeight: true,
        tooltipComponent: /*#__PURE__*/ (0, $l998X.jsx)((0, $iIVVb.ToolbarTooltip), {
            content: formatMessage((0, $2zaaI.toolbarMessages).textStylesTooltip)
        }),
        children: children
    });
};


const $98a79b5e3dbfe625$var$getInlineTextToolbarComponents = ()=>{
    return [
        {
            type: 'toolbar',
            key: (0, $cPCP8.TOOLBARS).INLINE_TEXT_TOOLBAR,
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $l7fKC.Toolbar), {
                    label: (0, $b044906b4f51186e$export$e235a0bccaa8a700),
                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).SELECTION_TOOLBAR,
                    testId: 'editor-floating-toolbar',
                    children: children
                });
            }
        }
    ];
};
const $98a79b5e3dbfe625$var$getPrimaryToolbarComponents = (breakpointPreset)=>{
    return [
        {
            type: 'toolbar',
            key: (0, $cPCP8.TOOLBARS).PRIMARY_TOOLBAR,
            component: ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6bc09cb4361fa368$export$7469f9986edfc2), {
                    breakpointPreset: breakpointPreset,
                    children: children
                })
        }
    ];
};
const $98a79b5e3dbfe625$export$a758406ca53b86a5 = (contextualFormattingEnabled, api, breakpointPreset)=>{
    const components = [
        {
            type: (0, $cPCP8.TEXT_SECTION).type,
            key: (0, $cPCP8.TEXT_SECTION).key,
            parents: [
                {
                    type: 'toolbar',
                    key: (0, $cPCP8.TOOLBARS).INLINE_TEXT_TOOLBAR,
                    rank: (0, $4Chin.TOOLBAR_RANK)[(0, $cPCP8.TEXT_SECTION).key]
                }
            ],
            component: ({ children: children, parents: parents })=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $aro2m.Show), {
                    above: "md",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $72e3b75043e2a744$export$6e2c8f0811a474ce), {
                        parents: parents,
                        api: api,
                        testId: "text-section",
                        children: children
                    })
                });
            }
        },
        {
            type: (0, $cPCP8.TEXT_SECTION_PRIMARY_TOOLBAR).type,
            key: (0, $cPCP8.TEXT_SECTION_PRIMARY_TOOLBAR).key,
            parents: [
                {
                    type: 'toolbar',
                    key: (0, $cPCP8.TOOLBARS).PRIMARY_TOOLBAR,
                    rank: (0, $4Chin.TOOLBAR_RANK)[(0, $cPCP8.TEXT_SECTION).key]
                }
            ],
            component: ({ children: children, parents: parents })=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $aro2m.Show), {
                    above: "md",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $72e3b75043e2a744$export$6e2c8f0811a474ce), {
                        parents: parents,
                        api: api,
                        testId: "text-section",
                        children: children
                    })
                });
            }
        },
        {
            type: (0, $cPCP8.TEXT_SECTION_COLLAPSED).type,
            key: (0, $cPCP8.TEXT_SECTION_COLLAPSED).key,
            parents: [
                {
                    type: 'toolbar',
                    key: (0, $cPCP8.TOOLBARS).PRIMARY_TOOLBAR,
                    rank: (0, $4Chin.TOOLBAR_RANK)[(0, $cPCP8.TEXT_SECTION_COLLAPSED).key]
                },
                {
                    type: 'toolbar',
                    key: (0, $cPCP8.TOOLBARS).INLINE_TEXT_TOOLBAR,
                    rank: (0, $4Chin.TOOLBAR_RANK)[(0, $cPCP8.TEXT_SECTION_COLLAPSED).key]
                }
            ],
            component: ({ children: children, parents: parents })=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $aro2m.Show), {
                    below: "md",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $72e3b75043e2a744$export$6e2c8f0811a474ce), {
                        parents: parents,
                        api: api,
                        testId: "text-section",
                        children: children
                    })
                });
            }
        },
        {
            type: (0, $cPCP8.TEXT_COLLAPSED_GROUP).type,
            key: (0, $cPCP8.TEXT_COLLAPSED_GROUP).key,
            parents: [
                {
                    type: (0, $cPCP8.TEXT_SECTION_COLLAPSED).type,
                    key: (0, $cPCP8.TEXT_SECTION_COLLAPSED).key,
                    rank: 100
                }
            ]
        },
        {
            type: (0, $cPCP8.TEXT_COLLAPSED_MENU).type,
            key: (0, $cPCP8.TEXT_COLLAPSED_MENU).key,
            parents: [
                {
                    type: (0, $cPCP8.TEXT_COLLAPSED_GROUP).type,
                    key: (0, $cPCP8.TEXT_COLLAPSED_GROUP).key,
                    rank: 100
                }
            ],
            component: (0, $9e6a17ef6bf75883$export$55607282fee51b86)
        },
        {
            type: (0, $cPCP8.INSERT_BLOCK_SECTION).type,
            key: (0, $cPCP8.INSERT_BLOCK_SECTION).key,
            parents: [
                {
                    type: 'toolbar',
                    key: (0, $cPCP8.TOOLBARS).PRIMARY_TOOLBAR,
                    rank: (0, $4Chin.TOOLBAR_RANK)[(0, $cPCP8.INSERT_BLOCK_SECTION).key]
                }
            ],
            component: ({ children: children, parents: parents })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $72e3b75043e2a744$export$6e2c8f0811a474ce), {
                    testId: "insert-block-section",
                    parents: parents,
                    api: api,
                    showSeparatorInFullPagePrimaryToolbar: true,
                    isSharedSection: false,
                    children: children
                })
        },
        {
            type: (0, $cPCP8.LINKING_SECTION).type,
            key: (0, $cPCP8.LINKING_SECTION).key,
            parents: [
                {
                    type: 'toolbar',
                    key: (0, $cPCP8.TOOLBARS).INLINE_TEXT_TOOLBAR,
                    rank: (0, $4Chin.TOOLBAR_RANK)[(0, $cPCP8.LINKING_SECTION).key]
                },
                {
                    type: 'toolbar',
                    key: (0, $cPCP8.TOOLBARS).PRIMARY_TOOLBAR,
                    rank: (0, $4Chin.TOOLBAR_RANK)[(0, $cPCP8.LINKING_SECTION).key]
                }
            ],
            component: ({ children: children, parents: parents })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $72e3b75043e2a744$export$6e2c8f0811a474ce), {
                    testId: "link-section",
                    parents: parents,
                    api: api,
                    showSeparatorInFullPagePrimaryToolbar: true,
                    children: children
                })
        },
        {
            type: (0, $cPCP8.OVERFLOW_SECTION).type,
            key: (0, $cPCP8.OVERFLOW_SECTION).key,
            parents: [
                {
                    type: 'toolbar',
                    key: (0, $cPCP8.TOOLBARS).INLINE_TEXT_TOOLBAR,
                    rank: (0, $4Chin.TOOLBAR_RANK)[(0, $cPCP8.OVERFLOW_SECTION).key]
                }
            ]
        },
        {
            type: (0, $cPCP8.OVERFLOW_GROUP).type,
            key: (0, $cPCP8.OVERFLOW_GROUP).key,
            parents: [
                {
                    type: (0, $cPCP8.OVERFLOW_SECTION).type,
                    key: (0, $cPCP8.OVERFLOW_SECTION).key,
                    rank: (0, $4Chin.OVERFLOW_SECTION_RANK)[(0, $cPCP8.OVERFLOW_GROUP).key]
                }
            ]
        },
        {
            type: (0, $cPCP8.OVERFLOW_MENU).type,
            key: (0, $cPCP8.OVERFLOW_MENU).key,
            parents: [
                {
                    type: (0, $cPCP8.OVERFLOW_GROUP).type,
                    key: (0, $cPCP8.OVERFLOW_GROUP).key,
                    rank: (0, $4Chin.OVERFLOW_GROUP_RANK)[(0, $cPCP8.OVERFLOW_MENU).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $e53f3a9fdbeaf9e5$export$f62801e1786d0b09), {
                    children: children
                });
            }
        },
        {
            type: (0, $cPCP8.OVERFLOW_EXTENSIONS_MENU_SECTION).type,
            key: (0, $cPCP8.OVERFLOW_EXTENSIONS_MENU_SECTION).key,
            parents: [
                {
                    type: (0, $cPCP8.OVERFLOW_MENU).type,
                    key: (0, $cPCP8.OVERFLOW_MENU).key,
                    rank: (0, $4Chin.OVERFLOW_MENU_RANK)[(0, $cPCP8.OVERFLOW_EXTENSIONS_MENU_SECTION).key]
                }
            ],
            component: (0, $50dd0076ab6a6d47$export$e3cf1fcb813fa9a4)
        },
        {
            type: (0, $cPCP8.PIN_SECTION).type,
            key: (0, $cPCP8.PIN_SECTION).key,
            parents: [
                {
                    type: 'toolbar',
                    key: (0, $cPCP8.TOOLBARS).PRIMARY_TOOLBAR,
                    rank: (0, $4Chin.TOOLBAR_RANK)[(0, $cPCP8.PIN_SECTION).key]
                }
            ],
            component: ({ children: children, parents: parents })=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $72e3b75043e2a744$export$6e2c8f0811a474ce), {
                    testId: "pin-section",
                    parents: parents,
                    api: api,
                    showSeparatorInFullPagePrimaryToolbar: true,
                    children: children
                });
            }
        }
    ];
    components.push({
        type: (0, $cPCP8.OVERFLOW_SECTION_PRIMARY_TOOLBAR).type,
        key: (0, $cPCP8.OVERFLOW_SECTION_PRIMARY_TOOLBAR).key,
        parents: [
            {
                type: 'toolbar',
                key: (0, $cPCP8.TOOLBARS).PRIMARY_TOOLBAR,
                rank: (0, $4Chin.TOOLBAR_RANK)[(0, $cPCP8.OVERFLOW_SECTION_PRIMARY_TOOLBAR).key]
            }
        ],
        component: ({ children: children })=>{
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $57122a1757f10afa$export$3590112bc75b92dc), {
                children: children
            });
        }
    }, {
        type: (0, $cPCP8.OVERFLOW_GROUP_PRIMARY_TOOLBAR).type,
        key: (0, $cPCP8.OVERFLOW_GROUP_PRIMARY_TOOLBAR).key,
        parents: [
            {
                type: (0, $cPCP8.OVERFLOW_SECTION_PRIMARY_TOOLBAR).type,
                key: (0, $cPCP8.OVERFLOW_SECTION_PRIMARY_TOOLBAR).key,
                rank: (0, $4Chin.OVERFLOW_SECTION_PRIMARY_TOOLBAR_RANK)[(0, $cPCP8.OVERFLOW_GROUP_PRIMARY_TOOLBAR).key]
            }
        ]
    }, {
        type: (0, $cPCP8.OVERFLOW_MENU_PRIMARY_TOOLBAR).type,
        key: (0, $cPCP8.OVERFLOW_MENU_PRIMARY_TOOLBAR).key,
        parents: [
            {
                type: (0, $cPCP8.OVERFLOW_GROUP_PRIMARY_TOOLBAR).type,
                key: (0, $cPCP8.OVERFLOW_GROUP_PRIMARY_TOOLBAR).key,
                rank: (0, $4Chin.OVERFLOW_GROUP_PRIMARY_TOOLBAR_RANK)[(0, $cPCP8.OVERFLOW_MENU_PRIMARY_TOOLBAR).key]
            }
        ],
        component: ({ children: children })=>{
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $e53f3a9fdbeaf9e5$export$f62801e1786d0b09), {
                children: children
            });
        }
    });
    switch(contextualFormattingEnabled){
        case 'always-inline':
            components.unshift(...$98a79b5e3dbfe625$var$getInlineTextToolbarComponents());
            break;
        case 'always-pinned':
            components.unshift(...$98a79b5e3dbfe625$var$getPrimaryToolbarComponents(breakpointPreset));
            break;
        case 'controlled':
            components.unshift(...$98a79b5e3dbfe625$var$getInlineTextToolbarComponents());
            components.unshift(...$98a79b5e3dbfe625$var$getPrimaryToolbarComponents(breakpointPreset));
            break;
    }
    components.push({
        type: (0, $cPCP8.TRACK_CHANGES_SECTION).type,
        key: (0, $cPCP8.TRACK_CHANGES_SECTION).key,
        parents: [
            {
                type: 'toolbar',
                key: (0, $cPCP8.TOOLBARS).PRIMARY_TOOLBAR,
                rank: (0, $4Chin.TOOLBAR_RANK)[(0, $cPCP8.TRACK_CHANGES_SECTION).key]
            }
        ],
        component: ({ children: children, parents: parents })=>{
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $72e3b75043e2a744$export$6e2c8f0811a474ce), {
                testId: "track-changes-section",
                parents: parents,
                api: api,
                showSeparatorInFullPagePrimaryToolbar: true,
                children: children
            });
        }
    });
    return components;
};



function $9a628dc32fcc124c$var$getSelectedNode(editorState) {
    const { selection: selection } = editorState;
    if (selection instanceof (0, $ks2lK.NodeSelection)) return {
        node: selection.node,
        pos: selection.from,
        nodeType: selection.node.type.name,
        marks: selection.node.marks.map((mark)=>`${mark.type.name}:${JSON.stringify(mark.attrs)}`)
    };
    const { nodes: nodes } = editorState.schema;
    const selectedNode = (0, $8m4tT.findSelectedNodeOfType)([
        nodes.paragraph,
        nodes.heading,
        nodes.blockquote,
        nodes.panel,
        nodes.codeBlock
    ])(selection);
    if (selectedNode) return {
        node: selectedNode.node,
        pos: selectedNode.pos,
        nodeType: selectedNode.node.type.name,
        marks: selectedNode.node.marks.map((mark)=>`${mark.type.name}:${JSON.stringify(mark.attrs)}`)
    };
    const parentNode = (0, $8m4tT.findParentNodeOfType)([
        nodes.paragraph,
        nodes.heading,
        nodes.blockquote,
        nodes.panel,
        nodes.listItem,
        nodes.taskItem
    ])(selection);
    if (parentNode) return {
        node: parentNode.node,
        pos: parentNode.pos,
        nodeType: parentNode.node.type.name,
        marks: parentNode.node.marks.map((mark)=>`${mark.type.name}:${JSON.stringify(mark.attrs)}`)
    };
    const $pos = selection.$from;
    return {
        node: $pos.parent,
        pos: $pos.pos,
        nodeType: $pos.parent.type.name,
        marks: $pos.marks().map((mark)=>`${mark.type.name}:${JSON.stringify(mark.attrs)}`)
    };
}
const $9a628dc32fcc124c$export$2235d7d328f4404b = ({ api: api, config: config = {
    disableSelectionToolbar: false,
    disableSelectionToolbarWhenPinned: false
} })=>{
    const refs = {};
    const { disableSelectionToolbar: disableSelectionToolbar, disableSelectionToolbarWhenPinned: disableSelectionToolbarWhenPinned, contextualFormattingEnabled: contextualFormattingEnabled = 'always-pinned', breakpointPreset: breakpointPreset } = config;
    const registry = (0, $7f61bbc1e97d2781$export$34783ae4fef40269)();
    registry.register((0, $98a79b5e3dbfe625$export$a758406ca53b86a5)(contextualFormattingEnabled, api, breakpointPreset));
    return {
        name: 'toolbar',
        actions: {
            registerComponents: (toolbarComponents, replaceItems = false)=>{
                if (replaceItems) registry.safeRegister(toolbarComponents);
                else registry.register(toolbarComponents);
            },
            // EDITOR-6558: `componentFilter` is evaluated at read time (not at
            // `registerComponents` time) so it can react to runtime state
            // (e.g. the current markdown view mode) without forcing every
            // plugin to re-register its components. Returning a new array on
            // every call means React-tree consumers re-render whenever the
            // underlying filter would change.
            getComponents: ()=>{
                return config?.componentFilter ? registry.components.filter(config.componentFilter) : registry.components;
            },
            contextualFormattingMode: ()=>{
                // Returns the config-time mode only. The runtime override
                // (`EditorToolbarPluginState.contextualFormattingModeOverride`)
                // lives in PM state and must be merged in by the React render
                // site — see SelectionToolbar / Section / FullPageToolbarNext for
                // the `runtimeOverride ?? action() ?? 'always-pinned'` pattern.
                // Doing the merge here would require closure-capturing `editorView`,
                // which races with StrictMode double-mount.
                return config?.contextualFormattingModeOverride?.() ?? contextualFormattingEnabled ?? 'always-pinned';
            },
            getBreakpointPreset: ()=>{
                return breakpointPreset;
            }
        },
        commands: {
            setContextualFormattingModeOverride: (mode)=>{
                return ({ tr: tr })=>{
                    tr.setMeta((0, $fseNl.editorToolbarPluginKey), {
                        contextualFormattingModeOverride: mode
                    });
                    return tr;
                };
            }
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return (0, $fseNl.editorToolbarPluginKey).getState(editorState);
        },
        pmPlugins () {
            return [
                {
                    name: 'editor-toolbar-selection',
                    plugin: ()=>{
                        // Tracks mouse-down state to prevent the focus event (first page load)
                        // from prematurely showing the toolbar mid-drag
                        const mouseState = {
                            isMouseDown: false
                        };
                        return new (0, $1S4f7.SafePlugin)({
                            key: (0, $fseNl.editorToolbarPluginKey),
                            state: {
                                init (_, editorState) {
                                    return {
                                        shouldShowToolbar: false,
                                        selectedNode: $9a628dc32fcc124c$var$getSelectedNode(editorState),
                                        contextualFormattingModeOverride: undefined
                                    };
                                },
                                apply (tr, pluginState, _, newState) {
                                    const meta = tr.getMeta((0, $fseNl.editorToolbarPluginKey));
                                    let newPluginState = {
                                        ...pluginState
                                    };
                                    const shouldUpdateNode = tr.docChanged || tr.selectionSet;
                                    if (shouldUpdateNode) {
                                        const newSelectedNode = $9a628dc32fcc124c$var$getSelectedNode(newState);
                                        const oldNode = pluginState.selectedNode;
                                        const hasNodeChanged = !oldNode || !newSelectedNode || oldNode.nodeType !== newSelectedNode.nodeType || oldNode.pos !== newSelectedNode.pos || JSON.stringify(oldNode.marks) !== JSON.stringify(newSelectedNode.marks);
                                        if (hasNodeChanged) newPluginState.selectedNode = newSelectedNode;
                                    }
                                    if (meta) {
                                        const { contextualFormattingModeOverride: contextualFormattingModeOverride, ...rest } = meta;
                                        // Only forward the override when the meta actually carries
                                        // the key — unrelated metas (mouseup / focus / mousedown
                                        // from the view() listeners) destructure it as `undefined`
                                        // and would otherwise wipe a previously-set override on
                                        // every interaction.
                                        newPluginState = {
                                            ...newPluginState,
                                            ...rest,
                                            ...'contextualFormattingModeOverride' in meta ? {
                                                contextualFormattingModeOverride: contextualFormattingModeOverride
                                            } : {}
                                        };
                                    }
                                    return newPluginState;
                                }
                            },
                            view (view) {
                                const unbind = (0, $fFa3V.bind)(view.root, {
                                    type: 'mouseup',
                                    listener: function(ev) {
                                        mouseState.isMouseDown = false;
                                        const event = ev;
                                        const isInToolbar = (0, $56396ae0b6232fe6$export$3985dc3e1cbf9fe4)(event, (0, $b044906b4f51186e$export$c0535c9204f67376).toolbarContainer);
                                        const isInPortal = (0, $56396ae0b6232fe6$export$3985dc3e1cbf9fe4)(event, (0, $b044906b4f51186e$export$c0535c9204f67376).portal);
                                        // We only want to set selectionStable to true if the editor has focus
                                        // to prevent the toolbar from showing when the editor is blurred
                                        // due to a click outside the editor.
                                        const editorViewModePlugin = api?.editorViewMode?.sharedState.currentState();
                                        const isViewModeEnabled = editorViewModePlugin?.mode === 'view';
                                        view.dispatch(view.state.tr.setMeta((0, $fseNl.editorToolbarPluginKey), {
                                            shouldShowToolbar: !isViewModeEnabled ? view.hasFocus() || isInToolbar || isInPortal : true
                                        }));
                                    }
                                });
                                const unbindEditorViewFocus = (0, $fFa3V.bind)(view.dom, {
                                    type: 'focus',
                                    listener: ()=>{
                                        // On first page load, focus fires after mousedown — skip to
                                        // avoid showing the toolbar mid-drag
                                        if (mouseState.isMouseDown) return;
                                        view.dispatch(view.state.tr.setMeta((0, $fseNl.editorToolbarPluginKey), {
                                            shouldShowToolbar: true
                                        }));
                                    }
                                });
                                return {
                                    destroy () {
                                        unbind();
                                        unbindEditorViewFocus();
                                    }
                                };
                            },
                            props: {
                                handleDOMEvents: {
                                    mousedown: (view)=>{
                                        mouseState.isMouseDown = true;
                                        view.dispatch(view.state.tr.setMeta((0, $fseNl.editorToolbarPluginKey), {
                                            shouldShowToolbar: false
                                        }));
                                        return false;
                                    }
                                }
                            }
                        });
                    }
                },
                ...!disableSelectionToolbar ? [
                    {
                        name: 'selectionToolbarOpenExperience',
                        plugin: ()=>(0, $43358589369c1658$export$cfe4aed4f8555228)({
                                refs: refs,
                                dispatchAnalyticsEvent: (payload)=>api?.analytics?.actions?.fireAnalyticsEvent(payload)
                            })
                    }
                ] : []
            ];
        },
        contentComponent: !disableSelectionToolbar ? ({ editorView: editorView, popupsMountPoint: popupsMountPoint })=>{
            refs.popupsMountPoint = popupsMountPoint || undefined;
            if (!editorView) return null;
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $50bc1c4d30c9d49d$export$316d94f683c144f1), {
                api: api,
                editorView: editorView,
                mountPoint: popupsMountPoint,
                disableSelectionToolbarWhenPinned: disableSelectionToolbarWhenPinned ?? false
            });
        } : undefined
    };
};
module.exports["toolbarPlugin"] = $9a628dc32fcc124c$export$2235d7d328f4404b;

});

parcelRegister("kw2eg", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $d925B = parcelRequire("d925B");


var $1S4f7 = parcelRequire("1S4f7");


var $g9Jfe = parcelRequire("g9Jfe");


var $ke2AI = parcelRequire("ke2AI");


var $iu6m9 = parcelRequire("iu6m9");





var $dAtrv = parcelRequire("dAtrv");


var $2pjJ5 = parcelRequire("2pjJ5");

// NOTE: The string values below intentionally duplicate the values of the
// matching `INPUT_METHOD` members in `@atlaskit/editor-common/analytics`
// (`TOOLBAR='toolbar'`, `KEYBOARD='keyboard'`, `EXTERNAL='external'`).
// Under TypeScript's `--isolatedDeclarations`, enum member initializers cannot
// reference external symbols (TS9020), so we cannot write
// `TOOLBAR = INPUT_METHOD.TOOLBAR`. If you change a value here, update the
// corresponding `INPUT_METHOD` member to match — these strings are written
// straight into transaction meta in `attach-input-meta.ts` and surface as
// the `historyTriggerMethod` analytics attribute (asserted in
// `editor-plugin-undo-redo-tests/.../analytics-input-method.ts`).
var $370a94c4ff659fda$export$c3de12c0810a343d = /*#__PURE__*/ function(InputSource) {
    InputSource["TOOLBAR"] = "toolbar";
    InputSource["KEYBOARD"] = "keyboard";
    InputSource["EXTERNAL"] = "external";
    return InputSource;
}({});



var $ks2lK = parcelRequire("ks2lK");

const $a922342e96f1c4f6$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('undoRedoPlugin');


const $c457fccf049fe3eb$export$84d159245233a2bb = (inputSource)=>(command)=>(state, dispatch)=>{
            let customTr = state.tr;
            const fakeDispatch = (tr)=>{
                customTr = tr;
            };
            command(state, fakeDispatch);
            if (!customTr || !customTr.docChanged) return false;
            customTr.setMeta((0, $a922342e96f1c4f6$export$18d4026d1ea86bb1), inputSource);
            if (dispatch) dispatch(customTr);
            return true;
        };
const $c457fccf049fe3eb$var$inputSourceToInputMethod = (inputSource)=>{
    switch(inputSource){
        case (0, $370a94c4ff659fda$export$c3de12c0810a343d).EXTERNAL:
            return (0, $d925B.INPUT_METHOD).EXTERNAL;
        case (0, $370a94c4ff659fda$export$c3de12c0810a343d).KEYBOARD:
            return (0, $d925B.INPUT_METHOD).KEYBOARD;
        case (0, $370a94c4ff659fda$export$c3de12c0810a343d).TOOLBAR:
            return (0, $d925B.INPUT_METHOD).TOOLBAR;
        default:
            return (0, $d925B.INPUT_METHOD).EXTERNAL;
    }
};
function $c457fccf049fe3eb$var$getNodesWithDifferingAttributes({ before: before, after: after }) {
    const allAttributeKeys = Object.keys({
        ...before.attrs,
        ...after.attrs
    });
    const differingAttributes = allAttributeKeys.filter((key)=>before.attrs[key] !== after.attrs[key]);
    const affectedNodes = differingAttributes.length ? [
        {
            type: before.type.name,
            attributes: differingAttributes
        }
    ] : [];
    return before.children.reduce((acc, beforeChild, index)=>[
            ...acc,
            ...$c457fccf049fe3eb$var$getNodesWithDifferingAttributes({
                before: beforeChild,
                after: after.child(index)
            })
        ], affectedNodes);
}
function $c457fccf049fe3eb$export$db14845dcbb6e6df({ before: before, after: after }) {
    const hasChanged = !(0, $2pjJ5.areNodesEqualIgnoreAttrs)(after, before);
    const affectedNodes = hasChanged ? undefined : $c457fccf049fe3eb$var$getNodesWithDifferingAttributes({
        before: before,
        after: after
    })// Limit to 25 nodes to avoid oversize payloads
    .slice(0, 25);
    return {
        hasChanged: hasChanged,
        affectedNodes: affectedNodes
    };
}
const $c457fccf049fe3eb$export$5b05f10224c3caf8 = (editorAnalyticsAPI)=>(inputSource, action)=>(command)=>$c457fccf049fe3eb$export$84d159245233a2bb(inputSource)((0, $dAtrv.withAnalytics)(editorAnalyticsAPI, ({ doc: before }, { currentDoc: after })=>({
                    eventType: (0, $d925B.EVENT_TYPE).TRACK,
                    action: action,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                    attributes: {
                        inputMethod: $c457fccf049fe3eb$var$inputSourceToInputMethod(inputSource),
                        ...$c457fccf049fe3eb$export$db14845dcbb6e6df({
                            before: before,
                            after: after
                        })
                    }
                }))(command));




var $hgeg8 = parcelRequire("hgeg8");





var $dus6D = parcelRequire("dus6D");









const $3056501c02d56c6c$export$1d1a6834315b2876 = (0, $c457fccf049fe3eb$export$84d159245233a2bb)((0, $370a94c4ff659fda$export$c3de12c0810a343d).KEYBOARD)((0, $ke2AI.undo));
const $3056501c02d56c6c$export$b51f9da6d7e523d2 = (0, $c457fccf049fe3eb$export$84d159245233a2bb)((0, $370a94c4ff659fda$export$c3de12c0810a343d).KEYBOARD)((0, $ke2AI.redo));
const $3056501c02d56c6c$export$841850d252e034f0 = (0, $c457fccf049fe3eb$export$84d159245233a2bb)((0, $370a94c4ff659fda$export$c3de12c0810a343d).TOOLBAR)((0, $ke2AI.undo));
const $3056501c02d56c6c$export$11ad0a77a5cc0ccf = (0, $c457fccf049fe3eb$export$84d159245233a2bb)((0, $370a94c4ff659fda$export$c3de12c0810a343d).TOOLBAR)((0, $ke2AI.redo));
const $3056501c02d56c6c$export$4c45d895aa8430e8 = (editorAnalyticsAPI)=>(0, $c457fccf049fe3eb$export$5b05f10224c3caf8)(editorAnalyticsAPI)((0, $370a94c4ff659fda$export$c3de12c0810a343d).KEYBOARD, (0, $d925B.ACTION).UNDO_PERFORMED)((0, $ke2AI.undo));
const $3056501c02d56c6c$export$1f3073e8f226f307 = (editorAnalyticsAPI)=>(0, $c457fccf049fe3eb$export$5b05f10224c3caf8)(editorAnalyticsAPI)((0, $370a94c4ff659fda$export$c3de12c0810a343d).KEYBOARD, (0, $d925B.ACTION).REDO_PERFORMED)((0, $ke2AI.redo));
const $3056501c02d56c6c$export$a9ef7677c700995e = (editorAnalyticsAPI)=>(0, $c457fccf049fe3eb$export$5b05f10224c3caf8)(editorAnalyticsAPI)((0, $370a94c4ff659fda$export$c3de12c0810a343d).TOOLBAR, (0, $d925B.ACTION).UNDO_PERFORMED)((0, $ke2AI.undo));
const $3056501c02d56c6c$export$1746c262152d0cc4 = (editorAnalyticsAPI)=>(0, $c457fccf049fe3eb$export$5b05f10224c3caf8)(editorAnalyticsAPI)((0, $370a94c4ff659fda$export$c3de12c0810a343d).TOOLBAR, (0, $d925B.ACTION).REDO_PERFORMED)((0, $ke2AI.redo));


function $e86bc7017d9c5cb2$export$e832373cff8dec22(api) {
    const list = {};
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.findKeyMapForBrowser)((0, $hgeg8.redo)), (0, $3056501c02d56c6c$export$1f3073e8f226f307)(api?.analytics?.actions), list);
    (0, $hgeg8.bindKeymapWithCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.findKeyMapForBrowser)((0, $hgeg8.redoAlt)), (0, $3056501c02d56c6c$export$1f3073e8f226f307)(api?.analytics?.actions), list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.undo).common, (0, $3056501c02d56c6c$export$4c45d895aa8430e8)(api?.analytics?.actions), list);
    return new (0, $1S4f7.SafePlugin)({
        props: {
            handleKeyDown (view, event) {
                const keyboardEvent = (0, $hgeg8.isCapsLockOnAndModifyKeyboardEvent)(event);
                return (0, $dus6D.keydownHandler)(list)(view, keyboardEvent);
            }
        }
    });
}






const $ed02a43abe0a83c8$export$ae829ec7b2625219 = ({ dispatch: dispatch })=>{
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $a922342e96f1c4f6$export$18d4026d1ea86bb1)
    });
};


const $1bf0fe62463c3d85$export$2c9048c8abe91d0d = (editorView, api)=>(command)=>{
        if (!editorView) return false;
        if (api?.typeAhead?.actions?.isOpen(editorView.state)) api?.typeAhead?.actions?.close({
            attachCommand: command,
            insertCurrentQueryAsRawText: false
        });
        else command(editorView.state, editorView.dispatch);
        return true;
    };
const $1bf0fe62463c3d85$export$4126ecb6f20789f0 = (editorView, api)=>(command)=>{
        const result = $1bf0fe62463c3d85$export$2c9048c8abe91d0d(editorView, api)(command);
        if (result && !editorView.hasFocus()) editorView.focus();
        return result;
    };


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9K4OG = parcelRequire("9K4OG");


var $aXWIB = parcelRequire("aXWIB");


var $eiA8Z = parcelRequire("eiA8Z");





var $ocPnd = parcelRequire("ocPnd");


var $cORDs = parcelRequire("cORDs");


var $8TW6I = parcelRequire("8TW6I");

var $a4eZN = parcelRequire("a4eZN");


var $kFjZK = parcelRequire("kFjZK");


var $fnaPh = parcelRequire("fnaPh");



const $0eda5cbe5a69ebe4$export$4a0f2fb817767d20 = ({ disabled: disabled, isReducedSpacing: isReducedSpacing, editorView: editorView, api: api, intl: { formatMessage: formatMessage } })=>{
    const { canRedo: canRedo, canUndo: canUndo } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'history'
    ], (states)=>({
            canUndo: states.historyState?.canUndo,
            canRedo: states.historyState?.canRedo
        }));
    const handleUndo = ()=>{
        (0, $1bf0fe62463c3d85$export$4126ecb6f20789f0)(editorView, api)((0, $3056501c02d56c6c$export$a9ef7677c700995e)(api?.analytics?.actions));
    };
    const handleRedo = ()=>{
        (0, $1bf0fe62463c3d85$export$4126ecb6f20789f0)(editorView, api)((0, $3056501c02d56c6c$export$1746c262152d0cc4)(api?.analytics?.actions));
    };
    const labelUndo = formatMessage((0, $ocPnd.messages).undo);
    const labelRedo = formatMessage((0, $ocPnd.messages).redo);
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $cORDs.buttonGroupStyle)
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a4eZN.default), {
        buttonId: (0, $8TW6I.TOOLBAR_ACTION_SUBJECT_ID).UNDO,
        spacing: isReducedSpacing ? 'none' : 'default',
        onClick: handleUndo,
        disabled: !canUndo || disabled,
        "aria-label": (0, $hgeg8.tooltip)((0, $hgeg8.undo), labelUndo),
        "aria-keyshortcuts": (0, $hgeg8.getAriaKeyshortcuts)((0, $hgeg8.undo)),
        title: /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hgeg8.ToolTipContent), {
            description: labelUndo,
            keymap: (0, $hgeg8.undo)
        }),
        iconBefore: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fnaPh))), {
            label: "",
            color: "currentColor",
            spacing: "spacious"
        }),
        testId: "ak-editor-toolbar-button-undo"
    }), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a4eZN.default), {
        spacing: isReducedSpacing ? 'none' : 'default',
        buttonId: (0, $8TW6I.TOOLBAR_ACTION_SUBJECT_ID).REDO,
        onClick: handleRedo,
        disabled: !canRedo || disabled,
        title: /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hgeg8.ToolTipContent), {
            description: labelRedo,
            keymap: (0, $hgeg8.redoAlt)
        }),
        iconBefore: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kFjZK))), {
            label: "",
            color: "currentColor",
            spacing: "spacious"
        }),
        testId: "ak-editor-toolbar-button-redo",
        "aria-label": (0, $hgeg8.tooltip)((0, $hgeg8.redoAlt), labelRedo),
        "aria-keyshortcuts": (0, $hgeg8.getAriaKeyshortcuts)((0, $hgeg8.redoAlt))
    }), !api?.primaryToolbar && /* eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: (0, $cORDs.separatorStyles)
    })));
};
// eslint-disable-next-line @typescript-eslint/ban-types
const $0eda5cbe5a69ebe4$var$_default_1 = (0, $aXWIB.injectIntl)($0eda5cbe5a69ebe4$export$4a0f2fb817767d20);
var $0eda5cbe5a69ebe4$export$2e2bcd8739ae039 = $0eda5cbe5a69ebe4$var$_default_1;





parcelRequire("42omo");


var $cPCP8 = parcelRequire("cPCP8");

var $4Chin = parcelRequire("4Chin");


var $aro2m = parcelRequire("aro2m");

var $kDB94 = parcelRequire("kDB94");




parcelRequire("42omo");














var $gzUv9 = parcelRequire("gzUv9");




var $7ERUE = parcelRequire("7ERUE");

var $iIVVb = parcelRequire("iIVVb");



const $75cc1dcefc577538$export$de10bfe090602e0a = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { editorView: editorView } = (0, $gzUv9.useEditorToolbar)();
    const { canRedo: canRedo } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'history'
    ], (states)=>({
            canRedo: states.historyState?.canRedo
        }));
    const handleRedo = ()=>{
        if (editorView) (0, $1bf0fe62463c3d85$export$4126ecb6f20789f0)(editorView, api)((0, $3056501c02d56c6c$export$1746c262152d0cc4)(api?.analytics?.actions));
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $iIVVb.ToolbarTooltip), {
        content: /*#__PURE__*/ (0, $l998X.jsx)((0, $hgeg8.ToolTipContent), {
            description: formatMessage((0, $ocPnd.messages).redo),
            keymap: (0, $hgeg8.redo)
        }),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7ERUE.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kFjZK))), {
                label: formatMessage((0, $ocPnd.messages).redo),
                size: "small"
            }),
            onClick: handleRedo,
            isDisabled: !canRedo,
            ariaKeyshortcuts: (0, $hgeg8.getAriaKeyshortcuts)((0, $hgeg8.redo)),
            testId: "ak-editor-toolbar-button-redo"
        })
    });
};





parcelRequire("42omo");

























const $62f206e8272e177c$export$f2500353cb92e6ec = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { editorView: editorView } = (0, $gzUv9.useEditorToolbar)();
    const { canUndo: canUndo } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'history'
    ], (states)=>({
            canUndo: states.historyState?.canUndo
        }));
    const handleUndo = ()=>{
        if (editorView) (0, $1bf0fe62463c3d85$export$4126ecb6f20789f0)(editorView, api)((0, $3056501c02d56c6c$export$a9ef7677c700995e)(api?.analytics?.actions));
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $iIVVb.ToolbarTooltip), {
        content: /*#__PURE__*/ (0, $l998X.jsx)((0, $hgeg8.ToolTipContent), {
            description: formatMessage((0, $ocPnd.messages).undo),
            keymap: (0, $hgeg8.undo)
        }),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7ERUE.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fnaPh))), {
                label: formatMessage((0, $ocPnd.messages).undo),
                size: "small"
            }),
            onClick: handleUndo,
            isDisabled: !canUndo,
            ariaKeyshortcuts: (0, $hgeg8.getAriaKeyshortcuts)((0, $hgeg8.undo)),
            testId: "ak-editor-toolbar-button-undo"
        })
    });
};


const $ff9400ece721d53b$export$a758406ca53b86a5 = (api)=>{
    const breakpointPreset = api?.toolbar?.actions.getBreakpointPreset();
    return [
        {
            type: (0, $cPCP8.UNDO_CHANGES_GROUP).type,
            key: (0, $cPCP8.UNDO_CHANGES_GROUP).key,
            parents: [
                {
                    type: (0, $cPCP8.TRACK_CHANGES_SECTION).type,
                    key: (0, $cPCP8.TRACK_CHANGES_SECTION).key,
                    rank: (0, $4Chin.TRACK_CHANGES_SECTION_RANK)[(0, $cPCP8.UNDO_CHANGES_GROUP).key]
                }
            ],
            component: ({ children: children })=>breakpointPreset === 'jsm-comment' ? /*#__PURE__*/ (0, $l998X.jsx)((0, $aro2m.Show), {
                    above: "lg",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kDB94.ToolbarButtonGroup), {
                        children: children
                    })
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $kDB94.ToolbarButtonGroup), {
                    children: children
                })
        },
        {
            type: (0, $cPCP8.UNDO_BUTTON).type,
            key: (0, $cPCP8.UNDO_BUTTON).key,
            parents: [
                {
                    type: (0, $cPCP8.UNDO_CHANGES_GROUP).type,
                    key: (0, $cPCP8.UNDO_CHANGES_GROUP).key,
                    rank: (0, $4Chin.UNDO_CHANGES_GROUP_RANK)[(0, $cPCP8.UNDO_BUTTON).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $62f206e8272e177c$export$f2500353cb92e6ec), {
                    api: api
                })
        },
        {
            type: (0, $cPCP8.REDO_CHANGES_GROUP).type,
            key: (0, $cPCP8.REDO_CHANGES_GROUP).key,
            parents: [
                {
                    type: (0, $cPCP8.TRACK_CHANGES_SECTION).type,
                    key: (0, $cPCP8.TRACK_CHANGES_SECTION).key,
                    rank: (0, $4Chin.TRACK_CHANGES_SECTION_RANK)[(0, $cPCP8.REDO_CHANGES_GROUP).key]
                }
            ],
            component: ({ children: children })=>breakpointPreset === 'jsm-comment' ? /*#__PURE__*/ (0, $l998X.jsx)((0, $aro2m.Show), {
                    above: "lg",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kDB94.ToolbarButtonGroup), {
                        children: children
                    })
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $kDB94.ToolbarButtonGroup), {
                    children: children
                })
        },
        {
            type: (0, $cPCP8.REDO_BUTTON).type,
            key: (0, $cPCP8.REDO_BUTTON).key,
            parents: [
                {
                    type: (0, $cPCP8.REDO_CHANGES_GROUP).type,
                    key: (0, $cPCP8.REDO_CHANGES_GROUP).key,
                    rank: (0, $4Chin.REDO_CHANGES_GROUP_RANK)[(0, $cPCP8.REDO_BUTTON).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $75cc1dcefc577538$export$de10bfe090602e0a), {
                    api: api
                })
        }
    ];
};


const $422d547128d90fd2$export$dcdc7fc7ecd3098 = ({ api: api, config: config })=>{
    const showToolbarButton = config?.showToolbarButton ?? true;
    const editorViewRef = {
        current: null
    };
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    const primaryToolbarComponent = ({ editorView: editorView, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing })=>{
        if (!editorView) return null;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $0eda5cbe5a69ebe4$export$2e2bcd8739ae039), {
            isReducedSpacing: isToolbarReducedSpacing,
            disabled: disabled,
            editorView: editorView,
            api: api
        });
    };
    if ((0, $g9Jfe.fg)('platform_editor_ai_add_undoredo_jira')) {
        if (showToolbarButton) {
            if (isToolbarAIFCEnabled) api?.toolbar?.actions.registerComponents((0, $ff9400ece721d53b$export$a758406ca53b86a5)(api));
            else api?.primaryToolbar?.actions.registerComponent({
                name: 'undoRedoPlugin',
                component: primaryToolbarComponent
            });
        }
    } else if (isToolbarAIFCEnabled) api?.toolbar?.actions.registerComponents((0, $ff9400ece721d53b$export$a758406ca53b86a5)(api));
    else api?.primaryToolbar?.actions.registerComponent({
        name: 'undoRedoPlugin',
        component: primaryToolbarComponent
    });
    const handleUndo = (inputSource)=>{
        if (!editorViewRef.current) return false;
        return (0, $1bf0fe62463c3d85$export$4126ecb6f20789f0)(editorViewRef.current, api)((0, $c457fccf049fe3eb$export$5b05f10224c3caf8)(api?.analytics?.actions)(inputSource || (0, $370a94c4ff659fda$export$c3de12c0810a343d).EXTERNAL, (0, $d925B.ACTION).UNDO_PERFORMED)((0, $ke2AI.undo)));
    };
    const handleRedo = (inputSource)=>{
        if (!editorViewRef.current) return false;
        return (0, $1bf0fe62463c3d85$export$4126ecb6f20789f0)(editorViewRef.current, api)((0, $c457fccf049fe3eb$export$5b05f10224c3caf8)(api?.analytics?.actions)(inputSource || (0, $370a94c4ff659fda$export$c3de12c0810a343d).EXTERNAL, (0, $d925B.ACTION).REDO_PERFORMED)((0, $ke2AI.redo)));
    };
    const showPrimaryToolbarComponent = (0, $g9Jfe.fg)('platform_editor_ai_add_undoredo_jira') ? !api?.primaryToolbar && !isToolbarAIFCEnabled && showToolbarButton : !api?.primaryToolbar && !isToolbarAIFCEnabled;
    return {
        name: 'undoRedoPlugin',
        actions: {
            undo: handleUndo,
            redo: handleRedo
        },
        pmPlugins () {
            const plugins = [
                {
                    name: 'undoRedoKeyMap',
                    plugin: ()=>(0, $e86bc7017d9c5cb2$export$e832373cff8dec22)(api)
                },
                {
                    name: 'undoRedoPlugin',
                    plugin: (options)=>(0, $ed02a43abe0a83c8$export$ae829ec7b2625219)(options)
                }
            ];
            if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1', {
                exposure: false
            })) plugins.push({
                name: 'undoRedoGetEditorViewReferencePlugin',
                plugin: ()=>{
                    return new (0, $1S4f7.SafePlugin)({
                        view: (editorView)=>{
                            editorViewRef.current = editorView;
                            return {
                                destroy: ()=>{
                                    editorViewRef.current = null;
                                }
                            };
                        }
                    });
                }
            });
            return plugins;
        },
        primaryToolbarComponent: showPrimaryToolbarComponent ? primaryToolbarComponent : undefined
    };
};
module.exports["undoRedoPlugin"] = $422d547128d90fd2$export$dcdc7fc7ecd3098;

});

parcelRegister("vxKdN", function(module, exports) {

var $aZa28 = parcelRequire("aZa28");

var $fnSCn = parcelRequire("fnSCn");

var $iSXnW = parcelRequire("iSXnW");

var $cre7m = parcelRequire("cre7m");

var $6eIpX = parcelRequire("6eIpX");

var $8KqSY = parcelRequire("8KqSY");


var $2gkmX = parcelRequire("2gkmX");

var $bT1qC = parcelRequire("bT1qC");


var $1S4f7 = parcelRequire("1S4f7");


var $iq4lN = parcelRequire("iq4lN");


var $ks2lK = parcelRequire("ks2lK");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $gndLe = parcelRequire("gndLe");

const $3475f4bb0180772c$export$b963567668795b80 = (props)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $gndLe.default), props);
};


const $e80fd63e182a8c04$var$pluginKey = new (0, $ks2lK.PluginKey)('unsupportedContentPlugin');
const $e80fd63e182a8c04$var$createPlugin = (pmPluginFactoryParams)=>{
    const { portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher, dispatchAnalyticsEvent: dispatchAnalyticsEvent } = pmPluginFactoryParams;
    return new (0, $1S4f7.SafePlugin)({
        key: $e80fd63e182a8c04$var$pluginKey,
        props: {
            nodeViews: {
                confluenceUnsupportedBlock: (0, $2gkmX.default).fromComponent((0, $iq4lN.default), portalProviderAPI, eventDispatcher, {
                    dispatchAnalyticsEvent: dispatchAnalyticsEvent
                }, undefined),
                confluenceUnsupportedInline: (0, $bT1qC.getInlineNodeViewProducer)({
                    pmPluginFactoryParams: pmPluginFactoryParams,
                    Component: (0, $3475f4bb0180772c$export$b963567668795b80),
                    extraComponentProps: {
                        dispatchAnalyticsEvent: dispatchAnalyticsEvent
                    }
                }),
                unsupportedBlock: (0, $2gkmX.default).fromComponent((0, $iq4lN.default), portalProviderAPI, eventDispatcher, {
                    dispatchAnalyticsEvent: dispatchAnalyticsEvent
                }, undefined),
                unsupportedInline: (0, $bT1qC.getInlineNodeViewProducer)({
                    pmPluginFactoryParams: pmPluginFactoryParams,
                    Component: (0, $3475f4bb0180772c$export$b963567668795b80),
                    extraComponentProps: {
                        dispatchAnalyticsEvent: dispatchAnalyticsEvent
                    }
                })
            }
        }
    });
};
const $e80fd63e182a8c04$export$fae834324d89b92 = ()=>({
        name: 'unsupportedContent',
        marks () {
            return [
                {
                    name: 'unsupportedMark',
                    mark: (0, $6eIpX.unsupportedMark)
                },
                {
                    name: 'unsupportedNodeAttribute',
                    mark: (0, $8KqSY.unsupportedNodeAttribute)
                }
            ];
        },
        nodes () {
            return [
                {
                    name: 'confluenceUnsupportedBlock',
                    node: (0, $aZa28.confluenceUnsupportedBlock)
                },
                {
                    name: 'confluenceUnsupportedInline',
                    node: (0, $fnSCn.confluenceUnsupportedInline)
                },
                {
                    name: 'unsupportedBlock',
                    node: (0, $iSXnW.unsupportedBlock)
                },
                {
                    name: 'unsupportedInline',
                    node: (0, $cre7m.unsupportedInline)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'unsupportedContent',
                    plugin: $e80fd63e182a8c04$var$createPlugin
                }
            ];
        }
    });
module.exports["unsupportedContentPlugin"] = $e80fd63e182a8c04$export$fae834324d89b92;

});

parcelRegister("3O0YV", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");

const $c42369811fa88306$export$f43d3f526d9434e = new (0, $ks2lK.PluginKey)('userIntentPlugin');
const $c42369811fa88306$var$initialState = {
    currentUserIntent: 'default'
};
const $c42369811fa88306$export$ae829ec7b2625219 = ()=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $c42369811fa88306$export$f43d3f526d9434e,
        state: {
            init () {
                return $c42369811fa88306$var$initialState;
            },
            apply: (tr, currentPluginState)=>{
                const meta = tr.getMeta($c42369811fa88306$export$f43d3f526d9434e);
                if (meta) {
                    // If the incoming currentUserIntent is the same as the existing one, return the existing state
                    if (meta.data.currentUserIntent === currentPluginState.currentUserIntent) return currentPluginState;
                    return {
                        currentUserIntent: meta.data.currentUserIntent
                    };
                }
                return currentPluginState;
            }
        }
    });
};


const $df70fc5748e6ddba$export$4de3f86a2063c3b3 = (currentUserIntent)=>({ tr: tr })=>{
        tr.setMeta((0, $c42369811fa88306$export$f43d3f526d9434e), {
            type: 'setCurrentUserIntent',
            data: {
                currentUserIntent: currentUserIntent
            }
        });
        return tr;
    };



const $3a616eeb36e390b8$export$234188bd1f793aed = ()=>({
        name: 'userIntent',
        pmPlugins () {
            return [
                {
                    name: 'userIntentPlugin',
                    plugin: (0, $c42369811fa88306$export$ae829ec7b2625219)
                }
            ];
        },
        getSharedState: (editorState)=>{
            if (!editorState) return;
            const pluginState = (0, $c42369811fa88306$export$f43d3f526d9434e).getState(editorState);
            if (!pluginState) return;
            return {
                currentUserIntent: pluginState.currentUserIntent
            };
        },
        commands: {
            setCurrentUserIntent: $df70fc5748e6ddba$export$4de3f86a2063c3b3
        }
    });
module.exports["userIntentPlugin"] = $3a616eeb36e390b8$export$234188bd1f793aed;

});

parcelRegister("fI6T7", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");

const $71946a3be8bdcf91$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('widthPlugin');


function $329a9e3096aeb9b2$export$ae829ec7b2625219(dispatch) {
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $71946a3be8bdcf91$export$18d4026d1ea86bb1),
        state: {
            init: ()=>{
                return {
                    width: document.body.offsetWidth
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta((0, $71946a3be8bdcf91$export$18d4026d1ea86bb1));
                if (!meta) return pluginState;
                const newPluginState = {
                    ...pluginState,
                    ...meta
                };
                if (newPluginState && (pluginState.width !== newPluginState.width || pluginState.lineLength !== newPluginState.lineLength)) {
                    dispatch((0, $71946a3be8bdcf91$export$18d4026d1ea86bb1), newPluginState);
                    return newPluginState;
                }
                return pluginState;
            }
        }
    });
}




var $42omo = parcelRequire("42omo");






var $fFa3V = parcelRequire("fFa3V");

// List of names for transition end events across browsers
const $1e8622f9cac168cf$var$transitionEventNames = [
    'transitionend',
    'oTransitionEnd',
    'webkitTransitionEnd'
];
const $1e8622f9cac168cf$export$b72edfd730e58e7c = (containerElement)=>{
    const [_, setLastWidthEvent] = (0, $42omo.useState)();
    (0, $42omo.useEffect)(()=>{
        if (!containerElement) return;
        /**
		 * Update the plugin components once the transition
		 * to full width / default mode completes
		 */ const forceComponentUpdate = (event)=>{
            // Only trigger an update if the transition is on a property containing `width`
            // This will cater for media and the content area itself currently.
            if (event.propertyName.includes('width')) setLastWidthEvent(event);
        };
        return (0, $fFa3V.bindAll)(containerElement, $1e8622f9cac168cf$var$transitionEventNames.map((name)=>({
                type: name,
                listener: forceComponentUpdate
            })));
    }, [
        containerElement
    ]);
};


const $4fbe3e1127a89ce0$export$33d12d97a81b0d33 = (props)=>(editorView)=>{
        const { dispatch: dispatch, state: { tr: tr } } = editorView;
        tr.setMeta((0, $71946a3be8bdcf91$export$18d4026d1ea86bb1), props);
        dispatch(tr);
    };
const $4fbe3e1127a89ce0$export$b0f894529c6bfe0a = ({ editorView: editorView, containerElement: containerElement })=>{
    (0, $1e8622f9cac168cf$export$b72edfd730e58e7c)(containerElement);
    (0, $42omo.useEffect)(()=>{
        const newState = {
            lineLength: editorView.dom.clientWidth,
            width: containerElement?.offsetWidth
        };
        $4fbe3e1127a89ce0$export$33d12d97a81b0d33(newState)(editorView);
    }, [
        editorView,
        editorView.dom.clientWidth,
        containerElement
    ]);
    (0, $42omo.useEffect)(()=>{
        const resizeWidth = (entries)=>{
            if (entries.length !== 1) return;
            const [fullAreaSize] = entries;
            if (!fullAreaSize || !Array.isArray(fullAreaSize.borderBoxSize)) return;
            const width = fullAreaSize.borderBoxSize[0].inlineSize;
            const lineLength = editorView.dom.clientWidth;
            $4fbe3e1127a89ce0$export$33d12d97a81b0d33({
                width: width,
                lineLength: lineLength
            })(editorView);
        };
        const resizeObserver = new ResizeObserver(resizeWidth);
        if (containerElement) resizeObserver.observe(containerElement);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        containerElement,
        editorView
    ]);
};


const $c8da50a96048430d$export$8cdf857cb01de6dc = ()=>{
    return {
        name: 'width',
        pmPlugins: ()=>[
                {
                    name: 'width',
                    plugin: ({ dispatch: dispatch })=>(0, $329a9e3096aeb9b2$export$ae829ec7b2625219)(dispatch)
                }
            ],
        getSharedState: (editorState)=>{
            if (!editorState) return undefined;
            return (0, $71946a3be8bdcf91$export$18d4026d1ea86bb1).getState(editorState);
        },
        usePluginHook: (0, $4fbe3e1127a89ce0$export$b0f894529c6bfe0a)
    };
};
module.exports["widthPlugin"] = $c8da50a96048430d$export$8cdf857cb01de6dc;

});

parcelRegister("3bEAg", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $31e4d3a4f86e133c$export$c174a7dc96b2afb8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    width: 0,
    positionedOverEditor: false,
    broadcastWidth: ()=>{},
    broadcastPosition: ()=>{}
});
class $31e4d3a4f86e133c$export$ba19517e2c08f4aa extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { width: width, positionedOverEditor: positionedOverEditor } = this.state;
        return /*#__PURE__*/ (0, $l998X.jsx)($31e4d3a4f86e133c$export$e38af27e662e9783, {
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            value: {
                width: width,
                positionedOverEditor: positionedOverEditor,
                broadcastWidth: this.broadcastSidebarWidth,
                broadcastPosition: this.broadcastPosition
            },
            children: this.props.children
        });
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(props){
        super(props);
        this.state = {
            width: 0,
            positionedOverEditor: false
        };
        this.broadcastSidebarWidth = (width)=>{
            if (width !== this.state.width) this.setState({
                width: width
            });
        };
        this.broadcastPosition = (positionedOverEditor)=>{
            if (positionedOverEditor !== this.state.positionedOverEditor) this.setState({
                positionedOverEditor: positionedOverEditor
            });
        };
    }
}
const $31e4d3a4f86e133c$export$e38af27e662e9783 = $31e4d3a4f86e133c$export$c174a7dc96b2afb8.Provider;
const $31e4d3a4f86e133c$export$24734d8d7782a3fc = $31e4d3a4f86e133c$export$c174a7dc96b2afb8.Consumer;
module.exports["ContextPanelWidthProvider"] = $31e4d3a4f86e133c$export$ba19517e2c08f4aa;
module.exports["ContextPanelConsumer"] = $31e4d3a4f86e133c$export$24734d8d7782a3fc;

});


$parcel$global.rlb("8pLtn")
//# sourceMappingURL=FullPageEditorComponent.4a8cff46.js.map
